export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string,
  String: string,
  Boolean: boolean,
  Int: number,
  Float: number,
  /** 
 * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
 */
  DateTime: any,
  /** 
 * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
 */
  Date: any,
  /** 
 * Allows use of a JSON String for input / output from the GraphQL schema.
   * 
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
 */
  JSONString: any,
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any,
  /** 
 * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
 */
  Time: any,
  /** 
 * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
 */
  GenericScalar: any,
};

export type AdicionarAnexosTaxaAbaixoDeEmprestimo = {
   __typename?: 'AdicionarAnexosTaxaAbaixoDeEmprestimo',
  emprestimo?: Maybe<EmprestimoType>,
};

export type AdicionarPagamentoEmprestimo = {
   __typename?: 'AdicionarPagamentoEmprestimo',
  ok?: Maybe<Scalars['Boolean']>,
  emprestimo?: Maybe<EmprestimoNode>,
};

export type AgrupadoPorDescricaoType = {
   __typename?: 'AgrupadoPorDescricaoType',
  loja?: Maybe<Array<Maybe<Scalars['Int']>>>,
  permssaoDescricao?: Maybe<Scalars['String']>,
};

export type AgrupadoPorLojaType = {
   __typename?: 'AgrupadoPorLojaType',
  loja?: Maybe<Scalars['Int']>,
  permssaoDescricao?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type AlterarEmailFuncionario = {
   __typename?: 'AlterarEmailFuncionario',
  funcionario?: Maybe<FuncionarioType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type AlterarGrupoDePermissoesMutation = {
   __typename?: 'AlterarGrupoDePermissoesMutation',
  ok?: Maybe<Scalars['Boolean']>,
  grupoPermissoes?: Maybe<GrupoDePermissoesType>,
};

export type AlterarSenhaCLienteMutation = {
   __typename?: 'AlterarSenhaCLienteMutation',
  cliente?: Maybe<ClienteType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type AlterarSenhaFuncionarioMutation = {
   __typename?: 'AlterarSenhaFuncionarioMutation',
  funcionario?: Maybe<FuncionarioType>,
  ok?: Maybe<Scalars['Boolean']>,
  token?: Maybe<Scalars['String']>,
};

export type AnexoDeContaAPagarType = {
   __typename?: 'AnexoDeContaAPagarType',
  id: Scalars['ID'],
  conta: ContaAPagarNode,
  descricao?: Maybe<Scalars['String']>,
  url: Scalars['String'],
};

export type AnexoDeEmprestimoType = {
   __typename?: 'AnexoDeEmprestimoType',
  id: Scalars['ID'],
  emprestimo: EmprestimoRelatorioType,
  descricao?: Maybe<Scalars['String']>,
  url: Scalars['String'],
};

export type AnexoDePedidoDeReembolsoType = {
   __typename?: 'AnexoDePedidoDeReembolsoType',
  id: Scalars['ID'],
  pedido: PedidoDeReembolsoNode,
  descricao?: Maybe<Scalars['String']>,
  url: Scalars['String'],
};

export type AnotacaoType = {
   __typename?: 'AnotacaoType',
  id: Scalars['ID'],
  nota: Scalars['String'],
  lead: LeadsNodeTypeRelayProp,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
};

export type AppConfigType = {
   __typename?: 'AppConfigType',
  id: Scalars['ID'],
  nomeApp: Scalars['String'],
  entidade: EntidadeTypeRelay,
  /** Selecione a unidade */
  unidade: EntidadeTypeRelayConnection,
  email?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  onesignalKey?: Maybe<Scalars['String']>,
  onesignalAppId?: Maybe<Scalars['String']>,
  appslideSet: Array<AppSlideType>,
  apppoliticaprivacideSet: Array<AppPoliticaPrivacideType>,
  apptermosusoSet: Array<AppTermosUsoType>,
  appfaqSet: Array<AppFaqType>,
};


export type AppConfigTypeUnidadeArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

export type AppFaqType = {
   __typename?: 'AppFaqType',
  id: Scalars['ID'],
  titulo: Scalars['String'],
  campo: Scalars['String'],
  appconfig: AppConfigType,
};

export type AppPoliticaPrivacideType = {
   __typename?: 'AppPoliticaPrivacideType',
  id: Scalars['ID'],
  titulo: Scalars['String'],
  campo: Scalars['String'],
  appconfig: AppConfigType,
};

export type AppSlideType = {
   __typename?: 'AppSlideType',
  id: Scalars['ID'],
  slide: Scalars['String'],
  appconfig: AppConfigType,
};

export type AppTermosUsoType = {
   __typename?: 'AppTermosUsoType',
  id: Scalars['ID'],
  titulo: Scalars['String'],
  campo: Scalars['String'],
  appconfig: AppConfigType,
};

export type AssociarClienteEntidadeMutation = {
   __typename?: 'AssociarClienteEntidadeMutation',
  ok?: Maybe<Scalars['Boolean']>,
  cliente?: Maybe<ClienteType>,
};

export type AssociarEntidadesGrupoMutation = {
   __typename?: 'AssociarEntidadesGrupoMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type AssociarFuncionariosGrupoMutation = {
   __typename?: 'AssociarFuncionariosGrupoMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type AtributosDePermissaoInput = {
  idEntidade: Scalars['ID'],
  descricao: Scalars['String'],
};

export type AtualizarAnexoDeContaAPagarMutation = {
   __typename?: 'AtualizarAnexoDeContaAPagarMutation',
  ok?: Maybe<Scalars['Boolean']>,
  anexo?: Maybe<AnexoDeContaAPagarType>,
};

export type AtualizarAnexoDePedidoDeReembolsoMutation = {
   __typename?: 'AtualizarAnexoDePedidoDeReembolsoMutation',
  ok?: Maybe<Scalars['Boolean']>,
  anexo?: Maybe<AnexoDePedidoDeReembolsoType>,
};

export type AtualizarClienteMutation = {
   __typename?: 'AtualizarClienteMutation',
  ok?: Maybe<Scalars['Boolean']>,
  cliente?: Maybe<ClienteType>,
};

export type AtualizarContaAPagarMutation = {
   __typename?: 'AtualizarContaAPagarMutation',
  ok?: Maybe<Scalars['Boolean']>,
  contaPagar?: Maybe<ContaAPagarNode>,
};

export type AtualizarContaDeClienteMutation = {
   __typename?: 'AtualizarContaDeClienteMutation',
  ok?: Maybe<Scalars['Boolean']>,
  conta?: Maybe<ContaDeClienteType>,
};

export type AtualizarEmprestimoMutation = {
   __typename?: 'AtualizarEmprestimoMutation',
  emprestimo?: Maybe<EmprestimoNode>,
};

export type AtualizarEmprestimoNsu = {
   __typename?: 'AtualizarEmprestimoNsu',
  emprestimo?: Maybe<EmprestimoNode>,
  nsu?: Maybe<NsuType>,
};

export type AtualizarEntidadeMutation = {
   __typename?: 'AtualizarEntidadeMutation',
  ok?: Maybe<Scalars['Boolean']>,
  entidade?: Maybe<EntidadeType>,
};

export type AtualizarFuncionarioMutation = {
   __typename?: 'AtualizarFuncionarioMutation',
  funcionario?: Maybe<FuncionarioType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type AtualizarInstanciaZApi = {
   __typename?: 'AtualizarInstanciaZApi',
  instancia?: Maybe<InstanciaZApiType>,
};

export type AtualizarMaquinaMutation = {
   __typename?: 'AtualizarMaquinaMutation',
  maquina?: Maybe<MaquinaNode>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type AtualizarPedidoDeReembolsoMutation = {
   __typename?: 'AtualizarPedidoDeReembolsoMutation',
  ok?: Maybe<Scalars['Boolean']>,
  pedidoReembolso?: Maybe<PedidoDeReembolsoNode>,
};

export type AtualizarTelefoneDeClienteMutation = {
   __typename?: 'AtualizarTelefoneDeClienteMutation',
  ok?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<TelefoneDeClienteType>,
};

export type AtualizarTelefoneDeEntidadeMutation = {
   __typename?: 'AtualizarTelefoneDeEntidadeMutation',
  ok?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<TelefoneDeEntidadeType>,
};

export type AtualizarTitularDivergenteNsu = {
   __typename?: 'AtualizarTitularDivergenteNsu',
  emprestimo?: Maybe<EmprestimoNode>,
  titularDivergente?: Maybe<NsuTitularDivergenteType>,
};

export type BandeirasDash = {
   __typename?: 'BandeirasDash',
  id?: Maybe<Scalars['String']>,
  label?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['Decimal']>,
};

export type BandeiraTabelaParceirosType = {
   __typename?: 'BandeiraTabelaParceirosType',
  id: Scalars['ID'],
  nomeBandeira: Scalars['String'],
};

export type BloquearFuncionario = {
   __typename?: 'BloquearFuncionario',
  funcionario?: Maybe<FuncionarioType>,
};

export type BloquearMaquinaMutation = {
   __typename?: 'BloquearMaquinaMutation',
  maquina?: Maybe<MaquinaNode>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type BoletoClienteMobile = {
  vencimento: Scalars['Date'],
  codigoBarra: Scalars['String'],
  numeroControle: Scalars['String'],
  valor: Scalars['Float'],
  anexoBoleto?: Maybe<Scalars['String']>,
};

export type CadastroTipoDeEmprestimoInput = {
  nome: Scalars['String'],
  entidades: Array<Maybe<Scalars['ID']>>,
  modalidadeCliente: Scalars['String'],
  periodicidadeRecorrencia?: Maybe<Scalars['String']>,
  tipoUso: Scalars['String'],
  tipoCalculo?: Maybe<Scalars['String']>,
  valorMinimo?: Maybe<Scalars['Decimal']>,
  valorMaximo?: Maybe<Scalars['Decimal']>,
  parcelasMinimas?: Maybe<Scalars['Int']>,
  parcelasMaximas?: Maybe<Scalars['Int']>,
  taxaJuros?: Maybe<Scalars['Decimal']>,
  tcc: Scalars['Decimal'],
  descricao?: Maybe<Scalars['String']>,
  loanExtraFields?: Maybe<Scalars['JSONString']>,
};

export type CadastroTipoDeEmprestimoMutation = {
   __typename?: 'CadastroTipoDeEmprestimoMutation',
  ok?: Maybe<Scalars['Boolean']>,
  tipoEmprestimo?: Maybe<TipoDeEmprestimoType>,
};

export type CancelaEmprestimoMobile = {
   __typename?: 'CancelaEmprestimoMobile',
  ok?: Maybe<Scalars['Boolean']>,
};

export type CartaoDeCreditoNodeTypeRelay = Node & {
   __typename?: 'CartaoDeCreditoNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nomeNoCartao: Scalars['String'],
  validade: Scalars['String'],
  numeroCartao: Scalars['String'],
  cvc?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  cpf: Scalars['String'],
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  anexoRgFrente?: Maybe<Scalars['String']>,
  anexoRgVerso?: Maybe<Scalars['String']>,
  anexoCpfFrente?: Maybe<Scalars['String']>,
  anexoCpfVerso?: Maybe<Scalars['String']>,
  anexoEndereco?: Maybe<Scalars['String']>,
  cartaoFrente?: Maybe<Scalars['String']>,
  cartaoVerso?: Maybe<Scalars['String']>,
  cartaoSelf?: Maybe<Scalars['String']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  pagcertoPayload: Scalars['JSONString'],
  cliente: EmprestimoClienteNode,
  entidadeId?: Maybe<Scalars['Int']>,
  deleted: Scalars['Boolean'],
};

export type CartaoDeCreditoNodeTypeRelayConnection = {
   __typename?: 'CartaoDeCreditoNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CartaoDeCreditoNodeTypeRelayEdge>>,
};

/** A Relay edge containing a `CartaoDeCreditoNodeTypeRelay` and its cursor. */
export type CartaoDeCreditoNodeTypeRelayEdge = {
   __typename?: 'CartaoDeCreditoNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<CartaoDeCreditoNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type CartaoDeCreditoType = {
   __typename?: 'CartaoDeCreditoType',
  id: Scalars['ID'],
  nomeNoCartao: Scalars['String'],
  validade: Scalars['String'],
  numeroCartao: Scalars['String'],
  cvc?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  cpf: Scalars['String'],
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  anexoRgFrente?: Maybe<Scalars['String']>,
  anexoRgVerso?: Maybe<Scalars['String']>,
  anexoCpfFrente?: Maybe<Scalars['String']>,
  anexoCpfVerso?: Maybe<Scalars['String']>,
  anexoEndereco?: Maybe<Scalars['String']>,
  cartaoFrente?: Maybe<Scalars['String']>,
  cartaoVerso?: Maybe<Scalars['String']>,
  cartaoSelf?: Maybe<Scalars['String']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  pagcertoPayload?: Maybe<PagcertoCreditCardPayloadType>,
  cliente: EmprestimoClienteNode,
  entidadeId?: Maybe<Scalars['Int']>,
  deleted: Scalars['Boolean'],
  numeroMascara?: Maybe<Scalars['String']>,
};

export type CategoriaTypeRelay = Node & {
   __typename?: 'CategoriaTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome?: Maybe<Scalars['String']>,
  excluido: Scalars['Boolean'],
  subcategoriasSet: SubCategoriasTypeRelayConnection,
  fornecedorSet: FornecedorViewNodeTypeConnection,
  totalSubcategoriaPorCategoria?: Maybe<Scalars['Int']>,
};


export type CategoriaTypeRelaySubcategoriasSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['Float']>,
  excluido?: Maybe<Scalars['Boolean']>
};


export type CategoriaTypeRelayFornecedorSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type CategoriaTypeRelayConnection = {
   __typename?: 'CategoriaTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoriaTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `CategoriaTypeRelay` and its cursor. */
export type CategoriaTypeRelayEdge = {
   __typename?: 'CategoriaTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<CategoriaTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type ChangeStatusTipoDeEmprestimoInput = {
  id: Scalars['ID'],
  ativo: Scalars['Boolean'],
};

export type ChangeStatusTipoEmprestimoMutation = {
   __typename?: 'ChangeStatusTipoEmprestimoMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

/** An enumeration. */
export enum ClienteEstadoCivil {
  /** Solteiro */
  Solteiro = 'SOLTEIRO',
  /** Casado */
  Casado = 'CASADO',
  /** Divorciado */
  Divorciado = 'DIVORCIADO',
  /** Viúvo */
  Viuvo = 'VIUVO'
}

export type ClienteInputMobile = {
  nome?: Maybe<Scalars['String']>,
  nascimento?: Maybe<Scalars['Date']>,
  sexo?: Maybe<Scalars['String']>,
  estadoCivil?: Maybe<Scalars['String']>,
  cpf?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  anexoRgFrente?: Maybe<Scalars['String']>,
  anexoRgVerso?: Maybe<Scalars['String']>,
  anexoCpfFrente?: Maybe<Scalars['String']>,
  anexoCpfVerso?: Maybe<Scalars['String']>,
  anexoEndereco?: Maybe<Scalars['String']>,
  observacao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
};

export type ClienteRelatorioInput = {
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  entidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  lead?: Maybe<Scalars['Boolean']>,
  cpf?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  nascimento?: Maybe<Scalars['Date']>,
  nascimento_Lte?: Maybe<Scalars['Date']>,
  nascimento_Gte?: Maybe<Scalars['Date']>,
  nascimento_Month_In?: Maybe<Scalars['String']>,
  nascimento_Day_In?: Maybe<Scalars['String']>,
  sexo?: Maybe<Scalars['String']>,
  sexo_In?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_Icontains?: Maybe<Scalars['String']>,
  telefone_Numero?: Maybe<Scalars['String']>,
  telefone_Numero_Icontains?: Maybe<Scalars['String']>,
  telefone_Ddd?: Maybe<Scalars['String']>,
  telefone_Ddd_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  uf_Icontains?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  bairro_Icontains?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  profissao_Icontains?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  /** Ordenando */
  orderBy?: Maybe<Scalars['String']>,
};

/** An enumeration. */
export enum ClienteSexo {
  /** Masculino */
  Masculino = 'MASCULINO',
  /** Feminino */
  Feminino = 'FEMININO',
  /** Indefinido */
  Indefinido = 'INDEFINIDO'
}

export type ClienteType = {
   __typename?: 'ClienteType',
  id: Scalars['ID'],
  nome: Scalars['String'],
  cpf?: Maybe<Scalars['String']>,
  nascimento?: Maybe<Scalars['Date']>,
  sexo?: Maybe<ClienteSexo>,
  estadoCivil?: Maybe<ClienteEstadoCivil>,
  rg?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  anexoRgFrente?: Maybe<Scalars['String']>,
  anexoRgVerso?: Maybe<Scalars['String']>,
  anexoCpfFrente?: Maybe<Scalars['String']>,
  anexoCpfVerso?: Maybe<Scalars['String']>,
  anexoEndereco?: Maybe<Scalars['String']>,
  anexoRenda?: Maybe<Scalars['String']>,
  observacao?: Maybe<Scalars['String']>,
  entidades: EntidadeTypeRelayConnection,
  lead: Scalars['Boolean'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  origem?: Maybe<Scalars['String']>,
  user?: Maybe<UserType>,
  sgiId?: Maybe<Scalars['Int']>,
  sgiImportedAt?: Maybe<Scalars['DateTime']>,
  telefones: Array<TelefoneDeClienteType>,
  contas: Array<ContaDeClienteType>,
  emprestimoSet: EmprestimoRelatorioTypeConnection,
  cartaodecreditoSet: CartaoDeCreditoNodeTypeRelayConnection,
  leadsSet: LeadsNodeTypeRelayPropConnection,
  listasmsSet: ListaSmsTypeRelayConnection,
  pk: Scalars['Int'],
};


export type ClienteTypeEntidadesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type ClienteTypeEmprestimoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type ClienteTypeCartaodecreditoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['ID']>
};


export type ClienteTypeLeadsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type ClienteTypeListasmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type ClienteTypeRelay = Node & {
   __typename?: 'ClienteTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  cpf?: Maybe<Scalars['String']>,
  nascimento?: Maybe<Scalars['Date']>,
  sexo?: Maybe<ClienteSexo>,
  estadoCivil?: Maybe<ClienteEstadoCivil>,
  rg?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  anexoRgFrente?: Maybe<Scalars['String']>,
  anexoRgVerso?: Maybe<Scalars['String']>,
  anexoCpfFrente?: Maybe<Scalars['String']>,
  anexoCpfVerso?: Maybe<Scalars['String']>,
  anexoEndereco?: Maybe<Scalars['String']>,
  anexoRenda?: Maybe<Scalars['String']>,
  observacao?: Maybe<Scalars['String']>,
  entidades: EntidadeTypeRelayConnection,
  lead: Scalars['Boolean'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  origem?: Maybe<Scalars['String']>,
  user?: Maybe<UserType>,
  sgiId?: Maybe<Scalars['Int']>,
  sgiImportedAt?: Maybe<Scalars['DateTime']>,
  telefones: Array<TelefoneDeClienteType>,
  contas: Array<ContaDeClienteType>,
  emprestimoSet?: Maybe<Array<Maybe<EmprestimoClienteType>>>,
  cartaodecreditoSet: CartaoDeCreditoNodeTypeRelayConnection,
  leadsSet: LeadsNodeTypeRelayPropConnection,
  listasmsSet: ListaSmsTypeRelayConnection,
  pk: Scalars['Int'],
};


export type ClienteTypeRelayEntidadesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type ClienteTypeRelayCartaodecreditoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['ID']>
};


export type ClienteTypeRelayLeadsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type ClienteTypeRelayListasmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type ClienteTypeRelayConnection = {
   __typename?: 'ClienteTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClienteTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `ClienteTypeRelay` and its cursor. */
export type ClienteTypeRelayEdge = {
   __typename?: 'ClienteTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<ClienteTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type ColunaTabelaType = {
   __typename?: 'ColunaTabelaType',
  id: Scalars['ID'],
  valorGeral: Scalars['Float'],
  taxaTabela: Scalars['Float'],
  line1?: Maybe<Scalars['Float']>,
  line1Valor: Scalars['Float'],
  line2?: Maybe<Scalars['Float']>,
  line2Valor: Scalars['Float'],
  line3?: Maybe<Scalars['Float']>,
  line3Valor: Scalars['Float'],
  line4?: Maybe<Scalars['Float']>,
  line4Valor: Scalars['Float'],
  line5?: Maybe<Scalars['Float']>,
  line5Valor: Scalars['Float'],
  line6?: Maybe<Scalars['Float']>,
  line6Valor: Scalars['Float'],
  line7?: Maybe<Scalars['Float']>,
  line7Valor: Scalars['Float'],
  line8?: Maybe<Scalars['Float']>,
  line8Valor: Scalars['Float'],
  line9?: Maybe<Scalars['Float']>,
  line9Valor: Scalars['Float'],
  line10?: Maybe<Scalars['Float']>,
  line10Valor: Scalars['Float'],
  line11?: Maybe<Scalars['Float']>,
  line11Valor: Scalars['Float'],
  line12?: Maybe<Scalars['Float']>,
  line12Valor: Scalars['Float'],
  line13?: Maybe<Scalars['Float']>,
  line13Valor: Scalars['Float'],
  line14?: Maybe<Scalars['Float']>,
  line14Valor: Scalars['Float'],
  line15?: Maybe<Scalars['Float']>,
  line15Valor: Scalars['Float'],
  line16?: Maybe<Scalars['Float']>,
  line16Valor: Scalars['Float'],
  line17?: Maybe<Scalars['Float']>,
  line17Valor: Scalars['Float'],
  line18?: Maybe<Scalars['Float']>,
  line18Valor: Scalars['Float'],
  line19?: Maybe<Scalars['Float']>,
  line19Valor: Scalars['Float'],
  line20?: Maybe<Scalars['Float']>,
  line20Valor: Scalars['Float'],
  line21?: Maybe<Scalars['Float']>,
  line21Valor: Scalars['Float'],
  tabela: TabelasNodeTypeRelay,
};

export type ColunaTabelaTypeInput = {
  valorGeral?: Maybe<Scalars['Float']>,
  taxaTabela?: Maybe<Scalars['Float']>,
  line1?: Maybe<Scalars['Float']>,
  line1Valor?: Maybe<Scalars['Float']>,
  line2?: Maybe<Scalars['Float']>,
  line2Valor?: Maybe<Scalars['Float']>,
  line3?: Maybe<Scalars['Float']>,
  line3Valor?: Maybe<Scalars['Float']>,
  line4?: Maybe<Scalars['Float']>,
  line4Valor?: Maybe<Scalars['Float']>,
  line5?: Maybe<Scalars['Float']>,
  line5Valor?: Maybe<Scalars['Float']>,
  line6?: Maybe<Scalars['Float']>,
  line6Valor?: Maybe<Scalars['Float']>,
  line7?: Maybe<Scalars['Float']>,
  line7Valor?: Maybe<Scalars['Float']>,
  line8?: Maybe<Scalars['Float']>,
  line8Valor?: Maybe<Scalars['Float']>,
  line9?: Maybe<Scalars['Float']>,
  line9Valor?: Maybe<Scalars['Float']>,
  line10?: Maybe<Scalars['Float']>,
  line10Valor?: Maybe<Scalars['Float']>,
  line11?: Maybe<Scalars['Float']>,
  line11Valor?: Maybe<Scalars['Float']>,
  line12?: Maybe<Scalars['Float']>,
  line12Valor?: Maybe<Scalars['Float']>,
  line13?: Maybe<Scalars['Float']>,
  line13Valor?: Maybe<Scalars['Float']>,
  line14?: Maybe<Scalars['Float']>,
  line14Valor?: Maybe<Scalars['Float']>,
  line15?: Maybe<Scalars['Float']>,
  line15Valor?: Maybe<Scalars['Float']>,
  line16?: Maybe<Scalars['Float']>,
  line16Valor?: Maybe<Scalars['Float']>,
  line17?: Maybe<Scalars['Float']>,
  line17Valor?: Maybe<Scalars['Float']>,
  line18?: Maybe<Scalars['Float']>,
  line18Valor?: Maybe<Scalars['Float']>,
  line19?: Maybe<Scalars['Float']>,
  line19Valor?: Maybe<Scalars['Float']>,
  line20?: Maybe<Scalars['Float']>,
  line20Valor?: Maybe<Scalars['Float']>,
  line21?: Maybe<Scalars['Float']>,
  line21Valor?: Maybe<Scalars['Float']>,
};

/** An enumeration. */
export enum ColunaTaxasParcelasParcelas {
  /** 1x */
  A_1 = 'A_1',
  /** 2x */
  A_2 = 'A_2',
  /** 3x */
  A_3 = 'A_3',
  /** 4x */
  A_4 = 'A_4',
  /** 5x */
  A_5 = 'A_5',
  /** 6x */
  A_6 = 'A_6',
  /** 7x */
  A_7 = 'A_7',
  /** 8x */
  A_8 = 'A_8',
  /** 9x */
  A_9 = 'A_9',
  /** 10x */
  A_10 = 'A_10',
  /** 11x */
  A_11 = 'A_11',
  /** 12x */
  A_12 = 'A_12',
  /** 13x */
  A_13 = 'A_13',
  /** 14x */
  A_14 = 'A_14',
  /** 15x */
  A_15 = 'A_15',
  /** 16x */
  A_16 = 'A_16',
  /** 17x */
  A_17 = 'A_17',
  /** 18x */
  A_18 = 'A_18',
  /** 19x */
  A_19 = 'A_19',
  /** 20x */
  A_20 = 'A_20',
  /** 21x */
  A_21 = 'A_21',
  /** 22x */
  A_22 = 'A_22',
  /** 23x */
  A_23 = 'A_23',
  /** 24x */
  A_24 = 'A_24',
  /** 25x */
  A_25 = 'A_25',
  /** 26x */
  A_26 = 'A_26',
  /** 27x */
  A_27 = 'A_27',
  /** 28x */
  A_28 = 'A_28',
  /** 29x */
  A_29 = 'A_29',
  /** 30x */
  A_30 = 'A_30',
  /** 31x */
  A_31 = 'A_31',
  /** 32x */
  A_32 = 'A_32',
  /** 33x */
  A_33 = 'A_33',
  /** 34x */
  A_34 = 'A_34',
  /** 35x */
  A_35 = 'A_35',
  /** 36x */
  A_36 = 'A_36',
  /** 37x */
  A_37 = 'A_37',
  /** 38x */
  A_38 = 'A_38',
  /** 39x */
  A_39 = 'A_39',
  /** 40x */
  A_40 = 'A_40',
  /** 41x */
  A_41 = 'A_41',
  /** 42x */
  A_42 = 'A_42',
  /** 43x */
  A_43 = 'A_43',
  /** 44x */
  A_44 = 'A_44',
  /** 45x */
  A_45 = 'A_45',
  /** 46x */
  A_46 = 'A_46',
  /** 47x */
  A_47 = 'A_47',
  /** 48x */
  A_48 = 'A_48',
  /** 49x */
  A_49 = 'A_49',
  /** 50x */
  A_50 = 'A_50',
  /** 51x */
  A_51 = 'A_51',
  /** 52x */
  A_52 = 'A_52',
  /** 53x */
  A_53 = 'A_53',
  /** 54x */
  A_54 = 'A_54',
  /** 55x */
  A_55 = 'A_55',
  /** 56x */
  A_56 = 'A_56',
  /** 57x */
  A_57 = 'A_57',
  /** 58x */
  A_58 = 'A_58',
  /** 59x */
  A_59 = 'A_59',
  /** 60x */
  A_60 = 'A_60',
  /** 61x */
  A_61 = 'A_61',
  /** 62x */
  A_62 = 'A_62',
  /** 63x */
  A_63 = 'A_63',
  /** 64x */
  A_64 = 'A_64',
  /** 65x */
  A_65 = 'A_65',
  /** 66x */
  A_66 = 'A_66',
  /** 67x */
  A_67 = 'A_67',
  /** 68x */
  A_68 = 'A_68',
  /** 69x */
  A_69 = 'A_69',
  /** 70x */
  A_70 = 'A_70',
  /** 71x */
  A_71 = 'A_71',
  /** 72x */
  A_72 = 'A_72',
  /** 73x */
  A_73 = 'A_73',
  /** 74x */
  A_74 = 'A_74',
  /** 75x */
  A_75 = 'A_75',
  /** 76x */
  A_76 = 'A_76',
  /** 77x */
  A_77 = 'A_77',
  /** 78x */
  A_78 = 'A_78',
  /** 79x */
  A_79 = 'A_79',
  /** 80x */
  A_80 = 'A_80',
  /** 81x */
  A_81 = 'A_81',
  /** 82x */
  A_82 = 'A_82',
  /** 83x */
  A_83 = 'A_83',
  /** 84x */
  A_84 = 'A_84',
  /** 85x */
  A_85 = 'A_85',
  /** 86x */
  A_86 = 'A_86',
  /** 87x */
  A_87 = 'A_87',
  /** 88x */
  A_88 = 'A_88',
  /** 89x */
  A_89 = 'A_89',
  /** 90x */
  A_90 = 'A_90',
  /** 91x */
  A_91 = 'A_91',
  /** 92x */
  A_92 = 'A_92',
  /** 93x */
  A_93 = 'A_93',
  /** 94x */
  A_94 = 'A_94',
  /** 95x */
  A_95 = 'A_95',
  /** 96x */
  A_96 = 'A_96',
  /** 97x */
  A_97 = 'A_97',
  /** 98x */
  A_98 = 'A_98',
  /** 99x */
  A_99 = 'A_99',
  /** 100x */
  A_100 = 'A_100',
  /** 101x */
  A_101 = 'A_101',
  /** 102x */
  A_102 = 'A_102',
  /** 103x */
  A_103 = 'A_103',
  /** 104x */
  A_104 = 'A_104',
  /** 105x */
  A_105 = 'A_105',
  /** 106x */
  A_106 = 'A_106',
  /** 107x */
  A_107 = 'A_107',
  /** 108x */
  A_108 = 'A_108',
  /** 109x */
  A_109 = 'A_109',
  /** 110x */
  A_110 = 'A_110',
  /** 111x */
  A_111 = 'A_111',
  /** 112x */
  A_112 = 'A_112',
  /** 113x */
  A_113 = 'A_113',
  /** 114x */
  A_114 = 'A_114',
  /** 115x */
  A_115 = 'A_115',
  /** 116x */
  A_116 = 'A_116',
  /** 117x */
  A_117 = 'A_117',
  /** 118x */
  A_118 = 'A_118',
  /** 119x */
  A_119 = 'A_119',
  /** 120x */
  A_120 = 'A_120',
  /** 121x */
  A_121 = 'A_121',
  /** 122x */
  A_122 = 'A_122',
  /** 123x */
  A_123 = 'A_123',
  /** 124x */
  A_124 = 'A_124',
  /** 125x */
  A_125 = 'A_125',
  /** 126x */
  A_126 = 'A_126',
  /** 127x */
  A_127 = 'A_127',
  /** 128x */
  A_128 = 'A_128',
  /** 129x */
  A_129 = 'A_129',
  /** 130x */
  A_130 = 'A_130',
  /** 131x */
  A_131 = 'A_131',
  /** 132x */
  A_132 = 'A_132',
  /** 133x */
  A_133 = 'A_133',
  /** 134x */
  A_134 = 'A_134',
  /** 135x */
  A_135 = 'A_135',
  /** 136x */
  A_136 = 'A_136',
  /** 137x */
  A_137 = 'A_137',
  /** 138x */
  A_138 = 'A_138',
  /** 139x */
  A_139 = 'A_139',
  /** 140x */
  A_140 = 'A_140',
  /** 141x */
  A_141 = 'A_141',
  /** 142x */
  A_142 = 'A_142',
  /** 143x */
  A_143 = 'A_143',
  /** 144x */
  A_144 = 'A_144',
  /** 145x */
  A_145 = 'A_145',
  /** 146x */
  A_146 = 'A_146',
  /** 147x */
  A_147 = 'A_147',
  /** 148x */
  A_148 = 'A_148',
  /** 149x */
  A_149 = 'A_149',
  /** 150x */
  A_150 = 'A_150',
  /** 151x */
  A_151 = 'A_151',
  /** 152x */
  A_152 = 'A_152',
  /** 153x */
  A_153 = 'A_153',
  /** 154x */
  A_154 = 'A_154',
  /** 155x */
  A_155 = 'A_155',
  /** 156x */
  A_156 = 'A_156',
  /** 157x */
  A_157 = 'A_157',
  /** 158x */
  A_158 = 'A_158',
  /** 159x */
  A_159 = 'A_159',
  /** 160x */
  A_160 = 'A_160',
  /** 161x */
  A_161 = 'A_161',
  /** 162x */
  A_162 = 'A_162',
  /** 163x */
  A_163 = 'A_163',
  /** 164x */
  A_164 = 'A_164',
  /** 165x */
  A_165 = 'A_165',
  /** 166x */
  A_166 = 'A_166',
  /** 167x */
  A_167 = 'A_167',
  /** 168x */
  A_168 = 'A_168',
  /** 169x */
  A_169 = 'A_169',
  /** 170x */
  A_170 = 'A_170',
  /** 171x */
  A_171 = 'A_171',
  /** 172x */
  A_172 = 'A_172',
  /** 173x */
  A_173 = 'A_173',
  /** 174x */
  A_174 = 'A_174',
  /** 175x */
  A_175 = 'A_175',
  /** 176x */
  A_176 = 'A_176',
  /** 177x */
  A_177 = 'A_177',
  /** 178x */
  A_178 = 'A_178',
  /** 179x */
  A_179 = 'A_179',
  /** 180x */
  A_180 = 'A_180',
  /** 181x */
  A_181 = 'A_181',
  /** 182x */
  A_182 = 'A_182',
  /** 183x */
  A_183 = 'A_183',
  /** 184x */
  A_184 = 'A_184',
  /** 185x */
  A_185 = 'A_185',
  /** 186x */
  A_186 = 'A_186',
  /** 187x */
  A_187 = 'A_187',
  /** 188x */
  A_188 = 'A_188',
  /** 189x */
  A_189 = 'A_189',
  /** 190x */
  A_190 = 'A_190',
  /** 191x */
  A_191 = 'A_191',
  /** 192x */
  A_192 = 'A_192',
  /** 193x */
  A_193 = 'A_193',
  /** 194x */
  A_194 = 'A_194',
  /** 195x */
  A_195 = 'A_195',
  /** 196x */
  A_196 = 'A_196',
  /** 197x */
  A_197 = 'A_197',
  /** 198x */
  A_198 = 'A_198',
  /** 199x */
  A_199 = 'A_199',
  /** 200x */
  A_200 = 'A_200',
  /** 201x */
  A_201 = 'A_201',
  /** 202x */
  A_202 = 'A_202',
  /** 203x */
  A_203 = 'A_203',
  /** 204x */
  A_204 = 'A_204',
  /** 205x */
  A_205 = 'A_205',
  /** 206x */
  A_206 = 'A_206',
  /** 207x */
  A_207 = 'A_207',
  /** 208x */
  A_208 = 'A_208',
  /** 209x */
  A_209 = 'A_209',
  /** 210x */
  A_210 = 'A_210',
  /** 211x */
  A_211 = 'A_211',
  /** 212x */
  A_212 = 'A_212',
  /** 213x */
  A_213 = 'A_213',
  /** 214x */
  A_214 = 'A_214',
  /** 215x */
  A_215 = 'A_215',
  /** 216x */
  A_216 = 'A_216',
  /** 217x */
  A_217 = 'A_217',
  /** 218x */
  A_218 = 'A_218',
  /** 219x */
  A_219 = 'A_219',
  /** 220x */
  A_220 = 'A_220',
  /** 221x */
  A_221 = 'A_221',
  /** 222x */
  A_222 = 'A_222',
  /** 223x */
  A_223 = 'A_223',
  /** 224x */
  A_224 = 'A_224',
  /** 225x */
  A_225 = 'A_225',
  /** 226x */
  A_226 = 'A_226',
  /** 227x */
  A_227 = 'A_227',
  /** 228x */
  A_228 = 'A_228',
  /** 229x */
  A_229 = 'A_229',
  /** 230x */
  A_230 = 'A_230',
  /** 231x */
  A_231 = 'A_231',
  /** 232x */
  A_232 = 'A_232',
  /** 233x */
  A_233 = 'A_233',
  /** 234x */
  A_234 = 'A_234',
  /** 235x */
  A_235 = 'A_235',
  /** 236x */
  A_236 = 'A_236',
  /** 237x */
  A_237 = 'A_237',
  /** 238x */
  A_238 = 'A_238',
  /** 239x */
  A_239 = 'A_239',
  /** 240x */
  A_240 = 'A_240',
  /** 241x */
  A_241 = 'A_241',
  /** 242x */
  A_242 = 'A_242',
  /** 243x */
  A_243 = 'A_243',
  /** 244x */
  A_244 = 'A_244',
  /** 245x */
  A_245 = 'A_245',
  /** 246x */
  A_246 = 'A_246',
  /** 247x */
  A_247 = 'A_247',
  /** 248x */
  A_248 = 'A_248',
  /** 249x */
  A_249 = 'A_249',
  /** 250x */
  A_250 = 'A_250',
  /** 251x */
  A_251 = 'A_251',
  /** 252x */
  A_252 = 'A_252',
  /** 253x */
  A_253 = 'A_253',
  /** 254x */
  A_254 = 'A_254',
  /** 255x */
  A_255 = 'A_255',
  /** 256x */
  A_256 = 'A_256',
  /** 257x */
  A_257 = 'A_257',
  /** 258x */
  A_258 = 'A_258',
  /** 259x */
  A_259 = 'A_259',
  /** 260x */
  A_260 = 'A_260',
  /** 261x */
  A_261 = 'A_261',
  /** 262x */
  A_262 = 'A_262',
  /** 263x */
  A_263 = 'A_263',
  /** 264x */
  A_264 = 'A_264',
  /** 265x */
  A_265 = 'A_265',
  /** 266x */
  A_266 = 'A_266',
  /** 267x */
  A_267 = 'A_267',
  /** 268x */
  A_268 = 'A_268',
  /** 269x */
  A_269 = 'A_269',
  /** 270x */
  A_270 = 'A_270',
  /** 271x */
  A_271 = 'A_271',
  /** 272x */
  A_272 = 'A_272',
  /** 273x */
  A_273 = 'A_273',
  /** 274x */
  A_274 = 'A_274',
  /** 275x */
  A_275 = 'A_275',
  /** 276x */
  A_276 = 'A_276',
  /** 277x */
  A_277 = 'A_277',
  /** 278x */
  A_278 = 'A_278',
  /** 279x */
  A_279 = 'A_279',
  /** 280x */
  A_280 = 'A_280',
  /** 281x */
  A_281 = 'A_281',
  /** 282x */
  A_282 = 'A_282',
  /** 283x */
  A_283 = 'A_283',
  /** 284x */
  A_284 = 'A_284',
  /** 285x */
  A_285 = 'A_285',
  /** 286x */
  A_286 = 'A_286',
  /** 287x */
  A_287 = 'A_287',
  /** 288x */
  A_288 = 'A_288',
  /** 289x */
  A_289 = 'A_289',
  /** 290x */
  A_290 = 'A_290',
  /** 291x */
  A_291 = 'A_291',
  /** 292x */
  A_292 = 'A_292',
  /** 293x */
  A_293 = 'A_293',
  /** 294x */
  A_294 = 'A_294',
  /** 295x */
  A_295 = 'A_295',
  /** 296x */
  A_296 = 'A_296',
  /** 297x */
  A_297 = 'A_297',
  /** 298x */
  A_298 = 'A_298',
  /** 299x */
  A_299 = 'A_299',
  /** 300x */
  A_300 = 'A_300',
  /** 301x */
  A_301 = 'A_301',
  /** 302x */
  A_302 = 'A_302',
  /** 303x */
  A_303 = 'A_303',
  /** 304x */
  A_304 = 'A_304',
  /** 305x */
  A_305 = 'A_305',
  /** 306x */
  A_306 = 'A_306',
  /** 307x */
  A_307 = 'A_307',
  /** 308x */
  A_308 = 'A_308',
  /** 309x */
  A_309 = 'A_309',
  /** 310x */
  A_310 = 'A_310',
  /** 311x */
  A_311 = 'A_311',
  /** 312x */
  A_312 = 'A_312',
  /** 313x */
  A_313 = 'A_313',
  /** 314x */
  A_314 = 'A_314',
  /** 315x */
  A_315 = 'A_315',
  /** 316x */
  A_316 = 'A_316',
  /** 317x */
  A_317 = 'A_317',
  /** 318x */
  A_318 = 'A_318',
  /** 319x */
  A_319 = 'A_319',
  /** 320x */
  A_320 = 'A_320',
  /** 321x */
  A_321 = 'A_321',
  /** 322x */
  A_322 = 'A_322',
  /** 323x */
  A_323 = 'A_323',
  /** 324x */
  A_324 = 'A_324',
  /** 325x */
  A_325 = 'A_325',
  /** 326x */
  A_326 = 'A_326',
  /** 327x */
  A_327 = 'A_327',
  /** 328x */
  A_328 = 'A_328',
  /** 329x */
  A_329 = 'A_329',
  /** 330x */
  A_330 = 'A_330',
  /** 331x */
  A_331 = 'A_331',
  /** 332x */
  A_332 = 'A_332',
  /** 333x */
  A_333 = 'A_333',
  /** 334x */
  A_334 = 'A_334',
  /** 335x */
  A_335 = 'A_335',
  /** 336x */
  A_336 = 'A_336',
  /** 337x */
  A_337 = 'A_337',
  /** 338x */
  A_338 = 'A_338',
  /** 339x */
  A_339 = 'A_339',
  /** 340x */
  A_340 = 'A_340',
  /** 341x */
  A_341 = 'A_341',
  /** 342x */
  A_342 = 'A_342',
  /** 343x */
  A_343 = 'A_343',
  /** 344x */
  A_344 = 'A_344',
  /** 345x */
  A_345 = 'A_345',
  /** 346x */
  A_346 = 'A_346',
  /** 347x */
  A_347 = 'A_347',
  /** 348x */
  A_348 = 'A_348',
  /** 349x */
  A_349 = 'A_349',
  /** 350x */
  A_350 = 'A_350',
  /** 351x */
  A_351 = 'A_351',
  /** 352x */
  A_352 = 'A_352',
  /** 353x */
  A_353 = 'A_353',
  /** 354x */
  A_354 = 'A_354',
  /** 355x */
  A_355 = 'A_355',
  /** 356x */
  A_356 = 'A_356',
  /** 357x */
  A_357 = 'A_357',
  /** 358x */
  A_358 = 'A_358',
  /** 359x */
  A_359 = 'A_359',
  /** 360x */
  A_360 = 'A_360',
  /** 361x */
  A_361 = 'A_361',
  /** 362x */
  A_362 = 'A_362',
  /** 363x */
  A_363 = 'A_363',
  /** 364x */
  A_364 = 'A_364',
  /** 365x */
  A_365 = 'A_365',
  /** 366x */
  A_366 = 'A_366',
  /** 367x */
  A_367 = 'A_367',
  /** 368x */
  A_368 = 'A_368',
  /** 369x */
  A_369 = 'A_369',
  /** 370x */
  A_370 = 'A_370',
  /** 371x */
  A_371 = 'A_371',
  /** 372x */
  A_372 = 'A_372',
  /** 373x */
  A_373 = 'A_373',
  /** 374x */
  A_374 = 'A_374',
  /** 375x */
  A_375 = 'A_375',
  /** 376x */
  A_376 = 'A_376',
  /** 377x */
  A_377 = 'A_377',
  /** 378x */
  A_378 = 'A_378',
  /** 379x */
  A_379 = 'A_379',
  /** 380x */
  A_380 = 'A_380',
  /** 381x */
  A_381 = 'A_381',
  /** 382x */
  A_382 = 'A_382',
  /** 383x */
  A_383 = 'A_383',
  /** 384x */
  A_384 = 'A_384',
  /** 385x */
  A_385 = 'A_385',
  /** 386x */
  A_386 = 'A_386',
  /** 387x */
  A_387 = 'A_387',
  /** 388x */
  A_388 = 'A_388',
  /** 389x */
  A_389 = 'A_389',
  /** 390x */
  A_390 = 'A_390',
  /** 391x */
  A_391 = 'A_391',
  /** 392x */
  A_392 = 'A_392',
  /** 393x */
  A_393 = 'A_393',
  /** 394x */
  A_394 = 'A_394',
  /** 395x */
  A_395 = 'A_395',
  /** 396x */
  A_396 = 'A_396',
  /** 397x */
  A_397 = 'A_397',
  /** 398x */
  A_398 = 'A_398',
  /** 399x */
  A_399 = 'A_399',
  /** 400x */
  A_400 = 'A_400',
  /** 401x */
  A_401 = 'A_401',
  /** 402x */
  A_402 = 'A_402',
  /** 403x */
  A_403 = 'A_403',
  /** 404x */
  A_404 = 'A_404',
  /** 405x */
  A_405 = 'A_405',
  /** 406x */
  A_406 = 'A_406',
  /** 407x */
  A_407 = 'A_407',
  /** 408x */
  A_408 = 'A_408',
  /** 409x */
  A_409 = 'A_409',
  /** 410x */
  A_410 = 'A_410',
  /** 411x */
  A_411 = 'A_411',
  /** 412x */
  A_412 = 'A_412',
  /** 413x */
  A_413 = 'A_413',
  /** 414x */
  A_414 = 'A_414',
  /** 415x */
  A_415 = 'A_415',
  /** 416x */
  A_416 = 'A_416',
  /** 417x */
  A_417 = 'A_417',
  /** 418x */
  A_418 = 'A_418',
  /** 419x */
  A_419 = 'A_419',
  /** 420x */
  A_420 = 'A_420',
  /** 421x */
  A_421 = 'A_421',
  /** 422x */
  A_422 = 'A_422',
  /** 423x */
  A_423 = 'A_423',
  /** 424x */
  A_424 = 'A_424',
  /** 425x */
  A_425 = 'A_425',
  /** 426x */
  A_426 = 'A_426',
  /** 427x */
  A_427 = 'A_427',
  /** 428x */
  A_428 = 'A_428',
  /** 429x */
  A_429 = 'A_429',
  /** 430x */
  A_430 = 'A_430',
  /** 431x */
  A_431 = 'A_431',
  /** 432x */
  A_432 = 'A_432',
  /** 433x */
  A_433 = 'A_433',
  /** 434x */
  A_434 = 'A_434',
  /** 435x */
  A_435 = 'A_435',
  /** 436x */
  A_436 = 'A_436',
  /** 437x */
  A_437 = 'A_437',
  /** 438x */
  A_438 = 'A_438',
  /** 439x */
  A_439 = 'A_439',
  /** 440x */
  A_440 = 'A_440',
  /** 441x */
  A_441 = 'A_441',
  /** 442x */
  A_442 = 'A_442',
  /** 443x */
  A_443 = 'A_443',
  /** 444x */
  A_444 = 'A_444',
  /** 445x */
  A_445 = 'A_445',
  /** 446x */
  A_446 = 'A_446',
  /** 447x */
  A_447 = 'A_447',
  /** 448x */
  A_448 = 'A_448',
  /** 449x */
  A_449 = 'A_449',
  /** 450x */
  A_450 = 'A_450',
  /** 451x */
  A_451 = 'A_451',
  /** 452x */
  A_452 = 'A_452',
  /** 453x */
  A_453 = 'A_453',
  /** 454x */
  A_454 = 'A_454',
  /** 455x */
  A_455 = 'A_455',
  /** 456x */
  A_456 = 'A_456',
  /** 457x */
  A_457 = 'A_457',
  /** 458x */
  A_458 = 'A_458',
  /** 459x */
  A_459 = 'A_459',
  /** 460x */
  A_460 = 'A_460',
  /** 461x */
  A_461 = 'A_461',
  /** 462x */
  A_462 = 'A_462',
  /** 463x */
  A_463 = 'A_463',
  /** 464x */
  A_464 = 'A_464',
  /** 465x */
  A_465 = 'A_465',
  /** 466x */
  A_466 = 'A_466',
  /** 467x */
  A_467 = 'A_467',
  /** 468x */
  A_468 = 'A_468',
  /** 469x */
  A_469 = 'A_469',
  /** 470x */
  A_470 = 'A_470',
  /** 471x */
  A_471 = 'A_471',
  /** 472x */
  A_472 = 'A_472',
  /** 473x */
  A_473 = 'A_473',
  /** 474x */
  A_474 = 'A_474',
  /** 475x */
  A_475 = 'A_475',
  /** 476x */
  A_476 = 'A_476',
  /** 477x */
  A_477 = 'A_477',
  /** 478x */
  A_478 = 'A_478',
  /** 479x */
  A_479 = 'A_479',
  /** 480x */
  A_480 = 'A_480',
  /** 481x */
  A_481 = 'A_481',
  /** 482x */
  A_482 = 'A_482',
  /** 483x */
  A_483 = 'A_483',
  /** 484x */
  A_484 = 'A_484',
  /** 485x */
  A_485 = 'A_485',
  /** 486x */
  A_486 = 'A_486',
  /** 487x */
  A_487 = 'A_487',
  /** 488x */
  A_488 = 'A_488',
  /** 489x */
  A_489 = 'A_489',
  /** 490x */
  A_490 = 'A_490',
  /** 491x */
  A_491 = 'A_491',
  /** 492x */
  A_492 = 'A_492',
  /** 493x */
  A_493 = 'A_493',
  /** 494x */
  A_494 = 'A_494',
  /** 495x */
  A_495 = 'A_495',
  /** 496x */
  A_496 = 'A_496',
  /** 497x */
  A_497 = 'A_497',
  /** 498x */
  A_498 = 'A_498',
  /** 499x */
  A_499 = 'A_499',
  /** 500x */
  A_500 = 'A_500',
  /** 501x */
  A_501 = 'A_501',
  /** 502x */
  A_502 = 'A_502',
  /** 503x */
  A_503 = 'A_503',
  /** 504x */
  A_504 = 'A_504',
  /** 505x */
  A_505 = 'A_505',
  /** 506x */
  A_506 = 'A_506',
  /** 507x */
  A_507 = 'A_507',
  /** 508x */
  A_508 = 'A_508',
  /** 509x */
  A_509 = 'A_509',
  /** 510x */
  A_510 = 'A_510',
  /** 511x */
  A_511 = 'A_511',
  /** 512x */
  A_512 = 'A_512',
  /** 513x */
  A_513 = 'A_513',
  /** 514x */
  A_514 = 'A_514',
  /** 515x */
  A_515 = 'A_515',
  /** 516x */
  A_516 = 'A_516',
  /** 517x */
  A_517 = 'A_517',
  /** 518x */
  A_518 = 'A_518',
  /** 519x */
  A_519 = 'A_519',
  /** 520x */
  A_520 = 'A_520',
  /** 521x */
  A_521 = 'A_521',
  /** 522x */
  A_522 = 'A_522',
  /** 523x */
  A_523 = 'A_523',
  /** 524x */
  A_524 = 'A_524',
  /** 525x */
  A_525 = 'A_525',
  /** 526x */
  A_526 = 'A_526',
  /** 527x */
  A_527 = 'A_527',
  /** 528x */
  A_528 = 'A_528',
  /** 529x */
  A_529 = 'A_529',
  /** 530x */
  A_530 = 'A_530',
  /** 531x */
  A_531 = 'A_531',
  /** 532x */
  A_532 = 'A_532',
  /** 533x */
  A_533 = 'A_533',
  /** 534x */
  A_534 = 'A_534',
  /** 535x */
  A_535 = 'A_535',
  /** 536x */
  A_536 = 'A_536',
  /** 537x */
  A_537 = 'A_537',
  /** 538x */
  A_538 = 'A_538',
  /** 539x */
  A_539 = 'A_539',
  /** 540x */
  A_540 = 'A_540',
  /** 541x */
  A_541 = 'A_541',
  /** 542x */
  A_542 = 'A_542',
  /** 543x */
  A_543 = 'A_543',
  /** 544x */
  A_544 = 'A_544',
  /** 545x */
  A_545 = 'A_545',
  /** 546x */
  A_546 = 'A_546',
  /** 547x */
  A_547 = 'A_547',
  /** 548x */
  A_548 = 'A_548',
  /** 549x */
  A_549 = 'A_549',
  /** 550x */
  A_550 = 'A_550',
  /** 551x */
  A_551 = 'A_551',
  /** 552x */
  A_552 = 'A_552',
  /** 553x */
  A_553 = 'A_553',
  /** 554x */
  A_554 = 'A_554',
  /** 555x */
  A_555 = 'A_555',
  /** 556x */
  A_556 = 'A_556',
  /** 557x */
  A_557 = 'A_557',
  /** 558x */
  A_558 = 'A_558',
  /** 559x */
  A_559 = 'A_559',
  /** 560x */
  A_560 = 'A_560',
  /** 561x */
  A_561 = 'A_561',
  /** 562x */
  A_562 = 'A_562',
  /** 563x */
  A_563 = 'A_563',
  /** 564x */
  A_564 = 'A_564',
  /** 565x */
  A_565 = 'A_565',
  /** 566x */
  A_566 = 'A_566',
  /** 567x */
  A_567 = 'A_567',
  /** 568x */
  A_568 = 'A_568',
  /** 569x */
  A_569 = 'A_569',
  /** 570x */
  A_570 = 'A_570',
  /** 571x */
  A_571 = 'A_571',
  /** 572x */
  A_572 = 'A_572',
  /** 573x */
  A_573 = 'A_573',
  /** 574x */
  A_574 = 'A_574',
  /** 575x */
  A_575 = 'A_575',
  /** 576x */
  A_576 = 'A_576',
  /** 577x */
  A_577 = 'A_577',
  /** 578x */
  A_578 = 'A_578',
  /** 579x */
  A_579 = 'A_579',
  /** 580x */
  A_580 = 'A_580',
  /** 581x */
  A_581 = 'A_581',
  /** 582x */
  A_582 = 'A_582',
  /** 583x */
  A_583 = 'A_583',
  /** 584x */
  A_584 = 'A_584',
  /** 585x */
  A_585 = 'A_585',
  /** 586x */
  A_586 = 'A_586',
  /** 587x */
  A_587 = 'A_587',
  /** 588x */
  A_588 = 'A_588',
  /** 589x */
  A_589 = 'A_589',
  /** 590x */
  A_590 = 'A_590',
  /** 591x */
  A_591 = 'A_591',
  /** 592x */
  A_592 = 'A_592',
  /** 593x */
  A_593 = 'A_593',
  /** 594x */
  A_594 = 'A_594',
  /** 595x */
  A_595 = 'A_595',
  /** 596x */
  A_596 = 'A_596',
  /** 597x */
  A_597 = 'A_597',
  /** 598x */
  A_598 = 'A_598',
  /** 599x */
  A_599 = 'A_599',
  /** 600x */
  A_600 = 'A_600',
  /** 601x */
  A_601 = 'A_601',
  /** 602x */
  A_602 = 'A_602',
  /** 603x */
  A_603 = 'A_603',
  /** 604x */
  A_604 = 'A_604',
  /** 605x */
  A_605 = 'A_605',
  /** 606x */
  A_606 = 'A_606',
  /** 607x */
  A_607 = 'A_607',
  /** 608x */
  A_608 = 'A_608',
  /** 609x */
  A_609 = 'A_609',
  /** 610x */
  A_610 = 'A_610',
  /** 611x */
  A_611 = 'A_611',
  /** 612x */
  A_612 = 'A_612',
  /** 613x */
  A_613 = 'A_613',
  /** 614x */
  A_614 = 'A_614',
  /** 615x */
  A_615 = 'A_615',
  /** 616x */
  A_616 = 'A_616',
  /** 617x */
  A_617 = 'A_617',
  /** 618x */
  A_618 = 'A_618',
  /** 619x */
  A_619 = 'A_619',
  /** 620x */
  A_620 = 'A_620',
  /** 621x */
  A_621 = 'A_621',
  /** 622x */
  A_622 = 'A_622',
  /** 623x */
  A_623 = 'A_623',
  /** 624x */
  A_624 = 'A_624',
  /** 625x */
  A_625 = 'A_625',
  /** 626x */
  A_626 = 'A_626',
  /** 627x */
  A_627 = 'A_627',
  /** 628x */
  A_628 = 'A_628',
  /** 629x */
  A_629 = 'A_629',
  /** 630x */
  A_630 = 'A_630',
  /** 631x */
  A_631 = 'A_631',
  /** 632x */
  A_632 = 'A_632',
  /** 633x */
  A_633 = 'A_633',
  /** 634x */
  A_634 = 'A_634',
  /** 635x */
  A_635 = 'A_635',
  /** 636x */
  A_636 = 'A_636',
  /** 637x */
  A_637 = 'A_637',
  /** 638x */
  A_638 = 'A_638',
  /** 639x */
  A_639 = 'A_639',
  /** 640x */
  A_640 = 'A_640',
  /** 641x */
  A_641 = 'A_641',
  /** 642x */
  A_642 = 'A_642',
  /** 643x */
  A_643 = 'A_643',
  /** 644x */
  A_644 = 'A_644',
  /** 645x */
  A_645 = 'A_645',
  /** 646x */
  A_646 = 'A_646',
  /** 647x */
  A_647 = 'A_647',
  /** 648x */
  A_648 = 'A_648',
  /** 649x */
  A_649 = 'A_649',
  /** 650x */
  A_650 = 'A_650',
  /** 651x */
  A_651 = 'A_651',
  /** 652x */
  A_652 = 'A_652',
  /** 653x */
  A_653 = 'A_653',
  /** 654x */
  A_654 = 'A_654',
  /** 655x */
  A_655 = 'A_655',
  /** 656x */
  A_656 = 'A_656',
  /** 657x */
  A_657 = 'A_657',
  /** 658x */
  A_658 = 'A_658',
  /** 659x */
  A_659 = 'A_659',
  /** 660x */
  A_660 = 'A_660',
  /** 661x */
  A_661 = 'A_661',
  /** 662x */
  A_662 = 'A_662',
  /** 663x */
  A_663 = 'A_663',
  /** 664x */
  A_664 = 'A_664',
  /** 665x */
  A_665 = 'A_665',
  /** 666x */
  A_666 = 'A_666',
  /** 667x */
  A_667 = 'A_667',
  /** 668x */
  A_668 = 'A_668',
  /** 669x */
  A_669 = 'A_669',
  /** 670x */
  A_670 = 'A_670',
  /** 671x */
  A_671 = 'A_671',
  /** 672x */
  A_672 = 'A_672',
  /** 673x */
  A_673 = 'A_673',
  /** 674x */
  A_674 = 'A_674',
  /** 675x */
  A_675 = 'A_675',
  /** 676x */
  A_676 = 'A_676',
  /** 677x */
  A_677 = 'A_677',
  /** 678x */
  A_678 = 'A_678',
  /** 679x */
  A_679 = 'A_679',
  /** 680x */
  A_680 = 'A_680',
  /** 681x */
  A_681 = 'A_681',
  /** 682x */
  A_682 = 'A_682',
  /** 683x */
  A_683 = 'A_683',
  /** 684x */
  A_684 = 'A_684',
  /** 685x */
  A_685 = 'A_685',
  /** 686x */
  A_686 = 'A_686',
  /** 687x */
  A_687 = 'A_687',
  /** 688x */
  A_688 = 'A_688',
  /** 689x */
  A_689 = 'A_689',
  /** 690x */
  A_690 = 'A_690',
  /** 691x */
  A_691 = 'A_691',
  /** 692x */
  A_692 = 'A_692',
  /** 693x */
  A_693 = 'A_693',
  /** 694x */
  A_694 = 'A_694',
  /** 695x */
  A_695 = 'A_695',
  /** 696x */
  A_696 = 'A_696',
  /** 697x */
  A_697 = 'A_697',
  /** 698x */
  A_698 = 'A_698',
  /** 699x */
  A_699 = 'A_699',
  /** 700x */
  A_700 = 'A_700',
  /** 701x */
  A_701 = 'A_701',
  /** 702x */
  A_702 = 'A_702',
  /** 703x */
  A_703 = 'A_703',
  /** 704x */
  A_704 = 'A_704',
  /** 705x */
  A_705 = 'A_705',
  /** 706x */
  A_706 = 'A_706',
  /** 707x */
  A_707 = 'A_707',
  /** 708x */
  A_708 = 'A_708',
  /** 709x */
  A_709 = 'A_709',
  /** 710x */
  A_710 = 'A_710',
  /** 711x */
  A_711 = 'A_711',
  /** 712x */
  A_712 = 'A_712',
  /** 713x */
  A_713 = 'A_713',
  /** 714x */
  A_714 = 'A_714',
  /** 715x */
  A_715 = 'A_715',
  /** 716x */
  A_716 = 'A_716',
  /** 717x */
  A_717 = 'A_717',
  /** 718x */
  A_718 = 'A_718',
  /** 719x */
  A_719 = 'A_719',
  /** 720x */
  A_720 = 'A_720',
  /** 721x */
  A_721 = 'A_721',
  /** 722x */
  A_722 = 'A_722',
  /** 723x */
  A_723 = 'A_723',
  /** 724x */
  A_724 = 'A_724',
  /** 725x */
  A_725 = 'A_725',
  /** 726x */
  A_726 = 'A_726',
  /** 727x */
  A_727 = 'A_727',
  /** 728x */
  A_728 = 'A_728',
  /** 729x */
  A_729 = 'A_729',
  /** 730x */
  A_730 = 'A_730',
  /** 731x */
  A_731 = 'A_731',
  /** 732x */
  A_732 = 'A_732',
  /** 733x */
  A_733 = 'A_733',
  /** 734x */
  A_734 = 'A_734',
  /** 735x */
  A_735 = 'A_735',
  /** 736x */
  A_736 = 'A_736',
  /** 737x */
  A_737 = 'A_737',
  /** 738x */
  A_738 = 'A_738',
  /** 739x */
  A_739 = 'A_739',
  /** 740x */
  A_740 = 'A_740',
  /** 741x */
  A_741 = 'A_741',
  /** 742x */
  A_742 = 'A_742',
  /** 743x */
  A_743 = 'A_743',
  /** 744x */
  A_744 = 'A_744',
  /** 745x */
  A_745 = 'A_745',
  /** 746x */
  A_746 = 'A_746',
  /** 747x */
  A_747 = 'A_747',
  /** 748x */
  A_748 = 'A_748',
  /** 749x */
  A_749 = 'A_749',
  /** 750x */
  A_750 = 'A_750',
  /** 751x */
  A_751 = 'A_751',
  /** 752x */
  A_752 = 'A_752',
  /** 753x */
  A_753 = 'A_753',
  /** 754x */
  A_754 = 'A_754',
  /** 755x */
  A_755 = 'A_755',
  /** 756x */
  A_756 = 'A_756',
  /** 757x */
  A_757 = 'A_757',
  /** 758x */
  A_758 = 'A_758',
  /** 759x */
  A_759 = 'A_759',
  /** 760x */
  A_760 = 'A_760',
  /** 761x */
  A_761 = 'A_761',
  /** 762x */
  A_762 = 'A_762',
  /** 763x */
  A_763 = 'A_763',
  /** 764x */
  A_764 = 'A_764',
  /** 765x */
  A_765 = 'A_765',
  /** 766x */
  A_766 = 'A_766',
  /** 767x */
  A_767 = 'A_767',
  /** 768x */
  A_768 = 'A_768',
  /** 769x */
  A_769 = 'A_769',
  /** 770x */
  A_770 = 'A_770',
  /** 771x */
  A_771 = 'A_771',
  /** 772x */
  A_772 = 'A_772',
  /** 773x */
  A_773 = 'A_773',
  /** 774x */
  A_774 = 'A_774',
  /** 775x */
  A_775 = 'A_775',
  /** 776x */
  A_776 = 'A_776',
  /** 777x */
  A_777 = 'A_777',
  /** 778x */
  A_778 = 'A_778',
  /** 779x */
  A_779 = 'A_779',
  /** 780x */
  A_780 = 'A_780',
  /** 781x */
  A_781 = 'A_781',
  /** 782x */
  A_782 = 'A_782',
  /** 783x */
  A_783 = 'A_783',
  /** 784x */
  A_784 = 'A_784',
  /** 785x */
  A_785 = 'A_785',
  /** 786x */
  A_786 = 'A_786',
  /** 787x */
  A_787 = 'A_787',
  /** 788x */
  A_788 = 'A_788',
  /** 789x */
  A_789 = 'A_789',
  /** 790x */
  A_790 = 'A_790',
  /** 791x */
  A_791 = 'A_791',
  /** 792x */
  A_792 = 'A_792',
  /** 793x */
  A_793 = 'A_793',
  /** 794x */
  A_794 = 'A_794',
  /** 795x */
  A_795 = 'A_795',
  /** 796x */
  A_796 = 'A_796',
  /** 797x */
  A_797 = 'A_797',
  /** 798x */
  A_798 = 'A_798',
  /** 799x */
  A_799 = 'A_799',
  /** 800x */
  A_800 = 'A_800',
  /** 801x */
  A_801 = 'A_801',
  /** 802x */
  A_802 = 'A_802',
  /** 803x */
  A_803 = 'A_803',
  /** 804x */
  A_804 = 'A_804',
  /** 805x */
  A_805 = 'A_805',
  /** 806x */
  A_806 = 'A_806',
  /** 807x */
  A_807 = 'A_807',
  /** 808x */
  A_808 = 'A_808',
  /** 809x */
  A_809 = 'A_809',
  /** 810x */
  A_810 = 'A_810',
  /** 811x */
  A_811 = 'A_811',
  /** 812x */
  A_812 = 'A_812',
  /** 813x */
  A_813 = 'A_813',
  /** 814x */
  A_814 = 'A_814',
  /** 815x */
  A_815 = 'A_815',
  /** 816x */
  A_816 = 'A_816',
  /** 817x */
  A_817 = 'A_817',
  /** 818x */
  A_818 = 'A_818',
  /** 819x */
  A_819 = 'A_819',
  /** 820x */
  A_820 = 'A_820',
  /** 821x */
  A_821 = 'A_821',
  /** 822x */
  A_822 = 'A_822',
  /** 823x */
  A_823 = 'A_823',
  /** 824x */
  A_824 = 'A_824',
  /** 825x */
  A_825 = 'A_825',
  /** 826x */
  A_826 = 'A_826',
  /** 827x */
  A_827 = 'A_827',
  /** 828x */
  A_828 = 'A_828',
  /** 829x */
  A_829 = 'A_829',
  /** 830x */
  A_830 = 'A_830',
  /** 831x */
  A_831 = 'A_831',
  /** 832x */
  A_832 = 'A_832',
  /** 833x */
  A_833 = 'A_833',
  /** 834x */
  A_834 = 'A_834',
  /** 835x */
  A_835 = 'A_835',
  /** 836x */
  A_836 = 'A_836',
  /** 837x */
  A_837 = 'A_837',
  /** 838x */
  A_838 = 'A_838',
  /** 839x */
  A_839 = 'A_839',
  /** 840x */
  A_840 = 'A_840',
  /** 841x */
  A_841 = 'A_841',
  /** 842x */
  A_842 = 'A_842',
  /** 843x */
  A_843 = 'A_843',
  /** 844x */
  A_844 = 'A_844',
  /** 845x */
  A_845 = 'A_845',
  /** 846x */
  A_846 = 'A_846',
  /** 847x */
  A_847 = 'A_847',
  /** 848x */
  A_848 = 'A_848',
  /** 849x */
  A_849 = 'A_849',
  /** 850x */
  A_850 = 'A_850',
  /** 851x */
  A_851 = 'A_851',
  /** 852x */
  A_852 = 'A_852',
  /** 853x */
  A_853 = 'A_853',
  /** 854x */
  A_854 = 'A_854',
  /** 855x */
  A_855 = 'A_855',
  /** 856x */
  A_856 = 'A_856',
  /** 857x */
  A_857 = 'A_857',
  /** 858x */
  A_858 = 'A_858',
  /** 859x */
  A_859 = 'A_859',
  /** 860x */
  A_860 = 'A_860',
  /** 861x */
  A_861 = 'A_861',
  /** 862x */
  A_862 = 'A_862',
  /** 863x */
  A_863 = 'A_863',
  /** 864x */
  A_864 = 'A_864',
  /** 865x */
  A_865 = 'A_865',
  /** 866x */
  A_866 = 'A_866',
  /** 867x */
  A_867 = 'A_867',
  /** 868x */
  A_868 = 'A_868',
  /** 869x */
  A_869 = 'A_869',
  /** 870x */
  A_870 = 'A_870',
  /** 871x */
  A_871 = 'A_871',
  /** 872x */
  A_872 = 'A_872',
  /** 873x */
  A_873 = 'A_873',
  /** 874x */
  A_874 = 'A_874',
  /** 875x */
  A_875 = 'A_875',
  /** 876x */
  A_876 = 'A_876',
  /** 877x */
  A_877 = 'A_877',
  /** 878x */
  A_878 = 'A_878',
  /** 879x */
  A_879 = 'A_879',
  /** 880x */
  A_880 = 'A_880',
  /** 881x */
  A_881 = 'A_881',
  /** 882x */
  A_882 = 'A_882',
  /** 883x */
  A_883 = 'A_883',
  /** 884x */
  A_884 = 'A_884',
  /** 885x */
  A_885 = 'A_885',
  /** 886x */
  A_886 = 'A_886',
  /** 887x */
  A_887 = 'A_887',
  /** 888x */
  A_888 = 'A_888',
  /** 889x */
  A_889 = 'A_889',
  /** 890x */
  A_890 = 'A_890',
  /** 891x */
  A_891 = 'A_891',
  /** 892x */
  A_892 = 'A_892',
  /** 893x */
  A_893 = 'A_893',
  /** 894x */
  A_894 = 'A_894',
  /** 895x */
  A_895 = 'A_895',
  /** 896x */
  A_896 = 'A_896',
  /** 897x */
  A_897 = 'A_897',
  /** 898x */
  A_898 = 'A_898',
  /** 899x */
  A_899 = 'A_899',
  /** 900x */
  A_900 = 'A_900',
  /** 901x */
  A_901 = 'A_901',
  /** 902x */
  A_902 = 'A_902',
  /** 903x */
  A_903 = 'A_903',
  /** 904x */
  A_904 = 'A_904',
  /** 905x */
  A_905 = 'A_905',
  /** 906x */
  A_906 = 'A_906',
  /** 907x */
  A_907 = 'A_907',
  /** 908x */
  A_908 = 'A_908',
  /** 909x */
  A_909 = 'A_909',
  /** 910x */
  A_910 = 'A_910',
  /** 911x */
  A_911 = 'A_911',
  /** 912x */
  A_912 = 'A_912',
  /** 913x */
  A_913 = 'A_913',
  /** 914x */
  A_914 = 'A_914',
  /** 915x */
  A_915 = 'A_915',
  /** 916x */
  A_916 = 'A_916',
  /** 917x */
  A_917 = 'A_917',
  /** 918x */
  A_918 = 'A_918',
  /** 919x */
  A_919 = 'A_919',
  /** 920x */
  A_920 = 'A_920',
  /** 921x */
  A_921 = 'A_921',
  /** 922x */
  A_922 = 'A_922',
  /** 923x */
  A_923 = 'A_923',
  /** 924x */
  A_924 = 'A_924',
  /** 925x */
  A_925 = 'A_925',
  /** 926x */
  A_926 = 'A_926',
  /** 927x */
  A_927 = 'A_927',
  /** 928x */
  A_928 = 'A_928',
  /** 929x */
  A_929 = 'A_929',
  /** 930x */
  A_930 = 'A_930',
  /** 931x */
  A_931 = 'A_931',
  /** 932x */
  A_932 = 'A_932',
  /** 933x */
  A_933 = 'A_933',
  /** 934x */
  A_934 = 'A_934',
  /** 935x */
  A_935 = 'A_935',
  /** 936x */
  A_936 = 'A_936',
  /** 937x */
  A_937 = 'A_937',
  /** 938x */
  A_938 = 'A_938',
  /** 939x */
  A_939 = 'A_939',
  /** 940x */
  A_940 = 'A_940',
  /** 941x */
  A_941 = 'A_941',
  /** 942x */
  A_942 = 'A_942',
  /** 943x */
  A_943 = 'A_943',
  /** 944x */
  A_944 = 'A_944',
  /** 945x */
  A_945 = 'A_945',
  /** 946x */
  A_946 = 'A_946',
  /** 947x */
  A_947 = 'A_947',
  /** 948x */
  A_948 = 'A_948',
  /** 949x */
  A_949 = 'A_949',
  /** 950x */
  A_950 = 'A_950',
  /** 951x */
  A_951 = 'A_951',
  /** 952x */
  A_952 = 'A_952',
  /** 953x */
  A_953 = 'A_953',
  /** 954x */
  A_954 = 'A_954',
  /** 955x */
  A_955 = 'A_955',
  /** 956x */
  A_956 = 'A_956',
  /** 957x */
  A_957 = 'A_957',
  /** 958x */
  A_958 = 'A_958',
  /** 959x */
  A_959 = 'A_959',
  /** 960x */
  A_960 = 'A_960',
  /** 961x */
  A_961 = 'A_961',
  /** 962x */
  A_962 = 'A_962',
  /** 963x */
  A_963 = 'A_963',
  /** 964x */
  A_964 = 'A_964',
  /** 965x */
  A_965 = 'A_965',
  /** 966x */
  A_966 = 'A_966',
  /** 967x */
  A_967 = 'A_967',
  /** 968x */
  A_968 = 'A_968',
  /** 969x */
  A_969 = 'A_969',
  /** 970x */
  A_970 = 'A_970',
  /** 971x */
  A_971 = 'A_971',
  /** 972x */
  A_972 = 'A_972',
  /** 973x */
  A_973 = 'A_973',
  /** 974x */
  A_974 = 'A_974',
  /** 975x */
  A_975 = 'A_975',
  /** 976x */
  A_976 = 'A_976',
  /** 977x */
  A_977 = 'A_977',
  /** 978x */
  A_978 = 'A_978',
  /** 979x */
  A_979 = 'A_979',
  /** 980x */
  A_980 = 'A_980',
  /** 981x */
  A_981 = 'A_981',
  /** 982x */
  A_982 = 'A_982',
  /** 983x */
  A_983 = 'A_983',
  /** 984x */
  A_984 = 'A_984',
  /** 985x */
  A_985 = 'A_985',
  /** 986x */
  A_986 = 'A_986',
  /** 987x */
  A_987 = 'A_987',
  /** 988x */
  A_988 = 'A_988',
  /** 989x */
  A_989 = 'A_989',
  /** 990x */
  A_990 = 'A_990',
  /** 991x */
  A_991 = 'A_991',
  /** 992x */
  A_992 = 'A_992',
  /** 993x */
  A_993 = 'A_993',
  /** 994x */
  A_994 = 'A_994',
  /** 995x */
  A_995 = 'A_995',
  /** 996x */
  A_996 = 'A_996',
  /** 997x */
  A_997 = 'A_997',
  /** 998x */
  A_998 = 'A_998',
  /** 999x */
  A_999 = 'A_999',
  /** 1000x */
  A_1000 = 'A_1000'
}

export type ColunaTaxasParcelasType = {
   __typename?: 'ColunaTaxasParcelasType',
  id: Scalars['ID'],
  tabelataxaparcelas: TabelaTaxaParcelasType,
  parcelas: ColunaTaxasParcelasParcelas,
  taxaLucro?: Maybe<Scalars['Float']>,
  taxaMinima?: Maybe<Scalars['Float']>,
  taxaSeguranca?: Maybe<Scalars['Float']>,
  taxas?: Maybe<TaxaColunaType>,
};

export type ComissaoFuncionarioNodeTypeRelay = Node & {
   __typename?: 'ComissaoFuncionarioNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  tipoComissao?: Maybe<ComissaoFuncionariosTipoComissao>,
  /** Esse parametro vai estar prenchido somento na COMISSAO_COLETIVA */
  funcionario?: Maybe<FuncionarioTypeRelay>,
  valorComissao: Scalars['Float'],
  emprestimo: EmprestimoRelatorioType,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateFuncionarioNodeTypeRelay>,
  detalhes: Scalars['String'],
  detalhesComissao?: Maybe<Scalars['JSONString']>,
};

export type ComissaoFuncionarioNodeTypeRelayConnection = {
   __typename?: 'ComissaoFuncionarioNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ComissaoFuncionarioNodeTypeRelayEdge>>,
  totalComissao?: Maybe<Scalars['Float']>,
  saldoComissao?: Maybe<Scalars['Float']>,
  valorReceber?: Maybe<Scalars['Float']>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `ComissaoFuncionarioNodeTypeRelay` and its cursor. */
export type ComissaoFuncionarioNodeTypeRelayEdge = {
   __typename?: 'ComissaoFuncionarioNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<ComissaoFuncionarioNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type ComissaoFuncionariosAgregations = {
   __typename?: 'ComissaoFuncionariosAgregations',
  somaRepasseFuncionario?: Maybe<Scalars['Decimal']>,
};

export type ComissaoFuncionariosRelatorioInput = {
  tipoComissao?: Maybe<Scalars['String']>,
  funcionario?: Maybe<Scalars['ID']>,
  funcionario_In?: Maybe<Scalars['ID']>,
  valorComissao?: Maybe<Scalars['Float']>,
  emprestimo_Entidade?: Maybe<Scalars['ID']>,
  emprestimo_Entidade_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgate_InicioPeriodo?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Gte?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Gt?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Lt?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Lte?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Gte?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Gt?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Lt?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Lte?: Maybe<Scalars['Date']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

/** An enumeration. */
export enum ComissaoFuncionariosTipoComissao {
  /** COMISSAO_FUNCIONARIO */
  ComissaoFuncionario = 'COMISSAO_FUNCIONARIO',
  /** COMISSAO_COLETIVA */
  ComissaoColetiva = 'COMISSAO_COLETIVA'
}

export type ComissaoFuncionariosType = {
   __typename?: 'ComissaoFuncionariosType',
  id: Scalars['ID'],
  tipoComissao?: Maybe<ComissaoFuncionariosTipoComissao>,
  /** Esse parametro vai estar prenchido somento na COMISSAO_COLETIVA */
  funcionario?: Maybe<FuncionarioTypeRelay>,
  valorComissao: Scalars['Float'],
  emprestimo: EmprestimoRelatorioType,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateFuncionarioNodeTypeRelay>,
  detalhes: Scalars['String'],
  detalhesComissao?: Maybe<Scalars['JSONString']>,
};

export type ComissaoFuncionariosTypeRelay = Node & {
   __typename?: 'ComissaoFuncionariosTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  tipoComissao?: Maybe<ComissaoFuncionariosTipoComissao>,
  /** Esse parametro vai estar prenchido somento na COMISSAO_COLETIVA */
  funcionario?: Maybe<FuncionarioTypeRelay>,
  valorComissao: Scalars['Float'],
  emprestimo: EmprestimoRelatorioType,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateFuncionarioNodeTypeRelay>,
  detalhes: Scalars['String'],
  detalhesComissao?: Maybe<Scalars['JSONString']>,
};

export type ComissaoFuncionariosTypeRelayConnection = {
   __typename?: 'ComissaoFuncionariosTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ComissaoFuncionariosTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `ComissaoFuncionariosTypeRelay` and its cursor. */
export type ComissaoFuncionariosTypeRelayEdge = {
   __typename?: 'ComissaoFuncionariosTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<ComissaoFuncionariosTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type ComissaoNodeTypeRelay = Node & {
   __typename?: 'ComissaoNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  valorComissao: Scalars['Float'],
  emprestimo: EmprestimoRelatorioType,
  valorPago?: Maybe<Scalars['Float']>,
  parceiro?: Maybe<ParceirosNodeTypeRelay>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateNodeTypeRelay>,
  dataRepasse?: Maybe<Scalars['Date']>,
  detalhes?: Maybe<Scalars['String']>,
  detalhesComissao?: Maybe<Scalars['JSONString']>,
  parcelasNsu?: Maybe<Scalars['String']>,
  nomeLoja?: Maybe<Scalars['String']>,
};

export type ComissaoNodeTypeRelayConnection = {
   __typename?: 'ComissaoNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ComissaoNodeTypeRelayEdge>>,
  totalComissao?: Maybe<Scalars['Float']>,
  saldoComissao?: Maybe<Scalars['Float']>,
  valorReceber?: Maybe<Scalars['Float']>,
  edgeCount?: Maybe<Scalars['Int']>,
  totalCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `ComissaoNodeTypeRelay` and its cursor. */
export type ComissaoNodeTypeRelayEdge = {
   __typename?: 'ComissaoNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<ComissaoNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type ComissaoParceirosType = {
   __typename?: 'ComissaoParceirosType',
  id: Scalars['ID'],
  valorComissao: Scalars['Float'],
  emprestimo: EmprestimoRelatorioType,
  valorPago?: Maybe<Scalars['Float']>,
  parceiro?: Maybe<ParceirosNodeTypeRelay>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateNodeTypeRelay>,
  dataRepasse?: Maybe<Scalars['Date']>,
  detalhes?: Maybe<Scalars['String']>,
  detalhesComissao?: Maybe<Scalars['JSONString']>,
  emprestimoSet?: Maybe<Array<Maybe<EmprestimoType>>>,
};

export type ComissaoParceiroType = {
   __typename?: 'ComissaoParceiroType',
  id: Scalars['ID'],
  valorComissao: Scalars['Float'],
  emprestimo: EmprestimoRelatorioType,
  valorPago?: Maybe<Scalars['Float']>,
  parceiro?: Maybe<ParceirosNodeTypeRelay>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateNodeTypeRelay>,
  dataRepasse?: Maybe<Scalars['Date']>,
  detalhes?: Maybe<Scalars['String']>,
  detalhesComissao?: Maybe<Scalars['JSONString']>,
};

export type CompletarEmprestimoDeliveryMutation = {
   __typename?: 'CompletarEmprestimoDeliveryMutation',
  emprestimo?: Maybe<EmprestimoNode>,
};

export type ConsultarZekiGiftbackMutation = {
   __typename?: 'ConsultarZekiGiftbackMutation',
  giftback?: Maybe<ZekiGiftbackConsultaType>,
};

/** An enumeration. */
export enum ContaAPagarFormaPagamento {
  /** Boleto */
  Boleto = 'BOLETO',
  /** Transferência */
  Transferencia = 'TRANSFERENCIA'
}

export type ContaAPagarNode = Node & {
   __typename?: 'ContaAPagarNode',
  /** The ID of the object. */
  id: Scalars['ID'],
  entidade: EntidadeTypeRelay,
  funcionario: FuncionarioTypeRelay,
  titulo: Scalars['String'],
  destinatario: Scalars['String'],
  valor: Scalars['Float'],
  valorPago?: Maybe<Scalars['Float']>,
  dataVencimento: Scalars['DateTime'],
  dataPagamento?: Maybe<Scalars['DateTime']>,
  recorrencia?: Maybe<ContaAPagarRecorrencia>,
  formaPagamento: ContaAPagarFormaPagamento,
  tipoDespesa?: Maybe<ContaAPagarTipoDespesa>,
  status: ContaAPagarStatus,
  categoria: Scalars['String'],
  observacao?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  boletoDataVencimento?: Maybe<Scalars['DateTime']>,
  boletoNumeroControle?: Maybe<Scalars['String']>,
  boletoCodigoBarra?: Maybe<Scalars['String']>,
  transferenciaNome?: Maybe<Scalars['String']>,
  transferenciaBanco?: Maybe<Scalars['String']>,
  transferenciaAgencia?: Maybe<Scalars['String']>,
  transferenciaTipoConta?: Maybe<ContaAPagarTransferenciaTipoConta>,
  transferenciaConta?: Maybe<Scalars['String']>,
  transferenciaTipoPix: Scalars['String'],
  transferenciaPix: Scalars['String'],
  transferenciaVariacao?: Maybe<Scalars['String']>,
  transferenciaCpfCnpj?: Maybe<Scalars['String']>,
  justificativaCancelamento?: Maybe<Scalars['String']>,
  justificativaValorPago?: Maybe<Scalars['String']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  anexos: Array<AnexoDeContaAPagarType>,
};

export type ContaAPagarNodeConnection = {
   __typename?: 'ContaAPagarNodeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContaAPagarNodeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `ContaAPagarNode` and its cursor. */
export type ContaAPagarNodeEdge = {
   __typename?: 'ContaAPagarNodeEdge',
  /** The item at the end of the edge */
  node?: Maybe<ContaAPagarNode>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum ContaAPagarRecorrencia {
  /** Dia */
  Dia = 'DIA',
  /** Semana */
  Semana = 'SEMANA',
  /** Mês */
  Mes = 'MES',
  /** Ano */
  Ano = 'ANO',
  /** Avulso */
  Avulso = 'AVULSO'
}

/** An enumeration. */
export enum ContaAPagarStatus {
  /** Pendente */
  Pendente = 'PENDENTE',
  /** Aprovado */
  Aprovado = 'APROVADO',
  /** Reprovado */
  Reprovado = 'REPROVADO',
  /** Cancelado */
  Cancelado = 'CANCELADO',
  /** Pago */
  Pago = 'PAGO',
  /** Vencido */
  Vencido = 'VENCIDO'
}

/** An enumeration. */
export enum ContaAPagarTipoDespesa {
  /** Fixa */
  Fixa = 'FIXA',
  /** Variável */
  Variavel = 'VARIAVEL'
}

/** An enumeration. */
export enum ContaAPagarTransferenciaTipoConta {
  /** Corrente */
  Corrente = 'CORRENTE',
  /** Poupança */
  Poupanca = 'POUPANCA',
  /** Fácil */
  Facil = 'FACIL'
}

export type ContaClienteInputMobile = {
  id?: Maybe<Scalars['ID']>,
  banco?: Maybe<Scalars['String']>,
  agencia?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  variacao?: Maybe<Scalars['String']>,
  cpfCnpj?: Maybe<Scalars['String']>,
};

export type ContaClienteMobileType2 = {
  id: Scalars['ID'],
  valor: Scalars['Float'],
};

/** An enumeration. */
export enum ContaDeClienteTipoConta {
  /** Corrente */
  Corrente = 'CORRENTE',
  /** Poupança */
  Poupanca = 'POUPANCA',
  /** Fácil */
  Facil = 'FACIL'
}

export type ContaDeClienteType = {
   __typename?: 'ContaDeClienteType',
  id: Scalars['ID'],
  cliente: EmprestimoClienteNode,
  nome: Scalars['String'],
  banco: Scalars['String'],
  tipoPix: Scalars['String'],
  pix: Scalars['String'],
  agencia: Scalars['String'],
  tipoConta: ContaDeClienteTipoConta,
  conta: Scalars['String'],
  variacao?: Maybe<Scalars['String']>,
  cpfCnpj: Scalars['String'],
  entidadeId?: Maybe<Scalars['Int']>,
};

export type ContagemDeCategoriaType = {
   __typename?: 'ContagemDeCategoriaType',
  totalTipoLojaAssociados?: Maybe<Scalars['Int']>,
  totalTipoLojaLojas?: Maybe<Scalars['Int']>,
  totalTipoLojaParceiros?: Maybe<Scalars['Int']>,
  totalTipoLojaOutros?: Maybe<Scalars['Int']>,
};

export type ContaPagarRelatorioInput = {
  id?: Maybe<Scalars['Float']>,
  titulo?: Maybe<Scalars['String']>,
  titulo_Icontains?: Maybe<Scalars['String']>,
  titulo_Istartswith?: Maybe<Scalars['String']>,
  destinatario?: Maybe<Scalars['String']>,
  destinatario_Icontains?: Maybe<Scalars['String']>,
  destinatario_Istartswith?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  recorrencia?: Maybe<Scalars['String']>,
  recorrencia_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>,
  dataVencimento?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gte?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lte?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gte?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lte?: Maybe<Scalars['DateTime']>,
  transferenciaConta?: Maybe<Scalars['String']>,
  transferenciaConta_Icontains?: Maybe<Scalars['String']>,
  formaPagamento?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Lt?: Maybe<Scalars['Float']>,
  valor_Gt?: Maybe<Scalars['Float']>,
  /** Ordenando */
  orderBy?: Maybe<Scalars['String']>,
};

/** An enumeration. */
export enum ContaParceirosTipoConta {
  /** Corrente */
  Corrente = 'CORRENTE',
  /** Poupança */
  Poupanca = 'POUPANCA',
  /** Fácil */
  Facil = 'FACIL'
}

export type ContaParceirosType = {
   __typename?: 'ContaParceirosType',
  id: Scalars['ID'],
  titular: Scalars['String'],
  tipoPix: Scalars['String'],
  pix: Scalars['String'],
  banco: Scalars['String'],
  agencia: Scalars['String'],
  tipoConta: ContaParceirosTipoConta,
  conta: Scalars['String'],
  variacao?: Maybe<Scalars['String']>,
  cpfCnpj: Scalars['String'],
  parceiro: ParceirosNodeTypeRelay,
  resgateautomaticoparceirosSet: Array<ResgateAutomaticoParceirosType>,
};

export type ContaParceirosTypeInput = {
  titular?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  banco?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  agencia?: Maybe<Scalars['String']>,
  cpfCnpj?: Maybe<Scalars['String']>,
  variacao?: Maybe<Scalars['String']>,
  tipoPix?: Maybe<Scalars['String']>,
  pix?: Maybe<Scalars['String']>,
};

export type CreateAnotacao = {
   __typename?: 'CreateAnotacao',
  ok?: Maybe<Scalars['Boolean']>,
  anotacao?: Maybe<AnotacaoType>,
};

export type CreateCartaoCreditoMobile = {
   __typename?: 'CreateCartaoCreditoMobile',
  ok?: Maybe<Scalars['Boolean']>,
  cartao?: Maybe<CartaoDeCreditoType>,
};

export type CreateCartaoCreditoTerceirosMobile = {
   __typename?: 'CreateCartaoCreditoTerceirosMobile',
  ok?: Maybe<Scalars['Boolean']>,
  cartao?: Maybe<CartaoDeCreditoType>,
};

export type CreateClienteFromLead = {
   __typename?: 'CreateClienteFromLead',
  cliente?: Maybe<ClienteType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type CreateClienteMobile = {
   __typename?: 'CreateClienteMobile',
  ok?: Maybe<Scalars['Boolean']>,
  cliente?: Maybe<ClienteType>,
  usuario?: Maybe<UserType>,
};

export type CreateContaClienteMobilne = {
   __typename?: 'CreateContaClienteMobilne',
  ok?: Maybe<Scalars['Boolean']>,
  conta?: Maybe<ContaDeClienteType>,
};

export type CreateCustomerMobileSimplify = {
   __typename?: 'CreateCustomerMobileSimplify',
  ok?: Maybe<Scalars['Boolean']>,
  lead?: Maybe<LeadsType>,
  user?: Maybe<UserType>,
};

export type CreateEmprestimoMobile = {
   __typename?: 'CreateEmprestimoMobile',
  ok?: Maybe<Scalars['Boolean']>,
  emprestimo?: Maybe<EmprestimoType>,
};

export type CreateLeadCrm = {
   __typename?: 'CreateLeadCRM',
  lead?: Maybe<LeadsType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type CreateLeadProp = {
   __typename?: 'CreateLeadProp',
  lead?: Maybe<LeadsType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type CreateLoanSimulationMobile = {
   __typename?: 'CreateLoanSimulationMobile',
  loanSimulation?: Maybe<PropostasType>,
};

export type CreatePreClienteMobile = {
   __typename?: 'CreatePreClienteMobile',
  ok?: Maybe<Scalars['Boolean']>,
  cliente?: Maybe<ClienteType>,
  usuario?: Maybe<UserType>,
};

export type CreateSourceMutation = {
   __typename?: 'CreateSourceMutation',
  ok?: Maybe<Scalars['Boolean']>,
  origem?: Maybe<OrigensType>,
};

export type CreateTarefa = {
   __typename?: 'CreateTarefa',
  ok?: Maybe<Scalars['Boolean']>,
  tarefa?: Maybe<TarefasType>,
};

export type CriarAutomacaoZApi = {
   __typename?: 'CriarAutomacaoZApi',
  instancia?: Maybe<InstanciaZApiType>,
};

export type CriarCategoriaMutation = {
   __typename?: 'CriarCategoriaMutation',
  ok?: Maybe<Scalars['Boolean']>,
  categoria?: Maybe<CategoriaTypeRelay>,
};

export type CriarClienteMutation = {
   __typename?: 'CriarClienteMutation',
  ok?: Maybe<Scalars['Boolean']>,
  cliente?: Maybe<ClienteType>,
};

export type CriarContaAPagarMutation = {
   __typename?: 'CriarContaAPagarMutation',
  ok?: Maybe<Scalars['Boolean']>,
  contaPagar?: Maybe<ContaAPagarNode>,
};

export type CriarEmprestimoMutation = {
   __typename?: 'CriarEmprestimoMutation',
  emprestimo?: Maybe<EmprestimoNode>,
};

export type CriarEntidadeMutation = {
   __typename?: 'CriarEntidadeMutation',
  permissao?: Maybe<PermissaoType>,
  entidade?: Maybe<EntidadeType>,
};

export type CriarEnvio = {
   __typename?: 'CriarEnvio',
  ok?: Maybe<Scalars['Boolean']>,
  envioSms?: Maybe<EnvioSmsType>,
  envioEmail?: Maybe<EnvioEmailType>,
};

export type CriarFornecedor = {
   __typename?: 'CriarFornecedor',
  fornecedor?: Maybe<FornecedorNodeType>,
};

export type CriarFuncionarioMutation = {
   __typename?: 'CriarFuncionarioMutation',
  funcionario?: Maybe<FuncionarioType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type CriarFuncionarioRepasse = {
   __typename?: 'CriarFuncionarioRepasse',
  ok?: Maybe<Scalars['Boolean']>,
  message?: Maybe<Scalars['String']>,
};

export type CriarGrupoDePermissoesMutation = {
   __typename?: 'CriarGrupoDePermissoesMutation',
  ok?: Maybe<Scalars['Boolean']>,
  grupoPermissoes?: Maybe<GrupoDePermissoesType>,
};

export type CriarInstanciaZApi = {
   __typename?: 'CriarInstanciaZApi',
  instancia?: Maybe<InstanciaZApiType>,
};

export type CriarLista = {
   __typename?: 'CriarLista',
  lista?: Maybe<ListaSmsType>,
};

export type CriarMaquinaMutation = {
   __typename?: 'CriarMaquinaMutation',
  maquina?: Maybe<MaquinaNode>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type CriarMensagens = {
   __typename?: 'CriarMensagens',
  ok?: Maybe<Scalars['Boolean']>,
  mensagem?: Maybe<MensagemSmsType>,
};

export type CriarMetaMutation = {
   __typename?: 'CriarMetaMutation',
  ok?: Maybe<Scalars['Boolean']>,
  metasCriadasComSucesso?: Maybe<Array<Maybe<Scalars['String']>>>,
  metasComErro?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type CriarParceiros = {
   __typename?: 'CriarParceiros',
  parceiro?: Maybe<ParceirosType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type CriarPedidoDeReembolsoMutation = {
   __typename?: 'CriarPedidoDeReembolsoMutation',
  ok?: Maybe<Scalars['Boolean']>,
  pedidoReembolso?: Maybe<PedidoDeReembolsoNode>,
};

export type CriarRegramentoEntidade = {
   __typename?: 'CriarRegramentoEntidade',
  entidade?: Maybe<EntidadeType>,
};

export type CriarRegramentoTipoEntidade = {
   __typename?: 'CriarRegramentoTipoEntidade',
  tipoEntidade?: Maybe<TiposEntidadesNodeType>,
};

export type CriarSubCategoriaMutation = {
   __typename?: 'CriarSubCategoriaMutation',
  ok?: Maybe<Scalars['Boolean']>,
  subcategoria?: Maybe<SubCategoriasTypeRelay>,
};

export type CriarTabelas = {
   __typename?: 'CriarTabelas',
  tabela?: Maybe<TabelaParceirosType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type CriarTipoEntidade = {
   __typename?: 'CriarTipoEntidade',
  tipoEntidade?: Maybe<TiposEntidadesNodeType>,
};

export type CriarTipoFuncionarioMutation = {
   __typename?: 'CriarTipoFuncionarioMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type CustomJsonWebToken = {
   __typename?: 'CustomJSONWebToken',
  payload: Scalars['GenericScalar'],
  refreshExpiresIn: Scalars['Int'],
  funcionario?: Maybe<FuncionarioType>,
  permissoes?: Maybe<Array<Maybe<PermissaoType>>>,
  gruposPermissao?: Maybe<Array<Maybe<GrupoDePermissoesType>>>,
  token: Scalars['String'],
};

export type DarPermissoesGrupoMutation = {
   __typename?: 'DarPermissoesGrupoMutation',
  ok?: Maybe<Scalars['Boolean']>,
  permissoesGrupo?: Maybe<Array<Maybe<PermissaoDeGrupoType>>>,
};

export type DarVariasPermissoesMutation = {
   __typename?: 'DarVariasPermissoesMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type Dashboard_Envios = {
   __typename?: 'Dashboard_envios',
  envios?: Maybe<Scalars['Int']>,
  listas?: Maybe<Scalars['Int']>,
  mensagens?: Maybe<Scalars['Int']>,
};

export type DashboardEmail = {
   __typename?: 'DashboardEmail',
  data?: Maybe<Scalars['Date']>,
  entregues?: Maybe<Scalars['Int']>,
  abertos?: Maybe<Scalars['Int']>,
  cliques?: Maybe<Scalars['Int']>,
  falhas?: Maybe<Scalars['Int']>,
  dascartados?: Maybe<Scalars['Int']>,
  spam?: Maybe<Scalars['Int']>,
  enviados?: Maybe<Scalars['Int']>,
};

export type DashboardEmprestimosPorLojaType = {
   __typename?: 'DashboardEmprestimosPorLojaType',
  emprestimosPorLoja?: Maybe<Array<Maybe<EmprestimoPorLojaType>>>,
};

export type DashboardMetaDetalhePorUnidadeType = {
   __typename?: 'DashboardMetaDetalhePorUnidadeType',
  detalhesPorUnidade?: Maybe<Array<Maybe<DetalhePorUnidadeType>>>,
};

export type DashboardMetaKpiCardsType = {
   __typename?: 'DashboardMetaKPICardsType',
  totalEmprestimos?: Maybe<Scalars['Int']>,
  faturamento?: Maybe<Scalars['Decimal']>,
  metaGeral?: Maybe<Scalars['Decimal']>,
  resultadoAlcancado?: Maybe<Scalars['Decimal']>,
  totalMetasCadastradas?: Maybe<Scalars['Int']>,
};

export type DashboardMetaTiposDeEmprestimosType = {
   __typename?: 'DashboardMetaTiposDeEmprestimosType',
  tiposDeEmprestimos?: Maybe<Array<Maybe<TipoDeEmprestimoObjectType>>>,
};

export type DashboardSms = {
   __typename?: 'DashboardSms',
  data?: Maybe<Scalars['Date']>,
  enviados?: Maybe<Scalars['Int']>,
  recebidos?: Maybe<Scalars['Int']>,
  falhas?: Maybe<Scalars['Int']>,
};

export type DashboardTopRankingFuncionariosType = {
   __typename?: 'DashboardTopRankingFuncionariosType',
  rankingFuncionarios?: Maybe<Array<Maybe<RankingFuncionarioType>>>,
};

export type DashboardTopRankingLojasType = {
   __typename?: 'DashboardTopRankingLojasType',
  rankingLojas?: Maybe<Array<Maybe<RankingLojaType>>>,
};




export type DefinirTablelaTaxasParcelas = {
   __typename?: 'DefinirTablelaTaxasParcelas',
  entidades?: Maybe<Array<Maybe<EntidadeType>>>,
};

export type DefinirTaxasParcelas = {
   __typename?: 'DefinirTaxasParcelas',
  entidades?: Maybe<Array<Maybe<EntidadeType>>>,
};

export type DefinirTaxasTabela = {
   __typename?: 'DefinirTaxasTabela',
  ok?: Maybe<Scalars['Boolean']>,
  entidades?: Maybe<Array<Maybe<EntidadeType>>>,
};

export type DeletarInstanciaZApi = {
   __typename?: 'DeletarInstanciaZApi',
  ok?: Maybe<Scalars['Boolean']>,
};

export type DeletarTaxasMaquina = {
   __typename?: 'DeletarTaxasMaquina',
  maquina?: Maybe<MaquinaNode>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type DeleteMetaMutation = {
   __typename?: 'DeleteMetaMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type DeleteSourceMutation = {
   __typename?: 'DeleteSourceMutation',
  ok?: Maybe<Scalars['Boolean']>,
  id?: Maybe<Scalars['ID']>,
};

export type DesabilitarMaquinaMutation = {
   __typename?: 'DesabilitarMaquinaMutation',
  maquina?: Maybe<MaquinaNode>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type DesassociarClienteEntidadeMutation = {
   __typename?: 'DesassociarClienteEntidadeMutation',
  ok?: Maybe<Scalars['Boolean']>,
  cliente?: Maybe<ClienteType>,
};

export type DesassociarEntidadesGrupoMutation = {
   __typename?: 'DesassociarEntidadesGrupoMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type DesassociarFuncionariosGrupoMutation = {
   __typename?: 'DesassociarFuncionariosGrupoMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type DesbloquearFuncionario = {
   __typename?: 'DesbloquearFuncionario',
  funcionario?: Maybe<FuncionarioType>,
};

export type DesbloquearMaquinaMutation = {
   __typename?: 'DesbloquearMaquinaMutation',
  maquina?: Maybe<MaquinaNode>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type DescricaoPorGruposType = {
   __typename?: 'DescricaoPorGruposType',
  grupo?: Maybe<Array<Maybe<Scalars['Int']>>>,
  permssaoDescricao?: Maybe<Scalars['String']>,
};

export type DetalhePorUnidadeHeaderType = {
   __typename?: 'DetalhePorUnidadeHeaderType',
  nomeLoja?: Maybe<Scalars['String']>,
  valorMeta?: Maybe<Scalars['Decimal']>,
  valorAlcancado?: Maybe<Scalars['Decimal']>,
  porcentagemAlcancada?: Maybe<Scalars['Float']>,
};

export type DetalhePorUnidadeTop3VendedoresType = {
   __typename?: 'DetalhePorUnidadeTop3VendedoresType',
  nomeFuncionario?: Maybe<Scalars['String']>,
  valorAcumulado?: Maybe<Scalars['Decimal']>,
  sexo?: Maybe<Scalars['String']>,
  ranking?: Maybe<Scalars['Int']>,
};

export type DetalhePorUnidadeType = {
   __typename?: 'DetalhePorUnidadeType',
  header?: Maybe<DetalhePorUnidadeHeaderType>,
  top3Vendedores?: Maybe<Array<Maybe<DetalhePorUnidadeTop3VendedoresType>>>,
  outrosVendedores?: Maybe<Array<Maybe<DetalhePorUnidadeVendedoresType>>>,
};

export type DetalhePorUnidadeVendedoresType = {
   __typename?: 'DetalhePorUnidadeVendedoresType',
  nomeFuncionario?: Maybe<Scalars['String']>,
  valorAcumulado?: Maybe<Scalars['Decimal']>,
  ranking?: Maybe<Scalars['Int']>,
};

export type DisvinculaTokenOnesignalMutation = {
   __typename?: 'DisvinculaTokenOnesignalMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type EdiarLista = {
   __typename?: 'EdiarLista',
  ok?: Maybe<Scalars['Boolean']>,
  lista?: Maybe<ListaSmsType>,
};

export type EdicaoTipoDeEmprestimoInput = {
  id: Scalars['ID'],
  nome?: Maybe<Scalars['String']>,
  entidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  modalidadeCliente?: Maybe<Scalars['String']>,
  periodicidadeRecorrencia?: Maybe<Scalars['String']>,
  tipoUso?: Maybe<Scalars['String']>,
  tipoCalculo?: Maybe<Scalars['String']>,
  valorMinimo?: Maybe<Scalars['Decimal']>,
  valorMaximo?: Maybe<Scalars['Decimal']>,
  parcelasMinimas?: Maybe<Scalars['Int']>,
  parcelasMaximas?: Maybe<Scalars['Int']>,
  taxaJuros?: Maybe<Scalars['Decimal']>,
  tcc?: Maybe<Scalars['Decimal']>,
  descricao?: Maybe<Scalars['String']>,
  loanExtraFields?: Maybe<Scalars['JSONString']>,
};

export type EdicaoTipoDeEmprestimoMutation = {
   __typename?: 'EdicaoTipoDeEmprestimoMutation',
  ok?: Maybe<Scalars['Boolean']>,
  tipoEmprestimo?: Maybe<TipoDeEmprestimoType>,
};

export type EditarAnotacao = {
   __typename?: 'EditarAnotacao',
  ok?: Maybe<Scalars['Boolean']>,
  anotacao?: Maybe<AnotacaoType>,
};

export type EditarCategoriaMutation = {
   __typename?: 'EditarCategoriaMutation',
  ok?: Maybe<Scalars['Boolean']>,
  categoria?: Maybe<CategoriaTypeRelay>,
};

export type EditarFornecedor = {
   __typename?: 'EditarFornecedor',
  fornecedor?: Maybe<FornecedorNodeType>,
};

export type EditarFuncionarioRepasse = {
   __typename?: 'EditarFuncionarioRepasse',
  ok?: Maybe<Scalars['Boolean']>,
  message?: Maybe<Scalars['String']>,
  funcionarioRepasse?: Maybe<FuncionariosRepasseType>,
};

export type EditarLead = {
   __typename?: 'EditarLead',
  lead?: Maybe<LeadsType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type EditarLeadProp = {
   __typename?: 'EditarLeadProp',
  lead?: Maybe<LeadsType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type EditarParceiros = {
   __typename?: 'EditarParceiros',
  parceiro?: Maybe<ParceirosType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type EditarRegramentoEntidade = {
   __typename?: 'EditarRegramentoEntidade',
  entidade?: Maybe<EntidadeType>,
};

export type EditarRegramentoTipoEntidade = {
   __typename?: 'EditarRegramentoTipoEntidade',
  tipoEntidade?: Maybe<TiposEntidadesNodeType>,
};

export type EditarSubCategoriaMutation = {
   __typename?: 'EditarSubCategoriaMutation',
  ok?: Maybe<Scalars['Boolean']>,
  subcategoria?: Maybe<SubCategoriasTypeRelay>,
};

export type EditarTabelas = {
   __typename?: 'EditarTabelas',
  tabela?: Maybe<TabelaParceirosType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type EditarTablelaTaxasParcelas = {
   __typename?: 'EditarTablelaTaxasParcelas',
  entidades?: Maybe<Array<Maybe<EntidadeType>>>,
};

export type EditarTarefa = {
   __typename?: 'EditarTarefa',
  ok?: Maybe<Scalars['Boolean']>,
  tarefa?: Maybe<TarefasType>,
};

export type EditarTarefasMult = {
   __typename?: 'EditarTarefasMult',
  ok?: Maybe<Scalars['Boolean']>,
};

export type EditarTipoEntidade = {
   __typename?: 'EditarTipoEntidade',
  tipoEntidade?: Maybe<TiposEntidadesNodeType>,
};

export type EditarTipoFuncionarioMutation = {
   __typename?: 'EditarTipoFuncionarioMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type EditSourceMutation = {
   __typename?: 'EditSourceMutation',
  ok?: Maybe<Scalars['Boolean']>,
  origem?: Maybe<OrigensType>,
};

export type EditUserProfileMobile = {
   __typename?: 'EditUserProfileMobile',
  lead?: Maybe<LeadsType>,
  token?: Maybe<Scalars['String']>,
};

export type EmailRemetenteType = {
   __typename?: 'EmailRemetenteType',
  id: Scalars['ID'],
  email: Scalars['String'],
  entidade: EntidadeTypeRelay,
  envioemailSet: EnvioEmailTypeRelayConnection,
};


export type EmailRemetenteTypeEnvioemailSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  listas_Id?: Maybe<Scalars['ID']>,
  listas_Id_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  hora?: Maybe<Scalars['Time']>,
  hora_Gte?: Maybe<Scalars['Time']>,
  hora_Gt?: Maybe<Scalars['Time']>,
  hora_Lt?: Maybe<Scalars['Time']>,
  hora_Lte?: Maybe<Scalars['Time']>,
  data?: Maybe<Scalars['Date']>,
  data_Gte?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Lte?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type EmprestimoAgregations = {
   __typename?: 'EmprestimoAgregations',
  somaValoresPassados?: Maybe<Scalars['Decimal']>,
  somaValorRetirado?: Maybe<Scalars['Decimal']>,
  taxaMediaTotal?: Maybe<Scalars['Decimal']>,
  somaRepasseParceiro?: Maybe<Scalars['Decimal']>,
};

export type EmprestimoAnexoInput = {
  url: Scalars['String'],
  descricao?: Maybe<Scalars['String']>,
};

export type EmprestimoClienteAgregations = {
   __typename?: 'EmprestimoClienteAgregations',
  somaValorPassado?: Maybe<Scalars['Decimal']>,
  somaValorRetirado?: Maybe<Scalars['Decimal']>,
  taxaMediaTotal?: Maybe<Scalars['Decimal']>,
  mediaParcelas?: Maybe<Scalars['Float']>,
  ticketMedio?: Maybe<Scalars['Decimal']>,
};

export type EmprestimoClienteNode = Node & {
   __typename?: 'EmprestimoClienteNode',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  cpf?: Maybe<Scalars['String']>,
  nascimento?: Maybe<Scalars['Date']>,
  sexo?: Maybe<ClienteSexo>,
  estadoCivil?: Maybe<ClienteEstadoCivil>,
  rg?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  anexoRgFrente?: Maybe<Scalars['String']>,
  anexoRgVerso?: Maybe<Scalars['String']>,
  anexoCpfFrente?: Maybe<Scalars['String']>,
  anexoCpfVerso?: Maybe<Scalars['String']>,
  anexoEndereco?: Maybe<Scalars['String']>,
  anexoRenda?: Maybe<Scalars['String']>,
  observacao?: Maybe<Scalars['String']>,
  entidades: EntidadeTypeRelayConnection,
  lead: Scalars['Boolean'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  origem?: Maybe<Scalars['String']>,
  user?: Maybe<UserType>,
  sgiId?: Maybe<Scalars['Int']>,
  sgiImportedAt?: Maybe<Scalars['DateTime']>,
  telefones: Array<TelefoneDeClienteType>,
  contas: Array<ContaDeClienteType>,
  emprestimoSet: EmprestimoRelatorioTypeConnection,
  cartaodecreditoSet: CartaoDeCreditoNodeTypeRelayConnection,
  leadsSet: LeadsNodeTypeRelayPropConnection,
  listasmsSet: ListaSmsTypeRelayConnection,
  pk: Scalars['Int'],
};


export type EmprestimoClienteNodeEntidadesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EmprestimoClienteNodeEmprestimoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type EmprestimoClienteNodeCartaodecreditoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['ID']>
};


export type EmprestimoClienteNodeLeadsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EmprestimoClienteNodeListasmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type EmprestimoClienteNodeConnection = {
   __typename?: 'EmprestimoClienteNodeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmprestimoClienteNodeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `EmprestimoClienteNode` and its cursor. */
export type EmprestimoClienteNodeEdge = {
   __typename?: 'EmprestimoClienteNodeEdge',
  /** The item at the end of the edge */
  node?: Maybe<EmprestimoClienteNode>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type EmprestimoClienteRelatorioInput = {
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  cliente_Id?: Maybe<Scalars['Float']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_In?: Maybe<Scalars['String']>,
  cliente_Sexo?: Maybe<Scalars['String']>,
  cliente_Sexo_In?: Maybe<Scalars['String']>,
  cliente_Municipio?: Maybe<Scalars['String']>,
  cliente_Municipio_In?: Maybe<Scalars['String']>,
  cliente_Municipio_Icontains?: Maybe<Scalars['String']>,
  entidade?: Maybe<Scalars['ID']>,
  entidade_In?: Maybe<Scalars['ID']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  quantidadeEmprestimo?: Maybe<Scalars['Float']>,
  taxaMedia?: Maybe<Scalars['Float']>,
  /** Ordenando */
  orderBy?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type EmprestimoClienteRelatorioType = Node & {
   __typename?: 'EmprestimoClienteRelatorioType',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  cpf?: Maybe<Scalars['String']>,
  nascimento?: Maybe<Scalars['Date']>,
  sexo?: Maybe<ClienteSexo>,
  estadoCivil?: Maybe<ClienteEstadoCivil>,
  rg?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  anexoRgFrente?: Maybe<Scalars['String']>,
  anexoRgVerso?: Maybe<Scalars['String']>,
  anexoCpfFrente?: Maybe<Scalars['String']>,
  anexoCpfVerso?: Maybe<Scalars['String']>,
  anexoEndereco?: Maybe<Scalars['String']>,
  anexoRenda?: Maybe<Scalars['String']>,
  observacao?: Maybe<Scalars['String']>,
  entidades: EntidadeTypeRelayConnection,
  lead: Scalars['Boolean'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  origem?: Maybe<Scalars['String']>,
  user?: Maybe<UserType>,
  sgiId?: Maybe<Scalars['Int']>,
  sgiImportedAt?: Maybe<Scalars['DateTime']>,
  telefones: Array<TelefoneDeClienteType>,
  contas: Array<ContaDeClienteType>,
  emprestimoSet: EmprestimoRelatorioTypeConnection,
  cartaodecreditoSet: CartaoDeCreditoNodeTypeRelayConnection,
  leadsSet: LeadsNodeTypeRelayPropConnection,
  listasmsSet: ListaSmsTypeRelayConnection,
  quantidadeEmprestimo?: Maybe<Scalars['Int']>,
  totalValorDesejado?: Maybe<Scalars['Decimal']>,
  totalValorEmprestimo?: Maybe<Scalars['Decimal']>,
  taxaMedia?: Maybe<Scalars['Decimal']>,
  lucroBruto?: Maybe<Scalars['Decimal']>,
  nomesEntidades?: Maybe<Scalars['String']>,
  numerosTelefones?: Maybe<Scalars['String']>,
};


export type EmprestimoClienteRelatorioTypeEntidadesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EmprestimoClienteRelatorioTypeEmprestimoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type EmprestimoClienteRelatorioTypeCartaodecreditoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['ID']>
};


export type EmprestimoClienteRelatorioTypeLeadsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EmprestimoClienteRelatorioTypeListasmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type EmprestimoClienteRelatorioTypeConnection = {
   __typename?: 'EmprestimoClienteRelatorioTypeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmprestimoClienteRelatorioTypeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `EmprestimoClienteRelatorioType` and its cursor. */
export type EmprestimoClienteRelatorioTypeEdge = {
   __typename?: 'EmprestimoClienteRelatorioTypeEdge',
  /** The item at the end of the edge */
  node?: Maybe<EmprestimoClienteRelatorioType>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type EmprestimoClienteType = {
   __typename?: 'EmprestimoClienteType',
  id: Scalars['ID'],
  entidade?: Maybe<EntidadeTypeRelay>,
  cliente?: Maybe<EmprestimoClienteNode>,
  funcionario: FuncionarioTypeRelay,
  valorDesejado: Scalars['Float'],
  valorTotal?: Maybe<Scalars['Float']>,
  bonusFuncionario?: Maybe<Scalars['Decimal']>,
  taxaAplicada: Scalars['Float'],
  parcelas: EmprestimoParcelas,
  tabelaTaxa?: Maybe<Scalars['String']>,
  delivery: Scalars['Boolean'],
  maquina?: Maybe<Scalars['String']>,
  nsuCartao?: Maybe<Scalars['String']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  anexoContrato?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  data: Scalars['Date'],
  taxaMinima?: Maybe<Scalars['Float']>,
  justificativaTaxaAbaixo?: Maybe<Scalars['String']>,
  justificativaCancelamento?: Maybe<Scalars['String']>,
  status: EmprestimoStatus,
  causaStatus?: Maybe<Scalars['String']>,
  clickSignChaveDocumento?: Maybe<Scalars['String']>,
  solicitadoVia: EmprestimoSolicitadoVia,
  vendaDigitada: Scalars['Boolean'],
  vendaResgatada: Scalars['Boolean'],
  leadId?: Maybe<Scalars['Int']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateNodeTypeRelay>,
  loanTypePayload?: Maybe<Scalars['JSONString']>,
  loanType?: Maybe<TipoDeEmprestimoRelayType>,
  extraFieldsResults?: Maybe<Scalars['JSONString']>,
  iof?: Maybe<Scalars['Float']>,
  nsus: NsuRelatorioTypeConnection,
  formasPagamento: Array<FormaPagamentoEmprestimoType>,
  anexos: Array<AnexoDeEmprestimoType>,
  comissaoparceirosSet: ComissaoNodeTypeRelayConnection,
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  comissaofuncionariosSet: ComissaoFuncionarioNodeTypeRelayConnection,
  zekiGiftback?: Maybe<ZekiGiftbackResgateType>,
};


export type EmprestimoClienteTypeNsusArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type EmprestimoClienteTypeComissaoparceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Nsu_Parcelas?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_In?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_Iexact?: Maybe<Scalars['String']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  dataRepasse?: Maybe<Scalars['Date']>,
  dataRepasse_Gte?: Maybe<Scalars['Date']>,
  dataRepasse_Gt?: Maybe<Scalars['Date']>,
  dataRepasse_Lt?: Maybe<Scalars['Date']>,
  dataRepasse_Lte?: Maybe<Scalars['Date']>,
  emprestimo_CriadoEm?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gte?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lte?: Maybe<Scalars['DateTime']>,
  emprestimo_Data?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gte?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lte?: Maybe<Scalars['Date']>,
  valorComissao?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EmprestimoClienteTypeComissaofuncionariosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  emprestimo_Id_In?: Maybe<Scalars['String']>,
  emprestimo_Funcionario_Id?: Maybe<Scalars['ID']>,
  emprestimo_Parcelas?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  tipoComissao?: Maybe<Scalars['String']>,
  valorComissao?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

export type EmprestimoFormaPagamentoEditInput = {
  id: Scalars['ID'],
  valor?: Maybe<Scalars['Float']>,
  anexo?: Maybe<Scalars['String']>,
  contaNome?: Maybe<Scalars['String']>,
  contaBanco?: Maybe<Scalars['String']>,
  contaAgencia?: Maybe<Scalars['String']>,
  contaTipoConta?: Maybe<Scalars['String']>,
  contaConta?: Maybe<Scalars['String']>,
  contaVariacao?: Maybe<Scalars['String']>,
  contaCpfCnpj?: Maybe<Scalars['String']>,
  boletoDataVencimento?: Maybe<Scalars['Date']>,
  boletoNumeroControle?: Maybe<Scalars['String']>,
  boletoCodigoBarra?: Maybe<Scalars['String']>,
  boletoAnexo?: Maybe<Scalars['String']>,
  tipoPix?: Maybe<Scalars['String']>,
  pix?: Maybe<Scalars['String']>,
};

export type EmprestimoFormaPagamentoInput = {
  valor: Scalars['Float'],
  anexo?: Maybe<Scalars['String']>,
  contaNome?: Maybe<Scalars['String']>,
  tipoPix?: Maybe<Scalars['String']>,
  pix?: Maybe<Scalars['String']>,
  contaBanco?: Maybe<Scalars['String']>,
  contaAgencia?: Maybe<Scalars['String']>,
  contaTipoConta?: Maybe<ContaDeClienteTipoConta>,
  contaConta?: Maybe<Scalars['String']>,
  contaVariacao?: Maybe<Scalars['String']>,
  contaCpfCnpj?: Maybe<Scalars['String']>,
  boletoDataVencimento?: Maybe<Scalars['Date']>,
  boletoNumeroControle?: Maybe<Scalars['String']>,
  boletoCodigoBarra?: Maybe<Scalars['String']>,
  boletoAnexo?: Maybe<Scalars['String']>,
};

export type EmprestimoFormaPagamentoPagarInput = {
  id?: Maybe<Scalars['ID']>,
  anexo?: Maybe<Scalars['String']>,
};

export type EmprestimoFuncionarioNodeTypeRalay = Node & {
   __typename?: 'EmprestimoFuncionarioNodeTypeRalay',
  /** The ID of the object. */
  id: Scalars['ID'],
  entidade?: Maybe<EntidadeTypeRelay>,
  cliente?: Maybe<EmprestimoClienteNode>,
  funcionario: FuncionarioTypeRelay,
  valorDesejado: Scalars['Float'],
  valorTotal?: Maybe<Scalars['Float']>,
  bonusFuncionario?: Maybe<Scalars['Decimal']>,
  taxaAplicada: Scalars['Float'],
  parcelas: EmprestimoParcelas,
  tabelaTaxa?: Maybe<Scalars['String']>,
  delivery: Scalars['Boolean'],
  maquina?: Maybe<Scalars['String']>,
  nsuCartao?: Maybe<Scalars['String']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  anexoContrato?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  data: Scalars['Date'],
  taxaMinima?: Maybe<Scalars['Float']>,
  justificativaTaxaAbaixo?: Maybe<Scalars['String']>,
  justificativaCancelamento?: Maybe<Scalars['String']>,
  status: EmprestimoStatus,
  causaStatus?: Maybe<Scalars['String']>,
  clickSignChaveDocumento?: Maybe<Scalars['String']>,
  solicitadoVia: EmprestimoSolicitadoVia,
  vendaDigitada: Scalars['Boolean'],
  vendaResgatada: Scalars['Boolean'],
  leadId?: Maybe<Scalars['Int']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateNodeTypeRelay>,
  loanTypePayload?: Maybe<Scalars['JSONString']>,
  loanType?: Maybe<TipoDeEmprestimoRelayType>,
  extraFieldsResults?: Maybe<Scalars['JSONString']>,
  iof?: Maybe<Scalars['Float']>,
  nsus: NsuRelatorioTypeConnection,
  formasPagamento: Array<FormaPagamentoEmprestimoType>,
  anexos: Array<AnexoDeEmprestimoType>,
  comissaoparceirosSet: ComissaoNodeTypeRelayConnection,
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  comissaofuncionariosSet?: Maybe<Array<Maybe<ComissaoFuncionariosType>>>,
  zekiGiftback?: Maybe<ZekiGiftbackResgateType>,
};


export type EmprestimoFuncionarioNodeTypeRalayNsusArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type EmprestimoFuncionarioNodeTypeRalayComissaoparceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Nsu_Parcelas?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_In?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_Iexact?: Maybe<Scalars['String']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  dataRepasse?: Maybe<Scalars['Date']>,
  dataRepasse_Gte?: Maybe<Scalars['Date']>,
  dataRepasse_Gt?: Maybe<Scalars['Date']>,
  dataRepasse_Lt?: Maybe<Scalars['Date']>,
  dataRepasse_Lte?: Maybe<Scalars['Date']>,
  emprestimo_CriadoEm?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gte?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lte?: Maybe<Scalars['DateTime']>,
  emprestimo_Data?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gte?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lte?: Maybe<Scalars['Date']>,
  valorComissao?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};

export type EmprestimoFuncionarioNodeTypeRalayConnection = {
   __typename?: 'EmprestimoFuncionarioNodeTypeRalayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmprestimoFuncionarioNodeTypeRalayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `EmprestimoFuncionarioNodeTypeRalay` and its cursor. */
export type EmprestimoFuncionarioNodeTypeRalayEdge = {
   __typename?: 'EmprestimoFuncionarioNodeTypeRalayEdge',
  /** The item at the end of the edge */
  node?: Maybe<EmprestimoFuncionarioNodeTypeRalay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type EmprestimoNode = Node & {
   __typename?: 'EmprestimoNode',
  /** The ID of the object. */
  id: Scalars['ID'],
  entidade?: Maybe<EntidadeTypeRelay>,
  cliente?: Maybe<EmprestimoClienteNode>,
  funcionario: FuncionarioTypeRelay,
  valorDesejado: Scalars['Float'],
  valorTotal?: Maybe<Scalars['Float']>,
  bonusFuncionario?: Maybe<Scalars['Decimal']>,
  taxaAplicada: Scalars['Float'],
  parcelas: EmprestimoParcelas,
  tabelaTaxa?: Maybe<Scalars['String']>,
  delivery: Scalars['Boolean'],
  maquina?: Maybe<Scalars['String']>,
  nsuCartao?: Maybe<Scalars['String']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  anexoContrato?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  data: Scalars['Date'],
  taxaMinima?: Maybe<Scalars['Float']>,
  justificativaTaxaAbaixo?: Maybe<Scalars['String']>,
  justificativaCancelamento?: Maybe<Scalars['String']>,
  status: EmprestimoStatus,
  causaStatus?: Maybe<Scalars['String']>,
  clickSignChaveDocumento?: Maybe<Scalars['String']>,
  solicitadoVia: EmprestimoSolicitadoVia,
  vendaDigitada: Scalars['Boolean'],
  vendaResgatada: Scalars['Boolean'],
  leadId?: Maybe<Scalars['Int']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateNodeTypeRelay>,
  loanTypePayload?: Maybe<Scalars['JSONString']>,
  loanType?: Maybe<TipoDeEmprestimoRelayType>,
  extraFieldsResults?: Maybe<Scalars['JSONString']>,
  iof?: Maybe<Scalars['Float']>,
  nsus: Array<NsuType>,
  formasPagamento: Array<FormaPagamentoEmprestimoType>,
  anexos: Array<AnexoDeEmprestimoType>,
  comissaoparceirosSet: ComissaoNodeTypeRelayConnection,
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  comissaofuncionariosSet: ComissaoFuncionarioNodeTypeRelayConnection,
  zekiGiftback?: Maybe<ZekiGiftbackResgateType>,
  pk: Scalars['Int'],
};


export type EmprestimoNodeComissaoparceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Nsu_Parcelas?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_In?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_Iexact?: Maybe<Scalars['String']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  dataRepasse?: Maybe<Scalars['Date']>,
  dataRepasse_Gte?: Maybe<Scalars['Date']>,
  dataRepasse_Gt?: Maybe<Scalars['Date']>,
  dataRepasse_Lt?: Maybe<Scalars['Date']>,
  dataRepasse_Lte?: Maybe<Scalars['Date']>,
  emprestimo_CriadoEm?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gte?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lte?: Maybe<Scalars['DateTime']>,
  emprestimo_Data?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gte?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lte?: Maybe<Scalars['Date']>,
  valorComissao?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EmprestimoNodeComissaofuncionariosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  emprestimo_Id_In?: Maybe<Scalars['String']>,
  emprestimo_Funcionario_Id?: Maybe<Scalars['ID']>,
  emprestimo_Parcelas?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  tipoComissao?: Maybe<Scalars['String']>,
  valorComissao?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

export type EmprestimoNodeConnection = {
   __typename?: 'EmprestimoNodeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmprestimoNodeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `EmprestimoNode` and its cursor. */
export type EmprestimoNodeEdge = {
   __typename?: 'EmprestimoNodeEdge',
  /** The item at the end of the edge */
  node?: Maybe<EmprestimoNode>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type EmprestimoNodeTypeRelay = Node & {
   __typename?: 'EmprestimoNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  entidade?: Maybe<EntidadeTypeRelay>,
  cliente?: Maybe<EmprestimoClienteNode>,
  funcionario: FuncionarioTypeRelay,
  valorDesejado: Scalars['Float'],
  valorTotal?: Maybe<Scalars['Float']>,
  bonusFuncionario?: Maybe<Scalars['Decimal']>,
  taxaAplicada: Scalars['Float'],
  parcelas: EmprestimoParcelas,
  tabelaTaxa?: Maybe<Scalars['String']>,
  delivery: Scalars['Boolean'],
  maquina?: Maybe<Scalars['String']>,
  nsuCartao?: Maybe<Scalars['String']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  anexoContrato?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  data: Scalars['Date'],
  taxaMinima?: Maybe<Scalars['Float']>,
  justificativaTaxaAbaixo?: Maybe<Scalars['String']>,
  justificativaCancelamento?: Maybe<Scalars['String']>,
  status: EmprestimoStatus,
  causaStatus?: Maybe<Scalars['String']>,
  clickSignChaveDocumento?: Maybe<Scalars['String']>,
  solicitadoVia: EmprestimoSolicitadoVia,
  vendaDigitada: Scalars['Boolean'],
  vendaResgatada: Scalars['Boolean'],
  leadId?: Maybe<Scalars['Int']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateNodeTypeRelay>,
  loanTypePayload?: Maybe<Scalars['JSONString']>,
  loanType?: Maybe<TipoDeEmprestimoRelayType>,
  extraFieldsResults?: Maybe<Scalars['JSONString']>,
  iof?: Maybe<Scalars['Float']>,
  nsus: Array<NsuType>,
  formasPagamento: Array<FormaPagamentoEmprestimoType>,
  anexos: Array<AnexoDeEmprestimoType>,
  comissaoparceirosSet: ComissaoNodeTypeRelayConnection,
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  comissaofuncionariosSet: ComissaoFuncionarioNodeTypeRelayConnection,
  zekiGiftback?: Maybe<ZekiGiftbackResgateType>,
};


export type EmprestimoNodeTypeRelayComissaoparceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Nsu_Parcelas?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_In?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_Iexact?: Maybe<Scalars['String']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  dataRepasse?: Maybe<Scalars['Date']>,
  dataRepasse_Gte?: Maybe<Scalars['Date']>,
  dataRepasse_Gt?: Maybe<Scalars['Date']>,
  dataRepasse_Lt?: Maybe<Scalars['Date']>,
  dataRepasse_Lte?: Maybe<Scalars['Date']>,
  emprestimo_CriadoEm?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gte?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lte?: Maybe<Scalars['DateTime']>,
  emprestimo_Data?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gte?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lte?: Maybe<Scalars['Date']>,
  valorComissao?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EmprestimoNodeTypeRelayComissaofuncionariosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  emprestimo_Id_In?: Maybe<Scalars['String']>,
  emprestimo_Funcionario_Id?: Maybe<Scalars['ID']>,
  emprestimo_Parcelas?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  tipoComissao?: Maybe<Scalars['String']>,
  valorComissao?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

export type EmprestimoNodeTypeRelayConnection = {
   __typename?: 'EmprestimoNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmprestimoNodeTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `EmprestimoNodeTypeRelay` and its cursor. */
export type EmprestimoNodeTypeRelayEdge = {
   __typename?: 'EmprestimoNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<EmprestimoNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum EmprestimoParcelas {
  /** 1x */
  A_1 = 'A_1',
  /** 2x */
  A_2 = 'A_2',
  /** 3x */
  A_3 = 'A_3',
  /** 4x */
  A_4 = 'A_4',
  /** 5x */
  A_5 = 'A_5',
  /** 6x */
  A_6 = 'A_6',
  /** 7x */
  A_7 = 'A_7',
  /** 8x */
  A_8 = 'A_8',
  /** 9x */
  A_9 = 'A_9',
  /** 10x */
  A_10 = 'A_10',
  /** 11x */
  A_11 = 'A_11',
  /** 12x */
  A_12 = 'A_12',
  /** 13x */
  A_13 = 'A_13',
  /** 14x */
  A_14 = 'A_14',
  /** 15x */
  A_15 = 'A_15',
  /** 16x */
  A_16 = 'A_16',
  /** 17x */
  A_17 = 'A_17',
  /** 18x */
  A_18 = 'A_18',
  /** 19x */
  A_19 = 'A_19',
  /** 20x */
  A_20 = 'A_20',
  /** 21x */
  A_21 = 'A_21',
  /** 22x */
  A_22 = 'A_22',
  /** 23x */
  A_23 = 'A_23',
  /** 24x */
  A_24 = 'A_24',
  /** 25x */
  A_25 = 'A_25',
  /** 26x */
  A_26 = 'A_26',
  /** 27x */
  A_27 = 'A_27',
  /** 28x */
  A_28 = 'A_28',
  /** 29x */
  A_29 = 'A_29',
  /** 30x */
  A_30 = 'A_30',
  /** 31x */
  A_31 = 'A_31',
  /** 32x */
  A_32 = 'A_32',
  /** 33x */
  A_33 = 'A_33',
  /** 34x */
  A_34 = 'A_34',
  /** 35x */
  A_35 = 'A_35',
  /** 36x */
  A_36 = 'A_36',
  /** 37x */
  A_37 = 'A_37',
  /** 38x */
  A_38 = 'A_38',
  /** 39x */
  A_39 = 'A_39',
  /** 40x */
  A_40 = 'A_40',
  /** 41x */
  A_41 = 'A_41',
  /** 42x */
  A_42 = 'A_42',
  /** 43x */
  A_43 = 'A_43',
  /** 44x */
  A_44 = 'A_44',
  /** 45x */
  A_45 = 'A_45',
  /** 46x */
  A_46 = 'A_46',
  /** 47x */
  A_47 = 'A_47',
  /** 48x */
  A_48 = 'A_48',
  /** 49x */
  A_49 = 'A_49',
  /** 50x */
  A_50 = 'A_50',
  /** 51x */
  A_51 = 'A_51',
  /** 52x */
  A_52 = 'A_52',
  /** 53x */
  A_53 = 'A_53',
  /** 54x */
  A_54 = 'A_54',
  /** 55x */
  A_55 = 'A_55',
  /** 56x */
  A_56 = 'A_56',
  /** 57x */
  A_57 = 'A_57',
  /** 58x */
  A_58 = 'A_58',
  /** 59x */
  A_59 = 'A_59',
  /** 60x */
  A_60 = 'A_60',
  /** 61x */
  A_61 = 'A_61',
  /** 62x */
  A_62 = 'A_62',
  /** 63x */
  A_63 = 'A_63',
  /** 64x */
  A_64 = 'A_64',
  /** 65x */
  A_65 = 'A_65',
  /** 66x */
  A_66 = 'A_66',
  /** 67x */
  A_67 = 'A_67',
  /** 68x */
  A_68 = 'A_68',
  /** 69x */
  A_69 = 'A_69',
  /** 70x */
  A_70 = 'A_70',
  /** 71x */
  A_71 = 'A_71',
  /** 72x */
  A_72 = 'A_72',
  /** 73x */
  A_73 = 'A_73',
  /** 74x */
  A_74 = 'A_74',
  /** 75x */
  A_75 = 'A_75',
  /** 76x */
  A_76 = 'A_76',
  /** 77x */
  A_77 = 'A_77',
  /** 78x */
  A_78 = 'A_78',
  /** 79x */
  A_79 = 'A_79',
  /** 80x */
  A_80 = 'A_80',
  /** 81x */
  A_81 = 'A_81',
  /** 82x */
  A_82 = 'A_82',
  /** 83x */
  A_83 = 'A_83',
  /** 84x */
  A_84 = 'A_84',
  /** 85x */
  A_85 = 'A_85',
  /** 86x */
  A_86 = 'A_86',
  /** 87x */
  A_87 = 'A_87',
  /** 88x */
  A_88 = 'A_88',
  /** 89x */
  A_89 = 'A_89',
  /** 90x */
  A_90 = 'A_90',
  /** 91x */
  A_91 = 'A_91',
  /** 92x */
  A_92 = 'A_92',
  /** 93x */
  A_93 = 'A_93',
  /** 94x */
  A_94 = 'A_94',
  /** 95x */
  A_95 = 'A_95',
  /** 96x */
  A_96 = 'A_96',
  /** 97x */
  A_97 = 'A_97',
  /** 98x */
  A_98 = 'A_98',
  /** 99x */
  A_99 = 'A_99',
  /** 100x */
  A_100 = 'A_100',
  /** 101x */
  A_101 = 'A_101',
  /** 102x */
  A_102 = 'A_102',
  /** 103x */
  A_103 = 'A_103',
  /** 104x */
  A_104 = 'A_104',
  /** 105x */
  A_105 = 'A_105',
  /** 106x */
  A_106 = 'A_106',
  /** 107x */
  A_107 = 'A_107',
  /** 108x */
  A_108 = 'A_108',
  /** 109x */
  A_109 = 'A_109',
  /** 110x */
  A_110 = 'A_110',
  /** 111x */
  A_111 = 'A_111',
  /** 112x */
  A_112 = 'A_112',
  /** 113x */
  A_113 = 'A_113',
  /** 114x */
  A_114 = 'A_114',
  /** 115x */
  A_115 = 'A_115',
  /** 116x */
  A_116 = 'A_116',
  /** 117x */
  A_117 = 'A_117',
  /** 118x */
  A_118 = 'A_118',
  /** 119x */
  A_119 = 'A_119',
  /** 120x */
  A_120 = 'A_120',
  /** 121x */
  A_121 = 'A_121',
  /** 122x */
  A_122 = 'A_122',
  /** 123x */
  A_123 = 'A_123',
  /** 124x */
  A_124 = 'A_124',
  /** 125x */
  A_125 = 'A_125',
  /** 126x */
  A_126 = 'A_126',
  /** 127x */
  A_127 = 'A_127',
  /** 128x */
  A_128 = 'A_128',
  /** 129x */
  A_129 = 'A_129',
  /** 130x */
  A_130 = 'A_130',
  /** 131x */
  A_131 = 'A_131',
  /** 132x */
  A_132 = 'A_132',
  /** 133x */
  A_133 = 'A_133',
  /** 134x */
  A_134 = 'A_134',
  /** 135x */
  A_135 = 'A_135',
  /** 136x */
  A_136 = 'A_136',
  /** 137x */
  A_137 = 'A_137',
  /** 138x */
  A_138 = 'A_138',
  /** 139x */
  A_139 = 'A_139',
  /** 140x */
  A_140 = 'A_140',
  /** 141x */
  A_141 = 'A_141',
  /** 142x */
  A_142 = 'A_142',
  /** 143x */
  A_143 = 'A_143',
  /** 144x */
  A_144 = 'A_144',
  /** 145x */
  A_145 = 'A_145',
  /** 146x */
  A_146 = 'A_146',
  /** 147x */
  A_147 = 'A_147',
  /** 148x */
  A_148 = 'A_148',
  /** 149x */
  A_149 = 'A_149',
  /** 150x */
  A_150 = 'A_150',
  /** 151x */
  A_151 = 'A_151',
  /** 152x */
  A_152 = 'A_152',
  /** 153x */
  A_153 = 'A_153',
  /** 154x */
  A_154 = 'A_154',
  /** 155x */
  A_155 = 'A_155',
  /** 156x */
  A_156 = 'A_156',
  /** 157x */
  A_157 = 'A_157',
  /** 158x */
  A_158 = 'A_158',
  /** 159x */
  A_159 = 'A_159',
  /** 160x */
  A_160 = 'A_160',
  /** 161x */
  A_161 = 'A_161',
  /** 162x */
  A_162 = 'A_162',
  /** 163x */
  A_163 = 'A_163',
  /** 164x */
  A_164 = 'A_164',
  /** 165x */
  A_165 = 'A_165',
  /** 166x */
  A_166 = 'A_166',
  /** 167x */
  A_167 = 'A_167',
  /** 168x */
  A_168 = 'A_168',
  /** 169x */
  A_169 = 'A_169',
  /** 170x */
  A_170 = 'A_170',
  /** 171x */
  A_171 = 'A_171',
  /** 172x */
  A_172 = 'A_172',
  /** 173x */
  A_173 = 'A_173',
  /** 174x */
  A_174 = 'A_174',
  /** 175x */
  A_175 = 'A_175',
  /** 176x */
  A_176 = 'A_176',
  /** 177x */
  A_177 = 'A_177',
  /** 178x */
  A_178 = 'A_178',
  /** 179x */
  A_179 = 'A_179',
  /** 180x */
  A_180 = 'A_180',
  /** 181x */
  A_181 = 'A_181',
  /** 182x */
  A_182 = 'A_182',
  /** 183x */
  A_183 = 'A_183',
  /** 184x */
  A_184 = 'A_184',
  /** 185x */
  A_185 = 'A_185',
  /** 186x */
  A_186 = 'A_186',
  /** 187x */
  A_187 = 'A_187',
  /** 188x */
  A_188 = 'A_188',
  /** 189x */
  A_189 = 'A_189',
  /** 190x */
  A_190 = 'A_190',
  /** 191x */
  A_191 = 'A_191',
  /** 192x */
  A_192 = 'A_192',
  /** 193x */
  A_193 = 'A_193',
  /** 194x */
  A_194 = 'A_194',
  /** 195x */
  A_195 = 'A_195',
  /** 196x */
  A_196 = 'A_196',
  /** 197x */
  A_197 = 'A_197',
  /** 198x */
  A_198 = 'A_198',
  /** 199x */
  A_199 = 'A_199',
  /** 200x */
  A_200 = 'A_200',
  /** 201x */
  A_201 = 'A_201',
  /** 202x */
  A_202 = 'A_202',
  /** 203x */
  A_203 = 'A_203',
  /** 204x */
  A_204 = 'A_204',
  /** 205x */
  A_205 = 'A_205',
  /** 206x */
  A_206 = 'A_206',
  /** 207x */
  A_207 = 'A_207',
  /** 208x */
  A_208 = 'A_208',
  /** 209x */
  A_209 = 'A_209',
  /** 210x */
  A_210 = 'A_210',
  /** 211x */
  A_211 = 'A_211',
  /** 212x */
  A_212 = 'A_212',
  /** 213x */
  A_213 = 'A_213',
  /** 214x */
  A_214 = 'A_214',
  /** 215x */
  A_215 = 'A_215',
  /** 216x */
  A_216 = 'A_216',
  /** 217x */
  A_217 = 'A_217',
  /** 218x */
  A_218 = 'A_218',
  /** 219x */
  A_219 = 'A_219',
  /** 220x */
  A_220 = 'A_220',
  /** 221x */
  A_221 = 'A_221',
  /** 222x */
  A_222 = 'A_222',
  /** 223x */
  A_223 = 'A_223',
  /** 224x */
  A_224 = 'A_224',
  /** 225x */
  A_225 = 'A_225',
  /** 226x */
  A_226 = 'A_226',
  /** 227x */
  A_227 = 'A_227',
  /** 228x */
  A_228 = 'A_228',
  /** 229x */
  A_229 = 'A_229',
  /** 230x */
  A_230 = 'A_230',
  /** 231x */
  A_231 = 'A_231',
  /** 232x */
  A_232 = 'A_232',
  /** 233x */
  A_233 = 'A_233',
  /** 234x */
  A_234 = 'A_234',
  /** 235x */
  A_235 = 'A_235',
  /** 236x */
  A_236 = 'A_236',
  /** 237x */
  A_237 = 'A_237',
  /** 238x */
  A_238 = 'A_238',
  /** 239x */
  A_239 = 'A_239',
  /** 240x */
  A_240 = 'A_240',
  /** 241x */
  A_241 = 'A_241',
  /** 242x */
  A_242 = 'A_242',
  /** 243x */
  A_243 = 'A_243',
  /** 244x */
  A_244 = 'A_244',
  /** 245x */
  A_245 = 'A_245',
  /** 246x */
  A_246 = 'A_246',
  /** 247x */
  A_247 = 'A_247',
  /** 248x */
  A_248 = 'A_248',
  /** 249x */
  A_249 = 'A_249',
  /** 250x */
  A_250 = 'A_250',
  /** 251x */
  A_251 = 'A_251',
  /** 252x */
  A_252 = 'A_252',
  /** 253x */
  A_253 = 'A_253',
  /** 254x */
  A_254 = 'A_254',
  /** 255x */
  A_255 = 'A_255',
  /** 256x */
  A_256 = 'A_256',
  /** 257x */
  A_257 = 'A_257',
  /** 258x */
  A_258 = 'A_258',
  /** 259x */
  A_259 = 'A_259',
  /** 260x */
  A_260 = 'A_260',
  /** 261x */
  A_261 = 'A_261',
  /** 262x */
  A_262 = 'A_262',
  /** 263x */
  A_263 = 'A_263',
  /** 264x */
  A_264 = 'A_264',
  /** 265x */
  A_265 = 'A_265',
  /** 266x */
  A_266 = 'A_266',
  /** 267x */
  A_267 = 'A_267',
  /** 268x */
  A_268 = 'A_268',
  /** 269x */
  A_269 = 'A_269',
  /** 270x */
  A_270 = 'A_270',
  /** 271x */
  A_271 = 'A_271',
  /** 272x */
  A_272 = 'A_272',
  /** 273x */
  A_273 = 'A_273',
  /** 274x */
  A_274 = 'A_274',
  /** 275x */
  A_275 = 'A_275',
  /** 276x */
  A_276 = 'A_276',
  /** 277x */
  A_277 = 'A_277',
  /** 278x */
  A_278 = 'A_278',
  /** 279x */
  A_279 = 'A_279',
  /** 280x */
  A_280 = 'A_280',
  /** 281x */
  A_281 = 'A_281',
  /** 282x */
  A_282 = 'A_282',
  /** 283x */
  A_283 = 'A_283',
  /** 284x */
  A_284 = 'A_284',
  /** 285x */
  A_285 = 'A_285',
  /** 286x */
  A_286 = 'A_286',
  /** 287x */
  A_287 = 'A_287',
  /** 288x */
  A_288 = 'A_288',
  /** 289x */
  A_289 = 'A_289',
  /** 290x */
  A_290 = 'A_290',
  /** 291x */
  A_291 = 'A_291',
  /** 292x */
  A_292 = 'A_292',
  /** 293x */
  A_293 = 'A_293',
  /** 294x */
  A_294 = 'A_294',
  /** 295x */
  A_295 = 'A_295',
  /** 296x */
  A_296 = 'A_296',
  /** 297x */
  A_297 = 'A_297',
  /** 298x */
  A_298 = 'A_298',
  /** 299x */
  A_299 = 'A_299',
  /** 300x */
  A_300 = 'A_300',
  /** 301x */
  A_301 = 'A_301',
  /** 302x */
  A_302 = 'A_302',
  /** 303x */
  A_303 = 'A_303',
  /** 304x */
  A_304 = 'A_304',
  /** 305x */
  A_305 = 'A_305',
  /** 306x */
  A_306 = 'A_306',
  /** 307x */
  A_307 = 'A_307',
  /** 308x */
  A_308 = 'A_308',
  /** 309x */
  A_309 = 'A_309',
  /** 310x */
  A_310 = 'A_310',
  /** 311x */
  A_311 = 'A_311',
  /** 312x */
  A_312 = 'A_312',
  /** 313x */
  A_313 = 'A_313',
  /** 314x */
  A_314 = 'A_314',
  /** 315x */
  A_315 = 'A_315',
  /** 316x */
  A_316 = 'A_316',
  /** 317x */
  A_317 = 'A_317',
  /** 318x */
  A_318 = 'A_318',
  /** 319x */
  A_319 = 'A_319',
  /** 320x */
  A_320 = 'A_320',
  /** 321x */
  A_321 = 'A_321',
  /** 322x */
  A_322 = 'A_322',
  /** 323x */
  A_323 = 'A_323',
  /** 324x */
  A_324 = 'A_324',
  /** 325x */
  A_325 = 'A_325',
  /** 326x */
  A_326 = 'A_326',
  /** 327x */
  A_327 = 'A_327',
  /** 328x */
  A_328 = 'A_328',
  /** 329x */
  A_329 = 'A_329',
  /** 330x */
  A_330 = 'A_330',
  /** 331x */
  A_331 = 'A_331',
  /** 332x */
  A_332 = 'A_332',
  /** 333x */
  A_333 = 'A_333',
  /** 334x */
  A_334 = 'A_334',
  /** 335x */
  A_335 = 'A_335',
  /** 336x */
  A_336 = 'A_336',
  /** 337x */
  A_337 = 'A_337',
  /** 338x */
  A_338 = 'A_338',
  /** 339x */
  A_339 = 'A_339',
  /** 340x */
  A_340 = 'A_340',
  /** 341x */
  A_341 = 'A_341',
  /** 342x */
  A_342 = 'A_342',
  /** 343x */
  A_343 = 'A_343',
  /** 344x */
  A_344 = 'A_344',
  /** 345x */
  A_345 = 'A_345',
  /** 346x */
  A_346 = 'A_346',
  /** 347x */
  A_347 = 'A_347',
  /** 348x */
  A_348 = 'A_348',
  /** 349x */
  A_349 = 'A_349',
  /** 350x */
  A_350 = 'A_350',
  /** 351x */
  A_351 = 'A_351',
  /** 352x */
  A_352 = 'A_352',
  /** 353x */
  A_353 = 'A_353',
  /** 354x */
  A_354 = 'A_354',
  /** 355x */
  A_355 = 'A_355',
  /** 356x */
  A_356 = 'A_356',
  /** 357x */
  A_357 = 'A_357',
  /** 358x */
  A_358 = 'A_358',
  /** 359x */
  A_359 = 'A_359',
  /** 360x */
  A_360 = 'A_360',
  /** 361x */
  A_361 = 'A_361',
  /** 362x */
  A_362 = 'A_362',
  /** 363x */
  A_363 = 'A_363',
  /** 364x */
  A_364 = 'A_364',
  /** 365x */
  A_365 = 'A_365',
  /** 366x */
  A_366 = 'A_366',
  /** 367x */
  A_367 = 'A_367',
  /** 368x */
  A_368 = 'A_368',
  /** 369x */
  A_369 = 'A_369',
  /** 370x */
  A_370 = 'A_370',
  /** 371x */
  A_371 = 'A_371',
  /** 372x */
  A_372 = 'A_372',
  /** 373x */
  A_373 = 'A_373',
  /** 374x */
  A_374 = 'A_374',
  /** 375x */
  A_375 = 'A_375',
  /** 376x */
  A_376 = 'A_376',
  /** 377x */
  A_377 = 'A_377',
  /** 378x */
  A_378 = 'A_378',
  /** 379x */
  A_379 = 'A_379',
  /** 380x */
  A_380 = 'A_380',
  /** 381x */
  A_381 = 'A_381',
  /** 382x */
  A_382 = 'A_382',
  /** 383x */
  A_383 = 'A_383',
  /** 384x */
  A_384 = 'A_384',
  /** 385x */
  A_385 = 'A_385',
  /** 386x */
  A_386 = 'A_386',
  /** 387x */
  A_387 = 'A_387',
  /** 388x */
  A_388 = 'A_388',
  /** 389x */
  A_389 = 'A_389',
  /** 390x */
  A_390 = 'A_390',
  /** 391x */
  A_391 = 'A_391',
  /** 392x */
  A_392 = 'A_392',
  /** 393x */
  A_393 = 'A_393',
  /** 394x */
  A_394 = 'A_394',
  /** 395x */
  A_395 = 'A_395',
  /** 396x */
  A_396 = 'A_396',
  /** 397x */
  A_397 = 'A_397',
  /** 398x */
  A_398 = 'A_398',
  /** 399x */
  A_399 = 'A_399',
  /** 400x */
  A_400 = 'A_400',
  /** 401x */
  A_401 = 'A_401',
  /** 402x */
  A_402 = 'A_402',
  /** 403x */
  A_403 = 'A_403',
  /** 404x */
  A_404 = 'A_404',
  /** 405x */
  A_405 = 'A_405',
  /** 406x */
  A_406 = 'A_406',
  /** 407x */
  A_407 = 'A_407',
  /** 408x */
  A_408 = 'A_408',
  /** 409x */
  A_409 = 'A_409',
  /** 410x */
  A_410 = 'A_410',
  /** 411x */
  A_411 = 'A_411',
  /** 412x */
  A_412 = 'A_412',
  /** 413x */
  A_413 = 'A_413',
  /** 414x */
  A_414 = 'A_414',
  /** 415x */
  A_415 = 'A_415',
  /** 416x */
  A_416 = 'A_416',
  /** 417x */
  A_417 = 'A_417',
  /** 418x */
  A_418 = 'A_418',
  /** 419x */
  A_419 = 'A_419',
  /** 420x */
  A_420 = 'A_420',
  /** 421x */
  A_421 = 'A_421',
  /** 422x */
  A_422 = 'A_422',
  /** 423x */
  A_423 = 'A_423',
  /** 424x */
  A_424 = 'A_424',
  /** 425x */
  A_425 = 'A_425',
  /** 426x */
  A_426 = 'A_426',
  /** 427x */
  A_427 = 'A_427',
  /** 428x */
  A_428 = 'A_428',
  /** 429x */
  A_429 = 'A_429',
  /** 430x */
  A_430 = 'A_430',
  /** 431x */
  A_431 = 'A_431',
  /** 432x */
  A_432 = 'A_432',
  /** 433x */
  A_433 = 'A_433',
  /** 434x */
  A_434 = 'A_434',
  /** 435x */
  A_435 = 'A_435',
  /** 436x */
  A_436 = 'A_436',
  /** 437x */
  A_437 = 'A_437',
  /** 438x */
  A_438 = 'A_438',
  /** 439x */
  A_439 = 'A_439',
  /** 440x */
  A_440 = 'A_440',
  /** 441x */
  A_441 = 'A_441',
  /** 442x */
  A_442 = 'A_442',
  /** 443x */
  A_443 = 'A_443',
  /** 444x */
  A_444 = 'A_444',
  /** 445x */
  A_445 = 'A_445',
  /** 446x */
  A_446 = 'A_446',
  /** 447x */
  A_447 = 'A_447',
  /** 448x */
  A_448 = 'A_448',
  /** 449x */
  A_449 = 'A_449',
  /** 450x */
  A_450 = 'A_450',
  /** 451x */
  A_451 = 'A_451',
  /** 452x */
  A_452 = 'A_452',
  /** 453x */
  A_453 = 'A_453',
  /** 454x */
  A_454 = 'A_454',
  /** 455x */
  A_455 = 'A_455',
  /** 456x */
  A_456 = 'A_456',
  /** 457x */
  A_457 = 'A_457',
  /** 458x */
  A_458 = 'A_458',
  /** 459x */
  A_459 = 'A_459',
  /** 460x */
  A_460 = 'A_460',
  /** 461x */
  A_461 = 'A_461',
  /** 462x */
  A_462 = 'A_462',
  /** 463x */
  A_463 = 'A_463',
  /** 464x */
  A_464 = 'A_464',
  /** 465x */
  A_465 = 'A_465',
  /** 466x */
  A_466 = 'A_466',
  /** 467x */
  A_467 = 'A_467',
  /** 468x */
  A_468 = 'A_468',
  /** 469x */
  A_469 = 'A_469',
  /** 470x */
  A_470 = 'A_470',
  /** 471x */
  A_471 = 'A_471',
  /** 472x */
  A_472 = 'A_472',
  /** 473x */
  A_473 = 'A_473',
  /** 474x */
  A_474 = 'A_474',
  /** 475x */
  A_475 = 'A_475',
  /** 476x */
  A_476 = 'A_476',
  /** 477x */
  A_477 = 'A_477',
  /** 478x */
  A_478 = 'A_478',
  /** 479x */
  A_479 = 'A_479',
  /** 480x */
  A_480 = 'A_480',
  /** 481x */
  A_481 = 'A_481',
  /** 482x */
  A_482 = 'A_482',
  /** 483x */
  A_483 = 'A_483',
  /** 484x */
  A_484 = 'A_484',
  /** 485x */
  A_485 = 'A_485',
  /** 486x */
  A_486 = 'A_486',
  /** 487x */
  A_487 = 'A_487',
  /** 488x */
  A_488 = 'A_488',
  /** 489x */
  A_489 = 'A_489',
  /** 490x */
  A_490 = 'A_490',
  /** 491x */
  A_491 = 'A_491',
  /** 492x */
  A_492 = 'A_492',
  /** 493x */
  A_493 = 'A_493',
  /** 494x */
  A_494 = 'A_494',
  /** 495x */
  A_495 = 'A_495',
  /** 496x */
  A_496 = 'A_496',
  /** 497x */
  A_497 = 'A_497',
  /** 498x */
  A_498 = 'A_498',
  /** 499x */
  A_499 = 'A_499',
  /** 500x */
  A_500 = 'A_500',
  /** 501x */
  A_501 = 'A_501',
  /** 502x */
  A_502 = 'A_502',
  /** 503x */
  A_503 = 'A_503',
  /** 504x */
  A_504 = 'A_504',
  /** 505x */
  A_505 = 'A_505',
  /** 506x */
  A_506 = 'A_506',
  /** 507x */
  A_507 = 'A_507',
  /** 508x */
  A_508 = 'A_508',
  /** 509x */
  A_509 = 'A_509',
  /** 510x */
  A_510 = 'A_510',
  /** 511x */
  A_511 = 'A_511',
  /** 512x */
  A_512 = 'A_512',
  /** 513x */
  A_513 = 'A_513',
  /** 514x */
  A_514 = 'A_514',
  /** 515x */
  A_515 = 'A_515',
  /** 516x */
  A_516 = 'A_516',
  /** 517x */
  A_517 = 'A_517',
  /** 518x */
  A_518 = 'A_518',
  /** 519x */
  A_519 = 'A_519',
  /** 520x */
  A_520 = 'A_520',
  /** 521x */
  A_521 = 'A_521',
  /** 522x */
  A_522 = 'A_522',
  /** 523x */
  A_523 = 'A_523',
  /** 524x */
  A_524 = 'A_524',
  /** 525x */
  A_525 = 'A_525',
  /** 526x */
  A_526 = 'A_526',
  /** 527x */
  A_527 = 'A_527',
  /** 528x */
  A_528 = 'A_528',
  /** 529x */
  A_529 = 'A_529',
  /** 530x */
  A_530 = 'A_530',
  /** 531x */
  A_531 = 'A_531',
  /** 532x */
  A_532 = 'A_532',
  /** 533x */
  A_533 = 'A_533',
  /** 534x */
  A_534 = 'A_534',
  /** 535x */
  A_535 = 'A_535',
  /** 536x */
  A_536 = 'A_536',
  /** 537x */
  A_537 = 'A_537',
  /** 538x */
  A_538 = 'A_538',
  /** 539x */
  A_539 = 'A_539',
  /** 540x */
  A_540 = 'A_540',
  /** 541x */
  A_541 = 'A_541',
  /** 542x */
  A_542 = 'A_542',
  /** 543x */
  A_543 = 'A_543',
  /** 544x */
  A_544 = 'A_544',
  /** 545x */
  A_545 = 'A_545',
  /** 546x */
  A_546 = 'A_546',
  /** 547x */
  A_547 = 'A_547',
  /** 548x */
  A_548 = 'A_548',
  /** 549x */
  A_549 = 'A_549',
  /** 550x */
  A_550 = 'A_550',
  /** 551x */
  A_551 = 'A_551',
  /** 552x */
  A_552 = 'A_552',
  /** 553x */
  A_553 = 'A_553',
  /** 554x */
  A_554 = 'A_554',
  /** 555x */
  A_555 = 'A_555',
  /** 556x */
  A_556 = 'A_556',
  /** 557x */
  A_557 = 'A_557',
  /** 558x */
  A_558 = 'A_558',
  /** 559x */
  A_559 = 'A_559',
  /** 560x */
  A_560 = 'A_560',
  /** 561x */
  A_561 = 'A_561',
  /** 562x */
  A_562 = 'A_562',
  /** 563x */
  A_563 = 'A_563',
  /** 564x */
  A_564 = 'A_564',
  /** 565x */
  A_565 = 'A_565',
  /** 566x */
  A_566 = 'A_566',
  /** 567x */
  A_567 = 'A_567',
  /** 568x */
  A_568 = 'A_568',
  /** 569x */
  A_569 = 'A_569',
  /** 570x */
  A_570 = 'A_570',
  /** 571x */
  A_571 = 'A_571',
  /** 572x */
  A_572 = 'A_572',
  /** 573x */
  A_573 = 'A_573',
  /** 574x */
  A_574 = 'A_574',
  /** 575x */
  A_575 = 'A_575',
  /** 576x */
  A_576 = 'A_576',
  /** 577x */
  A_577 = 'A_577',
  /** 578x */
  A_578 = 'A_578',
  /** 579x */
  A_579 = 'A_579',
  /** 580x */
  A_580 = 'A_580',
  /** 581x */
  A_581 = 'A_581',
  /** 582x */
  A_582 = 'A_582',
  /** 583x */
  A_583 = 'A_583',
  /** 584x */
  A_584 = 'A_584',
  /** 585x */
  A_585 = 'A_585',
  /** 586x */
  A_586 = 'A_586',
  /** 587x */
  A_587 = 'A_587',
  /** 588x */
  A_588 = 'A_588',
  /** 589x */
  A_589 = 'A_589',
  /** 590x */
  A_590 = 'A_590',
  /** 591x */
  A_591 = 'A_591',
  /** 592x */
  A_592 = 'A_592',
  /** 593x */
  A_593 = 'A_593',
  /** 594x */
  A_594 = 'A_594',
  /** 595x */
  A_595 = 'A_595',
  /** 596x */
  A_596 = 'A_596',
  /** 597x */
  A_597 = 'A_597',
  /** 598x */
  A_598 = 'A_598',
  /** 599x */
  A_599 = 'A_599',
  /** 600x */
  A_600 = 'A_600',
  /** 601x */
  A_601 = 'A_601',
  /** 602x */
  A_602 = 'A_602',
  /** 603x */
  A_603 = 'A_603',
  /** 604x */
  A_604 = 'A_604',
  /** 605x */
  A_605 = 'A_605',
  /** 606x */
  A_606 = 'A_606',
  /** 607x */
  A_607 = 'A_607',
  /** 608x */
  A_608 = 'A_608',
  /** 609x */
  A_609 = 'A_609',
  /** 610x */
  A_610 = 'A_610',
  /** 611x */
  A_611 = 'A_611',
  /** 612x */
  A_612 = 'A_612',
  /** 613x */
  A_613 = 'A_613',
  /** 614x */
  A_614 = 'A_614',
  /** 615x */
  A_615 = 'A_615',
  /** 616x */
  A_616 = 'A_616',
  /** 617x */
  A_617 = 'A_617',
  /** 618x */
  A_618 = 'A_618',
  /** 619x */
  A_619 = 'A_619',
  /** 620x */
  A_620 = 'A_620',
  /** 621x */
  A_621 = 'A_621',
  /** 622x */
  A_622 = 'A_622',
  /** 623x */
  A_623 = 'A_623',
  /** 624x */
  A_624 = 'A_624',
  /** 625x */
  A_625 = 'A_625',
  /** 626x */
  A_626 = 'A_626',
  /** 627x */
  A_627 = 'A_627',
  /** 628x */
  A_628 = 'A_628',
  /** 629x */
  A_629 = 'A_629',
  /** 630x */
  A_630 = 'A_630',
  /** 631x */
  A_631 = 'A_631',
  /** 632x */
  A_632 = 'A_632',
  /** 633x */
  A_633 = 'A_633',
  /** 634x */
  A_634 = 'A_634',
  /** 635x */
  A_635 = 'A_635',
  /** 636x */
  A_636 = 'A_636',
  /** 637x */
  A_637 = 'A_637',
  /** 638x */
  A_638 = 'A_638',
  /** 639x */
  A_639 = 'A_639',
  /** 640x */
  A_640 = 'A_640',
  /** 641x */
  A_641 = 'A_641',
  /** 642x */
  A_642 = 'A_642',
  /** 643x */
  A_643 = 'A_643',
  /** 644x */
  A_644 = 'A_644',
  /** 645x */
  A_645 = 'A_645',
  /** 646x */
  A_646 = 'A_646',
  /** 647x */
  A_647 = 'A_647',
  /** 648x */
  A_648 = 'A_648',
  /** 649x */
  A_649 = 'A_649',
  /** 650x */
  A_650 = 'A_650',
  /** 651x */
  A_651 = 'A_651',
  /** 652x */
  A_652 = 'A_652',
  /** 653x */
  A_653 = 'A_653',
  /** 654x */
  A_654 = 'A_654',
  /** 655x */
  A_655 = 'A_655',
  /** 656x */
  A_656 = 'A_656',
  /** 657x */
  A_657 = 'A_657',
  /** 658x */
  A_658 = 'A_658',
  /** 659x */
  A_659 = 'A_659',
  /** 660x */
  A_660 = 'A_660',
  /** 661x */
  A_661 = 'A_661',
  /** 662x */
  A_662 = 'A_662',
  /** 663x */
  A_663 = 'A_663',
  /** 664x */
  A_664 = 'A_664',
  /** 665x */
  A_665 = 'A_665',
  /** 666x */
  A_666 = 'A_666',
  /** 667x */
  A_667 = 'A_667',
  /** 668x */
  A_668 = 'A_668',
  /** 669x */
  A_669 = 'A_669',
  /** 670x */
  A_670 = 'A_670',
  /** 671x */
  A_671 = 'A_671',
  /** 672x */
  A_672 = 'A_672',
  /** 673x */
  A_673 = 'A_673',
  /** 674x */
  A_674 = 'A_674',
  /** 675x */
  A_675 = 'A_675',
  /** 676x */
  A_676 = 'A_676',
  /** 677x */
  A_677 = 'A_677',
  /** 678x */
  A_678 = 'A_678',
  /** 679x */
  A_679 = 'A_679',
  /** 680x */
  A_680 = 'A_680',
  /** 681x */
  A_681 = 'A_681',
  /** 682x */
  A_682 = 'A_682',
  /** 683x */
  A_683 = 'A_683',
  /** 684x */
  A_684 = 'A_684',
  /** 685x */
  A_685 = 'A_685',
  /** 686x */
  A_686 = 'A_686',
  /** 687x */
  A_687 = 'A_687',
  /** 688x */
  A_688 = 'A_688',
  /** 689x */
  A_689 = 'A_689',
  /** 690x */
  A_690 = 'A_690',
  /** 691x */
  A_691 = 'A_691',
  /** 692x */
  A_692 = 'A_692',
  /** 693x */
  A_693 = 'A_693',
  /** 694x */
  A_694 = 'A_694',
  /** 695x */
  A_695 = 'A_695',
  /** 696x */
  A_696 = 'A_696',
  /** 697x */
  A_697 = 'A_697',
  /** 698x */
  A_698 = 'A_698',
  /** 699x */
  A_699 = 'A_699',
  /** 700x */
  A_700 = 'A_700',
  /** 701x */
  A_701 = 'A_701',
  /** 702x */
  A_702 = 'A_702',
  /** 703x */
  A_703 = 'A_703',
  /** 704x */
  A_704 = 'A_704',
  /** 705x */
  A_705 = 'A_705',
  /** 706x */
  A_706 = 'A_706',
  /** 707x */
  A_707 = 'A_707',
  /** 708x */
  A_708 = 'A_708',
  /** 709x */
  A_709 = 'A_709',
  /** 710x */
  A_710 = 'A_710',
  /** 711x */
  A_711 = 'A_711',
  /** 712x */
  A_712 = 'A_712',
  /** 713x */
  A_713 = 'A_713',
  /** 714x */
  A_714 = 'A_714',
  /** 715x */
  A_715 = 'A_715',
  /** 716x */
  A_716 = 'A_716',
  /** 717x */
  A_717 = 'A_717',
  /** 718x */
  A_718 = 'A_718',
  /** 719x */
  A_719 = 'A_719',
  /** 720x */
  A_720 = 'A_720',
  /** 721x */
  A_721 = 'A_721',
  /** 722x */
  A_722 = 'A_722',
  /** 723x */
  A_723 = 'A_723',
  /** 724x */
  A_724 = 'A_724',
  /** 725x */
  A_725 = 'A_725',
  /** 726x */
  A_726 = 'A_726',
  /** 727x */
  A_727 = 'A_727',
  /** 728x */
  A_728 = 'A_728',
  /** 729x */
  A_729 = 'A_729',
  /** 730x */
  A_730 = 'A_730',
  /** 731x */
  A_731 = 'A_731',
  /** 732x */
  A_732 = 'A_732',
  /** 733x */
  A_733 = 'A_733',
  /** 734x */
  A_734 = 'A_734',
  /** 735x */
  A_735 = 'A_735',
  /** 736x */
  A_736 = 'A_736',
  /** 737x */
  A_737 = 'A_737',
  /** 738x */
  A_738 = 'A_738',
  /** 739x */
  A_739 = 'A_739',
  /** 740x */
  A_740 = 'A_740',
  /** 741x */
  A_741 = 'A_741',
  /** 742x */
  A_742 = 'A_742',
  /** 743x */
  A_743 = 'A_743',
  /** 744x */
  A_744 = 'A_744',
  /** 745x */
  A_745 = 'A_745',
  /** 746x */
  A_746 = 'A_746',
  /** 747x */
  A_747 = 'A_747',
  /** 748x */
  A_748 = 'A_748',
  /** 749x */
  A_749 = 'A_749',
  /** 750x */
  A_750 = 'A_750',
  /** 751x */
  A_751 = 'A_751',
  /** 752x */
  A_752 = 'A_752',
  /** 753x */
  A_753 = 'A_753',
  /** 754x */
  A_754 = 'A_754',
  /** 755x */
  A_755 = 'A_755',
  /** 756x */
  A_756 = 'A_756',
  /** 757x */
  A_757 = 'A_757',
  /** 758x */
  A_758 = 'A_758',
  /** 759x */
  A_759 = 'A_759',
  /** 760x */
  A_760 = 'A_760',
  /** 761x */
  A_761 = 'A_761',
  /** 762x */
  A_762 = 'A_762',
  /** 763x */
  A_763 = 'A_763',
  /** 764x */
  A_764 = 'A_764',
  /** 765x */
  A_765 = 'A_765',
  /** 766x */
  A_766 = 'A_766',
  /** 767x */
  A_767 = 'A_767',
  /** 768x */
  A_768 = 'A_768',
  /** 769x */
  A_769 = 'A_769',
  /** 770x */
  A_770 = 'A_770',
  /** 771x */
  A_771 = 'A_771',
  /** 772x */
  A_772 = 'A_772',
  /** 773x */
  A_773 = 'A_773',
  /** 774x */
  A_774 = 'A_774',
  /** 775x */
  A_775 = 'A_775',
  /** 776x */
  A_776 = 'A_776',
  /** 777x */
  A_777 = 'A_777',
  /** 778x */
  A_778 = 'A_778',
  /** 779x */
  A_779 = 'A_779',
  /** 780x */
  A_780 = 'A_780',
  /** 781x */
  A_781 = 'A_781',
  /** 782x */
  A_782 = 'A_782',
  /** 783x */
  A_783 = 'A_783',
  /** 784x */
  A_784 = 'A_784',
  /** 785x */
  A_785 = 'A_785',
  /** 786x */
  A_786 = 'A_786',
  /** 787x */
  A_787 = 'A_787',
  /** 788x */
  A_788 = 'A_788',
  /** 789x */
  A_789 = 'A_789',
  /** 790x */
  A_790 = 'A_790',
  /** 791x */
  A_791 = 'A_791',
  /** 792x */
  A_792 = 'A_792',
  /** 793x */
  A_793 = 'A_793',
  /** 794x */
  A_794 = 'A_794',
  /** 795x */
  A_795 = 'A_795',
  /** 796x */
  A_796 = 'A_796',
  /** 797x */
  A_797 = 'A_797',
  /** 798x */
  A_798 = 'A_798',
  /** 799x */
  A_799 = 'A_799',
  /** 800x */
  A_800 = 'A_800',
  /** 801x */
  A_801 = 'A_801',
  /** 802x */
  A_802 = 'A_802',
  /** 803x */
  A_803 = 'A_803',
  /** 804x */
  A_804 = 'A_804',
  /** 805x */
  A_805 = 'A_805',
  /** 806x */
  A_806 = 'A_806',
  /** 807x */
  A_807 = 'A_807',
  /** 808x */
  A_808 = 'A_808',
  /** 809x */
  A_809 = 'A_809',
  /** 810x */
  A_810 = 'A_810',
  /** 811x */
  A_811 = 'A_811',
  /** 812x */
  A_812 = 'A_812',
  /** 813x */
  A_813 = 'A_813',
  /** 814x */
  A_814 = 'A_814',
  /** 815x */
  A_815 = 'A_815',
  /** 816x */
  A_816 = 'A_816',
  /** 817x */
  A_817 = 'A_817',
  /** 818x */
  A_818 = 'A_818',
  /** 819x */
  A_819 = 'A_819',
  /** 820x */
  A_820 = 'A_820',
  /** 821x */
  A_821 = 'A_821',
  /** 822x */
  A_822 = 'A_822',
  /** 823x */
  A_823 = 'A_823',
  /** 824x */
  A_824 = 'A_824',
  /** 825x */
  A_825 = 'A_825',
  /** 826x */
  A_826 = 'A_826',
  /** 827x */
  A_827 = 'A_827',
  /** 828x */
  A_828 = 'A_828',
  /** 829x */
  A_829 = 'A_829',
  /** 830x */
  A_830 = 'A_830',
  /** 831x */
  A_831 = 'A_831',
  /** 832x */
  A_832 = 'A_832',
  /** 833x */
  A_833 = 'A_833',
  /** 834x */
  A_834 = 'A_834',
  /** 835x */
  A_835 = 'A_835',
  /** 836x */
  A_836 = 'A_836',
  /** 837x */
  A_837 = 'A_837',
  /** 838x */
  A_838 = 'A_838',
  /** 839x */
  A_839 = 'A_839',
  /** 840x */
  A_840 = 'A_840',
  /** 841x */
  A_841 = 'A_841',
  /** 842x */
  A_842 = 'A_842',
  /** 843x */
  A_843 = 'A_843',
  /** 844x */
  A_844 = 'A_844',
  /** 845x */
  A_845 = 'A_845',
  /** 846x */
  A_846 = 'A_846',
  /** 847x */
  A_847 = 'A_847',
  /** 848x */
  A_848 = 'A_848',
  /** 849x */
  A_849 = 'A_849',
  /** 850x */
  A_850 = 'A_850',
  /** 851x */
  A_851 = 'A_851',
  /** 852x */
  A_852 = 'A_852',
  /** 853x */
  A_853 = 'A_853',
  /** 854x */
  A_854 = 'A_854',
  /** 855x */
  A_855 = 'A_855',
  /** 856x */
  A_856 = 'A_856',
  /** 857x */
  A_857 = 'A_857',
  /** 858x */
  A_858 = 'A_858',
  /** 859x */
  A_859 = 'A_859',
  /** 860x */
  A_860 = 'A_860',
  /** 861x */
  A_861 = 'A_861',
  /** 862x */
  A_862 = 'A_862',
  /** 863x */
  A_863 = 'A_863',
  /** 864x */
  A_864 = 'A_864',
  /** 865x */
  A_865 = 'A_865',
  /** 866x */
  A_866 = 'A_866',
  /** 867x */
  A_867 = 'A_867',
  /** 868x */
  A_868 = 'A_868',
  /** 869x */
  A_869 = 'A_869',
  /** 870x */
  A_870 = 'A_870',
  /** 871x */
  A_871 = 'A_871',
  /** 872x */
  A_872 = 'A_872',
  /** 873x */
  A_873 = 'A_873',
  /** 874x */
  A_874 = 'A_874',
  /** 875x */
  A_875 = 'A_875',
  /** 876x */
  A_876 = 'A_876',
  /** 877x */
  A_877 = 'A_877',
  /** 878x */
  A_878 = 'A_878',
  /** 879x */
  A_879 = 'A_879',
  /** 880x */
  A_880 = 'A_880',
  /** 881x */
  A_881 = 'A_881',
  /** 882x */
  A_882 = 'A_882',
  /** 883x */
  A_883 = 'A_883',
  /** 884x */
  A_884 = 'A_884',
  /** 885x */
  A_885 = 'A_885',
  /** 886x */
  A_886 = 'A_886',
  /** 887x */
  A_887 = 'A_887',
  /** 888x */
  A_888 = 'A_888',
  /** 889x */
  A_889 = 'A_889',
  /** 890x */
  A_890 = 'A_890',
  /** 891x */
  A_891 = 'A_891',
  /** 892x */
  A_892 = 'A_892',
  /** 893x */
  A_893 = 'A_893',
  /** 894x */
  A_894 = 'A_894',
  /** 895x */
  A_895 = 'A_895',
  /** 896x */
  A_896 = 'A_896',
  /** 897x */
  A_897 = 'A_897',
  /** 898x */
  A_898 = 'A_898',
  /** 899x */
  A_899 = 'A_899',
  /** 900x */
  A_900 = 'A_900',
  /** 901x */
  A_901 = 'A_901',
  /** 902x */
  A_902 = 'A_902',
  /** 903x */
  A_903 = 'A_903',
  /** 904x */
  A_904 = 'A_904',
  /** 905x */
  A_905 = 'A_905',
  /** 906x */
  A_906 = 'A_906',
  /** 907x */
  A_907 = 'A_907',
  /** 908x */
  A_908 = 'A_908',
  /** 909x */
  A_909 = 'A_909',
  /** 910x */
  A_910 = 'A_910',
  /** 911x */
  A_911 = 'A_911',
  /** 912x */
  A_912 = 'A_912',
  /** 913x */
  A_913 = 'A_913',
  /** 914x */
  A_914 = 'A_914',
  /** 915x */
  A_915 = 'A_915',
  /** 916x */
  A_916 = 'A_916',
  /** 917x */
  A_917 = 'A_917',
  /** 918x */
  A_918 = 'A_918',
  /** 919x */
  A_919 = 'A_919',
  /** 920x */
  A_920 = 'A_920',
  /** 921x */
  A_921 = 'A_921',
  /** 922x */
  A_922 = 'A_922',
  /** 923x */
  A_923 = 'A_923',
  /** 924x */
  A_924 = 'A_924',
  /** 925x */
  A_925 = 'A_925',
  /** 926x */
  A_926 = 'A_926',
  /** 927x */
  A_927 = 'A_927',
  /** 928x */
  A_928 = 'A_928',
  /** 929x */
  A_929 = 'A_929',
  /** 930x */
  A_930 = 'A_930',
  /** 931x */
  A_931 = 'A_931',
  /** 932x */
  A_932 = 'A_932',
  /** 933x */
  A_933 = 'A_933',
  /** 934x */
  A_934 = 'A_934',
  /** 935x */
  A_935 = 'A_935',
  /** 936x */
  A_936 = 'A_936',
  /** 937x */
  A_937 = 'A_937',
  /** 938x */
  A_938 = 'A_938',
  /** 939x */
  A_939 = 'A_939',
  /** 940x */
  A_940 = 'A_940',
  /** 941x */
  A_941 = 'A_941',
  /** 942x */
  A_942 = 'A_942',
  /** 943x */
  A_943 = 'A_943',
  /** 944x */
  A_944 = 'A_944',
  /** 945x */
  A_945 = 'A_945',
  /** 946x */
  A_946 = 'A_946',
  /** 947x */
  A_947 = 'A_947',
  /** 948x */
  A_948 = 'A_948',
  /** 949x */
  A_949 = 'A_949',
  /** 950x */
  A_950 = 'A_950',
  /** 951x */
  A_951 = 'A_951',
  /** 952x */
  A_952 = 'A_952',
  /** 953x */
  A_953 = 'A_953',
  /** 954x */
  A_954 = 'A_954',
  /** 955x */
  A_955 = 'A_955',
  /** 956x */
  A_956 = 'A_956',
  /** 957x */
  A_957 = 'A_957',
  /** 958x */
  A_958 = 'A_958',
  /** 959x */
  A_959 = 'A_959',
  /** 960x */
  A_960 = 'A_960',
  /** 961x */
  A_961 = 'A_961',
  /** 962x */
  A_962 = 'A_962',
  /** 963x */
  A_963 = 'A_963',
  /** 964x */
  A_964 = 'A_964',
  /** 965x */
  A_965 = 'A_965',
  /** 966x */
  A_966 = 'A_966',
  /** 967x */
  A_967 = 'A_967',
  /** 968x */
  A_968 = 'A_968',
  /** 969x */
  A_969 = 'A_969',
  /** 970x */
  A_970 = 'A_970',
  /** 971x */
  A_971 = 'A_971',
  /** 972x */
  A_972 = 'A_972',
  /** 973x */
  A_973 = 'A_973',
  /** 974x */
  A_974 = 'A_974',
  /** 975x */
  A_975 = 'A_975',
  /** 976x */
  A_976 = 'A_976',
  /** 977x */
  A_977 = 'A_977',
  /** 978x */
  A_978 = 'A_978',
  /** 979x */
  A_979 = 'A_979',
  /** 980x */
  A_980 = 'A_980',
  /** 981x */
  A_981 = 'A_981',
  /** 982x */
  A_982 = 'A_982',
  /** 983x */
  A_983 = 'A_983',
  /** 984x */
  A_984 = 'A_984',
  /** 985x */
  A_985 = 'A_985',
  /** 986x */
  A_986 = 'A_986',
  /** 987x */
  A_987 = 'A_987',
  /** 988x */
  A_988 = 'A_988',
  /** 989x */
  A_989 = 'A_989',
  /** 990x */
  A_990 = 'A_990',
  /** 991x */
  A_991 = 'A_991',
  /** 992x */
  A_992 = 'A_992',
  /** 993x */
  A_993 = 'A_993',
  /** 994x */
  A_994 = 'A_994',
  /** 995x */
  A_995 = 'A_995',
  /** 996x */
  A_996 = 'A_996',
  /** 997x */
  A_997 = 'A_997',
  /** 998x */
  A_998 = 'A_998',
  /** 999x */
  A_999 = 'A_999',
  /** 1000x */
  A_1000 = 'A_1000'
}

export type EmprestimoPorLojaType = {
   __typename?: 'EmprestimoPorLojaType',
  nomeLoja?: Maybe<Scalars['String']>,
  quantidade?: Maybe<Scalars['Int']>,
  tiposDeEmprestimos?: Maybe<Array<Maybe<TiposDeEmprestimosPorLojaType>>>,
};

export type EmprestimoRelatorioInput = {
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  entidade_EntidadeGrupo_In?: Maybe<Array<Maybe<Scalars['ID']>>>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Cpf?: Maybe<Scalars['String']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  nsu_NsuCv?: Maybe<Scalars['String']>,
  nsu_NsuCv_Icontains?: Maybe<Scalars['String']>,
  nsu_NsuCv_In?: Maybe<Scalars['String']>,
  valorTotal?: Maybe<Scalars['Float']>,
  valorTotal_In?: Maybe<Scalars['Float']>,
  valorDesejado?: Maybe<Scalars['Float']>,
  valorDesejado_In?: Maybe<Scalars['Float']>,
  valorDesejado_Gte?: Maybe<Scalars['Float']>,
  valorDesejado_Lte?: Maybe<Scalars['Float']>,
  nsu_TitularDivergente_Cpf?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_In?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  bandeiraCartao_In?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['String']>,
  parcelas_In?: Maybe<Scalars['String']>,
  parcelas_Lt?: Maybe<Scalars['String']>,
  parcelas_Gt?: Maybe<Scalars['String']>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  entidade_Id?: Maybe<Scalars['ID']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  tipoEmprestimo_Id_In?: Maybe<Scalars['String']>,
  tipoEmprestimo_Modalidade_In?: Maybe<Scalars['String']>,
  tipoEmprestimoUso_In?: Maybe<Scalars['String']>,
  cartaoCredito?: Maybe<Scalars['Boolean']>,
  loanType_Isnull?: Maybe<Scalars['Boolean']>,
  status_In?: Maybe<Scalars['String']>,
  /** Ordenando */
  orderBy?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  grupoId?: Maybe<Scalars['ID']>,
};

export type EmprestimoRelatorioType = Node & {
   __typename?: 'EmprestimoRelatorioType',
  /** The ID of the object. */
  id: Scalars['ID'],
  entidade?: Maybe<EntidadeTypeRelay>,
  cliente?: Maybe<EmprestimoClienteNode>,
  funcionario: FuncionarioTypeRelay,
  valorDesejado: Scalars['Float'],
  valorTotal?: Maybe<Scalars['Float']>,
  taxaAplicada: Scalars['Float'],
  parcelas: EmprestimoParcelas,
  tabelaTaxa?: Maybe<Scalars['String']>,
  delivery: Scalars['Boolean'],
  maquina?: Maybe<Scalars['String']>,
  nsuCartao?: Maybe<Scalars['String']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  anexoContrato?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  data: Scalars['Date'],
  taxaMinima?: Maybe<Scalars['Float']>,
  justificativaTaxaAbaixo?: Maybe<Scalars['String']>,
  justificativaCancelamento?: Maybe<Scalars['String']>,
  status: EmprestimoStatus,
  causaStatus?: Maybe<Scalars['String']>,
  clickSignChaveDocumento?: Maybe<Scalars['String']>,
  solicitadoVia: EmprestimoSolicitadoVia,
  vendaDigitada: Scalars['Boolean'],
  vendaResgatada: Scalars['Boolean'],
  leadId?: Maybe<Scalars['Int']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateNodeTypeRelay>,
  loanTypePayload?: Maybe<Scalars['JSONString']>,
  loanType?: Maybe<TipoDeEmprestimoRelayType>,
  extraFieldsResults?: Maybe<Scalars['JSONString']>,
  iof?: Maybe<Scalars['Float']>,
  nsus: Array<NsuType>,
  formasPagamento: Array<FormaPagamentoEmprestimoType>,
  anexos: Array<AnexoDeEmprestimoType>,
  comissaoparceirosSet: ComissaoNodeTypeRelayConnection,
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  comissaofuncionariosSet: ComissaoFuncionarioNodeTypeRelayConnection,
  zekiGiftback?: Maybe<ZekiGiftbackResgateType>,
  valorRetirado?: Maybe<Scalars['Decimal']>,
  valorPassado?: Maybe<Scalars['Decimal']>,
};


export type EmprestimoRelatorioTypeComissaoparceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Nsu_Parcelas?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_In?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_Iexact?: Maybe<Scalars['String']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  dataRepasse?: Maybe<Scalars['Date']>,
  dataRepasse_Gte?: Maybe<Scalars['Date']>,
  dataRepasse_Gt?: Maybe<Scalars['Date']>,
  dataRepasse_Lt?: Maybe<Scalars['Date']>,
  dataRepasse_Lte?: Maybe<Scalars['Date']>,
  emprestimo_CriadoEm?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gte?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lte?: Maybe<Scalars['DateTime']>,
  emprestimo_Data?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gte?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lte?: Maybe<Scalars['Date']>,
  valorComissao?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EmprestimoRelatorioTypeComissaofuncionariosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  emprestimo_Id_In?: Maybe<Scalars['String']>,
  emprestimo_Funcionario_Id?: Maybe<Scalars['ID']>,
  emprestimo_Parcelas?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  tipoComissao?: Maybe<Scalars['String']>,
  valorComissao?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

export type EmprestimoRelatorioTypeConnection = {
   __typename?: 'EmprestimoRelatorioTypeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmprestimoRelatorioTypeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `EmprestimoRelatorioType` and its cursor. */
export type EmprestimoRelatorioTypeEdge = {
   __typename?: 'EmprestimoRelatorioTypeEdge',
  /** The item at the end of the edge */
  node?: Maybe<EmprestimoRelatorioType>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum EmprestimoSolicitadoVia {
  /** Web */
  Web = 'WEB',
  /** App */
  App = 'APP'
}

/** An enumeration. */
export enum EmprestimoStatus {
  /** Delivery */
  Delivery = 'DELIVERY',
  /** Em análise */
  EmAnalise = 'EM_ANALISE',
  /** Aprovada */
  Aprovada = 'APROVADA',
  /** Reprovada */
  Reprovada = 'REPROVADA',
  /** Paga */
  Paga = 'PAGA',
  /** Cancelada */
  Cancelada = 'CANCELADA',
  /** Aguardando assinatura */
  AguardandoAssinatura = 'AGUARDANDO_ASSINATURA',
  /**   Em Rascunho */
  Rascunho = 'RASCUNHO'
}

export type EmprestimoType = {
   __typename?: 'EmprestimoType',
  id: Scalars['ID'],
  entidade?: Maybe<EntidadeTypeRelay>,
  cliente?: Maybe<EmprestimoClienteNode>,
  funcionario: FuncionarioTypeRelay,
  valorDesejado: Scalars['Float'],
  valorTotal?: Maybe<Scalars['Float']>,
  bonusFuncionario?: Maybe<Scalars['Decimal']>,
  taxaAplicada: Scalars['Float'],
  parcelas: EmprestimoParcelas,
  tabelaTaxa?: Maybe<Scalars['String']>,
  delivery: Scalars['Boolean'],
  maquina?: Maybe<Scalars['String']>,
  nsuCartao?: Maybe<Scalars['String']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  anexoContrato?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  data: Scalars['Date'],
  taxaMinima?: Maybe<Scalars['Float']>,
  justificativaTaxaAbaixo?: Maybe<Scalars['String']>,
  justificativaCancelamento?: Maybe<Scalars['String']>,
  status: EmprestimoStatus,
  causaStatus?: Maybe<Scalars['String']>,
  clickSignChaveDocumento?: Maybe<Scalars['String']>,
  solicitadoVia: EmprestimoSolicitadoVia,
  vendaDigitada: Scalars['Boolean'],
  vendaResgatada: Scalars['Boolean'],
  leadId?: Maybe<Scalars['Int']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateNodeTypeRelay>,
  loanTypePayload?: Maybe<Scalars['JSONString']>,
  loanType?: Maybe<TipoDeEmprestimoRelayType>,
  extraFieldsResults?: Maybe<Scalars['JSONString']>,
  iof?: Maybe<Scalars['Float']>,
  nsus: Array<NsuType>,
  formasPagamento: Array<FormaPagamentoEmprestimoType>,
  anexos: Array<AnexoDeEmprestimoType>,
  comissaoparceirosSet: ComissaoNodeTypeRelayConnection,
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  comissaofuncionariosSet: ComissaoFuncionarioNodeTypeRelayConnection,
  zekiGiftback?: Maybe<ZekiGiftbackResgateType>,
};


export type EmprestimoTypeComissaoparceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Nsu_Parcelas?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_In?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_Iexact?: Maybe<Scalars['String']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  dataRepasse?: Maybe<Scalars['Date']>,
  dataRepasse_Gte?: Maybe<Scalars['Date']>,
  dataRepasse_Gt?: Maybe<Scalars['Date']>,
  dataRepasse_Lt?: Maybe<Scalars['Date']>,
  dataRepasse_Lte?: Maybe<Scalars['Date']>,
  emprestimo_CriadoEm?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gte?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lte?: Maybe<Scalars['DateTime']>,
  emprestimo_Data?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gte?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lte?: Maybe<Scalars['Date']>,
  valorComissao?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EmprestimoTypeComissaofuncionariosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  emprestimo_Id_In?: Maybe<Scalars['String']>,
  emprestimo_Funcionario_Id?: Maybe<Scalars['ID']>,
  emprestimo_Parcelas?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  tipoComissao?: Maybe<Scalars['String']>,
  valorComissao?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

/** An enumeration. */
export enum EntidadeCategoria {
  /** Loja */
  Loja = 'LOJA',
  /** Parceiro Comercial */
  Parceiro = 'PARCEIRO',
  /** Associado Operacional */
  Associado = 'ASSOCIADO',
  /** Usuários do Sistema */
  Usuario = 'USUARIO'
}

export type EntidadeDeGrupoType = {
   __typename?: 'EntidadeDeGrupoType',
  id: Scalars['ID'],
  grupo: GrupoDePermissoesTypeRelay,
  entidade: EntidadeTypeRelay,
};

export type EntidadeFuncionarioRepasseType = {
   __typename?: 'EntidadeFuncionarioRepasseType',
  id: Scalars['ID'],
  funcionario: FuncionariosRepasseNodeTypeRelay,
  entidade: EntidadeTypeRelay,
};

export type EntidadeType = {
   __typename?: 'EntidadeType',
  id: Scalars['ID'],
  nome: Scalars['String'],
  razao?: Maybe<Scalars['String']>,
  nomeIdentificacao: Scalars['String'],
  cnpj?: Maybe<Scalars['String']>,
  anexoCnpj?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  comprovanteEndereco?: Maybe<Scalars['String']>,
  latitude?: Maybe<Scalars['String']>,
  longitude?: Maybe<Scalars['String']>,
  categoria?: Maybe<EntidadeCategoria>,
  taxaLucro?: Maybe<Scalars['Float']>,
  taxaMinima?: Maybe<Scalars['Float']>,
  taxaSeguranca?: Maybe<Scalars['Float']>,
  tipoLoja?: Maybe<RegramentoTiposEntidadesNodeType>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  clientCustomerId?: Maybe<Scalars['String']>,
  mensagemInvoice: Scalars['String'],
  dddVinculacaoApp?: Maybe<Scalars['String']>,
  /** 
 * ex: Utilize o link
   * 'https://www.google.com/maps/dir/?api=1&origin=&destination=' + o endereço em
   * forma de url encoding, para formatar, pode utilizar o site <a
   * href='https://www.urlencoder.org/'>https://www.urlencoder.org/</a>
 */
  googleMapsUrl: Scalars['String'],
  /** https://api.whatsapp.com/send/?phone=[NUMERO_DA_LOJA]&text=[TEXTO_PARA_ENVIAR] */
  whatsappApi: Scalars['String'],
  imagem?: Maybe<Scalars['String']>,
  publicToken?: Maybe<Scalars['String']>,
  telefones: Array<TelefoneDeEntidadeType>,
  permissaoSet: Array<PermissaoType>,
  pedidodereembolsoSet: PedidoDeReembolsoNodeConnection,
  clienteSet: EmprestimoClienteNodeConnection,
  contaapagarSet: ContaAPagarNodeConnection,
  emprestimoSet: EmprestimoRelatorioTypeConnection,
  tabelataxaparcelasSet: Array<TabelaTaxaParcelasType>,
  taxasParcelas: Array<TaxasParcelasType>,
  entidadesGrupos: Array<EntidadeDeGrupoType>,
  meta: MetaNodeTypeRelayConnection,
  maquinaSet: MaquinaNodeConnection,
  ocorrenciasMaquinas: OcorrenciaComMaquinaNodeConnection,
  ocorrenciasPosterioresMaquinas: OcorrenciaComMaquinaNodeConnection,
  tiposEmprestimo: TipoDeEmprestimoRelayTypeConnection,
  appconfigSet: Array<AppConfigType>,
  /** Selecione a unidade */
  Entidades: Array<AppConfigType>,
  leadsSet: LeadsNodeTypeRelayPropConnection,
  parceirosSet: ParceirosNodeTypeRelayConnection,
  lojaparceiroSet: Array<LojaParceiroType>,
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  entidadefuncionariorepasseSet: Array<EntidadeFuncionarioRepasseType>,
  listasmsSet: ListaSmsTypeRelayConnection,
  emailremetenteSet: Array<EmailRemetenteType>,
  instanciazapiSet: InstanciaZApiNodeConnection,
  fornecedorSet: FornecedorViewNodeTypeConnection,
  distancia?: Maybe<Scalars['String']>,
};


export type EntidadeTypePedidodereembolsoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  tipoConta_In?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_Icontains?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  conta_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Icontains?: Maybe<Scalars['Float']>,
  data?: Maybe<Scalars['DateTime']>,
  data_Lt?: Maybe<Scalars['DateTime']>,
  data_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeClienteSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  cliente_Id?: Maybe<Scalars['ID']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_In?: Maybe<Scalars['String']>,
  cliente_Sexo?: Maybe<Scalars['String']>,
  cliente_Sexo_In?: Maybe<Scalars['String']>,
  cliente_Municipio?: Maybe<Scalars['String']>,
  cliente_Municipio_In?: Maybe<Scalars['String']>,
  cliente_Municipio_Icontains?: Maybe<Scalars['String']>,
  entidade?: Maybe<Scalars['ID']>,
  entidade_In?: Maybe<Scalars['ID']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  quantidadeEmprestimo?: Maybe<Scalars['Float']>,
  taxaMedia?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeContaapagarSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  titulo?: Maybe<Scalars['String']>,
  titulo_Icontains?: Maybe<Scalars['String']>,
  titulo_Istartswith?: Maybe<Scalars['String']>,
  destinatario?: Maybe<Scalars['String']>,
  destinatario_Icontains?: Maybe<Scalars['String']>,
  destinatario_Istartswith?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  recorrencia?: Maybe<Scalars['String']>,
  recorrencia_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>,
  dataVencimento?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gte?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lte?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gte?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lte?: Maybe<Scalars['DateTime']>,
  transferenciaConta?: Maybe<Scalars['String']>,
  transferenciaConta_Icontains?: Maybe<Scalars['String']>,
  formaPagamento?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Lt?: Maybe<Scalars['Float']>,
  valor_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeEmprestimoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type EntidadeTypeMetaArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  valorMeta?: Maybe<Scalars['Float']>,
  taxaMeta?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['String']>,
  inicioMeta?: Maybe<Scalars['String']>,
  inicioMeta_Gte?: Maybe<Scalars['Date']>,
  inicioMeta_Gt?: Maybe<Scalars['Date']>,
  inicioMeta_Lt?: Maybe<Scalars['Date']>,
  inicioMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta?: Maybe<Scalars['String']>,
  fimMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta_Lt?: Maybe<Scalars['Date']>,
  fimMeta_Gte?: Maybe<Scalars['Date']>,
  fimMeta_Gt?: Maybe<Scalars['Date']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  tipoRegramento?: Maybe<Scalars['String']>,
  tipoRegramento_In?: Maybe<Scalars['String']>,
  vinculoProduto?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  statusSaude?: Maybe<Scalars['String']>,
  grupoIds_In?: Maybe<Scalars['String']>,
  vinculoProduto_In?: Maybe<Scalars['String']>
};


export type EntidadeTypeMaquinaSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  cnpj?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  etiquetagem?: Maybe<Scalars['String']>,
  etiquetagem_Icontains?: Maybe<Scalars['String']>,
  numeroTerminal?: Maybe<Scalars['String']>,
  numeroTerminal_Icontains?: Maybe<Scalars['String']>,
  serialNumber?: Maybe<Scalars['String']>,
  serialNumber_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeOcorrenciasMaquinasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  detalhamento?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeOcorrenciasPosterioresMaquinasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  detalhamento?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeTiposEmprestimoArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  ativo?: Maybe<Scalars['Boolean']>,
  modalidadeCliente?: Maybe<Scalars['String']>,
  modalidadeCliente_In?: Maybe<Scalars['String']>,
  periodicidadeRecorrencia?: Maybe<Scalars['String']>,
  periodicidadeRecorrencia_In?: Maybe<Scalars['String']>,
  tipoUso?: Maybe<Scalars['String']>,
  tipoUso_In?: Maybe<Scalars['String']>,
  valorMinimo?: Maybe<Scalars['Float']>,
  valorMinimo_Gte?: Maybe<Scalars['Float']>,
  valorMinimo_Lte?: Maybe<Scalars['Float']>,
  valorMaximo?: Maybe<Scalars['Float']>,
  valorMaximo_Gte?: Maybe<Scalars['Float']>,
  valorMaximo_Lte?: Maybe<Scalars['Float']>,
  parcelasMinimas?: Maybe<Scalars['Int']>,
  parcelasMinimas_Gte?: Maybe<Scalars['Int']>,
  parcelasMinimas_Lte?: Maybe<Scalars['Int']>,
  parcelasMaximas?: Maybe<Scalars['Int']>,
  parcelasMaximas_Gte?: Maybe<Scalars['Int']>,
  parcelasMaximas_Lte?: Maybe<Scalars['Int']>,
  taxaJuros?: Maybe<Scalars['Float']>,
  taxaJuros_Gte?: Maybe<Scalars['Float']>,
  taxaJuros_Lte?: Maybe<Scalars['Float']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeLeadsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeParceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type EntidadeTypeListasmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type EntidadeTypeInstanciazapiSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  entidade?: Maybe<Scalars['ID']>,
  entidade_In?: Maybe<Scalars['String']>,
  isActived?: Maybe<Scalars['Boolean']>,
  isConnected?: Maybe<Scalars['Boolean']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Float']>
};


export type EntidadeTypeFornecedorSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type EntidadeTypeRelay = Node & {
   __typename?: 'EntidadeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  razao?: Maybe<Scalars['String']>,
  nomeIdentificacao: Scalars['String'],
  cnpj?: Maybe<Scalars['String']>,
  anexoCnpj?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  comprovanteEndereco?: Maybe<Scalars['String']>,
  latitude?: Maybe<Scalars['String']>,
  longitude?: Maybe<Scalars['String']>,
  categoria?: Maybe<EntidadeCategoria>,
  taxaLucro?: Maybe<Scalars['Float']>,
  taxaMinima?: Maybe<Scalars['Float']>,
  taxaSeguranca?: Maybe<Scalars['Float']>,
  tipoLoja?: Maybe<RegramentoTiposEntidadesNodeType>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  clientCustomerId?: Maybe<Scalars['String']>,
  mensagemInvoice: Scalars['String'],
  dddVinculacaoApp?: Maybe<Scalars['String']>,
  /** 
 * ex: Utilize o link
   * 'https://www.google.com/maps/dir/?api=1&origin=&destination=' + o endereço em
   * forma de url encoding, para formatar, pode utilizar o site <a
   * href='https://www.urlencoder.org/'>https://www.urlencoder.org/</a>
 */
  googleMapsUrl: Scalars['String'],
  /** https://api.whatsapp.com/send/?phone=[NUMERO_DA_LOJA]&text=[TEXTO_PARA_ENVIAR] */
  whatsappApi: Scalars['String'],
  imagem?: Maybe<Scalars['String']>,
  publicToken?: Maybe<Scalars['String']>,
  telefones: Array<TelefoneDeEntidadeType>,
  permissaoSet: Array<PermissaoType>,
  pedidodereembolsoSet: PedidoDeReembolsoNodeConnection,
  clienteSet: EmprestimoClienteNodeConnection,
  contaapagarSet: ContaAPagarNodeConnection,
  emprestimoSet: EmprestimoRelatorioTypeConnection,
  tabelataxaparcelasSet: Array<TabelaTaxaParcelasType>,
  taxasParcelas: Array<TaxasParcelasType>,
  entidadesGrupos: Array<EntidadeDeGrupoType>,
  meta: MetaNodeTypeRelayConnection,
  maquinaSet: MaquinaNodeConnection,
  ocorrenciasMaquinas: OcorrenciaComMaquinaNodeConnection,
  ocorrenciasPosterioresMaquinas: OcorrenciaComMaquinaNodeConnection,
  tiposEmprestimo: TipoDeEmprestimoRelayTypeConnection,
  appconfigSet: Array<AppConfigType>,
  /** Selecione a unidade */
  Entidades: Array<AppConfigType>,
  leadsSet: LeadsNodeTypeRelayPropConnection,
  parceirosSet: ParceirosNodeTypeRelayConnection,
  lojaparceiroSet: Array<LojaParceiroType>,
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  entidadefuncionariorepasseSet: Array<EntidadeFuncionarioRepasseType>,
  listasmsSet: ListaSmsTypeRelayConnection,
  emailremetenteSet: Array<EmailRemetenteType>,
  instanciazapiSet: InstanciaZApiNodeConnection,
  fornecedorSet: FornecedorViewNodeTypeConnection,
  pk: Scalars['Int'],
};


export type EntidadeTypeRelayPedidodereembolsoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  tipoConta_In?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_Icontains?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  conta_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Icontains?: Maybe<Scalars['Float']>,
  data?: Maybe<Scalars['DateTime']>,
  data_Lt?: Maybe<Scalars['DateTime']>,
  data_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeRelayClienteSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  cliente_Id?: Maybe<Scalars['ID']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_In?: Maybe<Scalars['String']>,
  cliente_Sexo?: Maybe<Scalars['String']>,
  cliente_Sexo_In?: Maybe<Scalars['String']>,
  cliente_Municipio?: Maybe<Scalars['String']>,
  cliente_Municipio_In?: Maybe<Scalars['String']>,
  cliente_Municipio_Icontains?: Maybe<Scalars['String']>,
  entidade?: Maybe<Scalars['ID']>,
  entidade_In?: Maybe<Scalars['ID']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  quantidadeEmprestimo?: Maybe<Scalars['Float']>,
  taxaMedia?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeRelayContaapagarSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  titulo?: Maybe<Scalars['String']>,
  titulo_Icontains?: Maybe<Scalars['String']>,
  titulo_Istartswith?: Maybe<Scalars['String']>,
  destinatario?: Maybe<Scalars['String']>,
  destinatario_Icontains?: Maybe<Scalars['String']>,
  destinatario_Istartswith?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  recorrencia?: Maybe<Scalars['String']>,
  recorrencia_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>,
  dataVencimento?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gte?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lte?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gte?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lte?: Maybe<Scalars['DateTime']>,
  transferenciaConta?: Maybe<Scalars['String']>,
  transferenciaConta_Icontains?: Maybe<Scalars['String']>,
  formaPagamento?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Lt?: Maybe<Scalars['Float']>,
  valor_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeRelayEmprestimoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type EntidadeTypeRelayMetaArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  valorMeta?: Maybe<Scalars['Float']>,
  taxaMeta?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['String']>,
  inicioMeta?: Maybe<Scalars['String']>,
  inicioMeta_Gte?: Maybe<Scalars['Date']>,
  inicioMeta_Gt?: Maybe<Scalars['Date']>,
  inicioMeta_Lt?: Maybe<Scalars['Date']>,
  inicioMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta?: Maybe<Scalars['String']>,
  fimMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta_Lt?: Maybe<Scalars['Date']>,
  fimMeta_Gte?: Maybe<Scalars['Date']>,
  fimMeta_Gt?: Maybe<Scalars['Date']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  tipoRegramento?: Maybe<Scalars['String']>,
  tipoRegramento_In?: Maybe<Scalars['String']>,
  vinculoProduto?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  statusSaude?: Maybe<Scalars['String']>,
  grupoIds_In?: Maybe<Scalars['String']>,
  vinculoProduto_In?: Maybe<Scalars['String']>
};


export type EntidadeTypeRelayMaquinaSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  cnpj?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  etiquetagem?: Maybe<Scalars['String']>,
  etiquetagem_Icontains?: Maybe<Scalars['String']>,
  numeroTerminal?: Maybe<Scalars['String']>,
  numeroTerminal_Icontains?: Maybe<Scalars['String']>,
  serialNumber?: Maybe<Scalars['String']>,
  serialNumber_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeRelayOcorrenciasMaquinasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  detalhamento?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeRelayOcorrenciasPosterioresMaquinasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  detalhamento?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeRelayTiposEmprestimoArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  ativo?: Maybe<Scalars['Boolean']>,
  modalidadeCliente?: Maybe<Scalars['String']>,
  modalidadeCliente_In?: Maybe<Scalars['String']>,
  periodicidadeRecorrencia?: Maybe<Scalars['String']>,
  periodicidadeRecorrencia_In?: Maybe<Scalars['String']>,
  tipoUso?: Maybe<Scalars['String']>,
  tipoUso_In?: Maybe<Scalars['String']>,
  valorMinimo?: Maybe<Scalars['Float']>,
  valorMinimo_Gte?: Maybe<Scalars['Float']>,
  valorMinimo_Lte?: Maybe<Scalars['Float']>,
  valorMaximo?: Maybe<Scalars['Float']>,
  valorMaximo_Gte?: Maybe<Scalars['Float']>,
  valorMaximo_Lte?: Maybe<Scalars['Float']>,
  parcelasMinimas?: Maybe<Scalars['Int']>,
  parcelasMinimas_Gte?: Maybe<Scalars['Int']>,
  parcelasMinimas_Lte?: Maybe<Scalars['Int']>,
  parcelasMaximas?: Maybe<Scalars['Int']>,
  parcelasMaximas_Gte?: Maybe<Scalars['Int']>,
  parcelasMaximas_Lte?: Maybe<Scalars['Int']>,
  taxaJuros?: Maybe<Scalars['Float']>,
  taxaJuros_Gte?: Maybe<Scalars['Float']>,
  taxaJuros_Lte?: Maybe<Scalars['Float']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeRelayLeadsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type EntidadeTypeRelayParceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type EntidadeTypeRelayListasmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type EntidadeTypeRelayInstanciazapiSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  entidade?: Maybe<Scalars['ID']>,
  entidade_In?: Maybe<Scalars['String']>,
  isActived?: Maybe<Scalars['Boolean']>,
  isConnected?: Maybe<Scalars['Boolean']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Float']>
};


export type EntidadeTypeRelayFornecedorSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type EntidadeTypeRelayConnection = {
   __typename?: 'EntidadeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EntidadeTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `EntidadeTypeRelay` and its cursor. */
export type EntidadeTypeRelayEdge = {
   __typename?: 'EntidadeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<EntidadeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type EnviarDocumentosClickSignDigitadoMobile = {
   __typename?: 'EnviarDocumentosClickSignDigitadoMobile',
  ok?: Maybe<Scalars['Boolean']>,
  documentKey?: Maybe<Scalars['String']>,
};

export type EnviarDocumentosClickSignMutation = {
   __typename?: 'EnviarDocumentosClickSignMutation',
  ok?: Maybe<Scalars['Boolean']>,
  documentKey?: Maybe<Scalars['String']>,
};

/** 
 * Esse método cria um pagamento com pré captura na Pagcerto e envia
 * Gera o contrato e envia para o cliente
 * Notifica o cliente quando da alguma falha no pagamento ou caso tenha sucesso
 */
export type EnviarDocumentosClickSignMutationMobile = {
   __typename?: 'EnviarDocumentosClickSignMutationMobile',
  ok?: Maybe<Scalars['Boolean']>,
  documentKey?: Maybe<Scalars['String']>,
};

export type EnviarEmailSuporteMobile = {
   __typename?: 'EnviarEmailSuporteMobile',
  ok?: Maybe<Scalars['Boolean']>,
};

export type EnviarSimulacaoEmail = {
   __typename?: 'EnviarSimulacaoEmail',
  ok?: Maybe<Scalars['Boolean']>,
};

export type EnvioEmailInput = {
  nome?: Maybe<Scalars['String']>,
  nomeTemplate?: Maybe<Scalars['String']>,
  descricaoTemplate?: Maybe<Scalars['String']>,
  emailRemetenteId?: Maybe<Scalars['ID']>,
};

/** An enumeration. */
export enum EnvioEmailStatus {
  /** AGENDADO */
  Agendado = 'AGENDADO',
  /** ENVIADO */
  Enviado = 'ENVIADO'
}

export type EnvioEmailType = {
   __typename?: 'EnvioEmailType',
  id: Scalars['ID'],
  nome: Scalars['String'],
  nomeTemplate: Scalars['String'],
  descricaoTemplate: Scalars['String'],
  emailRemetente: EmailRemetenteType,
  data?: Maybe<Scalars['Date']>,
  hora?: Maybe<Scalars['Time']>,
  listas: ListaSmsTypeRelayConnection,
  messageId?: Maybe<Scalars['String']>,
  entregues: Scalars['Int'],
  totalContatos: Scalars['Int'],
  abertos: Scalars['Int'],
  cliques: Scalars['Int'],
  falhas: Scalars['Int'],
  dascartados: Scalars['Int'],
  spam: Scalars['Int'],
  enviados: Scalars['Int'],
  status?: Maybe<EnvioEmailStatus>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
};


export type EnvioEmailTypeListasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type EnvioEmailTypeRelay = Node & {
   __typename?: 'EnvioEmailTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  nomeTemplate: Scalars['String'],
  descricaoTemplate: Scalars['String'],
  emailRemetente: EmailRemetenteType,
  data?: Maybe<Scalars['Date']>,
  hora?: Maybe<Scalars['Time']>,
  listas?: Maybe<Array<Maybe<ListaSmsType>>>,
  messageId?: Maybe<Scalars['String']>,
  entregues: Scalars['Int'],
  totalContatos: Scalars['Int'],
  abertos: Scalars['Int'],
  cliques: Scalars['Int'],
  falhas: Scalars['Int'],
  dascartados: Scalars['Int'],
  spam: Scalars['Int'],
  enviados: Scalars['Int'],
  status?: Maybe<EnvioEmailStatus>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  mensagens?: Maybe<Array<Maybe<MensagemSmsType>>>,
};

export type EnvioEmailTypeRelayConnection = {
   __typename?: 'EnvioEmailTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EnvioEmailTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `EnvioEmailTypeRelay` and its cursor. */
export type EnvioEmailTypeRelayEdge = {
   __typename?: 'EnvioEmailTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<EnvioEmailTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type EnvioSmsType = {
   __typename?: 'EnvioSmsType',
  id: Scalars['ID'],
  nome: Scalars['String'],
  enviados?: Maybe<Scalars['Int']>,
  recebidos?: Maybe<Scalars['Int']>,
  falhas?: Maybe<Scalars['Int']>,
  data?: Maybe<Scalars['Date']>,
  hora?: Maybe<Scalars['Time']>,
  listas: ListaSmsTypeRelayConnection,
  mensagem: MensagemSmsTypeRelay,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  tokenSms?: Maybe<Scalars['String']>,
  apiSmsFlag: Scalars['Boolean'],
  respostasmsSet: Array<RespostaSmsType>,
  tokensmsSet: Array<TokenSmsType>,
};


export type EnvioSmsTypeListasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type EnvioSmsTypeRelay = Node & {
   __typename?: 'EnvioSmsTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  enviados?: Maybe<Scalars['Int']>,
  recebidos?: Maybe<Scalars['Int']>,
  falhas?: Maybe<Scalars['Int']>,
  data?: Maybe<Scalars['Date']>,
  hora?: Maybe<Scalars['Time']>,
  listas?: Maybe<Array<Maybe<ListaSmsType>>>,
  mensagem: MensagemSmsTypeRelay,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  tokenSms?: Maybe<Scalars['String']>,
  apiSmsFlag: Scalars['Boolean'],
  respostasmsSet: Array<RespostaSmsType>,
  tokensmsSet: Array<TokenSmsType>,
  mensagens?: Maybe<Array<Maybe<MensagemSmsType>>>,
};

export type EnvioSmsTypeRelayConnection = {
   __typename?: 'EnvioSmsTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EnvioSmsTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `EnvioSmsTypeRelay` and its cursor. */
export type EnvioSmsTypeRelayEdge = {
   __typename?: 'EnvioSmsTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<EnvioSmsTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type ExcluirAnexoDeContaAPagarMutation = {
   __typename?: 'ExcluirAnexoDeContaAPagarMutation',
  ok?: Maybe<Scalars['Boolean']>,
  anexo?: Maybe<AnexoDeContaAPagarType>,
};

export type ExcluirAnexoDePedidoDeReembolsoMutation = {
   __typename?: 'ExcluirAnexoDePedidoDeReembolsoMutation',
  ok?: Maybe<Scalars['Boolean']>,
  anexo?: Maybe<AnexoDePedidoDeReembolsoType>,
};

export type ExcluirAnotacao = {
   __typename?: 'ExcluirAnotacao',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirCartaoCreditoMutation = {
   __typename?: 'ExcluirCartaoCreditoMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirCategoriaMutation = {
   __typename?: 'ExcluirCategoriaMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirClienteMobile = {
   __typename?: 'ExcluirClienteMobile',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirColunaTabelas = {
   __typename?: 'ExcluirColunaTabelas',
  coluna?: Maybe<ColunaTabelaType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirContaAPagarMutation = {
   __typename?: 'ExcluirContaAPagarMutation',
  ok?: Maybe<Scalars['Boolean']>,
  contaPagar?: Maybe<ContaAPagarNode>,
};

export type ExcluirContaClienteMobile = {
   __typename?: 'ExcluirContaClienteMobile',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirContaDeClienteMutation = {
   __typename?: 'ExcluirContaDeClienteMutation',
  ok?: Maybe<Scalars['Boolean']>,
  conta?: Maybe<ContaDeClienteType>,
};

export type ExcluirEntidadeMutation = {
   __typename?: 'ExcluirEntidadeMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirFuncionarioMutation = {
   __typename?: 'ExcluirFuncionarioMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirGrupoDePermissoesMutation = {
   __typename?: 'ExcluirGrupoDePermissoesMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirLista = {
   __typename?: 'ExcluirLista',
  ok?: Maybe<Scalars['Boolean']>,
  lista?: Maybe<ListaSmsType>,
};

export type ExcluirPedidoDeReembolsoMutation = {
   __typename?: 'ExcluirPedidoDeReembolsoMutation',
  ok?: Maybe<Scalars['Boolean']>,
  pedido?: Maybe<PedidoDeReembolsoNode>,
};

export type ExcluirRegramentoEntidade = {
   __typename?: 'ExcluirRegramentoEntidade',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirRegramentoTipoEntidade = {
   __typename?: 'ExcluirRegramentoTipoEntidade',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirSubCategoriaMutation = {
   __typename?: 'ExcluirSubCategoriaMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirTabelaTaxas = {
   __typename?: 'ExcluirTabelaTaxas',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirTarefa = {
   __typename?: 'ExcluirTarefa',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirTarefasMult = {
   __typename?: 'ExcluirTarefasMult',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirTaxasParcelas = {
   __typename?: 'ExcluirTaxasParcelas',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirTelefoneDeClienteMutation = {
   __typename?: 'ExcluirTelefoneDeClienteMutation',
  ok?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<TelefoneDeClienteType>,
};

export type ExcluirTelefoneDeEntidadeMutation = {
   __typename?: 'ExcluirTelefoneDeEntidadeMutation',
  ok?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<TelefoneDeEntidadeType>,
};

export type ExcluirTipoEntidade = {
   __typename?: 'ExcluirTipoEntidade',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirTipoFuncionarioMutation = {
   __typename?: 'ExcluirTipoFuncionarioMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirTodasTabelaTaxas = {
   __typename?: 'ExcluirTodasTabelaTaxas',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ExcluirVariasPermissoesMutation = {
   __typename?: 'ExcluirVariasPermissoesMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type FieldsHistoricoEmprestimoType = {
   __typename?: 'FieldsHistoricoEmprestimoType',
  atualizadoEm?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
};

export type FiltrosListaInput = {
  inputLeads?: Maybe<LeadRelatorioInput>,
  inputClient?: Maybe<ClienteRelatorioInput>,
  tipo?: Maybe<Scalars['String']>,
};

export type FiltrosListaObjectType = {
   __typename?: 'FiltrosListaObjectType',
  tipo?: Maybe<Scalars['String']>,
  entidadesIn?: Maybe<Array<Maybe<Scalars['ID']>>>,
  origem_In?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  ddd?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  sexo_In?: Maybe<Scalars['String']>,
  nascimento_Lte?: Maybe<Scalars['String']>,
  nascimento_Gte?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  telefone_Numero_Icontains?: Maybe<Scalars['String']>,
  criadoEm_Lte?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['String']>,
};

export type FinalizarRascunhoEmprestimoMutation = {
   __typename?: 'FinalizarRascunhoEmprestimoMutation',
  emprestimo?: Maybe<EmprestimoNode>,
};

/** An enumeration. */
export enum FormaPagamentoEmprestimoContaTipoConta {
  /** Corrente */
  Corrente = 'CORRENTE',
  /** Poupança */
  Poupanca = 'POUPANCA',
  /** Fácil */
  Facil = 'FACIL'
}

export type FormaPagamentoEmprestimoType = {
   __typename?: 'FormaPagamentoEmprestimoType',
  id: Scalars['ID'],
  emprestimo?: Maybe<EmprestimoRelatorioType>,
  valor: Scalars['Float'],
  anexo?: Maybe<Scalars['String']>,
  tipoPix: Scalars['String'],
  pix: Scalars['String'],
  boletoDataVencimento?: Maybe<Scalars['Date']>,
  boletoNumeroControle?: Maybe<Scalars['String']>,
  boletoCodigoBarra?: Maybe<Scalars['String']>,
  boletoAnexo?: Maybe<Scalars['String']>,
  contaNome?: Maybe<Scalars['String']>,
  contaBanco?: Maybe<Scalars['String']>,
  contaAgencia?: Maybe<Scalars['String']>,
  contaTipoConta?: Maybe<FormaPagamentoEmprestimoContaTipoConta>,
  contaConta?: Maybe<Scalars['String']>,
  contaVariacao?: Maybe<Scalars['String']>,
  contaCpfCnpj?: Maybe<Scalars['String']>,
  pk: Scalars['Int'],
};

/** An enumeration. */
export enum FormaPagamentoFornecedorContaTipoConta {
  /** Corrente */
  Corrente = 'CORRENTE',
  /** Poupança */
  Poupanca = 'POUPANCA',
  /** Fácil */
  Facil = 'FACIL'
}

export type FormaPagamentoFornecedorType = {
   __typename?: 'FormaPagamentoFornecedorType',
  id: Scalars['ID'],
  fornecedor?: Maybe<FornecedorViewNodeType>,
  tipoPix: Scalars['String'],
  pix: Scalars['String'],
  boletoDataVencimento?: Maybe<Scalars['Date']>,
  boletoNumeroControle?: Maybe<Scalars['String']>,
  boletoCodigoBarra?: Maybe<Scalars['String']>,
  boletoAnexo?: Maybe<Scalars['String']>,
  contaNome?: Maybe<Scalars['String']>,
  contaBanco?: Maybe<Scalars['String']>,
  contaAgencia?: Maybe<Scalars['String']>,
  contaTipoConta?: Maybe<FormaPagamentoFornecedorContaTipoConta>,
  contaConta?: Maybe<Scalars['String']>,
  contaVariacao?: Maybe<Scalars['String']>,
  contaCpfCnpj?: Maybe<Scalars['String']>,
  default: Scalars['Boolean'],
};

export type FornecedorNodeType = Node & {
   __typename?: 'FornecedorNodeType',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  cpfCnpj: Scalars['String'],
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  entidade: EntidadeTypeRelayConnection,
  categorias: CategoriaTypeRelayConnection,
  subcategorias: SubCategoriasTypeRelayConnection,
  telefones?: Maybe<Array<Maybe<TelefoneDeFornecedorType>>>,
  formasPagamento?: Maybe<Array<Maybe<FormaPagamentoFornecedorType>>>,
  vinculado?: Maybe<Scalars['Boolean']>,
};


export type FornecedorNodeTypeEntidadeArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FornecedorNodeTypeCategoriasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Iexact?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  subcategorias_Nome_Iexact?: Maybe<Scalars['String']>,
  subcategorias_Nome_Icontains?: Maybe<Scalars['String']>,
  excluido?: Maybe<Scalars['Boolean']>
};


export type FornecedorNodeTypeSubcategoriasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['Float']>,
  excluido?: Maybe<Scalars['Boolean']>
};

export type FornecedorNodeTypeConnection = {
   __typename?: 'FornecedorNodeTypeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FornecedorNodeTypeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `FornecedorNodeType` and its cursor. */
export type FornecedorNodeTypeEdge = {
   __typename?: 'FornecedorNodeTypeEdge',
  /** The item at the end of the edge */
  node?: Maybe<FornecedorNodeType>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type FornecedorViewNodeType = Node & {
   __typename?: 'FornecedorViewNodeType',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  cpfCnpj: Scalars['String'],
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  entidade: EntidadeTypeRelayConnection,
  categorias: CategoriaTypeRelayConnection,
  subcategorias: SubCategoriasTypeRelayConnection,
  telefones: Array<TelefoneDeFornecedorType>,
  formasPagamento: Array<FormaPagamentoFornecedorType>,
};


export type FornecedorViewNodeTypeEntidadeArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FornecedorViewNodeTypeCategoriasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Iexact?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  subcategorias_Nome_Iexact?: Maybe<Scalars['String']>,
  subcategorias_Nome_Icontains?: Maybe<Scalars['String']>,
  excluido?: Maybe<Scalars['Boolean']>
};


export type FornecedorViewNodeTypeSubcategoriasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['Float']>,
  excluido?: Maybe<Scalars['Boolean']>
};

export type FornecedorViewNodeTypeConnection = {
   __typename?: 'FornecedorViewNodeTypeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FornecedorViewNodeTypeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `FornecedorViewNodeType` and its cursor. */
export type FornecedorViewNodeTypeEdge = {
   __typename?: 'FornecedorViewNodeTypeEdge',
  /** The item at the end of the edge */
  node?: Maybe<FornecedorViewNodeType>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum FuncionarioCategoria {
  /** Panfletista */
  Panfletista = 'PANFLETISTA',
  /** Vendedor */
  Vendedor = 'VENDEDOR',
  /** Sócio da Unidade */
  Socio = 'SOCIO',
  /** Diretor Executivo */
  DiretorExecutivo = 'DIRETOR_EXECUTIVO',
  /** Gerente Regional */
  GerenteRegional = 'GERENTE_REGIONAL',
  /** Gerente Comercial */
  GerenteComercial = 'GERENTE_COMERCIAL',
  /** Supervisor de Loja */
  SupervisorLoja = 'SUPERVISOR_LOJA',
  /** Supervisor Comercial */
  SupervisorComercial = 'SUPERVISOR_COMERCIAL',
  /** Supervisor Regional */
  SupervisorRegional = 'SUPERVISOR_REGIONAL'
}

export type FuncionarioDeGrupoType = {
   __typename?: 'FuncionarioDeGrupoType',
  id: Scalars['ID'],
  grupo: GrupoDePermissoesTypeRelay,
  funcionario: FuncionarioTypeRelay,
  tabelaParceiro?: Maybe<TabelasNodeTypeRelay>,
};

/** An enumeration. */
export enum FuncionarioSexo {
  /** Masculino */
  Masculino = 'MASCULINO',
  /** Feminino */
  Feminino = 'FEMININO',
  /** Indefinido */
  Indefinido = 'INDEFINIDO'
}

export type FuncionariosRepasseNodeTypeRelay = Node & {
   __typename?: 'FuncionariosRepasseNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  funcionario: FuncionarioTypeRelay,
  tabelaDeParceiro: TabelasNodeTypeRelay,
  tipoFuncionario: FuncionariosRepasseTipoFuncionario,
  funcionariosPermitidos: FuncionarioTypeRelayConnection,
  gruposPermitidos: GrupoDePermissoesTypeRelayConnection,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  entidadefuncionariorepasseSet: Array<EntidadeFuncionarioRepasseType>,
  grupoentidadefuncionariorepasseSet: Array<GrupoEntidadeFuncionarioRepasseType>,
};


export type FuncionariosRepasseNodeTypeRelayFuncionariosPermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  categoria?: Maybe<Scalars['String']>,
  tipoFuncionario_Nome?: Maybe<Scalars['String']>,
  tipoContrato?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_Icontains?: Maybe<Scalars['String']>,
  cpf?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  user_IsActive?: Maybe<Scalars['Boolean']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionariosRepasseNodeTypeRelayGruposPermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Id?: Maybe<Scalars['ID']>,
  entidade_Entidade_Nome?: Maybe<Scalars['String']>,
  entidade_Entidade_Nome_Icontains?: Maybe<Scalars['String']>,
  entidade_Entidade_Id?: Maybe<Scalars['ID']>,
  permissao_Descricao?: Maybe<Scalars['String']>,
  permissao_Descricao_Icontains?: Maybe<Scalars['String']>,
  permissao_Descricao_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};

export type FuncionariosRepasseNodeTypeRelayConnection = {
   __typename?: 'FuncionariosRepasseNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FuncionariosRepasseNodeTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `FuncionariosRepasseNodeTypeRelay` and its cursor. */
export type FuncionariosRepasseNodeTypeRelayEdge = {
   __typename?: 'FuncionariosRepasseNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<FuncionariosRepasseNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum FuncionariosRepasseTipoFuncionario {
  /** Comissão individual */
  Individual = 'INDIVIDUAL',
  /** Comissão coletiva */
  Coletiva = 'COLETIVA'
}

export type FuncionariosRepasseType = {
   __typename?: 'FuncionariosRepasseType',
  id: Scalars['ID'],
  funcionario: FuncionarioTypeRelay,
  tabelaDeParceiro: TabelasNodeTypeRelay,
  tipoFuncionario: FuncionariosRepasseTipoFuncionario,
  funcionariosPermitidos: FuncionarioTypeRelayConnection,
  gruposPermitidos: GrupoDePermissoesTypeRelayConnection,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  entidadefuncionariorepasseSet: Array<EntidadeFuncionarioRepasseType>,
  grupoentidadefuncionariorepasseSet: Array<GrupoEntidadeFuncionarioRepasseType>,
};


export type FuncionariosRepasseTypeFuncionariosPermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  categoria?: Maybe<Scalars['String']>,
  tipoFuncionario_Nome?: Maybe<Scalars['String']>,
  tipoContrato?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_Icontains?: Maybe<Scalars['String']>,
  cpf?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  user_IsActive?: Maybe<Scalars['Boolean']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionariosRepasseTypeGruposPermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Id?: Maybe<Scalars['ID']>,
  entidade_Entidade_Nome?: Maybe<Scalars['String']>,
  entidade_Entidade_Nome_Icontains?: Maybe<Scalars['String']>,
  entidade_Entidade_Id?: Maybe<Scalars['ID']>,
  permissao_Descricao?: Maybe<Scalars['String']>,
  permissao_Descricao_Icontains?: Maybe<Scalars['String']>,
  permissao_Descricao_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};

/** An enumeration. */
export enum FuncionarioTipoContrato {
  /** CLT */
  Clt = 'CLT',
  /** Prestação de Serviço */
  Prestacao = 'PRESTACAO',
  /** Associado */
  Associado = 'ASSOCIADO',
  /** Sem Vínculo */
  SemVinculo = 'SEM_VINCULO'
}

export type FuncionarioType = {
   __typename?: 'FuncionarioType',
  id: Scalars['ID'],
  user: UserType,
  nome: Scalars['String'],
  cpf: Scalars['String'],
  rg: Scalars['String'],
  email: Scalars['String'],
  categoria?: Maybe<FuncionarioCategoria>,
  tipoFuncionario?: Maybe<TipoFuncionarioTypeRelay>,
  tipoContrato: FuncionarioTipoContrato,
  anexoContrato?: Maybe<Scalars['String']>,
  endereco: Scalars['String'],
  complemento: Scalars['String'],
  bairro: Scalars['String'],
  municipio: Scalars['String'],
  uf: Scalars['String'],
  cep: Scalars['String'],
  pais: Scalars['String'],
  sexo?: Maybe<FuncionarioSexo>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  permissaoglobal?: Maybe<PermissaoGlobalType>,
  permissaoSet: Array<PermissaoType>,
  pedidodereembolsoSet: PedidoDeReembolsoNodeConnection,
  contaapagarSet: ContaAPagarNodeConnection,
  emprestimoSet: EmprestimoRelatorioTypeConnection,
  funcionariodegrupoSet: Array<FuncionarioDeGrupoType>,
  metaSet: MetaNodeTypeRelayConnection,
  relatorios: Array<RelatorioNode>,
  ocorrenciacommaquinaSet: OcorrenciaComMaquinaNodeConnection,
  leadsSet: LeadsNodeTypeRelayPropConnection,
  tarefasSet: TarefasNodeTypeRelayConnection,
  historicoSet: HistoricoNodeTypeRelayConnection,
  parceirosSet: ParceirosNodeTypeRelayConnection,
  parceirosRepassePermitidos: ParceirosNodeTypeRelayConnection,
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  funcionariosrepasseSet: FuncionariosRepasseNodeTypeRelayConnection,
  funcionariosRepassePermitidos: FuncionariosRepasseNodeTypeRelayConnection,
  /** Esse parametro vai estar prenchido somento na COMISSAO_COLETIVA */
  comissaofuncionariosSet: ComissaoFuncionarioNodeTypeRelayConnection,
};


export type FuncionarioTypePedidodereembolsoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  tipoConta_In?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_Icontains?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  conta_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Icontains?: Maybe<Scalars['Float']>,
  data?: Maybe<Scalars['DateTime']>,
  data_Lt?: Maybe<Scalars['DateTime']>,
  data_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionarioTypeContaapagarSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  titulo?: Maybe<Scalars['String']>,
  titulo_Icontains?: Maybe<Scalars['String']>,
  titulo_Istartswith?: Maybe<Scalars['String']>,
  destinatario?: Maybe<Scalars['String']>,
  destinatario_Icontains?: Maybe<Scalars['String']>,
  destinatario_Istartswith?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  recorrencia?: Maybe<Scalars['String']>,
  recorrencia_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>,
  dataVencimento?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gte?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lte?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gte?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lte?: Maybe<Scalars['DateTime']>,
  transferenciaConta?: Maybe<Scalars['String']>,
  transferenciaConta_Icontains?: Maybe<Scalars['String']>,
  formaPagamento?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Lt?: Maybe<Scalars['Float']>,
  valor_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionarioTypeEmprestimoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type FuncionarioTypeMetaSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  valorMeta?: Maybe<Scalars['Float']>,
  taxaMeta?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['String']>,
  inicioMeta?: Maybe<Scalars['String']>,
  inicioMeta_Gte?: Maybe<Scalars['Date']>,
  inicioMeta_Gt?: Maybe<Scalars['Date']>,
  inicioMeta_Lt?: Maybe<Scalars['Date']>,
  inicioMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta?: Maybe<Scalars['String']>,
  fimMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta_Lt?: Maybe<Scalars['Date']>,
  fimMeta_Gte?: Maybe<Scalars['Date']>,
  fimMeta_Gt?: Maybe<Scalars['Date']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  tipoRegramento?: Maybe<Scalars['String']>,
  tipoRegramento_In?: Maybe<Scalars['String']>,
  vinculoProduto?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  statusSaude?: Maybe<Scalars['String']>,
  grupoIds_In?: Maybe<Scalars['String']>,
  vinculoProduto_In?: Maybe<Scalars['String']>
};


export type FuncionarioTypeOcorrenciacommaquinaSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  detalhamento?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionarioTypeLeadsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionarioTypeTarefasSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  assunto_Icontains?: Maybe<Scalars['String']>,
  tipo?: Maybe<Scalars['String']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lead_Nome?: Maybe<Scalars['String']>,
  lead_Nome_Icontains?: Maybe<Scalars['String']>,
  lead_Entidade_Id?: Maybe<Scalars['ID']>,
  hora?: Maybe<Scalars['Time']>,
  hora_Gte?: Maybe<Scalars['Time']>,
  hora_Gt?: Maybe<Scalars['Time']>,
  hora_Lt?: Maybe<Scalars['Time']>,
  hora_Lte?: Maybe<Scalars['Time']>,
  data?: Maybe<Scalars['Date']>,
  data_Gte?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Lte?: Maybe<Scalars['Date']>,
  dataHora?: Maybe<Scalars['DateTime']>,
  dataHora_Gte?: Maybe<Scalars['DateTime']>,
  dataHora_Gt?: Maybe<Scalars['DateTime']>,
  dataHora_Lt?: Maybe<Scalars['DateTime']>,
  dataHora_Lte?: Maybe<Scalars['DateTime']>,
  status?: Maybe<Scalars['String']>,
  leadId?: Maybe<Scalars['ID']>
};


export type FuncionarioTypeHistoricoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  leadId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionarioTypeParceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type FuncionarioTypeParceirosRepassePermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type FuncionarioTypeFuncionariosrepasseSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  funcionario_Id?: Maybe<Scalars['ID']>,
  funcionario_Id_In?: Maybe<Scalars['ID']>,
  tipoFuncionario?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Id?: Maybe<Scalars['ID']>,
  tabelaDeParceiro_Id_In?: Maybe<Scalars['String']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type FuncionarioTypeFuncionariosRepassePermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  funcionario_Id?: Maybe<Scalars['ID']>,
  funcionario_Id_In?: Maybe<Scalars['ID']>,
  tipoFuncionario?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Id?: Maybe<Scalars['ID']>,
  tabelaDeParceiro_Id_In?: Maybe<Scalars['String']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type FuncionarioTypeComissaofuncionariosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  emprestimo_Id_In?: Maybe<Scalars['String']>,
  emprestimo_Funcionario_Id?: Maybe<Scalars['ID']>,
  emprestimo_Parcelas?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  tipoComissao?: Maybe<Scalars['String']>,
  valorComissao?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

export type FuncionarioTypeRelay = Node & {
   __typename?: 'FuncionarioTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  user: UserType,
  nome: Scalars['String'],
  cpf: Scalars['String'],
  rg: Scalars['String'],
  email: Scalars['String'],
  categoria?: Maybe<FuncionarioCategoria>,
  tipoFuncionario?: Maybe<TipoFuncionarioTypeRelay>,
  tipoContrato: FuncionarioTipoContrato,
  anexoContrato?: Maybe<Scalars['String']>,
  endereco: Scalars['String'],
  complemento: Scalars['String'],
  bairro: Scalars['String'],
  municipio: Scalars['String'],
  uf: Scalars['String'],
  cep: Scalars['String'],
  pais: Scalars['String'],
  sexo?: Maybe<FuncionarioSexo>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  permissaoglobal?: Maybe<PermissaoGlobalType>,
  permissaoSet: Array<PermissaoType>,
  pedidodereembolsoSet: PedidoDeReembolsoNodeConnection,
  contaapagarSet: ContaAPagarNodeConnection,
  emprestimoSet: EmprestimoRelatorioTypeConnection,
  funcionariodegrupoSet: Array<FuncionarioDeGrupoType>,
  metaSet: MetaNodeTypeRelayConnection,
  relatorios: Array<RelatorioNode>,
  ocorrenciacommaquinaSet: OcorrenciaComMaquinaNodeConnection,
  leadsSet: LeadsNodeTypeRelayPropConnection,
  tarefasSet: TarefasNodeTypeRelayConnection,
  historicoSet: HistoricoNodeTypeRelayConnection,
  parceirosSet: ParceirosNodeTypeRelayConnection,
  parceirosRepassePermitidos: ParceirosNodeTypeRelayConnection,
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  funcionariosrepasseSet: FuncionariosRepasseNodeTypeRelayConnection,
  funcionariosRepassePermitidos: FuncionariosRepasseNodeTypeRelayConnection,
  /** Esse parametro vai estar prenchido somento na COMISSAO_COLETIVA */
  comissaofuncionariosSet: ComissaoFuncionarioNodeTypeRelayConnection,
  pk: Scalars['Int'],
};


export type FuncionarioTypeRelayPedidodereembolsoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  tipoConta_In?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_Icontains?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  conta_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Icontains?: Maybe<Scalars['Float']>,
  data?: Maybe<Scalars['DateTime']>,
  data_Lt?: Maybe<Scalars['DateTime']>,
  data_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionarioTypeRelayContaapagarSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  titulo?: Maybe<Scalars['String']>,
  titulo_Icontains?: Maybe<Scalars['String']>,
  titulo_Istartswith?: Maybe<Scalars['String']>,
  destinatario?: Maybe<Scalars['String']>,
  destinatario_Icontains?: Maybe<Scalars['String']>,
  destinatario_Istartswith?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  recorrencia?: Maybe<Scalars['String']>,
  recorrencia_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>,
  dataVencimento?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gte?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lte?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gte?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lte?: Maybe<Scalars['DateTime']>,
  transferenciaConta?: Maybe<Scalars['String']>,
  transferenciaConta_Icontains?: Maybe<Scalars['String']>,
  formaPagamento?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Lt?: Maybe<Scalars['Float']>,
  valor_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionarioTypeRelayEmprestimoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type FuncionarioTypeRelayMetaSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  valorMeta?: Maybe<Scalars['Float']>,
  taxaMeta?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['String']>,
  inicioMeta?: Maybe<Scalars['String']>,
  inicioMeta_Gte?: Maybe<Scalars['Date']>,
  inicioMeta_Gt?: Maybe<Scalars['Date']>,
  inicioMeta_Lt?: Maybe<Scalars['Date']>,
  inicioMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta?: Maybe<Scalars['String']>,
  fimMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta_Lt?: Maybe<Scalars['Date']>,
  fimMeta_Gte?: Maybe<Scalars['Date']>,
  fimMeta_Gt?: Maybe<Scalars['Date']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  tipoRegramento?: Maybe<Scalars['String']>,
  tipoRegramento_In?: Maybe<Scalars['String']>,
  vinculoProduto?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  statusSaude?: Maybe<Scalars['String']>,
  grupoIds_In?: Maybe<Scalars['String']>,
  vinculoProduto_In?: Maybe<Scalars['String']>
};


export type FuncionarioTypeRelayOcorrenciacommaquinaSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  detalhamento?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionarioTypeRelayLeadsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionarioTypeRelayTarefasSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  assunto_Icontains?: Maybe<Scalars['String']>,
  tipo?: Maybe<Scalars['String']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lead_Nome?: Maybe<Scalars['String']>,
  lead_Nome_Icontains?: Maybe<Scalars['String']>,
  lead_Entidade_Id?: Maybe<Scalars['ID']>,
  hora?: Maybe<Scalars['Time']>,
  hora_Gte?: Maybe<Scalars['Time']>,
  hora_Gt?: Maybe<Scalars['Time']>,
  hora_Lt?: Maybe<Scalars['Time']>,
  hora_Lte?: Maybe<Scalars['Time']>,
  data?: Maybe<Scalars['Date']>,
  data_Gte?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Lte?: Maybe<Scalars['Date']>,
  dataHora?: Maybe<Scalars['DateTime']>,
  dataHora_Gte?: Maybe<Scalars['DateTime']>,
  dataHora_Gt?: Maybe<Scalars['DateTime']>,
  dataHora_Lt?: Maybe<Scalars['DateTime']>,
  dataHora_Lte?: Maybe<Scalars['DateTime']>,
  status?: Maybe<Scalars['String']>,
  leadId?: Maybe<Scalars['ID']>
};


export type FuncionarioTypeRelayHistoricoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  leadId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type FuncionarioTypeRelayParceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type FuncionarioTypeRelayParceirosRepassePermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type FuncionarioTypeRelayFuncionariosrepasseSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  funcionario_Id?: Maybe<Scalars['ID']>,
  funcionario_Id_In?: Maybe<Scalars['ID']>,
  tipoFuncionario?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Id?: Maybe<Scalars['ID']>,
  tabelaDeParceiro_Id_In?: Maybe<Scalars['String']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type FuncionarioTypeRelayFuncionariosRepassePermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  funcionario_Id?: Maybe<Scalars['ID']>,
  funcionario_Id_In?: Maybe<Scalars['ID']>,
  tipoFuncionario?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Id?: Maybe<Scalars['ID']>,
  tabelaDeParceiro_Id_In?: Maybe<Scalars['String']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type FuncionarioTypeRelayComissaofuncionariosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  emprestimo_Id_In?: Maybe<Scalars['String']>,
  emprestimo_Funcionario_Id?: Maybe<Scalars['ID']>,
  emprestimo_Parcelas?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  tipoComissao?: Maybe<Scalars['String']>,
  valorComissao?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

export type FuncionarioTypeRelayConnection = {
   __typename?: 'FuncionarioTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FuncionarioTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `FuncionarioTypeRelay` and its cursor. */
export type FuncionarioTypeRelayEdge = {
   __typename?: 'FuncionarioTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<FuncionarioTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type GenerateNewUserPasswordMobile = {
   __typename?: 'GenerateNewUserPasswordMobile',
  lead?: Maybe<LeadsType>,
  sendEmail?: Maybe<Scalars['Boolean']>,
};


export type GerarNovaSenhaClienteMobile = {
   __typename?: 'GerarNovaSenhaClienteMobile',
  cliente?: Maybe<ClienteType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type GerarNovaSenhaFuncionarioMutation = {
   __typename?: 'GerarNovaSenhaFuncionarioMutation',
  funcionario?: Maybe<FuncionarioType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export enum GrapheneListaPermissionsEnum {
  VerParceiro = 'VER_PARCEIRO',
  DashboardParceiro = 'DASHBOARD_PARCEIRO',
  VerTabelaParceiro = 'VER_TABELA_PARCEIRO',
  HistoricoResgateParceiro = 'HISTORICO_RESGATE_PARCEIRO'
}

export type GrupoDePermissoesType = {
   __typename?: 'GrupoDePermissoesType',
  id: Scalars['ID'],
  nome: Scalars['String'],
  descricao?: Maybe<Scalars['String']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  tabelaParceiro?: Maybe<TabelasNodeTypeRelay>,
  permissoes: Array<PermissaoDeGrupoType>,
  entidades: Array<EntidadeDeGrupoType>,
  funcionarios: Array<FuncionarioDeGrupoType>,
  parceirosGruposPermitidos: ParceirosNodeTypeRelayConnection,
  parceirosSet: ParceirosNodeTypeRelayConnection,
  funcionariosRepasseGruposPermitidos: FuncionariosRepasseNodeTypeRelayConnection,
  grupofuncionariosrepasseSet: Array<GrupoFuncionariosRepasseType>,
  grupoentidadefuncionariorepasseSet: Array<GrupoEntidadeFuncionarioRepasseType>,
  totalPermissoes?: Maybe<Scalars['Int']>,
  totalEntidades?: Maybe<Scalars['Int']>,
  totalFuncionarios?: Maybe<Scalars['Int']>,
};


export type GrupoDePermissoesTypeParceirosGruposPermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type GrupoDePermissoesTypeParceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type GrupoDePermissoesTypeFuncionariosRepasseGruposPermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  funcionario_Id?: Maybe<Scalars['ID']>,
  funcionario_Id_In?: Maybe<Scalars['ID']>,
  tipoFuncionario?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Id?: Maybe<Scalars['ID']>,
  tabelaDeParceiro_Id_In?: Maybe<Scalars['String']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type GrupoDePermissoesTypeRelay = Node & {
   __typename?: 'GrupoDePermissoesTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  descricao?: Maybe<Scalars['String']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  tabelaParceiro?: Maybe<TabelasNodeTypeRelay>,
  permissoes: Array<PermissaoDeGrupoType>,
  entidades: Array<EntidadeDeGrupoType>,
  funcionarios: Array<FuncionarioDeGrupoType>,
  parceirosGruposPermitidos: ParceirosNodeTypeRelayConnection,
  parceirosSet: ParceirosNodeTypeRelayConnection,
  funcionariosRepasseGruposPermitidos: FuncionariosRepasseNodeTypeRelayConnection,
  grupofuncionariosrepasseSet: Array<GrupoFuncionariosRepasseType>,
  grupoentidadefuncionariorepasseSet: Array<GrupoEntidadeFuncionarioRepasseType>,
  pk: Scalars['Int'],
  totalPermissoes?: Maybe<Scalars['Int']>,
  totalEntidades?: Maybe<Scalars['Int']>,
  totalFuncionarios?: Maybe<Scalars['Int']>,
};


export type GrupoDePermissoesTypeRelayParceirosGruposPermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type GrupoDePermissoesTypeRelayParceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type GrupoDePermissoesTypeRelayFuncionariosRepasseGruposPermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  funcionario_Id?: Maybe<Scalars['ID']>,
  funcionario_Id_In?: Maybe<Scalars['ID']>,
  tipoFuncionario?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Id?: Maybe<Scalars['ID']>,
  tabelaDeParceiro_Id_In?: Maybe<Scalars['String']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type GrupoDePermissoesTypeRelayConnection = {
   __typename?: 'GrupoDePermissoesTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GrupoDePermissoesTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `GrupoDePermissoesTypeRelay` and its cursor. */
export type GrupoDePermissoesTypeRelayEdge = {
   __typename?: 'GrupoDePermissoesTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<GrupoDePermissoesTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type GrupoEntidadeFuncionarioRepasseType = {
   __typename?: 'GrupoEntidadeFuncionarioRepasseType',
  id: Scalars['ID'],
  funcionario: FuncionariosRepasseNodeTypeRelay,
  grupo: GrupoDePermissoesTypeRelay,
};

export type GrupoFuncionariosRepasseType = {
   __typename?: 'GrupoFuncionariosRepasseType',
  id: Scalars['ID'],
  grupo?: Maybe<GrupoDePermissoesTypeRelay>,
  tabelaDeParceiro: TabelasNodeTypeRelay,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
};

export type GrupoPorDescricoesType = {
   __typename?: 'GrupoPorDescricoesType',
  grupo?: Maybe<Scalars['Int']>,
  permssaoDescricao?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type HabilitarMaquinaMutation = {
   __typename?: 'HabilitarMaquinaMutation',
  maquina?: Maybe<MaquinaNode>,
};

export type HistoricoEmprestimoClienteInput = {
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  entidade_EntidadeGrupo_In?: Maybe<Array<Maybe<Scalars['ID']>>>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Cpf?: Maybe<Scalars['String']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  nsu_NsuCv?: Maybe<Scalars['String']>,
  nsu_NsuCv_Icontains?: Maybe<Scalars['String']>,
  nsu_NsuCv_In?: Maybe<Scalars['String']>,
  valorTotal?: Maybe<Scalars['Float']>,
  valorTotal_In?: Maybe<Scalars['Float']>,
  valorDesejado?: Maybe<Scalars['Float']>,
  valorDesejado_In?: Maybe<Scalars['Float']>,
  valorDesejado_Gte?: Maybe<Scalars['Float']>,
  valorDesejado_Lte?: Maybe<Scalars['Float']>,
  nsu_TitularDivergente_Cpf?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_In?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  bandeiraCartao_In?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['String']>,
  parcelas_In?: Maybe<Scalars['String']>,
  parcelas_Lt?: Maybe<Scalars['String']>,
  parcelas_Gt?: Maybe<Scalars['String']>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  entidade_Id?: Maybe<Scalars['ID']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  tipoEmprestimo_Id_In?: Maybe<Scalars['String']>,
  tipoEmprestimo_Modalidade_In?: Maybe<Scalars['String']>,
  tipoEmprestimoUso_In?: Maybe<Scalars['String']>,
  cartaoCredito?: Maybe<Scalars['Boolean']>,
  loanType_Isnull?: Maybe<Scalars['Boolean']>,
  status_In?: Maybe<Scalars['String']>,
  /** Ordenando */
  orderBy?: Maybe<Scalars['String']>,
};

export type HistoricoEmprestimoClienteType = Node & {
   __typename?: 'HistoricoEmprestimoClienteType',
  /** The ID of the object. */
  id: Scalars['ID'],
  entidade?: Maybe<EntidadeTypeRelay>,
  cliente?: Maybe<EmprestimoClienteNode>,
  funcionario: FuncionarioTypeRelay,
  valorDesejado: Scalars['Float'],
  valorTotal?: Maybe<Scalars['Float']>,
  taxaAplicada: Scalars['Float'],
  parcelas: EmprestimoParcelas,
  tabelaTaxa?: Maybe<Scalars['String']>,
  delivery: Scalars['Boolean'],
  maquina?: Maybe<Scalars['String']>,
  nsuCartao?: Maybe<Scalars['String']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  anexoContrato?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  data: Scalars['Date'],
  taxaMinima?: Maybe<Scalars['Float']>,
  justificativaTaxaAbaixo?: Maybe<Scalars['String']>,
  justificativaCancelamento?: Maybe<Scalars['String']>,
  status: EmprestimoStatus,
  causaStatus?: Maybe<Scalars['String']>,
  clickSignChaveDocumento?: Maybe<Scalars['String']>,
  solicitadoVia: EmprestimoSolicitadoVia,
  vendaDigitada: Scalars['Boolean'],
  vendaResgatada: Scalars['Boolean'],
  leadId?: Maybe<Scalars['Int']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  resgate?: Maybe<HistoricoResgateNodeTypeRelay>,
  loanTypePayload?: Maybe<Scalars['JSONString']>,
  loanType?: Maybe<TipoDeEmprestimoRelayType>,
  extraFieldsResults?: Maybe<Scalars['JSONString']>,
  iof?: Maybe<Scalars['Float']>,
  nsus: NsuRelatorioTypeConnection,
  formasPagamento: Array<FormaPagamentoEmprestimoType>,
  anexos: Array<AnexoDeEmprestimoType>,
  comissaoparceirosSet: ComissaoNodeTypeRelayConnection,
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  comissaofuncionariosSet: ComissaoFuncionarioNodeTypeRelayConnection,
  zekiGiftback?: Maybe<ZekiGiftbackResgateType>,
  lucroBruto?: Maybe<Scalars['Decimal']>,
};


export type HistoricoEmprestimoClienteTypeNsusArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type HistoricoEmprestimoClienteTypeComissaoparceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Nsu_Parcelas?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_In?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_Iexact?: Maybe<Scalars['String']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  dataRepasse?: Maybe<Scalars['Date']>,
  dataRepasse_Gte?: Maybe<Scalars['Date']>,
  dataRepasse_Gt?: Maybe<Scalars['Date']>,
  dataRepasse_Lt?: Maybe<Scalars['Date']>,
  dataRepasse_Lte?: Maybe<Scalars['Date']>,
  emprestimo_CriadoEm?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gte?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lte?: Maybe<Scalars['DateTime']>,
  emprestimo_Data?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gte?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lte?: Maybe<Scalars['Date']>,
  valorComissao?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type HistoricoEmprestimoClienteTypeComissaofuncionariosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  emprestimo_Id_In?: Maybe<Scalars['String']>,
  emprestimo_Funcionario_Id?: Maybe<Scalars['ID']>,
  emprestimo_Parcelas?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  tipoComissao?: Maybe<Scalars['String']>,
  valorComissao?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

export type HistoricoEmprestimoClienteTypeConnection = {
   __typename?: 'HistoricoEmprestimoClienteTypeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HistoricoEmprestimoClienteTypeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `HistoricoEmprestimoClienteType` and its cursor. */
export type HistoricoEmprestimoClienteTypeEdge = {
   __typename?: 'HistoricoEmprestimoClienteTypeEdge',
  /** The item at the end of the edge */
  node?: Maybe<HistoricoEmprestimoClienteType>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type HistoricoEmprestimoType = {
   __typename?: 'HistoricoEmprestimoType',
  nome?: Maybe<Scalars['String']>,
  model?: Maybe<Scalars['String']>,
  pk?: Maybe<Scalars['Int']>,
  fields?: Maybe<FieldsHistoricoEmprestimoType>,
};

export type HistoricoNodeTypeRelay = Node & {
   __typename?: 'HistoricoNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  acao: Scalars['String'],
  data: Scalars['DateTime'],
  funcionario?: Maybe<FuncionarioTypeRelay>,
  lead: LeadsNodeTypeRelayProp,
};

export type HistoricoNodeTypeRelayConnection = {
   __typename?: 'HistoricoNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HistoricoNodeTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `HistoricoNodeTypeRelay` and its cursor. */
export type HistoricoNodeTypeRelayEdge = {
   __typename?: 'HistoricoNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<HistoricoNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type HistoricoResgateExcelType = {
   __typename?: 'HistoricoResgateExcelType',
  relatorio?: Maybe<Scalars['String']>,
  background?: Maybe<Scalars['Boolean']>,
};

export type HistoricoResgateFuncionarioNodeTypeRelay = Node & {
   __typename?: 'HistoricoResgateFuncionarioNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  inicioPeriodo: Scalars['Date'],
  fimPeriodo: Scalars['Date'],
  valorResgate: Scalars['Float'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  comissaofuncionariosSet: ComissaoFuncionarioNodeTypeRelayConnection,
  nomesEntidades?: Maybe<Scalars['String']>,
  nomesFuncionarios?: Maybe<Scalars['String']>,
};


export type HistoricoResgateFuncionarioNodeTypeRelayComissaofuncionariosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  emprestimo_Id_In?: Maybe<Scalars['String']>,
  emprestimo_Funcionario_Id?: Maybe<Scalars['ID']>,
  emprestimo_Parcelas?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  tipoComissao?: Maybe<Scalars['String']>,
  valorComissao?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

export type HistoricoResgateFuncionarioNodeTypeRelayConnection = {
   __typename?: 'HistoricoResgateFuncionarioNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HistoricoResgateFuncionarioNodeTypeRelayEdge>>,
  totalResgate?: Maybe<Scalars['Float']>,
  edgeCount?: Maybe<Scalars['Int']>,
  totalCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `HistoricoResgateFuncionarioNodeTypeRelay` and its cursor. */
export type HistoricoResgateFuncionarioNodeTypeRelayEdge = {
   __typename?: 'HistoricoResgateFuncionarioNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<HistoricoResgateFuncionarioNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type HistoricoResgateNodeTypeRelay = Node & {
   __typename?: 'HistoricoResgateNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  valorResgate: Scalars['Float'],
  valorPago?: Maybe<Scalars['Float']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  parceiro: ParceirosNodeTypeRelay,
  tipoPix: Scalars['String'],
  pix: Scalars['String'],
  banco: Scalars['String'],
  agencia: Scalars['String'],
  conta: Scalars['String'],
  emprestimoSet?: Maybe<Array<Maybe<EmprestimoType>>>,
  comissaoparceirosSet: ComissaoNodeTypeRelayConnection,
};


export type HistoricoResgateNodeTypeRelayComissaoparceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Nsu_Parcelas?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_In?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_Iexact?: Maybe<Scalars['String']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  dataRepasse?: Maybe<Scalars['Date']>,
  dataRepasse_Gte?: Maybe<Scalars['Date']>,
  dataRepasse_Gt?: Maybe<Scalars['Date']>,
  dataRepasse_Lt?: Maybe<Scalars['Date']>,
  dataRepasse_Lte?: Maybe<Scalars['Date']>,
  emprestimo_CriadoEm?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gte?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lte?: Maybe<Scalars['DateTime']>,
  emprestimo_Data?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gte?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lte?: Maybe<Scalars['Date']>,
  valorComissao?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};

export type HistoricoResgateNodeTypeRelayConnection = {
   __typename?: 'HistoricoResgateNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HistoricoResgateNodeTypeRelayEdge>>,
  totalResgate?: Maybe<Scalars['Float']>,
  edgeCount?: Maybe<Scalars['Int']>,
  totalCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `HistoricoResgateNodeTypeRelay` and its cursor. */
export type HistoricoResgateNodeTypeRelayEdge = {
   __typename?: 'HistoricoResgateNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<HistoricoResgateNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type IncluirAnexoDeContaAPagarMutation = {
   __typename?: 'IncluirAnexoDeContaAPagarMutation',
  ok?: Maybe<Scalars['Boolean']>,
  anexo?: Maybe<AnexoDeContaAPagarType>,
};

export type IncluirAnexoDePedidoDeReembolsoMutation = {
   __typename?: 'IncluirAnexoDePedidoDeReembolsoMutation',
  ok?: Maybe<Scalars['Boolean']>,
  anexo?: Maybe<AnexoDePedidoDeReembolsoType>,
};

export type IncluirContaDeClienteMutation = {
   __typename?: 'IncluirContaDeClienteMutation',
  ok?: Maybe<Scalars['Boolean']>,
  conta?: Maybe<ContaDeClienteType>,
};

export type IncluirTelefoneDeClienteMutation = {
   __typename?: 'IncluirTelefoneDeClienteMutation',
  ok?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<TelefoneDeClienteType>,
};

export type IncluirTelefoneDeEntidadeMutation = {
   __typename?: 'IncluirTelefoneDeEntidadeMutation',
  ok?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<TelefoneDeEntidadeType>,
};

export type InputCriarCartaoDeCredito = {
  nomeNoCartao: Scalars['String'],
  validade: Scalars['String'],
  numeroCartao: Scalars['String'],
  cvc: Scalars['String'],
  cartaoFrente: Scalars['String'],
  cartaoVerso: Scalars['String'],
  cartaoSelf?: Maybe<Scalars['String']>,
};

export type InputCriarCartaoDeCreditoTerceiros = {
  rg: Scalars['String'],
  cpf: Scalars['String'],
  endereco: Scalars['String'],
  complemento?: Maybe<Scalars['String']>,
  bairro: Scalars['String'],
  municipio: Scalars['String'],
  uf: Scalars['String'],
  cep: Scalars['String'],
  pais: Scalars['String'],
  anexoRgFrente: Scalars['String'],
  anexoRgVerso: Scalars['String'],
  anexoCpfFrente: Scalars['String'],
  anexoCpfVerso: Scalars['String'],
  anexoEndereco?: Maybe<Scalars['String']>,
};

export type InputEditarFornecedorType = {
  id: Scalars['ID'],
  nome: Scalars['String'],
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  idsEntidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsCategorias?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsSubcategorias?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type InputEmprestimoMobile = {
  valorTotal: Scalars['Float'],
  valorDesejado: Scalars['Float'],
  taxaAplicada: Scalars['Int'],
  parcelas: EmprestimoParcelas,
  data: Scalars['Date'],
};

export type InputFormaPagamentoFornecedorType = {
  id?: Maybe<Scalars['ID']>,
  tipoPix?: Maybe<Scalars['String']>,
  pix?: Maybe<Scalars['String']>,
  boletoDataVencimento?: Maybe<Scalars['Date']>,
  boletoNumeroControle?: Maybe<Scalars['String']>,
  boletoCodigoBarra?: Maybe<Scalars['String']>,
  boletoAnexo?: Maybe<Scalars['String']>,
  contaNome?: Maybe<Scalars['String']>,
  contaBanco?: Maybe<Scalars['String']>,
  contaAgencia?: Maybe<Scalars['String']>,
  contaTipoConta?: Maybe<Scalars['String']>,
  contaConta?: Maybe<Scalars['String']>,
  contaVariacao?: Maybe<Scalars['String']>,
  contaCpfCnpj?: Maybe<Scalars['String']>,
  default?: Maybe<Scalars['Boolean']>,
};

export type InputFornecedorType = {
  nome: Scalars['String'],
  cpfCnpj: Scalars['String'],
  endereco?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  idsEntidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsCategorias?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsSubcategorias?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type InputTarefa = {
  leadId: Scalars['ID'],
  assunto: Scalars['String'],
  tipo: Scalars['String'],
  funcionarioId: Scalars['ID'],
  data: Scalars['Date'],
  hora: Scalars['Time'],
};

export type InputTelefoneFornecedorType = {
  id?: Maybe<Scalars['ID']>,
  ddd?: Maybe<Scalars['String']>,
  numero?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
};

export type InputTiposEntidadesType = {
  tipoLoja: Scalars['String'],
  valorAcimaTipo?: Maybe<Scalars['Float']>,
  default?: Maybe<Scalars['Boolean']>,
};

export type InstanciaZApiInput = {
  id?: Maybe<Scalars['Int']>,
  entidadeId?: Maybe<Scalars['ID']>,
  nome?: Maybe<Scalars['String']>,
  isActived?: Maybe<Scalars['Boolean']>,
  zApiId?: Maybe<Scalars['String']>,
  zApiToken?: Maybe<Scalars['String']>,
};

export type InstanciaZApiNode = Node & {
   __typename?: 'InstanciaZApiNode',
  /** The ID of the object. */
  id: Scalars['ID'],
  entidade: EntidadeTypeRelay,
  nome: Scalars['String'],
  isActived: Scalars['Boolean'],
  isConnected: Scalars['Boolean'],
  zApiId: Scalars['String'],
  zApiToken: Scalars['String'],
  zekiCash: Scalars['Int'],
  dataCriacao?: Maybe<Scalars['DateTime']>,
  mensagemzapiSet: Array<MensagemZApiType>,
  pk: Scalars['Int'],
};

export type InstanciaZApiNodeConnection = {
   __typename?: 'InstanciaZApiNodeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InstanciaZApiNodeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `InstanciaZApiNode` and its cursor. */
export type InstanciaZApiNodeEdge = {
   __typename?: 'InstanciaZApiNodeEdge',
  /** The item at the end of the edge */
  node?: Maybe<InstanciaZApiNode>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type InstanciaZApiType = {
   __typename?: 'InstanciaZApiType',
  id: Scalars['ID'],
  entidade: EntidadeTypeRelay,
  nome: Scalars['String'],
  isActived: Scalars['Boolean'],
  isConnected: Scalars['Boolean'],
  zApiId: Scalars['String'],
  zApiToken: Scalars['String'],
  zekiCash: Scalars['Int'],
  dataCriacao?: Maybe<Scalars['DateTime']>,
  mensagemzapiSet: Array<MensagemZApiType>,
  pk: Scalars['Int'],
};


export type LeadMarketingAgregations = {
   __typename?: 'LeadMarketingAgregations',
  somaValorPassado?: Maybe<Scalars['Decimal']>,
  somaValorRetirado?: Maybe<Scalars['Decimal']>,
  taxaMediaTotal?: Maybe<Scalars['Decimal']>,
  mediaParcelas?: Maybe<Scalars['Float']>,
  ticketMedio?: Maybe<Scalars['Decimal']>,
};

export type LeadRelatorioInput = {
  nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  tarefas_Funcionario_Id?: Maybe<Scalars['ID']>,
  pausado?: Maybe<Scalars['Boolean']>,
  email_Isnull?: Maybe<Scalars['Boolean']>,
  telefone_Isnull?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  qualificacao?: Maybe<Scalars['Int']>,
  clienteId?: Maybe<Scalars['ID']>,
  cliente_Sexo?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  responsavelId?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  possuiCartao?: Maybe<Scalars['Boolean']>,
  statusLead_Index?: Maybe<Scalars['Int']>,
  statusLead_Nome?: Maybe<Scalars['String']>,
  tarefas_Tipo_Icontains?: Maybe<Scalars['String']>,
  tarefas_Status?: Maybe<Scalars['String']>,
  tarefas_Hora?: Maybe<Scalars['Time']>,
  tarefas_Hora_Gte?: Maybe<Scalars['Time']>,
  tarefas_Hora_Gt?: Maybe<Scalars['Time']>,
  tarefas_Hora_Lt?: Maybe<Scalars['Time']>,
  tarefas_Hora_Lte?: Maybe<Scalars['Time']>,
  tarefas_Data?: Maybe<Scalars['Date']>,
  tarefas_Data_Gte?: Maybe<Scalars['Date']>,
  tarefas_Data_Gt?: Maybe<Scalars['Date']>,
  tarefas_Data_Lt?: Maybe<Scalars['Date']>,
  tarefas_Data_Lte?: Maybe<Scalars['Date']>,
  tarefas_DataHora?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Gte?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Gt?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Lt?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Lte?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  produtoInteresse_Icontains?: Maybe<Scalars['String']>,
  app?: Maybe<Scalars['Boolean']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  statusLeadId?: Maybe<Scalars['ID']>,
  tarefas_Id?: Maybe<Scalars['ID']>,
  /** Ordenando */
  orderBy?: Maybe<Scalars['String']>,
};

export type LeadsNodeTypeRelay = Node & {
   __typename?: 'LeadsNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  pausado: Scalars['Boolean'],
  vendaRealizada: Scalars['Boolean'],
  cliente?: Maybe<EmprestimoClienteNode>,
  entidade?: Maybe<EntidadeTypeRelay>,
  responsavel?: Maybe<FuncionarioTypeRelay>,
  statusAnterior?: Maybe<Scalars['Int']>,
  qualificacao?: Maybe<Scalars['Int']>,
  justificativa?: Maybe<Scalars['String']>,
  origemCrm?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origemUrl?: Maybe<Scalars['String']>,
  possuiCartao?: Maybe<Scalars['Boolean']>,
  tipoBeneficio?: Maybe<Scalars['String']>,
  contaMaisTempo?: Maybe<Scalars['Boolean']>,
  carteiraAssinada?: Maybe<Scalars['Boolean']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  position?: Maybe<Scalars['Float']>,
  statusLead?: Maybe<StatusLeadType>,
  produtoInteresse?: Maybe<Scalars['String']>,
  emprestimoContratado?: Maybe<Scalars['Int']>,
  gclidField?: Maybe<Scalars['String']>,
  vagas: Array<VagaType>,
  utmSource?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  app: Scalars['Boolean'],
  sgiId?: Maybe<Scalars['Int']>,
  sgiImportedAt?: Maybe<Scalars['DateTime']>,
  /** Payload original do webhook */
  payloadOriginal?: Maybe<Scalars['JSONString']>,
  tarefasSet?: Maybe<Array<Maybe<TarefasType>>>,
  propostasSet: Array<PropostasType>,
  anotacaoSet?: Maybe<Array<Maybe<AnotacaoType>>>,
  historicoSet: HistoricoNodeTypeRelayConnection,
  listasmsSet: ListaSmsTypeRelayConnection,
  quantidadeEmprestimo?: Maybe<Scalars['Int']>,
  totalValorDesejado?: Maybe<Scalars['Decimal']>,
  totalValorEmprestimo?: Maybe<Scalars['Decimal']>,
  taxaMedia?: Maybe<Scalars['Decimal']>,
  lucroBruto?: Maybe<Scalars['Float']>,
};


export type LeadsNodeTypeRelayHistoricoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  leadId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type LeadsNodeTypeRelayListasmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type LeadsNodeTypeRelayConnection = {
   __typename?: 'LeadsNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LeadsNodeTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `LeadsNodeTypeRelay` and its cursor. */
export type LeadsNodeTypeRelayEdge = {
   __typename?: 'LeadsNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<LeadsNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type LeadsNodeTypeRelayProp = Node & {
   __typename?: 'LeadsNodeTypeRelayProp',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  pausado: Scalars['Boolean'],
  vendaRealizada: Scalars['Boolean'],
  cliente?: Maybe<EmprestimoClienteNode>,
  entidade?: Maybe<EntidadeTypeRelay>,
  responsavel?: Maybe<FuncionarioTypeRelay>,
  statusAnterior?: Maybe<Scalars['Int']>,
  qualificacao?: Maybe<Scalars['Int']>,
  justificativa?: Maybe<Scalars['String']>,
  origemCrm?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origemUrl?: Maybe<Scalars['String']>,
  possuiCartao?: Maybe<Scalars['Boolean']>,
  tipoBeneficio?: Maybe<Scalars['String']>,
  contaMaisTempo?: Maybe<Scalars['Boolean']>,
  carteiraAssinada?: Maybe<Scalars['Boolean']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  position?: Maybe<Scalars['Float']>,
  statusLead?: Maybe<StatusLeadType>,
  produtoInteresse?: Maybe<Scalars['String']>,
  emprestimoContratado?: Maybe<Scalars['Int']>,
  gclidField?: Maybe<Scalars['String']>,
  vagas: Array<VagaType>,
  utmSource?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  app: Scalars['Boolean'],
  sgiId?: Maybe<Scalars['Int']>,
  sgiImportedAt?: Maybe<Scalars['DateTime']>,
  /** Payload original do webhook */
  payloadOriginal?: Maybe<Scalars['JSONString']>,
  tarefasSet: TarefasNodeTypeRelayConnection,
  propostasSet: Array<PropostasType>,
  anotacaoSet: Array<AnotacaoType>,
  historicoSet: HistoricoNodeTypeRelayConnection,
  listasmsSet: ListaSmsTypeRelayConnection,
};


export type LeadsNodeTypeRelayPropTarefasSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  assunto_Icontains?: Maybe<Scalars['String']>,
  tipo?: Maybe<Scalars['String']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lead_Nome?: Maybe<Scalars['String']>,
  lead_Nome_Icontains?: Maybe<Scalars['String']>,
  lead_Entidade_Id?: Maybe<Scalars['ID']>,
  hora?: Maybe<Scalars['Time']>,
  hora_Gte?: Maybe<Scalars['Time']>,
  hora_Gt?: Maybe<Scalars['Time']>,
  hora_Lt?: Maybe<Scalars['Time']>,
  hora_Lte?: Maybe<Scalars['Time']>,
  data?: Maybe<Scalars['Date']>,
  data_Gte?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Lte?: Maybe<Scalars['Date']>,
  dataHora?: Maybe<Scalars['DateTime']>,
  dataHora_Gte?: Maybe<Scalars['DateTime']>,
  dataHora_Gt?: Maybe<Scalars['DateTime']>,
  dataHora_Lt?: Maybe<Scalars['DateTime']>,
  dataHora_Lte?: Maybe<Scalars['DateTime']>,
  status?: Maybe<Scalars['String']>,
  leadId?: Maybe<Scalars['ID']>
};


export type LeadsNodeTypeRelayPropHistoricoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  leadId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type LeadsNodeTypeRelayPropListasmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type LeadsNodeTypeRelayPropConnection = {
   __typename?: 'LeadsNodeTypeRelayPropConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LeadsNodeTypeRelayPropEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `LeadsNodeTypeRelayProp` and its cursor. */
export type LeadsNodeTypeRelayPropEdge = {
   __typename?: 'LeadsNodeTypeRelayPropEdge',
  /** The item at the end of the edge */
  node?: Maybe<LeadsNodeTypeRelayProp>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type LeadsType = {
   __typename?: 'LeadsType',
  id: Scalars['ID'],
  nome: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  pausado: Scalars['Boolean'],
  vendaRealizada: Scalars['Boolean'],
  cliente?: Maybe<EmprestimoClienteNode>,
  entidade?: Maybe<EntidadeTypeRelay>,
  responsavel?: Maybe<FuncionarioTypeRelay>,
  statusAnterior?: Maybe<Scalars['Int']>,
  qualificacao?: Maybe<Scalars['Int']>,
  justificativa?: Maybe<Scalars['String']>,
  origemCrm?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origemUrl?: Maybe<Scalars['String']>,
  possuiCartao?: Maybe<Scalars['Boolean']>,
  tipoBeneficio?: Maybe<Scalars['String']>,
  contaMaisTempo?: Maybe<Scalars['Boolean']>,
  carteiraAssinada?: Maybe<Scalars['Boolean']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  position?: Maybe<Scalars['Float']>,
  statusLead?: Maybe<StatusLeadType>,
  produtoInteresse?: Maybe<Scalars['String']>,
  emprestimoContratado?: Maybe<Scalars['Int']>,
  gclidField?: Maybe<Scalars['String']>,
  vagas: Array<VagaType>,
  utmSource?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  app: Scalars['Boolean'],
  sgiId?: Maybe<Scalars['Int']>,
  sgiImportedAt?: Maybe<Scalars['DateTime']>,
  /** Payload original do webhook */
  payloadOriginal?: Maybe<Scalars['JSONString']>,
  tarefasSet?: Maybe<Array<Maybe<TarefasType>>>,
  propostasSet: Array<PropostasType>,
  anotacaoSet: Array<AnotacaoType>,
  historicoSet: HistoricoNodeTypeRelayConnection,
  listasmsSet: ListaSmsTypeRelayConnection,
};


export type LeadsTypeHistoricoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  leadId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type LeadsTypeListasmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type LerArquivoLead = {
   __typename?: 'LerArquivoLead',
  ok?: Maybe<Scalars['Boolean']>,
};

export enum ListaEntidadeFuncionarioPermissionsEnum {
  VerLeads = 'VER_LEADS',
  VerTabelaParceiro = 'VER_TABELA_PARCEIRO',
  VerParceiro = 'VER_PARCEIRO'
}

export type ListaSmsType = {
   __typename?: 'ListaSmsType',
  id: Scalars['ID'],
  nome: Scalars['String'],
  entidades: EntidadeTypeRelayConnection,
  clientes: EmprestimoClienteNodeConnection,
  leads: LeadsNodeTypeRelayPropConnection,
  totalContatos?: Maybe<Scalars['Int']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  filtros?: Maybe<FiltrosListaObjectType>,
  enviosmsSet: EnvioSmsTypeRelayConnection,
  envioemailSet: EnvioEmailTypeRelayConnection,
};


export type ListaSmsTypeEntidadesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type ListaSmsTypeClientesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  cliente_Id?: Maybe<Scalars['ID']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_In?: Maybe<Scalars['String']>,
  cliente_Sexo?: Maybe<Scalars['String']>,
  cliente_Sexo_In?: Maybe<Scalars['String']>,
  cliente_Municipio?: Maybe<Scalars['String']>,
  cliente_Municipio_In?: Maybe<Scalars['String']>,
  cliente_Municipio_Icontains?: Maybe<Scalars['String']>,
  entidade?: Maybe<Scalars['ID']>,
  entidade_In?: Maybe<Scalars['ID']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  quantidadeEmprestimo?: Maybe<Scalars['Float']>,
  taxaMedia?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type ListaSmsTypeLeadsArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type ListaSmsTypeEnviosmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  listas_Id?: Maybe<Scalars['ID']>,
  listas_Id_In?: Maybe<Scalars['String']>,
  apiSmsFlag?: Maybe<Scalars['Boolean']>,
  hora?: Maybe<Scalars['Time']>,
  hora_Gte?: Maybe<Scalars['Time']>,
  hora_Gt?: Maybe<Scalars['Time']>,
  hora_Lt?: Maybe<Scalars['Time']>,
  hora_Lte?: Maybe<Scalars['Time']>,
  data?: Maybe<Scalars['Date']>,
  data_Gte?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Lte?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type ListaSmsTypeEnvioemailSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  listas_Id?: Maybe<Scalars['ID']>,
  listas_Id_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  hora?: Maybe<Scalars['Time']>,
  hora_Gte?: Maybe<Scalars['Time']>,
  hora_Gt?: Maybe<Scalars['Time']>,
  hora_Lt?: Maybe<Scalars['Time']>,
  hora_Lte?: Maybe<Scalars['Time']>,
  data?: Maybe<Scalars['Date']>,
  data_Gte?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Lte?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type ListaSmsTypeRelay = Node & {
   __typename?: 'ListaSmsTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  entidades?: Maybe<Array<Maybe<EntidadeType>>>,
  clientes?: Maybe<Array<Maybe<ClienteType>>>,
  leads?: Maybe<Array<Maybe<LeadsType>>>,
  totalContatos?: Maybe<Scalars['Int']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  filtros?: Maybe<Scalars['JSONString']>,
  enviosmsSet?: Maybe<Array<Maybe<EnvioSmsType>>>,
  envioemailSet?: Maybe<Array<Maybe<EnvioEmailType>>>,
  nomesEntidades?: Maybe<Scalars['String']>,
};

export type ListaSmsTypeRelayConnection = {
   __typename?: 'ListaSmsTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ListaSmsTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `ListaSmsTypeRelay` and its cursor. */
export type ListaSmsTypeRelayEdge = {
   __typename?: 'ListaSmsTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<ListaSmsTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type LoginMobile = {
   __typename?: 'LoginMobile',
  token?: Maybe<Scalars['String']>,
  lead?: Maybe<LeadsType>,
  user?: Maybe<UserType>,
};

export type LojaParceiroType = {
   __typename?: 'LojaParceiroType',
  id: Scalars['ID'],
  loja?: Maybe<EntidadeTypeRelay>,
  parceiro: ParceirosNodeTypeRelay,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  tabela?: Maybe<TabelasNodeTypeRelay>,
};

export type LojasParceirosInput = {
  parceiroId?: Maybe<Scalars['ID']>,
  lojasParceiroIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type LojasTabelasTypeInput = {
  idTabela?: Maybe<Scalars['ID']>,
  idsLoja?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type MaquinaCreateInput = {
  etiquetagem: Scalars['String'],
  serialNumber: Scalars['String'],
  status?: Maybe<MaquinaStatus>,
  numeroTerminal?: Maybe<Scalars['String']>,
  razaoSocial?: Maybe<Scalars['String']>,
  nomeFantasia?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  numeroEstabelecimento?: Maybe<Scalars['String']>,
  adquirente?: Maybe<Scalars['String']>,
  senha?: Maybe<Scalars['String']>,
  taxasParcelas?: Maybe<Array<Maybe<TaxasParcelasMaquinaInput>>>,
  idEntidade?: Maybe<Scalars['ID']>,
};

export type MaquinaNode = Node & {
   __typename?: 'MaquinaNode',
  /** The ID of the object. */
  id: Scalars['ID'],
  etiquetagem: Scalars['String'],
  serialNumber: Scalars['String'],
  status: MaquinaStatus,
  entidade?: Maybe<EntidadeTypeRelay>,
  numeroTerminal?: Maybe<Scalars['String']>,
  razaoSocial?: Maybe<Scalars['String']>,
  nomeFantasia?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  numeroEstabelecimento?: Maybe<Scalars['String']>,
  adquirente?: Maybe<Scalars['String']>,
  senha?: Maybe<Scalars['String']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  nsus: Array<NsuType>,
  ocorrencias: OcorrenciaComMaquinaNodeConnection,
  taxasParcelas: TaxasParcelasMaquinaNodeConnection,
  quantidadeEmprestimos?: Maybe<Scalars['Int']>,
};


export type MaquinaNodeOcorrenciasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  detalhamento?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>
};


export type MaquinaNodeTaxasParcelasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type MaquinaNodeConnection = {
   __typename?: 'MaquinaNodeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MaquinaNodeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `MaquinaNode` and its cursor. */
export type MaquinaNodeEdge = {
   __typename?: 'MaquinaNodeEdge',
  /** The item at the end of the edge */
  node?: Maybe<MaquinaNode>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum MaquinaStatus {
  /** Em Uso */
  EmUso = 'EM_USO',
  /** Parada */
  Parada = 'PARADA',
  /** Em Estoque */
  EmEstoque = 'EM_ESTOQUE',
  /** Em Estoque com Problema */
  EmEstoqueProblema = 'EM_ESTOQUE_PROBLEMA',
  /** Em Estoque Descartada */
  EmEstoqueDescartada = 'EM_ESTOQUE_DESCARTADA',
  /** Bloqueada */
  Bloqueada = 'BLOQUEADA',
  /** Antecipação Bloqueada */
  AntecipacaoBloqueada = 'ANTECIPACAO_BLOQUEADA'
}

export type MaquinaUpdateInput = {
  id: Scalars['ID'],
  numeroTerminal?: Maybe<Scalars['String']>,
  etiquetagem?: Maybe<Scalars['String']>,
  razaoSocial?: Maybe<Scalars['String']>,
  nomeFantasia?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  numeroEstabelecimento?: Maybe<Scalars['String']>,
  adquirente?: Maybe<Scalars['String']>,
  senha?: Maybe<Scalars['String']>,
  status?: Maybe<MaquinaStatus>,
  taxasParcelas?: Maybe<Array<Maybe<TaxasParcelasMaquinaInput>>>,
};

export type MensagemSmsType = {
   __typename?: 'MensagemSmsType',
  id: Scalars['ID'],
  titulo: Scalars['String'],
  descricao: Scalars['String'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  enviosmsSet: EnvioSmsTypeRelayConnection,
};


export type MensagemSmsTypeEnviosmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  listas_Id?: Maybe<Scalars['ID']>,
  listas_Id_In?: Maybe<Scalars['String']>,
  apiSmsFlag?: Maybe<Scalars['Boolean']>,
  hora?: Maybe<Scalars['Time']>,
  hora_Gte?: Maybe<Scalars['Time']>,
  hora_Gt?: Maybe<Scalars['Time']>,
  hora_Lt?: Maybe<Scalars['Time']>,
  hora_Lte?: Maybe<Scalars['Time']>,
  data?: Maybe<Scalars['Date']>,
  data_Gte?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Lte?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type MensagemSmsTypeRelay = Node & {
   __typename?: 'MensagemSmsTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  titulo: Scalars['String'],
  descricao: Scalars['String'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  enviosmsSet: EnvioSmsTypeRelayConnection,
};


export type MensagemSmsTypeRelayEnviosmsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  listas_Id?: Maybe<Scalars['ID']>,
  listas_Id_In?: Maybe<Scalars['String']>,
  apiSmsFlag?: Maybe<Scalars['Boolean']>,
  hora?: Maybe<Scalars['Time']>,
  hora_Gte?: Maybe<Scalars['Time']>,
  hora_Gt?: Maybe<Scalars['Time']>,
  hora_Lt?: Maybe<Scalars['Time']>,
  hora_Lte?: Maybe<Scalars['Time']>,
  data?: Maybe<Scalars['Date']>,
  data_Gte?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Lte?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};

export type MensagemSmsTypeRelayConnection = {
   __typename?: 'MensagemSmsTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MensagemSmsTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `MensagemSmsTypeRelay` and its cursor. */
export type MensagemSmsTypeRelayEdge = {
   __typename?: 'MensagemSmsTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<MensagemSmsTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type MensagemType = {
  titulo?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
};

export type MensagemZApiType = {
   __typename?: 'MensagemZApiType',
  id: Scalars['ID'],
  status: StatusLeadType,
  instancia: InstanciaZApiNode,
  texto: Scalars['String'],
  pk: Scalars['Int'],
};

export type MetaDiariaTypeRelay = Node & {
   __typename?: 'MetaDiariaTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  meta: MetaNodeTypeRelay,
  dataDia: Scalars['Date'],
  valorPassado?: Maybe<Scalars['Float']>,
  valorAcumulada?: Maybe<Scalars['Float']>,
  taxaPassado?: Maybe<Scalars['Float']>,
  taxaAcumulada?: Maybe<Scalars['Float']>,
  statusSaude?: Maybe<Scalars['String']>,
};

export type MetaDiariaTypeRelayConnection = {
   __typename?: 'MetaDiariaTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetaDiariaTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `MetaDiariaTypeRelay` and its cursor. */
export type MetaDiariaTypeRelayEdge = {
   __typename?: 'MetaDiariaTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<MetaDiariaTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type MetaFilterSetInput = {
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  valorMeta?: Maybe<Scalars['Float']>,
  taxaMeta?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['String']>,
  inicioMeta?: Maybe<Scalars['String']>,
  inicioMeta_Gte?: Maybe<Scalars['Date']>,
  inicioMeta_Gt?: Maybe<Scalars['Date']>,
  inicioMeta_Lt?: Maybe<Scalars['Date']>,
  inicioMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta?: Maybe<Scalars['String']>,
  fimMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta_Lt?: Maybe<Scalars['Date']>,
  fimMeta_Gte?: Maybe<Scalars['Date']>,
  fimMeta_Gt?: Maybe<Scalars['Date']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  tipoRegramento?: Maybe<Scalars['String']>,
  tipoRegramento_In?: Maybe<Scalars['String']>,
  vinculoProduto?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Float']>,
  /** Ordenando */
  orderBy?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  statusSaude?: Maybe<Scalars['String']>,
  grupoIds_In?: Maybe<Scalars['String']>,
  vinculoProduto_In?: Maybe<Scalars['String']>,
};

export type MetaInput = {
  entidadeId: Scalars['ID'],
  nome?: Maybe<Scalars['String']>,
  funcionarioId: Scalars['ID'],
  inicioMeta: Scalars['Date'],
  fimMeta: Scalars['Date'],
  valorMeta?: Maybe<Scalars['Float']>,
  taxaMeta: Scalars['Float'],
  margemDeLucro?: Maybe<Scalars['Decimal']>,
  tiposDeEmprestimos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  listaDatasExcluidas?: Maybe<Scalars['String']>,
};

export type MetaInputList = {
  entidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  nome?: Maybe<Scalars['String']>,
  funcionarioId: Scalars['ID'],
  inicioMeta: Scalars['Date'],
  fimMeta: Scalars['Date'],
  valorMeta?: Maybe<Scalars['Float']>,
  taxaMeta: Scalars['Float'],
  tipoRegramento?: Maybe<Scalars['String']>,
  vinculoProduto?: Maybe<Scalars['String']>,
  tiposDeEmprestimos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  margemDeLucro?: Maybe<Scalars['Decimal']>,
  listaDatasExcluidas?: Maybe<Scalars['String']>,
};

export type MetaNodeTypeRelay = Node & {
   __typename?: 'MetaNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome?: Maybe<Scalars['String']>,
  entidade: EntidadeTypeRelay,
  inicioMeta: Scalars['Date'],
  fimMeta: Scalars['Date'],
  listaDatasExcluidas?: Maybe<Scalars['String']>,
  valorMeta?: Maybe<Scalars['Float']>,
  valorAlcancado?: Maybe<Scalars['Float']>,
  taxaMeta?: Maybe<Scalars['Float']>,
  taxaAlcancado?: Maybe<Scalars['Float']>,
  margemDeLucro?: Maybe<Scalars['Float']>,
  tipoRegramento?: Maybe<MetaTipoRegramento>,
  tipoDeEmprestimos: TipoDeEmprestimoRelayTypeConnection,
  vinculoProduto?: Maybe<MetaVinculoProduto>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  funcionario: FuncionarioTypeRelay,
  metasdiariasSet: MetaDiariaTypeRelayConnection,
  totalValorRetirado?: Maybe<Scalars['Decimal']>,
  totalValorPassado?: Maybe<Scalars['Decimal']>,
  valorBruto?: Maybe<Scalars['Decimal']>,
  taxaAlcancada?: Maybe<Scalars['Decimal']>,
  statusSaude?: Maybe<Scalars['String']>,
};


export type MetaNodeTypeRelayTipoDeEmprestimosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  ativo?: Maybe<Scalars['Boolean']>,
  modalidadeCliente?: Maybe<Scalars['String']>,
  modalidadeCliente_In?: Maybe<Scalars['String']>,
  periodicidadeRecorrencia?: Maybe<Scalars['String']>,
  periodicidadeRecorrencia_In?: Maybe<Scalars['String']>,
  tipoUso?: Maybe<Scalars['String']>,
  tipoUso_In?: Maybe<Scalars['String']>,
  valorMinimo?: Maybe<Scalars['Float']>,
  valorMinimo_Gte?: Maybe<Scalars['Float']>,
  valorMinimo_Lte?: Maybe<Scalars['Float']>,
  valorMaximo?: Maybe<Scalars['Float']>,
  valorMaximo_Gte?: Maybe<Scalars['Float']>,
  valorMaximo_Lte?: Maybe<Scalars['Float']>,
  parcelasMinimas?: Maybe<Scalars['Int']>,
  parcelasMinimas_Gte?: Maybe<Scalars['Int']>,
  parcelasMinimas_Lte?: Maybe<Scalars['Int']>,
  parcelasMaximas?: Maybe<Scalars['Int']>,
  parcelasMaximas_Gte?: Maybe<Scalars['Int']>,
  parcelasMaximas_Lte?: Maybe<Scalars['Int']>,
  taxaJuros?: Maybe<Scalars['Float']>,
  taxaJuros_Gte?: Maybe<Scalars['Float']>,
  taxaJuros_Lte?: Maybe<Scalars['Float']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type MetaNodeTypeRelayMetasdiariasSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  dataDia?: Maybe<Scalars['Date']>,
  dataDia_Gte?: Maybe<Scalars['Date']>,
  dataDia_Lte?: Maybe<Scalars['Date']>,
  dataDia_Gt?: Maybe<Scalars['Date']>,
  dataDia_Lt?: Maybe<Scalars['Date']>,
  valorPassado?: Maybe<Scalars['Float']>,
  valorAcumulada?: Maybe<Scalars['Float']>,
  taxaPassado?: Maybe<Scalars['Float']>,
  taxaAcumulada?: Maybe<Scalars['Float']>,
  meta?: Maybe<Scalars['ID']>,
  meta_In?: Maybe<Scalars['ID']>,
  statusSaude?: Maybe<Scalars['String']>,
  meta_Id_In?: Maybe<Scalars['String']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>
};

export type MetaNodeTypeRelayConnection = {
   __typename?: 'MetaNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetaNodeTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `MetaNodeTypeRelay` and its cursor. */
export type MetaNodeTypeRelayEdge = {
   __typename?: 'MetaNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<MetaNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type MetasDiariasType = {
   __typename?: 'MetasDiariasType',
  id: Scalars['ID'],
  meta: MetaNodeTypeRelay,
  dataDia: Scalars['Date'],
  valorPassado?: Maybe<Scalars['Float']>,
  valorAcumulada?: Maybe<Scalars['Float']>,
  taxaPassado?: Maybe<Scalars['Float']>,
  taxaAcumulada?: Maybe<Scalars['Float']>,
  statusSaude?: Maybe<Scalars['String']>,
};

/** An enumeration. */
export enum MetaTipoRegramento {
  /** Valor do Empréstimo */
  ValorEmprestimo = 'VALOR_EMPRESTIMO',
  /** Despesa */
  Despesa = 'DESPESA'
}

export type MetaType = {
   __typename?: 'MetaType',
  id: Scalars['ID'],
  nome?: Maybe<Scalars['String']>,
  entidade: EntidadeTypeRelay,
  inicioMeta: Scalars['Date'],
  fimMeta: Scalars['Date'],
  listaDatasExcluidas?: Maybe<Scalars['String']>,
  valorMeta?: Maybe<Scalars['Float']>,
  valorAlcancado?: Maybe<Scalars['Float']>,
  taxaMeta?: Maybe<Scalars['Float']>,
  taxaAlcancado?: Maybe<Scalars['Float']>,
  margemDeLucro?: Maybe<Scalars['Float']>,
  tipoRegramento?: Maybe<MetaTipoRegramento>,
  tipoDeEmprestimos: TipoDeEmprestimoRelayTypeConnection,
  vinculoProduto?: Maybe<MetaVinculoProduto>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  funcionario: FuncionarioTypeRelay,
  metasdiariasSet: MetaDiariaTypeRelayConnection,
  totalValorRetirado?: Maybe<Scalars['Decimal']>,
  totalValorPassado?: Maybe<Scalars['Decimal']>,
  valorBruto?: Maybe<Scalars['Decimal']>,
  taxaAlcancada?: Maybe<Scalars['Decimal']>,
  statusSaude?: Maybe<Scalars['String']>,
};


export type MetaTypeTipoDeEmprestimosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  ativo?: Maybe<Scalars['Boolean']>,
  modalidadeCliente?: Maybe<Scalars['String']>,
  modalidadeCliente_In?: Maybe<Scalars['String']>,
  periodicidadeRecorrencia?: Maybe<Scalars['String']>,
  periodicidadeRecorrencia_In?: Maybe<Scalars['String']>,
  tipoUso?: Maybe<Scalars['String']>,
  tipoUso_In?: Maybe<Scalars['String']>,
  valorMinimo?: Maybe<Scalars['Float']>,
  valorMinimo_Gte?: Maybe<Scalars['Float']>,
  valorMinimo_Lte?: Maybe<Scalars['Float']>,
  valorMaximo?: Maybe<Scalars['Float']>,
  valorMaximo_Gte?: Maybe<Scalars['Float']>,
  valorMaximo_Lte?: Maybe<Scalars['Float']>,
  parcelasMinimas?: Maybe<Scalars['Int']>,
  parcelasMinimas_Gte?: Maybe<Scalars['Int']>,
  parcelasMinimas_Lte?: Maybe<Scalars['Int']>,
  parcelasMaximas?: Maybe<Scalars['Int']>,
  parcelasMaximas_Gte?: Maybe<Scalars['Int']>,
  parcelasMaximas_Lte?: Maybe<Scalars['Int']>,
  taxaJuros?: Maybe<Scalars['Float']>,
  taxaJuros_Gte?: Maybe<Scalars['Float']>,
  taxaJuros_Lte?: Maybe<Scalars['Float']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type MetaTypeMetasdiariasSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  dataDia?: Maybe<Scalars['Date']>,
  dataDia_Gte?: Maybe<Scalars['Date']>,
  dataDia_Lte?: Maybe<Scalars['Date']>,
  dataDia_Gt?: Maybe<Scalars['Date']>,
  dataDia_Lt?: Maybe<Scalars['Date']>,
  valorPassado?: Maybe<Scalars['Float']>,
  valorAcumulada?: Maybe<Scalars['Float']>,
  taxaPassado?: Maybe<Scalars['Float']>,
  taxaAcumulada?: Maybe<Scalars['Float']>,
  meta?: Maybe<Scalars['ID']>,
  meta_In?: Maybe<Scalars['ID']>,
  statusSaude?: Maybe<Scalars['String']>,
  meta_Id_In?: Maybe<Scalars['String']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>
};

/** An enumeration. */
export enum MetaVinculoProduto {
  /** Cartão de Crédito */
  CartaoCredito = 'CARTAO_CREDITO',
  /** Tipo de Empréstimo */
  TipoEmprestimo = 'TIPO_EMPRESTIMO',
  /** Ambos */
  Ambos = 'AMBOS'
}

export type MoveLead = {
   __typename?: 'MoveLead',
  lead?: Maybe<LeadsType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type MudarStatusContaAPagarMutation = {
   __typename?: 'MudarStatusContaAPagarMutation',
  contaPagar?: Maybe<ContaAPagarNode>,
};

export type MudarStatusEmprestimoMutation = {
   __typename?: 'MudarStatusEmprestimoMutation',
  emprestimo?: Maybe<EmprestimoNode>,
};

export type MudarStatusPedidoDeReembolsoMutation = {
   __typename?: 'MudarStatusPedidoDeReembolsoMutation',
  pedidoReembolso?: Maybe<PedidoDeReembolsoNode>,
};

export type Mutation = {
   __typename?: 'Mutation',
  criarInstancia?: Maybe<CriarInstanciaZApi>,
  atualizarInstancia?: Maybe<AtualizarInstanciaZApi>,
  deletarInstancia?: Maybe<DeletarInstanciaZApi>,
  criarAutomacao?: Maybe<CriarAutomacaoZApi>,
  criarTipoEmprestimo?: Maybe<CadastroTipoDeEmprestimoMutation>,
  atualizarTipoEmprestimo?: Maybe<EdicaoTipoDeEmprestimoMutation>,
  alterarStatusTipoEmprestimo?: Maybe<ChangeStatusTipoEmprestimoMutation>,
  criarFornecedor?: Maybe<CriarFornecedor>,
  editarFornecedor?: Maybe<EditarFornecedor>,
  vincularFornecedor?: Maybe<VincularFornecedorEntidade>,
  removerRelatorio?: Maybe<RemoverRelatorio>,
  criarParceiros?: Maybe<CriarParceiros>,
  editarParceiros?: Maybe<EditarParceiros>,
  criarTabela?: Maybe<CriarTabelas>,
  editarTabela?: Maybe<EditarTabelas>,
  excluirColuna?: Maybe<ExcluirColunaTabelas>,
  resgatarSaldo?: Maybe<ResgatarSaldo>,
  criarFuncionarioRepasse?: Maybe<CriarFuncionarioRepasse>,
  editarFuncionarioRepasse?: Maybe<EditarFuncionarioRepasse>,
  criarMaquina?: Maybe<CriarMaquinaMutation>,
  atualizarMaquina?: Maybe<AtualizarMaquinaMutation>,
  bloquearMaquina?: Maybe<BloquearMaquinaMutation>,
  desbloquearMaquina?: Maybe<DesbloquearMaquinaMutation>,
  desabilitarMaquina?: Maybe<DesabilitarMaquinaMutation>,
  habilitarMaquina?: Maybe<HabilitarMaquinaMutation>,
  reportarProblemaMaquina?: Maybe<ReportarProblemaMaquinaMutation>,
  deletarTaxasMaquina?: Maybe<DeletarTaxasMaquina>,
  criarEmprestimo?: Maybe<CriarEmprestimoMutation>,
  consultarZekiGiftback?: Maybe<ConsultarZekiGiftbackMutation>,
  vinculaLeadEmprestimo?: Maybe<VinculaLeadEmprestimo>,
  atualizarEmprestimo?: Maybe<AtualizarEmprestimoMutation>,
  pagarEmprestimo?: Maybe<PagarEmprestimoMutation>,
  atualizarStatusEmprestimo?: Maybe<MudarStatusEmprestimoMutation>,
  adicionarPagamentoEmprestimo?: Maybe<AdicionarPagamentoEmprestimo>,
  removerPagamentoEmprestimo?: Maybe<RemoverPagamentoEmprestimo>,
  adicionarAnexosTaxaAbaixo?: Maybe<AdicionarAnexosTaxaAbaixoDeEmprestimo>,
  removerAnexosTaxaAbaixo?: Maybe<RemoverAnexosTaxaAbaixoDeEmprestimo>,
  completarEmprestimoDelivery?: Maybe<CompletarEmprestimoDeliveryMutation>,
  finalizarRascunho?: Maybe<FinalizarRascunhoEmprestimoMutation>,
  removerRascunhos?: Maybe<RemoverRascunhos>,
  removerNsusEmprestimo?: Maybe<RemoverEmprestimoNsus>,
  atualizarNsuEmprestimo?: Maybe<AtualizarEmprestimoNsu>,
  atualizarTitularDivergenteEmprestimo?: Maybe<AtualizarTitularDivergenteNsu>,
  criarMensagem?: Maybe<CriarMensagens>,
  criarListaSms?: Maybe<CriarLista>,
  editarListaSms?: Maybe<EdiarLista>,
  excluirListaSms?: Maybe<ExcluirLista>,
  criarEnviosSms?: Maybe<CriarEnvio>,
  dashboardEnviosSms?: Maybe<Dashboard_Envios>,
  criarEntidade?: Maybe<CriarEntidadeMutation>,
  atualizarEntidade?: Maybe<AtualizarEntidadeMutation>,
  excluirEntidade?: Maybe<ExcluirEntidadeMutation>,
  definirTaxasParcelas?: Maybe<DefinirTaxasParcelas>,
  definirTaxasTabela?: Maybe<DefinirTaxasTabela>,
  definirTabelaTaxasParcelas?: Maybe<DefinirTablelaTaxasParcelas>,
  excluirTabelaTaxas?: Maybe<ExcluirTabelaTaxas>,
  editarTabelaTaxasParcelas?: Maybe<EditarTablelaTaxasParcelas>,
  excluirTodasTabelaTaxas?: Maybe<ExcluirTodasTabelaTaxas>,
  incluirTelefoneEntidade?: Maybe<IncluirTelefoneDeEntidadeMutation>,
  atualizarTelefoneEntidade?: Maybe<AtualizarTelefoneDeEntidadeMutation>,
  excluirTelefoneEntidade?: Maybe<ExcluirTelefoneDeEntidadeMutation>,
  excluirTaxasParcelas?: Maybe<ExcluirTaxasParcelas>,
  criarFuncionario?: Maybe<CriarFuncionarioMutation>,
  atualizarFuncionario?: Maybe<AtualizarFuncionarioMutation>,
  excluirFuncionario?: Maybe<ExcluirFuncionarioMutation>,
  alterarSenhaFuncionario?: Maybe<AlterarSenhaFuncionarioMutation>,
  gerarNovaSenhaFuncionario?: Maybe<GerarNovaSenhaFuncionarioMutation>,
  bloquearFuncionario?: Maybe<BloquearFuncionario>,
  desbloquearFuncionario?: Maybe<DesbloquearFuncionario>,
  alterarEmailFuncionario?: Maybe<AlterarEmailFuncionario>,
  criarTipoFuncionario?: Maybe<CriarTipoFuncionarioMutation>,
  editarTipoFuncionario?: Maybe<EditarTipoFuncionarioMutation>,
  excluirTipoFuncionario?: Maybe<ExcluirTipoFuncionarioMutation>,
  darVariasPermissoes?: Maybe<DarVariasPermissoesMutation>,
  excluirVariasPermissoes?: Maybe<ExcluirVariasPermissoesMutation>,
  criarGrupoPermissoes?: Maybe<CriarGrupoDePermissoesMutation>,
  alterarGrupoPermissoes?: Maybe<AlterarGrupoDePermissoesMutation>,
  excluirGrupoPermissoes?: Maybe<ExcluirGrupoDePermissoesMutation>,
  darPermissoesGrupo?: Maybe<DarPermissoesGrupoMutation>,
  retirarPermissoesGrupo?: Maybe<RetirarPermissoesGrupoMutation>,
  associarEntidadesGrupo?: Maybe<AssociarEntidadesGrupoMutation>,
  desassociarEntidadesGrupo?: Maybe<DesassociarEntidadesGrupoMutation>,
  associarFuncionariosGrupo?: Maybe<AssociarFuncionariosGrupoMutation>,
  desassociarFuncionariosGrupo?: Maybe<DesassociarFuncionariosGrupoMutation>,
  criarPedidoReembolso?: Maybe<CriarPedidoDeReembolsoMutation>,
  atualizarPedidoReembolso?: Maybe<AtualizarPedidoDeReembolsoMutation>,
  excluirPedidoReembolso?: Maybe<ExcluirPedidoDeReembolsoMutation>,
  atualizarStatusReembolso?: Maybe<MudarStatusPedidoDeReembolsoMutation>,
  pagarPedidoReembolso?: Maybe<PagarPedidoDeReembolsoMutation>,
  incluirAnexoPedidoReembolso?: Maybe<IncluirAnexoDePedidoDeReembolsoMutation>,
  atualizarAnexoPedidoReembolso?: Maybe<AtualizarAnexoDePedidoDeReembolsoMutation>,
  excluirAnexoPedidoReembolso?: Maybe<ExcluirAnexoDePedidoDeReembolsoMutation>,
  enviarDocumentoClickSign?: Maybe<EnviarDocumentosClickSignMutation>,
  /** 
 * Esse método cria um pagamento com pré captura na Pagcerto e envia
   * Gera o contrato e envia para o cliente
   * Notifica o cliente quando da alguma falha no pagamento ou caso tenha sucesso
 */
  enviarDocumentoClickSignMobile?: Maybe<EnviarDocumentosClickSignMutationMobile>,
  enviarDocumentoClickSignMobileDigitadaMobile?: Maybe<EnviarDocumentosClickSignDigitadoMobile>,
  vincularDocumentoClickSign?: Maybe<VincularClickSignMutation>,
  vincularTokenOnesignalMutation?: Maybe<VincularTokenOnesignalMutation>,
  disvinculaTokenOnesignalMutation?: Maybe<DisvinculaTokenOnesignalMutation>,
  criarCliente?: Maybe<CriarClienteMutation>,
  atualizarCliente?: Maybe<AtualizarClienteMutation>,
  associarClienteEntidade?: Maybe<AssociarClienteEntidadeMutation>,
  desassociarClienteEntidade?: Maybe<DesassociarClienteEntidadeMutation>,
  incluirTelefoneCliente?: Maybe<IncluirTelefoneDeClienteMutation>,
  atualizarTelefoneCliente?: Maybe<AtualizarTelefoneDeClienteMutation>,
  excluirTelefoneCliente?: Maybe<ExcluirTelefoneDeClienteMutation>,
  incluirContaCliente?: Maybe<IncluirContaDeClienteMutation>,
  atualizarContaCliente?: Maybe<AtualizarContaDeClienteMutation>,
  excluirContaCliente?: Maybe<ExcluirContaDeClienteMutation>,
  criarContaPagar?: Maybe<CriarContaAPagarMutation>,
  atualizarContaPagar?: Maybe<AtualizarContaAPagarMutation>,
  excluirContaPagar?: Maybe<ExcluirContaAPagarMutation>,
  pagarContaPagar?: Maybe<PagarContaAPagarMutation>,
  atualizarStatusContaPagar?: Maybe<MudarStatusContaAPagarMutation>,
  incluirAnexoContaPagar?: Maybe<IncluirAnexoDeContaAPagarMutation>,
  atualizarAnexoContaPagar?: Maybe<AtualizarAnexoDeContaAPagarMutation>,
  excluirAnexoContaPagar?: Maybe<ExcluirAnexoDeContaAPagarMutation>,
  criarMetaMutation?: Maybe<CriarMetaMutation>,
  updateMetaMutation?: Maybe<UpdateMetaMutation>,
  updateMetaDiariaMutation?: Maybe<UpdateMetaDiariaMutation>,
  deleteMetaMutation?: Maybe<DeleteMetaMutation>,
  todasMetasDash?: Maybe<TodasMetasDash>,
  editarLeadProspeccao?: Maybe<EditarLeadProp>,
  createLeadProspeccao?: Maybe<CreateLeadProp>,
  createClienteFromLead?: Maybe<CreateClienteFromLead>,
  criarCategoria?: Maybe<CriarCategoriaMutation>,
  editarCategoria?: Maybe<EditarCategoriaMutation>,
  excluirCategoria?: Maybe<ExcluirCategoriaMutation>,
  criarSubcategoria?: Maybe<CriarSubCategoriaMutation>,
  editarSubcategoria?: Maybe<EditarSubCategoriaMutation>,
  excluirSubcategoria?: Maybe<ExcluirSubCategoriaMutation>,
  criarOrigem?: Maybe<CreateSourceMutation>,
  editarOrigem?: Maybe<EditSourceMutation>,
  deletarOrigem?: Maybe<DeleteSourceMutation>,
  criarRegramentoEntidade?: Maybe<CriarRegramentoEntidade>,
  criarRegramentoTipoEntidade?: Maybe<CriarRegramentoTipoEntidade>,
  editarRegramentoEntidade?: Maybe<EditarRegramentoEntidade>,
  editarRegramentoTipoEntidade?: Maybe<EditarRegramentoTipoEntidade>,
  excluirRegramentoEntidade?: Maybe<ExcluirRegramentoEntidade>,
  excluirRegramentoTipoEntidade?: Maybe<ExcluirRegramentoTipoEntidade>,
  criarTipoEntidade?: Maybe<CriarTipoEntidade>,
  editarTipoEntidade?: Maybe<EditarTipoEntidade>,
  excluirTipoEntidade?: Maybe<ExcluirTipoEntidade>,
  createTarefa?: Maybe<CreateTarefa>,
  editarTarefa?: Maybe<EditarTarefa>,
  excluirTarefa?: Maybe<ExcluirTarefa>,
  editarLead?: Maybe<EditarLead>,
  simulaEmprestimoLead?: Maybe<SimulaEmprestimoLead>,
  atualizaStatusNegociacao?: Maybe<PausarLead>,
  marcarPerdaLead?: Maybe<PerdaLead>,
  marcarVendaLead?: Maybe<VendaLead>,
  moveLead?: Maybe<MoveLead>,
  qualificaLead?: Maybe<QualificaLead>,
  retomarOportunidadeLead?: Maybe<RetomarOportunidadeLead>,
  createLeadCrm?: Maybe<CreateLeadCrm>,
  createAnotacao?: Maybe<CreateAnotacao>,
  editarAnotacao?: Maybe<EditarAnotacao>,
  excluirAnotacao?: Maybe<ExcluirAnotacao>,
  produtoInteresse?: Maybe<ProdutoDeInteresse>,
  responsavelLead?: Maybe<ResponsavelLead>,
  excluirTarefasMultiplas?: Maybe<ExcluirTarefasMult>,
  editarTarefasMultiplas?: Maybe<EditarTarefasMult>,
  lerArquivoLead?: Maybe<LerArquivoLead>,
  enviarSimulacaoEmail?: Maybe<EnviarSimulacaoEmail>,
  loginMobile?: Maybe<LoginMobile>,
  createClienteMobile?: Maybe<CreateClienteMobile>,
  createCustomerMobileSimplify?: Maybe<CreateCustomerMobileSimplify>,
  createLoanSimulationMobile?: Maybe<CreateLoanSimulationMobile>,
  createPreClienteMobile?: Maybe<CreatePreClienteMobile>,
  createEmprestimoMobile?: Maybe<CreateEmprestimoMobile>,
  createCartaoCredito?: Maybe<CreateCartaoCreditoMobile>,
  createContaClienteMobile?: Maybe<CreateContaClienteMobilne>,
  createCartaoCreditoTerceiros?: Maybe<CreateCartaoCreditoTerceirosMobile>,
  updateClienteMobile?: Maybe<UpdateClienteMobile>,
  editUserProfileMobile?: Maybe<EditUserProfileMobile>,
  updateEnderecoClienteMobile?: Maybe<UpdateEnderecoClienteMobile>,
  updateContaClienteMobile?: Maybe<UpdateContaClienteMobile>,
  excluirClienteMobile?: Maybe<ExcluirClienteMobile>,
  excluirCartaoCredito?: Maybe<ExcluirCartaoCreditoMutation>,
  excluirContaClienteMobile?: Maybe<ExcluirContaClienteMobile>,
  enviarMemsagemSuporteMobile?: Maybe<EnviarEmailSuporteMobile>,
  gerarNovaSenhaClienteMobile?: Maybe<GerarNovaSenhaClienteMobile>,
  alterarSenhaClienteMobile?: Maybe<AlterarSenhaCLienteMutation>,
  cancelaEmprestimoMobile?: Maybe<CancelaEmprestimoMobile>,
  uploadFoto64?: Maybe<Upload_Foto_64>,
  generateNewUserPasswordMobile?: Maybe<GenerateNewUserPasswordMobile>,
  obterToken?: Maybe<CustomJsonWebToken>,
  verificarToken?: Maybe<Verify>,
  atualizarToken?: Maybe<Refresh>,
};


export type MutationCriarInstanciaArgs = {
  instanciaInput?: Maybe<InstanciaZApiInput>
};


export type MutationAtualizarInstanciaArgs = {
  instanciaInput?: Maybe<InstanciaZApiInput>
};


export type MutationDeletarInstanciaArgs = {
  instanciaId?: Maybe<Scalars['ID']>
};


export type MutationCriarAutomacaoArgs = {
  instanciaId?: Maybe<Scalars['ID']>,
  triggersInput?: Maybe<Array<Maybe<TriggerInputZApiInput>>>
};


export type MutationCriarTipoEmprestimoArgs = {
  input: CadastroTipoDeEmprestimoInput
};


export type MutationAtualizarTipoEmprestimoArgs = {
  input: EdicaoTipoDeEmprestimoInput
};


export type MutationAlterarStatusTipoEmprestimoArgs = {
  input: ChangeStatusTipoDeEmprestimoInput
};


export type MutationCriarFornecedorArgs = {
  formasPagamento?: Maybe<Array<Maybe<InputFormaPagamentoFornecedorType>>>,
  input?: Maybe<InputFornecedorType>,
  telefones?: Maybe<Array<Maybe<InputTelefoneFornecedorType>>>
};


export type MutationEditarFornecedorArgs = {
  formasPagamento?: Maybe<Array<Maybe<InputFormaPagamentoFornecedorType>>>,
  input?: Maybe<InputEditarFornecedorType>,
  telefones?: Maybe<Array<Maybe<InputTelefoneFornecedorType>>>
};


export type MutationVincularFornecedorArgs = {
  idFornecedor: Scalars['ID'],
  idsEntidades?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type MutationRemoverRelatorioArgs = {
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type MutationCriarParceirosArgs = {
  contaInput?: Maybe<Array<Maybe<ContaParceirosTypeInput>>>,
  gruposDePermissoesInput?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsFuncionariosPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsGruposPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsLojas?: Maybe<Array<Maybe<Scalars['ID']>>>,
  lojasTabelasInput?: Maybe<Array<Maybe<LojasTabelasTypeInput>>>,
  parceirosInput?: Maybe<ParceirosTypeInput>,
  resgateAutomaticoInput?: Maybe<ResgateAutomaticoParceirosTypeInput>
};


export type MutationEditarParceirosArgs = {
  contaInput?: Maybe<Array<Maybe<ContaParceirosTypeInput>>>,
  gruposDePermissoesInput?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsFuncionariosPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsGruposPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsLojas?: Maybe<Array<Maybe<Scalars['ID']>>>,
  lojasTabelasInput?: Maybe<Array<Maybe<LojasTabelasTypeInput>>>,
  parceirosInput?: Maybe<ParceirosTypeInput>,
  resgateAutomaticoInput?: Maybe<ResgateAutomaticoParceirosTypeInput>
};


export type MutationCriarTabelaArgs = {
  bandeiraTabelaIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  categoria?: Maybe<Scalars['String']>,
  funcionariosIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsFuncionariosPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsGruposPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  lojasParceiro?: Maybe<Array<Maybe<LojasParceirosInput>>>,
  nomeTabela?: Maybe<Scalars['String']>,
  tabelaInput?: Maybe<Array<Maybe<ColunaTabelaTypeInput>>>,
  tipoTabela?: Maybe<Scalars['String']>
};


export type MutationEditarTabelaArgs = {
  bandeiraTabelaIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  categoria?: Maybe<Scalars['String']>,
  funcionariosIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsFuncionariosPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsGruposPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  lojasParceiro?: Maybe<Array<Maybe<LojasParceirosInput>>>,
  nomeTabela?: Maybe<Scalars['String']>,
  tabelaId?: Maybe<Scalars['ID']>,
  tabelaInput?: Maybe<Array<Maybe<ColunaTabelaTypeInput>>>,
  tipoTabela?: Maybe<Scalars['String']>
};


export type MutationExcluirColunaArgs = {
  colunaId?: Maybe<Scalars['ID']>
};


export type MutationResgatarSaldoArgs = {
  contaId?: Maybe<Scalars['ID']>,
  dataFim?: Maybe<Scalars['Date']>,
  dataInicio?: Maybe<Scalars['Date']>,
  dataVencimento?: Maybe<Scalars['Date']>,
  lojasId?: Maybe<Array<Maybe<Scalars['ID']>>>,
  parceiroId?: Maybe<Scalars['ID']>
};


export type MutationCriarFuncionarioRepasseArgs = {
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idFuncionario?: Maybe<Scalars['ID']>,
  idsFuncionariosPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsGruposPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  lojasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  tabelaDeParceiro?: Maybe<Scalars['ID']>
};


export type MutationEditarFuncionarioRepasseArgs = {
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idFuncionario?: Maybe<Scalars['ID']>,
  idsFuncionariosPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idsGruposPermitidos?: Maybe<Array<Maybe<Scalars['ID']>>>,
  lojasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  tabelaDeParceiro?: Maybe<Scalars['ID']>,
  tipo?: Maybe<Scalars['String']>
};


export type MutationCriarMaquinaArgs = {
  input: MaquinaCreateInput
};


export type MutationAtualizarMaquinaArgs = {
  input: MaquinaUpdateInput
};


export type MutationBloquearMaquinaArgs = {
  detalhamento?: Maybe<Scalars['String']>,
  id: Scalars['ID']
};


export type MutationDesbloquearMaquinaArgs = {
  id: Scalars['ID']
};


export type MutationDesabilitarMaquinaArgs = {
  id: Scalars['ID']
};


export type MutationHabilitarMaquinaArgs = {
  id: Scalars['ID'],
  idEntidade: Scalars['ID']
};


export type MutationReportarProblemaMaquinaArgs = {
  detalhamento: Scalars['String'],
  id: Scalars['ID']
};


export type MutationDeletarTaxasMaquinaArgs = {
  maquinaId: Scalars['ID'],
  taxasIds: Array<Maybe<Scalars['ID']>>
};


export type MutationCriarEmprestimoArgs = {
  anexoContrato?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  anexosTaxaAbaixo?: Maybe<Array<Maybe<EmprestimoAnexoInput>>>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  data: Scalars['Date'],
  delivery?: Maybe<Scalars['Boolean']>,
  extraFieldsResults?: Maybe<Scalars['JSONString']>,
  formasPagamento?: Maybe<Array<Maybe<EmprestimoFormaPagamentoInput>>>,
  idCliente: Scalars['ID'],
  idEntidade: Scalars['ID'],
  iof?: Maybe<Scalars['Decimal']>,
  justificativaTaxaAbaixo?: Maybe<Scalars['String']>,
  loanTypeId?: Maybe<Scalars['ID']>,
  nsuCartao?: Maybe<Scalars['String']>,
  nsus?: Maybe<Array<Maybe<NsuInput>>>,
  origem?: Maybe<Scalars['String']>,
  parcelas?: Maybe<EmprestimoParcelas>,
  tabelaTaxa?: Maybe<Scalars['String']>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  valorDesejado: Scalars['Float'],
  zekiGiftbackCodigo?: Maybe<Scalars['String']>
};


export type MutationConsultarZekiGiftbackArgs = {
  codigo?: Maybe<Scalars['String']>,
  idCliente: Scalars['ID'],
  idEntidade: Scalars['ID'],
  valorTotalOriginal: Scalars['Decimal']
};


export type MutationVinculaLeadEmprestimoArgs = {
  idEmprestimo?: Maybe<Scalars['ID']>,
  idLead?: Maybe<Scalars['ID']>
};


export type MutationAtualizarEmprestimoArgs = {
  anexoContrato?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  cvvCartao?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['Date']>,
  entidadeId?: Maybe<Scalars['ID']>,
  extraFieldsResults?: Maybe<Scalars['JSONString']>,
  formasPagamento?: Maybe<Array<Maybe<EmprestimoFormaPagamentoEditInput>>>,
  id: Scalars['ID'],
  iof?: Maybe<Scalars['Decimal']>,
  justificativaCancelamento?: Maybe<Scalars['String']>,
  justificativaTaxaAbaixo?: Maybe<Scalars['String']>,
  nomeCartao?: Maybe<Scalars['String']>,
  nsuCartao?: Maybe<Scalars['String']>,
  nsus?: Maybe<Array<Maybe<NsuInput>>>,
  numeroCartao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  parcelas?: Maybe<EmprestimoParcelas>,
  removerZekiGiftback?: Maybe<Scalars['Boolean']>,
  tabelaTaxa?: Maybe<Scalars['String']>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  tcc?: Maybe<Scalars['Decimal']>,
  validadeCartao?: Maybe<Scalars['String']>,
  valorDesejado?: Maybe<Scalars['Float']>
};


export type MutationPagarEmprestimoArgs = {
  anexosPagamento?: Maybe<Array<Maybe<EmprestimoFormaPagamentoPagarInput>>>,
  id: Scalars['ID']
};


export type MutationAtualizarStatusEmprestimoArgs = {
  idEmprestimo: Scalars['ID'],
  justificativaCancelamento?: Maybe<Scalars['String']>,
  status: EmprestimoStatus
};


export type MutationAdicionarPagamentoEmprestimoArgs = {
  formasPagamento: Array<Maybe<EmprestimoFormaPagamentoInput>>,
  id: Scalars['ID']
};


export type MutationRemoverPagamentoEmprestimoArgs = {
  id?: Maybe<Scalars['ID']>,
  idsPagamento: Array<Maybe<Scalars['ID']>>
};


export type MutationAdicionarAnexosTaxaAbaixoArgs = {
  anexosTaxaAbaixo?: Maybe<Array<Maybe<EmprestimoAnexoInput>>>,
  idEmprestimo: Scalars['ID']
};


export type MutationRemoverAnexosTaxaAbaixoArgs = {
  idEmprestimo: Scalars['ID'],
  idsAnexosTaxaAbaixo?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type MutationCompletarEmprestimoDeliveryArgs = {
  anexoContrato?: Maybe<Scalars['String']>,
  id: Scalars['ID']
};


export type MutationFinalizarRascunhoArgs = {
  anexoContrato?: Maybe<Scalars['String']>,
  anexosTaxaAbaixo?: Maybe<Array<Maybe<EmprestimoAnexoInput>>>,
  delivery?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  formasPagamento?: Maybe<Array<Maybe<EmprestimoFormaPagamentoInput>>>,
  id: Scalars['ID'],
  justificativaTaxaAbaixo?: Maybe<Scalars['String']>,
  nsus?: Maybe<Array<Maybe<NsuInput>>>,
  origem?: Maybe<Scalars['String']>,
  parcelas?: Maybe<EmprestimoParcelas>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  valorDesejado?: Maybe<Scalars['Float']>
};


export type MutationRemoverRascunhosArgs = {
  ids: Array<Maybe<Scalars['ID']>>
};


export type MutationRemoverNsusEmprestimoArgs = {
  idEmprestimo: Scalars['ID'],
  idsNsus?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type MutationAtualizarNsuEmprestimoArgs = {
  idEmprestimo: Scalars['ID'],
  idNsu: Scalars['ID'],
  nsu: NsuInput
};


export type MutationAtualizarTitularDivergenteEmprestimoArgs = {
  idEmprestimo: Scalars['ID'],
  idTitular: Scalars['ID'],
  titularDivergente: TitularDivergenteInput
};


export type MutationCriarMensagemArgs = {
  descricao?: Maybe<Scalars['String']>,
  titulo?: Maybe<Scalars['String']>
};


export type MutationCriarListaSmsArgs = {
  filtros?: Maybe<FiltrosListaInput>,
  nome?: Maybe<Scalars['String']>
};


export type MutationEditarListaSmsArgs = {
  filtros?: Maybe<FiltrosListaInput>,
  id?: Maybe<Scalars['ID']>,
  nome?: Maybe<Scalars['String']>
};


export type MutationExcluirListaSmsArgs = {
  id?: Maybe<Scalars['ID']>
};


export type MutationCriarEnviosSmsArgs = {
  data: Scalars['Date'],
  envioEmailInput?: Maybe<EnvioEmailInput>,
  hora: Scalars['Time'],
  listas?: Maybe<Array<Maybe<Scalars['ID']>>>,
  mensagem?: Maybe<MensagemType>,
  mensagemId?: Maybe<Scalars['ID']>,
  nome?: Maybe<Scalars['String']>,
  tipoEnvio?: Maybe<TiposEnvioOpcoes>
};


export type MutationDashboardEnviosSmsArgs = {
  dataFim?: Maybe<Scalars['Date']>,
  dataInicio?: Maybe<Scalars['Date']>
};


export type MutationCriarEntidadeArgs = {
  anexoCnpj?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  comprovanteEndereco?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  latitude?: Maybe<Scalars['String']>,
  longitude?: Maybe<Scalars['String']>,
  mensagemInvoice?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  nome: Scalars['String'],
  nomeIdentificacao: Scalars['String'],
  pais?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Array<Maybe<TaxasParcelasInput>>>,
  razao?: Maybe<Scalars['String']>,
  taxaLucro?: Maybe<Scalars['Float']>,
  taxaMinima?: Maybe<Scalars['Float']>,
  taxaSeguranca?: Maybe<Scalars['Float']>,
  tipoLoja?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>
};


export type MutationAtualizarEntidadeArgs = {
  anexoCnpj?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  comprovanteEndereco?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  inscricaoEstadual?: Maybe<Scalars['String']>,
  latitude?: Maybe<Scalars['String']>,
  longitude?: Maybe<Scalars['String']>,
  mensagemInvoice?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  taxaLucro?: Maybe<Scalars['Float']>,
  taxaMinima?: Maybe<Scalars['Float']>,
  taxaSeguranca?: Maybe<Scalars['Float']>,
  tipoLoja?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>
};


export type MutationExcluirEntidadeArgs = {
  id?: Maybe<Scalars['ID']>
};


export type MutationDefinirTaxasParcelasArgs = {
  entidadesIds: Array<Maybe<Scalars['ID']>>,
  parcelas?: Maybe<Array<Maybe<TaxasParcelasInput>>>
};


export type MutationDefinirTaxasTabelaArgs = {
  entidadesIds: Array<Maybe<Scalars['ID']>>,
  parcelasList?: Maybe<Array<Maybe<TaxasTabelasInput>>>
};


export type MutationDefinirTabelaTaxasParcelasArgs = {
  entidadesIds: Array<Maybe<Scalars['ID']>>,
  tabelas?: Maybe<Array<Maybe<TabelaTaxasInput>>>
};


export type MutationExcluirTabelaTaxasArgs = {
  id?: Maybe<Scalars['ID']>
};


export type MutationEditarTabelaTaxasParcelasArgs = {
  entidadesIds: Array<Maybe<Scalars['ID']>>,
  tabelas?: Maybe<Array<Maybe<TabelaTaxasInput>>>
};


export type MutationExcluirTodasTabelaTaxasArgs = {
  id?: Maybe<Scalars['ID']>
};


export type MutationIncluirTelefoneEntidadeArgs = {
  ddd?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  idEntidade?: Maybe<Scalars['ID']>,
  numero: Scalars['String']
};


export type MutationAtualizarTelefoneEntidadeArgs = {
  ddd?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  numero?: Maybe<Scalars['String']>
};


export type MutationExcluirTelefoneEntidadeArgs = {
  id?: Maybe<Scalars['ID']>
};


export type MutationExcluirTaxasParcelasArgs = {
  idEntidade?: Maybe<Scalars['ID']>
};


export type MutationCriarFuncionarioArgs = {
  anexoContrato?: Maybe<Scalars['String']>,
  bairro: Scalars['String'],
  categoria?: Maybe<Scalars['String']>,
  cep: Scalars['String'],
  complemento: Scalars['String'],
  cpf: Scalars['String'],
  email: Scalars['String'],
  endereco: Scalars['String'],
  idEntidade: Scalars['ID'],
  municipio: Scalars['String'],
  nome: Scalars['String'],
  pais: Scalars['String'],
  rg: Scalars['String'],
  senha: Scalars['String'],
  sexo?: Maybe<Scalars['String']>,
  tipoContrato: Scalars['String'],
  tipoFuncionario: Scalars['String'],
  uf: Scalars['String']
};


export type MutationAtualizarFuncionarioArgs = {
  anexoContrato?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  cpf?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  municipio?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  senha?: Maybe<Scalars['String']>,
  sexo?: Maybe<Scalars['String']>,
  tipoContrato?: Maybe<Scalars['String']>,
  tipoFuncionario: Scalars['String'],
  uf?: Maybe<Scalars['String']>
};


export type MutationExcluirFuncionarioArgs = {
  id?: Maybe<Scalars['ID']>
};


export type MutationAlterarSenhaFuncionarioArgs = {
  idFuncionario?: Maybe<Scalars['ID']>,
  senhaAtual: Scalars['String'],
  senhaNova: Scalars['String']
};


export type MutationGerarNovaSenhaFuncionarioArgs = {
  emailFuncionario: Scalars['String']
};


export type MutationBloquearFuncionarioArgs = {
  idFuncionario: Scalars['ID']
};


export type MutationDesbloquearFuncionarioArgs = {
  idFuncionario: Scalars['ID']
};


export type MutationAlterarEmailFuncionarioArgs = {
  email: Scalars['String']
};


export type MutationCriarTipoFuncionarioArgs = {
  nome: Scalars['String'],
  tipoDefault?: Maybe<Scalars['Boolean']>
};


export type MutationEditarTipoFuncionarioArgs = {
  id: Scalars['ID'],
  nome: Scalars['String'],
  tipoDefault?: Maybe<Scalars['Boolean']>
};


export type MutationExcluirTipoFuncionarioArgs = {
  id: Scalars['ID']
};


export type MutationDarVariasPermissoesArgs = {
  atributosPermissoes?: Maybe<Array<Maybe<AtributosDePermissaoInput>>>,
  idFuncionario: Scalars['ID']
};


export type MutationExcluirVariasPermissoesArgs = {
  atributosPermissoes?: Maybe<Array<Maybe<AtributosDePermissaoInput>>>,
  idFuncionario: Scalars['ID']
};


export type MutationCriarGrupoPermissoesArgs = {
  descricao?: Maybe<Scalars['String']>,
  nome: Scalars['String']
};


export type MutationAlterarGrupoPermissoesArgs = {
  descricao?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  nome?: Maybe<Scalars['String']>
};


export type MutationExcluirGrupoPermissoesArgs = {
  id?: Maybe<Scalars['ID']>
};


export type MutationDarPermissoesGrupoArgs = {
  descricoes: Array<Maybe<Scalars['String']>>,
  idGrupo: Scalars['ID']
};


export type MutationRetirarPermissoesGrupoArgs = {
  descricoes: Array<Maybe<Scalars['String']>>,
  idGrupo: Scalars['ID']
};


export type MutationAssociarEntidadesGrupoArgs = {
  idGrupo: Scalars['ID'],
  idsEntidades: Array<Maybe<Scalars['Int']>>
};


export type MutationDesassociarEntidadesGrupoArgs = {
  idGrupo: Scalars['ID'],
  idsEntidades: Array<Maybe<Scalars['Int']>>
};


export type MutationAssociarFuncionariosGrupoArgs = {
  idGrupo: Scalars['ID'],
  idsFuncionarios: Array<Maybe<Scalars['Int']>>
};


export type MutationDesassociarFuncionariosGrupoArgs = {
  idGrupo: Scalars['ID'],
  idsFuncionarios: Array<Maybe<Scalars['Int']>>
};


export type MutationCriarPedidoReembolsoArgs = {
  agencia: Scalars['String'],
  anexoPagamento?: Maybe<Scalars['String']>,
  banco: Scalars['String'],
  categoria: Scalars['String'],
  conta: Scalars['String'],
  cpfCnpj: Scalars['String'],
  data: Scalars['DateTime'],
  dataPagamento?: Maybe<Scalars['DateTime']>,
  descricao: Scalars['String'],
  idEntidade: Scalars['ID'],
  nome: Scalars['String'],
  pix?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<PedidoDeReembolsoTipoConta>,
  tipoDespesa?: Maybe<PedidoDeReembolsoTipoDespesa>,
  tipoPix?: Maybe<Scalars['String']>,
  valor: Scalars['Float'],
  variacao?: Maybe<Scalars['String']>
};


export type MutationAtualizarPedidoReembolsoArgs = {
  agencia?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  banco?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  cpfCnpj?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  descricao?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  nome?: Maybe<Scalars['String']>,
  pix?: Maybe<Scalars['String']>,
  status?: Maybe<PedidoDeReembolsoStatus>,
  tipoConta?: Maybe<PedidoDeReembolsoTipoConta>,
  tipoDespesa?: Maybe<PedidoDeReembolsoTipoDespesa>,
  tipoPix?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  variacao?: Maybe<Scalars['String']>
};


export type MutationExcluirPedidoReembolsoArgs = {
  id?: Maybe<Scalars['ID']>
};


export type MutationAtualizarStatusReembolsoArgs = {
  anexoPagamento?: Maybe<Scalars['String']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  idPedido: Scalars['ID'],
  justificativaCancelamento?: Maybe<Scalars['String']>,
  status?: Maybe<PedidoDeReembolsoStatus>
};


export type MutationPagarPedidoReembolsoArgs = {
  anexoPagamento?: Maybe<Scalars['String']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  id: Scalars['ID']
};


export type MutationIncluirAnexoPedidoReembolsoArgs = {
  descricao?: Maybe<Scalars['String']>,
  idPedido: Scalars['ID'],
  url: Scalars['String']
};


export type MutationAtualizarAnexoPedidoReembolsoArgs = {
  descricao?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  url?: Maybe<Scalars['String']>
};


export type MutationExcluirAnexoPedidoReembolsoArgs = {
  id: Scalars['ID']
};


export type MutationEnviarDocumentoClickSignArgs = {
  idEmprestimo: Scalars['ID']
};


export type MutationEnviarDocumentoClickSignMobileArgs = {
  idEmprestimo: Scalars['ID']
};


export type MutationEnviarDocumentoClickSignMobileDigitadaMobileArgs = {
  idEmprestimo: Scalars['ID']
};


export type MutationVincularDocumentoClickSignArgs = {
  chaveDocumento: Scalars['String'],
  idEmprestimo: Scalars['ID']
};


export type MutationVincularTokenOnesignalMutationArgs = {
  token: Scalars['String']
};


export type MutationDisvinculaTokenOnesignalMutationArgs = {
  token: Scalars['String']
};


export type MutationCriarClienteArgs = {
  anexoCpfFrente?: Maybe<Scalars['String']>,
  anexoCpfVerso?: Maybe<Scalars['String']>,
  anexoEndereco?: Maybe<Scalars['String']>,
  anexoRenda?: Maybe<Scalars['String']>,
  anexoRgFrente?: Maybe<Scalars['String']>,
  anexoRgVerso?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  cadastroRapido?: Maybe<Scalars['Boolean']>,
  cep?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  cpf?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  estadoCivil?: Maybe<Scalars['String']>,
  idEntidade?: Maybe<Scalars['ID']>,
  municipio?: Maybe<Scalars['String']>,
  nascimento?: Maybe<Scalars['Date']>,
  nome: Scalars['String'],
  observacao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  sexo?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>
};


export type MutationAtualizarClienteArgs = {
  anexoCpfFrente?: Maybe<Scalars['String']>,
  anexoCpfVerso?: Maybe<Scalars['String']>,
  anexoEndereco?: Maybe<Scalars['String']>,
  anexoRenda?: Maybe<Scalars['String']>,
  anexoRgFrente?: Maybe<Scalars['String']>,
  anexoRgVerso?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  cpf?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  estadoCivil?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  municipio?: Maybe<Scalars['String']>,
  nascimento?: Maybe<Scalars['Date']>,
  nome?: Maybe<Scalars['String']>,
  observacao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  sexo?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>
};


export type MutationAssociarClienteEntidadeArgs = {
  id: Scalars['ID'],
  idEntidade: Scalars['ID']
};


export type MutationDesassociarClienteEntidadeArgs = {
  id: Scalars['ID'],
  idEntidade: Scalars['ID']
};


export type MutationIncluirTelefoneClienteArgs = {
  ddd?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  idCliente?: Maybe<Scalars['ID']>,
  numero: Scalars['String']
};


export type MutationAtualizarTelefoneClienteArgs = {
  ddd?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  numero?: Maybe<Scalars['String']>
};


export type MutationExcluirTelefoneClienteArgs = {
  id?: Maybe<Scalars['ID']>
};


export type MutationIncluirContaClienteArgs = {
  agencia: Scalars['String'],
  banco: Scalars['String'],
  conta: Scalars['String'],
  cpfCnpj: Scalars['String'],
  idCliente?: Maybe<Scalars['ID']>,
  nome: Scalars['String'],
  pix?: Maybe<Scalars['String']>,
  tipoConta: Scalars['String'],
  tipoPix?: Maybe<Scalars['String']>,
  variacao?: Maybe<Scalars['String']>
};


export type MutationAtualizarContaClienteArgs = {
  agencia?: Maybe<Scalars['String']>,
  banco?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  cpfCnpj?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['ID']>,
  nome?: Maybe<Scalars['String']>,
  pix?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  tipoPix?: Maybe<Scalars['String']>,
  variacao?: Maybe<Scalars['String']>
};


export type MutationExcluirContaClienteArgs = {
  id?: Maybe<Scalars['ID']>
};


export type MutationCriarContaPagarArgs = {
  anexoPagamento?: Maybe<Scalars['String']>,
  boletoCodigoBarra?: Maybe<Scalars['String']>,
  boletoDataVencimento?: Maybe<Scalars['DateTime']>,
  boletoNumeroControle?: Maybe<Scalars['String']>,
  categoria: Scalars['String'],
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataVencimento: Scalars['DateTime'],
  destinatario: Scalars['String'],
  formaPagamento?: Maybe<ContaAPagarFormaPagamento>,
  idEntidade: Scalars['ID'],
  observacao?: Maybe<Scalars['String']>,
  recorrencia?: Maybe<ContaAPagarRecorrencia>,
  tipoDespesa?: Maybe<ContaAPagarTipoDespesa>,
  titulo: Scalars['String'],
  transferenciaAgencia?: Maybe<Scalars['String']>,
  transferenciaBanco?: Maybe<Scalars['String']>,
  transferenciaConta?: Maybe<Scalars['String']>,
  transferenciaCpfCnpj?: Maybe<Scalars['String']>,
  transferenciaNome?: Maybe<Scalars['String']>,
  transferenciaPix?: Maybe<Scalars['String']>,
  transferenciaTipoConta?: Maybe<ContaAPagarTransferenciaTipoConta>,
  transferenciaTipoPix?: Maybe<Scalars['String']>,
  transferenciaVariacao?: Maybe<Scalars['String']>,
  valor: Scalars['Float'],
  valorPago?: Maybe<Scalars['Float']>
};


export type MutationAtualizarContaPagarArgs = {
  anexoPagamento?: Maybe<Scalars['String']>,
  boletoCodigoBarra?: Maybe<Scalars['String']>,
  boletoDataVencimento?: Maybe<Scalars['DateTime']>,
  boletoNumeroControle?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataVencimento?: Maybe<Scalars['DateTime']>,
  destinatario?: Maybe<Scalars['String']>,
  formaPagamento?: Maybe<ContaAPagarFormaPagamento>,
  id: Scalars['ID'],
  idEntidade?: Maybe<Scalars['ID']>,
  observacao?: Maybe<Scalars['String']>,
  recorrencia?: Maybe<ContaAPagarRecorrencia>,
  tipoDespesa?: Maybe<ContaAPagarTipoDespesa>,
  titulo?: Maybe<Scalars['String']>,
  transferenciaAgencia?: Maybe<Scalars['String']>,
  transferenciaBanco?: Maybe<Scalars['String']>,
  transferenciaConta?: Maybe<Scalars['String']>,
  transferenciaCpfCnpj?: Maybe<Scalars['String']>,
  transferenciaNome?: Maybe<Scalars['String']>,
  transferenciaPix?: Maybe<Scalars['String']>,
  transferenciaTipoConta?: Maybe<ContaAPagarTransferenciaTipoConta>,
  transferenciaTipoPix?: Maybe<Scalars['String']>,
  transferenciaVariacao?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valorPago?: Maybe<Scalars['Float']>
};


export type MutationExcluirContaPagarArgs = {
  id?: Maybe<Scalars['ID']>
};


export type MutationPagarContaPagarArgs = {
  anexoPagamento?: Maybe<Scalars['String']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  id: Scalars['ID'],
  justificativaValorPago?: Maybe<Scalars['String']>,
  valorPago?: Maybe<Scalars['Decimal']>
};


export type MutationAtualizarStatusContaPagarArgs = {
  anexoPagamento?: Maybe<Scalars['String']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  idConta: Scalars['ID'],
  justificativaCancelamento?: Maybe<Scalars['String']>,
  justificativaValorPago?: Maybe<Scalars['String']>,
  status?: Maybe<ContaAPagarStatus>,
  valorPago?: Maybe<Scalars['Decimal']>
};


export type MutationIncluirAnexoContaPagarArgs = {
  descricao?: Maybe<Scalars['String']>,
  idConta: Scalars['ID'],
  url: Scalars['String']
};


export type MutationAtualizarAnexoContaPagarArgs = {
  descricao?: Maybe<Scalars['String']>,
  id: Scalars['ID'],
  url?: Maybe<Scalars['String']>
};


export type MutationExcluirAnexoContaPagarArgs = {
  id: Scalars['ID']
};


export type MutationCriarMetaMutationArgs = {
  input?: Maybe<Array<Maybe<MetaInputList>>>
};


export type MutationUpdateMetaMutationArgs = {
  id: Scalars['ID'],
  input?: Maybe<Array<Maybe<MetaInput>>>
};


export type MutationUpdateMetaDiariaMutationArgs = {
  id: Scalars['ID']
};


export type MutationDeleteMetaMutationArgs = {
  id: Scalars['ID']
};


export type MutationTodasMetasDashArgs = {
  fimMeta?: Maybe<Scalars['Date']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idEntidade?: Maybe<Array<Maybe<Scalars['ID']>>>,
  idFuncionario?: Maybe<Array<Maybe<Scalars['ID']>>>,
  inicioMeta?: Maybe<Scalars['Date']>,
  listaDatasExcluidas?: Maybe<Scalars['String']>
};


export type MutationEditarLeadProspeccaoArgs = {
  bairro?: Maybe<Scalars['String']>,
  carteiraAssinada?: Maybe<Scalars['Boolean']>,
  cidade?: Maybe<Scalars['String']>,
  contaMaisTempo?: Maybe<Scalars['Boolean']>,
  email?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  id: Scalars['ID'],
  nome?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['Int']>,
  possuiCartao?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<Scalars['String']>,
  tipoBeneficio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  vagasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  valorDesejado?: Maybe<Scalars['Float']>,
  valorTotal?: Maybe<Scalars['Float']>
};


export type MutationCreateLeadProspeccaoArgs = {
  bairro?: Maybe<Scalars['String']>,
  carteiraAssinada?: Maybe<Scalars['Boolean']>,
  cidade?: Maybe<Scalars['String']>,
  contaMaisTempo?: Maybe<Scalars['Boolean']>,
  email?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  nome: Scalars['String'],
  origem?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['Int']>,
  possuiCartao?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<Scalars['String']>,
  tipoBeneficio?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  vagasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  valorDesejado?: Maybe<Scalars['Float']>,
  valorTotal?: Maybe<Scalars['Float']>
};


export type MutationCreateClienteFromLeadArgs = {
  anexoCpfFrente?: Maybe<Scalars['String']>,
  anexoCpfVerso?: Maybe<Scalars['String']>,
  anexoEndereco?: Maybe<Scalars['String']>,
  anexoRenda?: Maybe<Scalars['String']>,
  anexoRgFrente?: Maybe<Scalars['String']>,
  anexoRgVerso?: Maybe<Scalars['String']>,
  bairro: Scalars['String'],
  cep: Scalars['String'],
  complemento: Scalars['String'],
  cpf: Scalars['String'],
  email?: Maybe<Scalars['String']>,
  endereco: Scalars['String'],
  estadoCivil: Scalars['String'],
  idEntidade?: Maybe<Scalars['ID']>,
  idLead?: Maybe<Scalars['ID']>,
  municipio: Scalars['String'],
  nascimento: Scalars['String'],
  nome: Scalars['String'],
  observacao?: Maybe<Scalars['String']>,
  profissao: Scalars['String'],
  rg: Scalars['String'],
  sexo: Scalars['String'],
  telefone?: Maybe<Scalars['String']>,
  uf: Scalars['String']
};


export type MutationCriarCategoriaArgs = {
  nome: Scalars['String']
};


export type MutationEditarCategoriaArgs = {
  id: Scalars['ID'],
  nome: Scalars['String']
};


export type MutationExcluirCategoriaArgs = {
  id: Scalars['ID']
};


export type MutationCriarSubcategoriaArgs = {
  categoria: Scalars['ID'],
  nome: Scalars['String']
};


export type MutationEditarSubcategoriaArgs = {
  categoria: Scalars['ID'],
  id: Scalars['ID'],
  nome: Scalars['String']
};


export type MutationExcluirSubcategoriaArgs = {
  id: Scalars['ID']
};


export type MutationCriarOrigemArgs = {
  origem?: Maybe<Scalars['String']>
};


export type MutationEditarOrigemArgs = {
  id: Scalars['ID'],
  origem?: Maybe<Scalars['String']>
};


export type MutationDeletarOrigemArgs = {
  id: Scalars['ID']
};


export type MutationCriarRegramentoEntidadeArgs = {
  idEntidade: Scalars['ID'],
  valorAcima: Scalars['Float']
};


export type MutationCriarRegramentoTipoEntidadeArgs = {
  idTipoEntidade: Scalars['ID'],
  valorAcima: Scalars['Float']
};


export type MutationEditarRegramentoEntidadeArgs = {
  idEntidade: Scalars['ID'],
  valorAcima: Scalars['Float']
};


export type MutationEditarRegramentoTipoEntidadeArgs = {
  idTipoEntidade: Scalars['ID'],
  valorAcima: Scalars['Float']
};


export type MutationExcluirRegramentoEntidadeArgs = {
  idEntidade: Scalars['ID']
};


export type MutationExcluirRegramentoTipoEntidadeArgs = {
  idTipoEntidade: Scalars['ID']
};


export type MutationCriarTipoEntidadeArgs = {
  input?: Maybe<InputTiposEntidadesType>
};


export type MutationEditarTipoEntidadeArgs = {
  idTipoEntidade: Scalars['ID'],
  input?: Maybe<InputTiposEntidadesType>
};


export type MutationExcluirTipoEntidadeArgs = {
  idTipoEntidade: Scalars['ID']
};


export type MutationCreateTarefaArgs = {
  tarefa?: Maybe<InputTarefa>
};


export type MutationEditarTarefaArgs = {
  assunto?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['Date']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  hora?: Maybe<Scalars['Time']>,
  id: Scalars['ID'],
  leadId?: Maybe<Scalars['ID']>,
  status?: Maybe<Scalars['String']>,
  tipo?: Maybe<Scalars['String']>
};


export type MutationExcluirTarefaArgs = {
  id: Scalars['ID']
};


export type MutationEditarLeadArgs = {
  bairro?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  id: Scalars['ID'],
  nome?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  telefone?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  vagasIds?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type MutationSimulaEmprestimoLeadArgs = {
  propostaInput?: Maybe<PropostaTypeInput>
};


export type MutationAtualizaStatusNegociacaoArgs = {
  id: Scalars['ID'],
  justificativa?: Maybe<Scalars['String']>,
  pausado: Scalars['Boolean']
};


export type MutationMarcarPerdaLeadArgs = {
  id: Scalars['ID'],
  justificativa: Scalars['String']
};


export type MutationMarcarVendaLeadArgs = {
  id: Scalars['ID'],
  idCliente?: Maybe<Scalars['ID']>,
  idEmprestimo?: Maybe<Scalars['ID']>
};


export type MutationMoveLeadArgs = {
  id: Scalars['ID'],
  index: Scalars['Int'],
  position: Scalars['Float']
};


export type MutationQualificaLeadArgs = {
  id: Scalars['ID'],
  qualificacao: Scalars['Int']
};


export type MutationRetomarOportunidadeLeadArgs = {
  id: Scalars['ID']
};


export type MutationCreateLeadCrmArgs = {
  bairro?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  nome: Scalars['String'],
  origem?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  vagasIds?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type MutationCreateAnotacaoArgs = {
  leadId: Scalars['ID'],
  nota: Scalars['String']
};


export type MutationEditarAnotacaoArgs = {
  id: Scalars['ID'],
  nota: Scalars['String']
};


export type MutationExcluirAnotacaoArgs = {
  id: Scalars['ID']
};


export type MutationProdutoInteresseArgs = {
  idLead: Scalars['ID'],
  produto: Scalars['String']
};


export type MutationResponsavelLeadArgs = {
  idLead: Scalars['ID'],
  idResponsavel: Scalars['ID']
};


export type MutationExcluirTarefasMultiplasArgs = {
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type MutationEditarTarefasMultiplasArgs = {
  data?: Maybe<Scalars['Date']>,
  hora?: Maybe<Scalars['Time']>,
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>,
  status?: Maybe<Scalars['String']>
};


export type MutationLerArquivoLeadArgs = {
  arquivo?: Maybe<Scalars['String']>
};


export type MutationEnviarSimulacaoEmailArgs = {
  leadId?: Maybe<Scalars['ID']>,
  propostaId?: Maybe<Scalars['ID']>
};


export type MutationLoginMobileArgs = {
  password: Scalars['String'],
  username: Scalars['String']
};


export type MutationCreateClienteMobileArgs = {
  celular?: Maybe<Scalars['String']>,
  contas?: Maybe<Array<Maybe<ContaClienteInputMobile>>>,
  input?: Maybe<ClienteInputMobile>,
  password?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>
};


export type MutationCreateCustomerMobileSimplifyArgs = {
  email?: Maybe<Scalars['String']>,
  name?: Maybe<Scalars['String']>,
  password?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  source?: Maybe<Scalars['String']>
};


export type MutationCreateLoanSimulationMobileArgs = {
  date: Scalars['Date'],
  desiredValue: Scalars['Float'],
  installments: EmprestimoParcelas
};


export type MutationCreatePreClienteMobileArgs = {
  celular?: Maybe<Scalars['String']>,
  contas?: Maybe<Array<Maybe<ContaClienteInputMobile>>>,
  idCliente: Scalars['ID'],
  input: ClienteInputMobile,
  password?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>
};


export type MutationCreateEmprestimoMobileArgs = {
  boletos?: Maybe<Array<Maybe<BoletoClienteMobile>>>,
  cartaoId: Scalars['Int'],
  contas?: Maybe<Array<Maybe<ContaClienteMobileType2>>>,
  emprestimoInput?: Maybe<InputEmprestimoMobile>
};


export type MutationCreateCartaoCreditoArgs = {
  dadosCartao?: Maybe<InputCriarCartaoDeCredito>
};


export type MutationCreateContaClienteMobileArgs = {
  agencia?: Maybe<Scalars['String']>,
  banco?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  cpfCnpj?: Maybe<Scalars['String']>,
  idCliente: Scalars['ID'],
  nome?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  variacao?: Maybe<Scalars['String']>
};


export type MutationCreateCartaoCreditoTerceirosArgs = {
  dadosCartao?: Maybe<InputCriarCartaoDeCredito>,
  dadosTerceiro?: Maybe<InputCriarCartaoDeCreditoTerceiros>
};


export type MutationUpdateClienteMobileArgs = {
  anexoCpfFrente?: Maybe<Scalars['String']>,
  anexoCpfVerso?: Maybe<Scalars['String']>,
  anexoEndereco?: Maybe<Scalars['String']>,
  anexoRgFrente?: Maybe<Scalars['String']>,
  anexoRgVerso?: Maybe<Scalars['String']>,
  celular?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  estadoCivil?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['ID']>,
  nome?: Maybe<Scalars['String']>,
  observacao?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  sexo?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>
};


export type MutationEditUserProfileMobileArgs = {
  name?: Maybe<Scalars['String']>,
  phone?: Maybe<Scalars['String']>,
  source?: Maybe<Scalars['String']>
};


export type MutationUpdateEnderecoClienteMobileArgs = {
  anexoEndereco?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  cep?: Maybe<Scalars['String']>,
  complemento?: Maybe<Scalars['String']>,
  endereco?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['ID']>,
  municipio?: Maybe<Scalars['String']>,
  pais?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>
};


export type MutationUpdateContaClienteMobileArgs = {
  agencia?: Maybe<Scalars['String']>,
  banco?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  cpfCnpj?: Maybe<Scalars['String']>,
  idCliente: Scalars['ID'],
  idConta: Scalars['ID'],
  nome?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  variacao?: Maybe<Scalars['String']>
};


export type MutationExcluirClienteMobileArgs = {
  idCliente: Scalars['ID'],
  password: Scalars['String']
};


export type MutationExcluirCartaoCreditoArgs = {
  id: Scalars['ID']
};


export type MutationExcluirContaClienteMobileArgs = {
  id: Scalars['ID']
};


export type MutationEnviarMemsagemSuporteMobileArgs = {
  assunto: Scalars['String'],
  idCliente: Scalars['ID'],
  memsagem: Scalars['String']
};


export type MutationGerarNovaSenhaClienteMobileArgs = {
  emailCliente: Scalars['String']
};


export type MutationAlterarSenhaClienteMobileArgs = {
  idCliente?: Maybe<Scalars['ID']>,
  senhaAtual: Scalars['String'],
  senhaNova: Scalars['String']
};


export type MutationCancelaEmprestimoMobileArgs = {
  id: Scalars['ID'],
  justificativa: Scalars['String']
};


export type MutationUploadFoto64Args = {
  file: Scalars['String']
};


export type MutationGenerateNewUserPasswordMobileArgs = {
  userEmail: Scalars['String']
};


export type MutationObterTokenArgs = {
  username: Scalars['String'],
  password: Scalars['String']
};


export type MutationVerificarTokenArgs = {
  token?: Maybe<Scalars['String']>
};


export type MutationAtualizarTokenArgs = {
  token?: Maybe<Scalars['String']>
};

export type Node = {
  /** The ID of the object. */
  id: Scalars['ID'],
};

export type NsuInput = {
  id?: Maybe<Scalars['ID']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  valorNsuCv: Scalars['Float'],
  maquinaId?: Maybe<Scalars['ID']>,
  maquinaOld?: Maybe<Scalars['String']>,
  parcelas?: Maybe<EmprestimoParcelas>,
  nsuCv?: Maybe<Scalars['String']>,
  titularDivergente?: Maybe<TitularDivergenteInput>,
};

export type NsuNode = Node & {
   __typename?: 'NsuNode',
  /** The ID of the object. */
  id: Scalars['ID'],
  emprestimo: EmprestimoRelatorioType,
  bandeiraCartao?: Maybe<Scalars['String']>,
  nsuCv?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  valorNsuCv?: Maybe<Scalars['Float']>,
  idPagamento?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  nomeNoCartao?: Maybe<Scalars['String']>,
  validade?: Maybe<Scalars['DateTime']>,
  numeroCartao?: Maybe<Scalars['String']>,
  idPagcetoCartao?: Maybe<Scalars['String']>,
  pagcertoPagamentoPayload?: Maybe<Scalars['JSONString']>,
  maquinaOld?: Maybe<Scalars['String']>,
  maquina?: Maybe<MaquinaNode>,
  limiteMaquinaAlterado: Scalars['Boolean'],
  parcelas?: Maybe<NsuParcelas>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  titularDivergente?: Maybe<NsuTitularDivergenteType>,
  pk: Scalars['Int'],
};

export type NsuNodeConnection = {
   __typename?: 'NsuNodeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NsuNodeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `NsuNode` and its cursor. */
export type NsuNodeEdge = {
   __typename?: 'NsuNodeEdge',
  /** The item at the end of the edge */
  node?: Maybe<NsuNode>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum NsuParcelas {
  /** 1x */
  A_1 = 'A_1',
  /** 2x */
  A_2 = 'A_2',
  /** 3x */
  A_3 = 'A_3',
  /** 4x */
  A_4 = 'A_4',
  /** 5x */
  A_5 = 'A_5',
  /** 6x */
  A_6 = 'A_6',
  /** 7x */
  A_7 = 'A_7',
  /** 8x */
  A_8 = 'A_8',
  /** 9x */
  A_9 = 'A_9',
  /** 10x */
  A_10 = 'A_10',
  /** 11x */
  A_11 = 'A_11',
  /** 12x */
  A_12 = 'A_12',
  /** 13x */
  A_13 = 'A_13',
  /** 14x */
  A_14 = 'A_14',
  /** 15x */
  A_15 = 'A_15',
  /** 16x */
  A_16 = 'A_16',
  /** 17x */
  A_17 = 'A_17',
  /** 18x */
  A_18 = 'A_18',
  /** 19x */
  A_19 = 'A_19',
  /** 20x */
  A_20 = 'A_20',
  /** 21x */
  A_21 = 'A_21',
  /** 22x */
  A_22 = 'A_22',
  /** 23x */
  A_23 = 'A_23',
  /** 24x */
  A_24 = 'A_24',
  /** 25x */
  A_25 = 'A_25',
  /** 26x */
  A_26 = 'A_26',
  /** 27x */
  A_27 = 'A_27',
  /** 28x */
  A_28 = 'A_28',
  /** 29x */
  A_29 = 'A_29',
  /** 30x */
  A_30 = 'A_30',
  /** 31x */
  A_31 = 'A_31',
  /** 32x */
  A_32 = 'A_32',
  /** 33x */
  A_33 = 'A_33',
  /** 34x */
  A_34 = 'A_34',
  /** 35x */
  A_35 = 'A_35',
  /** 36x */
  A_36 = 'A_36',
  /** 37x */
  A_37 = 'A_37',
  /** 38x */
  A_38 = 'A_38',
  /** 39x */
  A_39 = 'A_39',
  /** 40x */
  A_40 = 'A_40',
  /** 41x */
  A_41 = 'A_41',
  /** 42x */
  A_42 = 'A_42',
  /** 43x */
  A_43 = 'A_43',
  /** 44x */
  A_44 = 'A_44',
  /** 45x */
  A_45 = 'A_45',
  /** 46x */
  A_46 = 'A_46',
  /** 47x */
  A_47 = 'A_47',
  /** 48x */
  A_48 = 'A_48',
  /** 49x */
  A_49 = 'A_49',
  /** 50x */
  A_50 = 'A_50',
  /** 51x */
  A_51 = 'A_51',
  /** 52x */
  A_52 = 'A_52',
  /** 53x */
  A_53 = 'A_53',
  /** 54x */
  A_54 = 'A_54',
  /** 55x */
  A_55 = 'A_55',
  /** 56x */
  A_56 = 'A_56',
  /** 57x */
  A_57 = 'A_57',
  /** 58x */
  A_58 = 'A_58',
  /** 59x */
  A_59 = 'A_59',
  /** 60x */
  A_60 = 'A_60',
  /** 61x */
  A_61 = 'A_61',
  /** 62x */
  A_62 = 'A_62',
  /** 63x */
  A_63 = 'A_63',
  /** 64x */
  A_64 = 'A_64',
  /** 65x */
  A_65 = 'A_65',
  /** 66x */
  A_66 = 'A_66',
  /** 67x */
  A_67 = 'A_67',
  /** 68x */
  A_68 = 'A_68',
  /** 69x */
  A_69 = 'A_69',
  /** 70x */
  A_70 = 'A_70',
  /** 71x */
  A_71 = 'A_71',
  /** 72x */
  A_72 = 'A_72',
  /** 73x */
  A_73 = 'A_73',
  /** 74x */
  A_74 = 'A_74',
  /** 75x */
  A_75 = 'A_75',
  /** 76x */
  A_76 = 'A_76',
  /** 77x */
  A_77 = 'A_77',
  /** 78x */
  A_78 = 'A_78',
  /** 79x */
  A_79 = 'A_79',
  /** 80x */
  A_80 = 'A_80',
  /** 81x */
  A_81 = 'A_81',
  /** 82x */
  A_82 = 'A_82',
  /** 83x */
  A_83 = 'A_83',
  /** 84x */
  A_84 = 'A_84',
  /** 85x */
  A_85 = 'A_85',
  /** 86x */
  A_86 = 'A_86',
  /** 87x */
  A_87 = 'A_87',
  /** 88x */
  A_88 = 'A_88',
  /** 89x */
  A_89 = 'A_89',
  /** 90x */
  A_90 = 'A_90',
  /** 91x */
  A_91 = 'A_91',
  /** 92x */
  A_92 = 'A_92',
  /** 93x */
  A_93 = 'A_93',
  /** 94x */
  A_94 = 'A_94',
  /** 95x */
  A_95 = 'A_95',
  /** 96x */
  A_96 = 'A_96',
  /** 97x */
  A_97 = 'A_97',
  /** 98x */
  A_98 = 'A_98',
  /** 99x */
  A_99 = 'A_99',
  /** 100x */
  A_100 = 'A_100',
  /** 101x */
  A_101 = 'A_101',
  /** 102x */
  A_102 = 'A_102',
  /** 103x */
  A_103 = 'A_103',
  /** 104x */
  A_104 = 'A_104',
  /** 105x */
  A_105 = 'A_105',
  /** 106x */
  A_106 = 'A_106',
  /** 107x */
  A_107 = 'A_107',
  /** 108x */
  A_108 = 'A_108',
  /** 109x */
  A_109 = 'A_109',
  /** 110x */
  A_110 = 'A_110',
  /** 111x */
  A_111 = 'A_111',
  /** 112x */
  A_112 = 'A_112',
  /** 113x */
  A_113 = 'A_113',
  /** 114x */
  A_114 = 'A_114',
  /** 115x */
  A_115 = 'A_115',
  /** 116x */
  A_116 = 'A_116',
  /** 117x */
  A_117 = 'A_117',
  /** 118x */
  A_118 = 'A_118',
  /** 119x */
  A_119 = 'A_119',
  /** 120x */
  A_120 = 'A_120',
  /** 121x */
  A_121 = 'A_121',
  /** 122x */
  A_122 = 'A_122',
  /** 123x */
  A_123 = 'A_123',
  /** 124x */
  A_124 = 'A_124',
  /** 125x */
  A_125 = 'A_125',
  /** 126x */
  A_126 = 'A_126',
  /** 127x */
  A_127 = 'A_127',
  /** 128x */
  A_128 = 'A_128',
  /** 129x */
  A_129 = 'A_129',
  /** 130x */
  A_130 = 'A_130',
  /** 131x */
  A_131 = 'A_131',
  /** 132x */
  A_132 = 'A_132',
  /** 133x */
  A_133 = 'A_133',
  /** 134x */
  A_134 = 'A_134',
  /** 135x */
  A_135 = 'A_135',
  /** 136x */
  A_136 = 'A_136',
  /** 137x */
  A_137 = 'A_137',
  /** 138x */
  A_138 = 'A_138',
  /** 139x */
  A_139 = 'A_139',
  /** 140x */
  A_140 = 'A_140',
  /** 141x */
  A_141 = 'A_141',
  /** 142x */
  A_142 = 'A_142',
  /** 143x */
  A_143 = 'A_143',
  /** 144x */
  A_144 = 'A_144',
  /** 145x */
  A_145 = 'A_145',
  /** 146x */
  A_146 = 'A_146',
  /** 147x */
  A_147 = 'A_147',
  /** 148x */
  A_148 = 'A_148',
  /** 149x */
  A_149 = 'A_149',
  /** 150x */
  A_150 = 'A_150',
  /** 151x */
  A_151 = 'A_151',
  /** 152x */
  A_152 = 'A_152',
  /** 153x */
  A_153 = 'A_153',
  /** 154x */
  A_154 = 'A_154',
  /** 155x */
  A_155 = 'A_155',
  /** 156x */
  A_156 = 'A_156',
  /** 157x */
  A_157 = 'A_157',
  /** 158x */
  A_158 = 'A_158',
  /** 159x */
  A_159 = 'A_159',
  /** 160x */
  A_160 = 'A_160',
  /** 161x */
  A_161 = 'A_161',
  /** 162x */
  A_162 = 'A_162',
  /** 163x */
  A_163 = 'A_163',
  /** 164x */
  A_164 = 'A_164',
  /** 165x */
  A_165 = 'A_165',
  /** 166x */
  A_166 = 'A_166',
  /** 167x */
  A_167 = 'A_167',
  /** 168x */
  A_168 = 'A_168',
  /** 169x */
  A_169 = 'A_169',
  /** 170x */
  A_170 = 'A_170',
  /** 171x */
  A_171 = 'A_171',
  /** 172x */
  A_172 = 'A_172',
  /** 173x */
  A_173 = 'A_173',
  /** 174x */
  A_174 = 'A_174',
  /** 175x */
  A_175 = 'A_175',
  /** 176x */
  A_176 = 'A_176',
  /** 177x */
  A_177 = 'A_177',
  /** 178x */
  A_178 = 'A_178',
  /** 179x */
  A_179 = 'A_179',
  /** 180x */
  A_180 = 'A_180',
  /** 181x */
  A_181 = 'A_181',
  /** 182x */
  A_182 = 'A_182',
  /** 183x */
  A_183 = 'A_183',
  /** 184x */
  A_184 = 'A_184',
  /** 185x */
  A_185 = 'A_185',
  /** 186x */
  A_186 = 'A_186',
  /** 187x */
  A_187 = 'A_187',
  /** 188x */
  A_188 = 'A_188',
  /** 189x */
  A_189 = 'A_189',
  /** 190x */
  A_190 = 'A_190',
  /** 191x */
  A_191 = 'A_191',
  /** 192x */
  A_192 = 'A_192',
  /** 193x */
  A_193 = 'A_193',
  /** 194x */
  A_194 = 'A_194',
  /** 195x */
  A_195 = 'A_195',
  /** 196x */
  A_196 = 'A_196',
  /** 197x */
  A_197 = 'A_197',
  /** 198x */
  A_198 = 'A_198',
  /** 199x */
  A_199 = 'A_199',
  /** 200x */
  A_200 = 'A_200',
  /** 201x */
  A_201 = 'A_201',
  /** 202x */
  A_202 = 'A_202',
  /** 203x */
  A_203 = 'A_203',
  /** 204x */
  A_204 = 'A_204',
  /** 205x */
  A_205 = 'A_205',
  /** 206x */
  A_206 = 'A_206',
  /** 207x */
  A_207 = 'A_207',
  /** 208x */
  A_208 = 'A_208',
  /** 209x */
  A_209 = 'A_209',
  /** 210x */
  A_210 = 'A_210',
  /** 211x */
  A_211 = 'A_211',
  /** 212x */
  A_212 = 'A_212',
  /** 213x */
  A_213 = 'A_213',
  /** 214x */
  A_214 = 'A_214',
  /** 215x */
  A_215 = 'A_215',
  /** 216x */
  A_216 = 'A_216',
  /** 217x */
  A_217 = 'A_217',
  /** 218x */
  A_218 = 'A_218',
  /** 219x */
  A_219 = 'A_219',
  /** 220x */
  A_220 = 'A_220',
  /** 221x */
  A_221 = 'A_221',
  /** 222x */
  A_222 = 'A_222',
  /** 223x */
  A_223 = 'A_223',
  /** 224x */
  A_224 = 'A_224',
  /** 225x */
  A_225 = 'A_225',
  /** 226x */
  A_226 = 'A_226',
  /** 227x */
  A_227 = 'A_227',
  /** 228x */
  A_228 = 'A_228',
  /** 229x */
  A_229 = 'A_229',
  /** 230x */
  A_230 = 'A_230',
  /** 231x */
  A_231 = 'A_231',
  /** 232x */
  A_232 = 'A_232',
  /** 233x */
  A_233 = 'A_233',
  /** 234x */
  A_234 = 'A_234',
  /** 235x */
  A_235 = 'A_235',
  /** 236x */
  A_236 = 'A_236',
  /** 237x */
  A_237 = 'A_237',
  /** 238x */
  A_238 = 'A_238',
  /** 239x */
  A_239 = 'A_239',
  /** 240x */
  A_240 = 'A_240',
  /** 241x */
  A_241 = 'A_241',
  /** 242x */
  A_242 = 'A_242',
  /** 243x */
  A_243 = 'A_243',
  /** 244x */
  A_244 = 'A_244',
  /** 245x */
  A_245 = 'A_245',
  /** 246x */
  A_246 = 'A_246',
  /** 247x */
  A_247 = 'A_247',
  /** 248x */
  A_248 = 'A_248',
  /** 249x */
  A_249 = 'A_249',
  /** 250x */
  A_250 = 'A_250',
  /** 251x */
  A_251 = 'A_251',
  /** 252x */
  A_252 = 'A_252',
  /** 253x */
  A_253 = 'A_253',
  /** 254x */
  A_254 = 'A_254',
  /** 255x */
  A_255 = 'A_255',
  /** 256x */
  A_256 = 'A_256',
  /** 257x */
  A_257 = 'A_257',
  /** 258x */
  A_258 = 'A_258',
  /** 259x */
  A_259 = 'A_259',
  /** 260x */
  A_260 = 'A_260',
  /** 261x */
  A_261 = 'A_261',
  /** 262x */
  A_262 = 'A_262',
  /** 263x */
  A_263 = 'A_263',
  /** 264x */
  A_264 = 'A_264',
  /** 265x */
  A_265 = 'A_265',
  /** 266x */
  A_266 = 'A_266',
  /** 267x */
  A_267 = 'A_267',
  /** 268x */
  A_268 = 'A_268',
  /** 269x */
  A_269 = 'A_269',
  /** 270x */
  A_270 = 'A_270',
  /** 271x */
  A_271 = 'A_271',
  /** 272x */
  A_272 = 'A_272',
  /** 273x */
  A_273 = 'A_273',
  /** 274x */
  A_274 = 'A_274',
  /** 275x */
  A_275 = 'A_275',
  /** 276x */
  A_276 = 'A_276',
  /** 277x */
  A_277 = 'A_277',
  /** 278x */
  A_278 = 'A_278',
  /** 279x */
  A_279 = 'A_279',
  /** 280x */
  A_280 = 'A_280',
  /** 281x */
  A_281 = 'A_281',
  /** 282x */
  A_282 = 'A_282',
  /** 283x */
  A_283 = 'A_283',
  /** 284x */
  A_284 = 'A_284',
  /** 285x */
  A_285 = 'A_285',
  /** 286x */
  A_286 = 'A_286',
  /** 287x */
  A_287 = 'A_287',
  /** 288x */
  A_288 = 'A_288',
  /** 289x */
  A_289 = 'A_289',
  /** 290x */
  A_290 = 'A_290',
  /** 291x */
  A_291 = 'A_291',
  /** 292x */
  A_292 = 'A_292',
  /** 293x */
  A_293 = 'A_293',
  /** 294x */
  A_294 = 'A_294',
  /** 295x */
  A_295 = 'A_295',
  /** 296x */
  A_296 = 'A_296',
  /** 297x */
  A_297 = 'A_297',
  /** 298x */
  A_298 = 'A_298',
  /** 299x */
  A_299 = 'A_299',
  /** 300x */
  A_300 = 'A_300',
  /** 301x */
  A_301 = 'A_301',
  /** 302x */
  A_302 = 'A_302',
  /** 303x */
  A_303 = 'A_303',
  /** 304x */
  A_304 = 'A_304',
  /** 305x */
  A_305 = 'A_305',
  /** 306x */
  A_306 = 'A_306',
  /** 307x */
  A_307 = 'A_307',
  /** 308x */
  A_308 = 'A_308',
  /** 309x */
  A_309 = 'A_309',
  /** 310x */
  A_310 = 'A_310',
  /** 311x */
  A_311 = 'A_311',
  /** 312x */
  A_312 = 'A_312',
  /** 313x */
  A_313 = 'A_313',
  /** 314x */
  A_314 = 'A_314',
  /** 315x */
  A_315 = 'A_315',
  /** 316x */
  A_316 = 'A_316',
  /** 317x */
  A_317 = 'A_317',
  /** 318x */
  A_318 = 'A_318',
  /** 319x */
  A_319 = 'A_319',
  /** 320x */
  A_320 = 'A_320',
  /** 321x */
  A_321 = 'A_321',
  /** 322x */
  A_322 = 'A_322',
  /** 323x */
  A_323 = 'A_323',
  /** 324x */
  A_324 = 'A_324',
  /** 325x */
  A_325 = 'A_325',
  /** 326x */
  A_326 = 'A_326',
  /** 327x */
  A_327 = 'A_327',
  /** 328x */
  A_328 = 'A_328',
  /** 329x */
  A_329 = 'A_329',
  /** 330x */
  A_330 = 'A_330',
  /** 331x */
  A_331 = 'A_331',
  /** 332x */
  A_332 = 'A_332',
  /** 333x */
  A_333 = 'A_333',
  /** 334x */
  A_334 = 'A_334',
  /** 335x */
  A_335 = 'A_335',
  /** 336x */
  A_336 = 'A_336',
  /** 337x */
  A_337 = 'A_337',
  /** 338x */
  A_338 = 'A_338',
  /** 339x */
  A_339 = 'A_339',
  /** 340x */
  A_340 = 'A_340',
  /** 341x */
  A_341 = 'A_341',
  /** 342x */
  A_342 = 'A_342',
  /** 343x */
  A_343 = 'A_343',
  /** 344x */
  A_344 = 'A_344',
  /** 345x */
  A_345 = 'A_345',
  /** 346x */
  A_346 = 'A_346',
  /** 347x */
  A_347 = 'A_347',
  /** 348x */
  A_348 = 'A_348',
  /** 349x */
  A_349 = 'A_349',
  /** 350x */
  A_350 = 'A_350',
  /** 351x */
  A_351 = 'A_351',
  /** 352x */
  A_352 = 'A_352',
  /** 353x */
  A_353 = 'A_353',
  /** 354x */
  A_354 = 'A_354',
  /** 355x */
  A_355 = 'A_355',
  /** 356x */
  A_356 = 'A_356',
  /** 357x */
  A_357 = 'A_357',
  /** 358x */
  A_358 = 'A_358',
  /** 359x */
  A_359 = 'A_359',
  /** 360x */
  A_360 = 'A_360',
  /** 361x */
  A_361 = 'A_361',
  /** 362x */
  A_362 = 'A_362',
  /** 363x */
  A_363 = 'A_363',
  /** 364x */
  A_364 = 'A_364',
  /** 365x */
  A_365 = 'A_365',
  /** 366x */
  A_366 = 'A_366',
  /** 367x */
  A_367 = 'A_367',
  /** 368x */
  A_368 = 'A_368',
  /** 369x */
  A_369 = 'A_369',
  /** 370x */
  A_370 = 'A_370',
  /** 371x */
  A_371 = 'A_371',
  /** 372x */
  A_372 = 'A_372',
  /** 373x */
  A_373 = 'A_373',
  /** 374x */
  A_374 = 'A_374',
  /** 375x */
  A_375 = 'A_375',
  /** 376x */
  A_376 = 'A_376',
  /** 377x */
  A_377 = 'A_377',
  /** 378x */
  A_378 = 'A_378',
  /** 379x */
  A_379 = 'A_379',
  /** 380x */
  A_380 = 'A_380',
  /** 381x */
  A_381 = 'A_381',
  /** 382x */
  A_382 = 'A_382',
  /** 383x */
  A_383 = 'A_383',
  /** 384x */
  A_384 = 'A_384',
  /** 385x */
  A_385 = 'A_385',
  /** 386x */
  A_386 = 'A_386',
  /** 387x */
  A_387 = 'A_387',
  /** 388x */
  A_388 = 'A_388',
  /** 389x */
  A_389 = 'A_389',
  /** 390x */
  A_390 = 'A_390',
  /** 391x */
  A_391 = 'A_391',
  /** 392x */
  A_392 = 'A_392',
  /** 393x */
  A_393 = 'A_393',
  /** 394x */
  A_394 = 'A_394',
  /** 395x */
  A_395 = 'A_395',
  /** 396x */
  A_396 = 'A_396',
  /** 397x */
  A_397 = 'A_397',
  /** 398x */
  A_398 = 'A_398',
  /** 399x */
  A_399 = 'A_399',
  /** 400x */
  A_400 = 'A_400',
  /** 401x */
  A_401 = 'A_401',
  /** 402x */
  A_402 = 'A_402',
  /** 403x */
  A_403 = 'A_403',
  /** 404x */
  A_404 = 'A_404',
  /** 405x */
  A_405 = 'A_405',
  /** 406x */
  A_406 = 'A_406',
  /** 407x */
  A_407 = 'A_407',
  /** 408x */
  A_408 = 'A_408',
  /** 409x */
  A_409 = 'A_409',
  /** 410x */
  A_410 = 'A_410',
  /** 411x */
  A_411 = 'A_411',
  /** 412x */
  A_412 = 'A_412',
  /** 413x */
  A_413 = 'A_413',
  /** 414x */
  A_414 = 'A_414',
  /** 415x */
  A_415 = 'A_415',
  /** 416x */
  A_416 = 'A_416',
  /** 417x */
  A_417 = 'A_417',
  /** 418x */
  A_418 = 'A_418',
  /** 419x */
  A_419 = 'A_419',
  /** 420x */
  A_420 = 'A_420',
  /** 421x */
  A_421 = 'A_421',
  /** 422x */
  A_422 = 'A_422',
  /** 423x */
  A_423 = 'A_423',
  /** 424x */
  A_424 = 'A_424',
  /** 425x */
  A_425 = 'A_425',
  /** 426x */
  A_426 = 'A_426',
  /** 427x */
  A_427 = 'A_427',
  /** 428x */
  A_428 = 'A_428',
  /** 429x */
  A_429 = 'A_429',
  /** 430x */
  A_430 = 'A_430',
  /** 431x */
  A_431 = 'A_431',
  /** 432x */
  A_432 = 'A_432',
  /** 433x */
  A_433 = 'A_433',
  /** 434x */
  A_434 = 'A_434',
  /** 435x */
  A_435 = 'A_435',
  /** 436x */
  A_436 = 'A_436',
  /** 437x */
  A_437 = 'A_437',
  /** 438x */
  A_438 = 'A_438',
  /** 439x */
  A_439 = 'A_439',
  /** 440x */
  A_440 = 'A_440',
  /** 441x */
  A_441 = 'A_441',
  /** 442x */
  A_442 = 'A_442',
  /** 443x */
  A_443 = 'A_443',
  /** 444x */
  A_444 = 'A_444',
  /** 445x */
  A_445 = 'A_445',
  /** 446x */
  A_446 = 'A_446',
  /** 447x */
  A_447 = 'A_447',
  /** 448x */
  A_448 = 'A_448',
  /** 449x */
  A_449 = 'A_449',
  /** 450x */
  A_450 = 'A_450',
  /** 451x */
  A_451 = 'A_451',
  /** 452x */
  A_452 = 'A_452',
  /** 453x */
  A_453 = 'A_453',
  /** 454x */
  A_454 = 'A_454',
  /** 455x */
  A_455 = 'A_455',
  /** 456x */
  A_456 = 'A_456',
  /** 457x */
  A_457 = 'A_457',
  /** 458x */
  A_458 = 'A_458',
  /** 459x */
  A_459 = 'A_459',
  /** 460x */
  A_460 = 'A_460',
  /** 461x */
  A_461 = 'A_461',
  /** 462x */
  A_462 = 'A_462',
  /** 463x */
  A_463 = 'A_463',
  /** 464x */
  A_464 = 'A_464',
  /** 465x */
  A_465 = 'A_465',
  /** 466x */
  A_466 = 'A_466',
  /** 467x */
  A_467 = 'A_467',
  /** 468x */
  A_468 = 'A_468',
  /** 469x */
  A_469 = 'A_469',
  /** 470x */
  A_470 = 'A_470',
  /** 471x */
  A_471 = 'A_471',
  /** 472x */
  A_472 = 'A_472',
  /** 473x */
  A_473 = 'A_473',
  /** 474x */
  A_474 = 'A_474',
  /** 475x */
  A_475 = 'A_475',
  /** 476x */
  A_476 = 'A_476',
  /** 477x */
  A_477 = 'A_477',
  /** 478x */
  A_478 = 'A_478',
  /** 479x */
  A_479 = 'A_479',
  /** 480x */
  A_480 = 'A_480',
  /** 481x */
  A_481 = 'A_481',
  /** 482x */
  A_482 = 'A_482',
  /** 483x */
  A_483 = 'A_483',
  /** 484x */
  A_484 = 'A_484',
  /** 485x */
  A_485 = 'A_485',
  /** 486x */
  A_486 = 'A_486',
  /** 487x */
  A_487 = 'A_487',
  /** 488x */
  A_488 = 'A_488',
  /** 489x */
  A_489 = 'A_489',
  /** 490x */
  A_490 = 'A_490',
  /** 491x */
  A_491 = 'A_491',
  /** 492x */
  A_492 = 'A_492',
  /** 493x */
  A_493 = 'A_493',
  /** 494x */
  A_494 = 'A_494',
  /** 495x */
  A_495 = 'A_495',
  /** 496x */
  A_496 = 'A_496',
  /** 497x */
  A_497 = 'A_497',
  /** 498x */
  A_498 = 'A_498',
  /** 499x */
  A_499 = 'A_499',
  /** 500x */
  A_500 = 'A_500',
  /** 501x */
  A_501 = 'A_501',
  /** 502x */
  A_502 = 'A_502',
  /** 503x */
  A_503 = 'A_503',
  /** 504x */
  A_504 = 'A_504',
  /** 505x */
  A_505 = 'A_505',
  /** 506x */
  A_506 = 'A_506',
  /** 507x */
  A_507 = 'A_507',
  /** 508x */
  A_508 = 'A_508',
  /** 509x */
  A_509 = 'A_509',
  /** 510x */
  A_510 = 'A_510',
  /** 511x */
  A_511 = 'A_511',
  /** 512x */
  A_512 = 'A_512',
  /** 513x */
  A_513 = 'A_513',
  /** 514x */
  A_514 = 'A_514',
  /** 515x */
  A_515 = 'A_515',
  /** 516x */
  A_516 = 'A_516',
  /** 517x */
  A_517 = 'A_517',
  /** 518x */
  A_518 = 'A_518',
  /** 519x */
  A_519 = 'A_519',
  /** 520x */
  A_520 = 'A_520',
  /** 521x */
  A_521 = 'A_521',
  /** 522x */
  A_522 = 'A_522',
  /** 523x */
  A_523 = 'A_523',
  /** 524x */
  A_524 = 'A_524',
  /** 525x */
  A_525 = 'A_525',
  /** 526x */
  A_526 = 'A_526',
  /** 527x */
  A_527 = 'A_527',
  /** 528x */
  A_528 = 'A_528',
  /** 529x */
  A_529 = 'A_529',
  /** 530x */
  A_530 = 'A_530',
  /** 531x */
  A_531 = 'A_531',
  /** 532x */
  A_532 = 'A_532',
  /** 533x */
  A_533 = 'A_533',
  /** 534x */
  A_534 = 'A_534',
  /** 535x */
  A_535 = 'A_535',
  /** 536x */
  A_536 = 'A_536',
  /** 537x */
  A_537 = 'A_537',
  /** 538x */
  A_538 = 'A_538',
  /** 539x */
  A_539 = 'A_539',
  /** 540x */
  A_540 = 'A_540',
  /** 541x */
  A_541 = 'A_541',
  /** 542x */
  A_542 = 'A_542',
  /** 543x */
  A_543 = 'A_543',
  /** 544x */
  A_544 = 'A_544',
  /** 545x */
  A_545 = 'A_545',
  /** 546x */
  A_546 = 'A_546',
  /** 547x */
  A_547 = 'A_547',
  /** 548x */
  A_548 = 'A_548',
  /** 549x */
  A_549 = 'A_549',
  /** 550x */
  A_550 = 'A_550',
  /** 551x */
  A_551 = 'A_551',
  /** 552x */
  A_552 = 'A_552',
  /** 553x */
  A_553 = 'A_553',
  /** 554x */
  A_554 = 'A_554',
  /** 555x */
  A_555 = 'A_555',
  /** 556x */
  A_556 = 'A_556',
  /** 557x */
  A_557 = 'A_557',
  /** 558x */
  A_558 = 'A_558',
  /** 559x */
  A_559 = 'A_559',
  /** 560x */
  A_560 = 'A_560',
  /** 561x */
  A_561 = 'A_561',
  /** 562x */
  A_562 = 'A_562',
  /** 563x */
  A_563 = 'A_563',
  /** 564x */
  A_564 = 'A_564',
  /** 565x */
  A_565 = 'A_565',
  /** 566x */
  A_566 = 'A_566',
  /** 567x */
  A_567 = 'A_567',
  /** 568x */
  A_568 = 'A_568',
  /** 569x */
  A_569 = 'A_569',
  /** 570x */
  A_570 = 'A_570',
  /** 571x */
  A_571 = 'A_571',
  /** 572x */
  A_572 = 'A_572',
  /** 573x */
  A_573 = 'A_573',
  /** 574x */
  A_574 = 'A_574',
  /** 575x */
  A_575 = 'A_575',
  /** 576x */
  A_576 = 'A_576',
  /** 577x */
  A_577 = 'A_577',
  /** 578x */
  A_578 = 'A_578',
  /** 579x */
  A_579 = 'A_579',
  /** 580x */
  A_580 = 'A_580',
  /** 581x */
  A_581 = 'A_581',
  /** 582x */
  A_582 = 'A_582',
  /** 583x */
  A_583 = 'A_583',
  /** 584x */
  A_584 = 'A_584',
  /** 585x */
  A_585 = 'A_585',
  /** 586x */
  A_586 = 'A_586',
  /** 587x */
  A_587 = 'A_587',
  /** 588x */
  A_588 = 'A_588',
  /** 589x */
  A_589 = 'A_589',
  /** 590x */
  A_590 = 'A_590',
  /** 591x */
  A_591 = 'A_591',
  /** 592x */
  A_592 = 'A_592',
  /** 593x */
  A_593 = 'A_593',
  /** 594x */
  A_594 = 'A_594',
  /** 595x */
  A_595 = 'A_595',
  /** 596x */
  A_596 = 'A_596',
  /** 597x */
  A_597 = 'A_597',
  /** 598x */
  A_598 = 'A_598',
  /** 599x */
  A_599 = 'A_599',
  /** 600x */
  A_600 = 'A_600',
  /** 601x */
  A_601 = 'A_601',
  /** 602x */
  A_602 = 'A_602',
  /** 603x */
  A_603 = 'A_603',
  /** 604x */
  A_604 = 'A_604',
  /** 605x */
  A_605 = 'A_605',
  /** 606x */
  A_606 = 'A_606',
  /** 607x */
  A_607 = 'A_607',
  /** 608x */
  A_608 = 'A_608',
  /** 609x */
  A_609 = 'A_609',
  /** 610x */
  A_610 = 'A_610',
  /** 611x */
  A_611 = 'A_611',
  /** 612x */
  A_612 = 'A_612',
  /** 613x */
  A_613 = 'A_613',
  /** 614x */
  A_614 = 'A_614',
  /** 615x */
  A_615 = 'A_615',
  /** 616x */
  A_616 = 'A_616',
  /** 617x */
  A_617 = 'A_617',
  /** 618x */
  A_618 = 'A_618',
  /** 619x */
  A_619 = 'A_619',
  /** 620x */
  A_620 = 'A_620',
  /** 621x */
  A_621 = 'A_621',
  /** 622x */
  A_622 = 'A_622',
  /** 623x */
  A_623 = 'A_623',
  /** 624x */
  A_624 = 'A_624',
  /** 625x */
  A_625 = 'A_625',
  /** 626x */
  A_626 = 'A_626',
  /** 627x */
  A_627 = 'A_627',
  /** 628x */
  A_628 = 'A_628',
  /** 629x */
  A_629 = 'A_629',
  /** 630x */
  A_630 = 'A_630',
  /** 631x */
  A_631 = 'A_631',
  /** 632x */
  A_632 = 'A_632',
  /** 633x */
  A_633 = 'A_633',
  /** 634x */
  A_634 = 'A_634',
  /** 635x */
  A_635 = 'A_635',
  /** 636x */
  A_636 = 'A_636',
  /** 637x */
  A_637 = 'A_637',
  /** 638x */
  A_638 = 'A_638',
  /** 639x */
  A_639 = 'A_639',
  /** 640x */
  A_640 = 'A_640',
  /** 641x */
  A_641 = 'A_641',
  /** 642x */
  A_642 = 'A_642',
  /** 643x */
  A_643 = 'A_643',
  /** 644x */
  A_644 = 'A_644',
  /** 645x */
  A_645 = 'A_645',
  /** 646x */
  A_646 = 'A_646',
  /** 647x */
  A_647 = 'A_647',
  /** 648x */
  A_648 = 'A_648',
  /** 649x */
  A_649 = 'A_649',
  /** 650x */
  A_650 = 'A_650',
  /** 651x */
  A_651 = 'A_651',
  /** 652x */
  A_652 = 'A_652',
  /** 653x */
  A_653 = 'A_653',
  /** 654x */
  A_654 = 'A_654',
  /** 655x */
  A_655 = 'A_655',
  /** 656x */
  A_656 = 'A_656',
  /** 657x */
  A_657 = 'A_657',
  /** 658x */
  A_658 = 'A_658',
  /** 659x */
  A_659 = 'A_659',
  /** 660x */
  A_660 = 'A_660',
  /** 661x */
  A_661 = 'A_661',
  /** 662x */
  A_662 = 'A_662',
  /** 663x */
  A_663 = 'A_663',
  /** 664x */
  A_664 = 'A_664',
  /** 665x */
  A_665 = 'A_665',
  /** 666x */
  A_666 = 'A_666',
  /** 667x */
  A_667 = 'A_667',
  /** 668x */
  A_668 = 'A_668',
  /** 669x */
  A_669 = 'A_669',
  /** 670x */
  A_670 = 'A_670',
  /** 671x */
  A_671 = 'A_671',
  /** 672x */
  A_672 = 'A_672',
  /** 673x */
  A_673 = 'A_673',
  /** 674x */
  A_674 = 'A_674',
  /** 675x */
  A_675 = 'A_675',
  /** 676x */
  A_676 = 'A_676',
  /** 677x */
  A_677 = 'A_677',
  /** 678x */
  A_678 = 'A_678',
  /** 679x */
  A_679 = 'A_679',
  /** 680x */
  A_680 = 'A_680',
  /** 681x */
  A_681 = 'A_681',
  /** 682x */
  A_682 = 'A_682',
  /** 683x */
  A_683 = 'A_683',
  /** 684x */
  A_684 = 'A_684',
  /** 685x */
  A_685 = 'A_685',
  /** 686x */
  A_686 = 'A_686',
  /** 687x */
  A_687 = 'A_687',
  /** 688x */
  A_688 = 'A_688',
  /** 689x */
  A_689 = 'A_689',
  /** 690x */
  A_690 = 'A_690',
  /** 691x */
  A_691 = 'A_691',
  /** 692x */
  A_692 = 'A_692',
  /** 693x */
  A_693 = 'A_693',
  /** 694x */
  A_694 = 'A_694',
  /** 695x */
  A_695 = 'A_695',
  /** 696x */
  A_696 = 'A_696',
  /** 697x */
  A_697 = 'A_697',
  /** 698x */
  A_698 = 'A_698',
  /** 699x */
  A_699 = 'A_699',
  /** 700x */
  A_700 = 'A_700',
  /** 701x */
  A_701 = 'A_701',
  /** 702x */
  A_702 = 'A_702',
  /** 703x */
  A_703 = 'A_703',
  /** 704x */
  A_704 = 'A_704',
  /** 705x */
  A_705 = 'A_705',
  /** 706x */
  A_706 = 'A_706',
  /** 707x */
  A_707 = 'A_707',
  /** 708x */
  A_708 = 'A_708',
  /** 709x */
  A_709 = 'A_709',
  /** 710x */
  A_710 = 'A_710',
  /** 711x */
  A_711 = 'A_711',
  /** 712x */
  A_712 = 'A_712',
  /** 713x */
  A_713 = 'A_713',
  /** 714x */
  A_714 = 'A_714',
  /** 715x */
  A_715 = 'A_715',
  /** 716x */
  A_716 = 'A_716',
  /** 717x */
  A_717 = 'A_717',
  /** 718x */
  A_718 = 'A_718',
  /** 719x */
  A_719 = 'A_719',
  /** 720x */
  A_720 = 'A_720',
  /** 721x */
  A_721 = 'A_721',
  /** 722x */
  A_722 = 'A_722',
  /** 723x */
  A_723 = 'A_723',
  /** 724x */
  A_724 = 'A_724',
  /** 725x */
  A_725 = 'A_725',
  /** 726x */
  A_726 = 'A_726',
  /** 727x */
  A_727 = 'A_727',
  /** 728x */
  A_728 = 'A_728',
  /** 729x */
  A_729 = 'A_729',
  /** 730x */
  A_730 = 'A_730',
  /** 731x */
  A_731 = 'A_731',
  /** 732x */
  A_732 = 'A_732',
  /** 733x */
  A_733 = 'A_733',
  /** 734x */
  A_734 = 'A_734',
  /** 735x */
  A_735 = 'A_735',
  /** 736x */
  A_736 = 'A_736',
  /** 737x */
  A_737 = 'A_737',
  /** 738x */
  A_738 = 'A_738',
  /** 739x */
  A_739 = 'A_739',
  /** 740x */
  A_740 = 'A_740',
  /** 741x */
  A_741 = 'A_741',
  /** 742x */
  A_742 = 'A_742',
  /** 743x */
  A_743 = 'A_743',
  /** 744x */
  A_744 = 'A_744',
  /** 745x */
  A_745 = 'A_745',
  /** 746x */
  A_746 = 'A_746',
  /** 747x */
  A_747 = 'A_747',
  /** 748x */
  A_748 = 'A_748',
  /** 749x */
  A_749 = 'A_749',
  /** 750x */
  A_750 = 'A_750',
  /** 751x */
  A_751 = 'A_751',
  /** 752x */
  A_752 = 'A_752',
  /** 753x */
  A_753 = 'A_753',
  /** 754x */
  A_754 = 'A_754',
  /** 755x */
  A_755 = 'A_755',
  /** 756x */
  A_756 = 'A_756',
  /** 757x */
  A_757 = 'A_757',
  /** 758x */
  A_758 = 'A_758',
  /** 759x */
  A_759 = 'A_759',
  /** 760x */
  A_760 = 'A_760',
  /** 761x */
  A_761 = 'A_761',
  /** 762x */
  A_762 = 'A_762',
  /** 763x */
  A_763 = 'A_763',
  /** 764x */
  A_764 = 'A_764',
  /** 765x */
  A_765 = 'A_765',
  /** 766x */
  A_766 = 'A_766',
  /** 767x */
  A_767 = 'A_767',
  /** 768x */
  A_768 = 'A_768',
  /** 769x */
  A_769 = 'A_769',
  /** 770x */
  A_770 = 'A_770',
  /** 771x */
  A_771 = 'A_771',
  /** 772x */
  A_772 = 'A_772',
  /** 773x */
  A_773 = 'A_773',
  /** 774x */
  A_774 = 'A_774',
  /** 775x */
  A_775 = 'A_775',
  /** 776x */
  A_776 = 'A_776',
  /** 777x */
  A_777 = 'A_777',
  /** 778x */
  A_778 = 'A_778',
  /** 779x */
  A_779 = 'A_779',
  /** 780x */
  A_780 = 'A_780',
  /** 781x */
  A_781 = 'A_781',
  /** 782x */
  A_782 = 'A_782',
  /** 783x */
  A_783 = 'A_783',
  /** 784x */
  A_784 = 'A_784',
  /** 785x */
  A_785 = 'A_785',
  /** 786x */
  A_786 = 'A_786',
  /** 787x */
  A_787 = 'A_787',
  /** 788x */
  A_788 = 'A_788',
  /** 789x */
  A_789 = 'A_789',
  /** 790x */
  A_790 = 'A_790',
  /** 791x */
  A_791 = 'A_791',
  /** 792x */
  A_792 = 'A_792',
  /** 793x */
  A_793 = 'A_793',
  /** 794x */
  A_794 = 'A_794',
  /** 795x */
  A_795 = 'A_795',
  /** 796x */
  A_796 = 'A_796',
  /** 797x */
  A_797 = 'A_797',
  /** 798x */
  A_798 = 'A_798',
  /** 799x */
  A_799 = 'A_799',
  /** 800x */
  A_800 = 'A_800',
  /** 801x */
  A_801 = 'A_801',
  /** 802x */
  A_802 = 'A_802',
  /** 803x */
  A_803 = 'A_803',
  /** 804x */
  A_804 = 'A_804',
  /** 805x */
  A_805 = 'A_805',
  /** 806x */
  A_806 = 'A_806',
  /** 807x */
  A_807 = 'A_807',
  /** 808x */
  A_808 = 'A_808',
  /** 809x */
  A_809 = 'A_809',
  /** 810x */
  A_810 = 'A_810',
  /** 811x */
  A_811 = 'A_811',
  /** 812x */
  A_812 = 'A_812',
  /** 813x */
  A_813 = 'A_813',
  /** 814x */
  A_814 = 'A_814',
  /** 815x */
  A_815 = 'A_815',
  /** 816x */
  A_816 = 'A_816',
  /** 817x */
  A_817 = 'A_817',
  /** 818x */
  A_818 = 'A_818',
  /** 819x */
  A_819 = 'A_819',
  /** 820x */
  A_820 = 'A_820',
  /** 821x */
  A_821 = 'A_821',
  /** 822x */
  A_822 = 'A_822',
  /** 823x */
  A_823 = 'A_823',
  /** 824x */
  A_824 = 'A_824',
  /** 825x */
  A_825 = 'A_825',
  /** 826x */
  A_826 = 'A_826',
  /** 827x */
  A_827 = 'A_827',
  /** 828x */
  A_828 = 'A_828',
  /** 829x */
  A_829 = 'A_829',
  /** 830x */
  A_830 = 'A_830',
  /** 831x */
  A_831 = 'A_831',
  /** 832x */
  A_832 = 'A_832',
  /** 833x */
  A_833 = 'A_833',
  /** 834x */
  A_834 = 'A_834',
  /** 835x */
  A_835 = 'A_835',
  /** 836x */
  A_836 = 'A_836',
  /** 837x */
  A_837 = 'A_837',
  /** 838x */
  A_838 = 'A_838',
  /** 839x */
  A_839 = 'A_839',
  /** 840x */
  A_840 = 'A_840',
  /** 841x */
  A_841 = 'A_841',
  /** 842x */
  A_842 = 'A_842',
  /** 843x */
  A_843 = 'A_843',
  /** 844x */
  A_844 = 'A_844',
  /** 845x */
  A_845 = 'A_845',
  /** 846x */
  A_846 = 'A_846',
  /** 847x */
  A_847 = 'A_847',
  /** 848x */
  A_848 = 'A_848',
  /** 849x */
  A_849 = 'A_849',
  /** 850x */
  A_850 = 'A_850',
  /** 851x */
  A_851 = 'A_851',
  /** 852x */
  A_852 = 'A_852',
  /** 853x */
  A_853 = 'A_853',
  /** 854x */
  A_854 = 'A_854',
  /** 855x */
  A_855 = 'A_855',
  /** 856x */
  A_856 = 'A_856',
  /** 857x */
  A_857 = 'A_857',
  /** 858x */
  A_858 = 'A_858',
  /** 859x */
  A_859 = 'A_859',
  /** 860x */
  A_860 = 'A_860',
  /** 861x */
  A_861 = 'A_861',
  /** 862x */
  A_862 = 'A_862',
  /** 863x */
  A_863 = 'A_863',
  /** 864x */
  A_864 = 'A_864',
  /** 865x */
  A_865 = 'A_865',
  /** 866x */
  A_866 = 'A_866',
  /** 867x */
  A_867 = 'A_867',
  /** 868x */
  A_868 = 'A_868',
  /** 869x */
  A_869 = 'A_869',
  /** 870x */
  A_870 = 'A_870',
  /** 871x */
  A_871 = 'A_871',
  /** 872x */
  A_872 = 'A_872',
  /** 873x */
  A_873 = 'A_873',
  /** 874x */
  A_874 = 'A_874',
  /** 875x */
  A_875 = 'A_875',
  /** 876x */
  A_876 = 'A_876',
  /** 877x */
  A_877 = 'A_877',
  /** 878x */
  A_878 = 'A_878',
  /** 879x */
  A_879 = 'A_879',
  /** 880x */
  A_880 = 'A_880',
  /** 881x */
  A_881 = 'A_881',
  /** 882x */
  A_882 = 'A_882',
  /** 883x */
  A_883 = 'A_883',
  /** 884x */
  A_884 = 'A_884',
  /** 885x */
  A_885 = 'A_885',
  /** 886x */
  A_886 = 'A_886',
  /** 887x */
  A_887 = 'A_887',
  /** 888x */
  A_888 = 'A_888',
  /** 889x */
  A_889 = 'A_889',
  /** 890x */
  A_890 = 'A_890',
  /** 891x */
  A_891 = 'A_891',
  /** 892x */
  A_892 = 'A_892',
  /** 893x */
  A_893 = 'A_893',
  /** 894x */
  A_894 = 'A_894',
  /** 895x */
  A_895 = 'A_895',
  /** 896x */
  A_896 = 'A_896',
  /** 897x */
  A_897 = 'A_897',
  /** 898x */
  A_898 = 'A_898',
  /** 899x */
  A_899 = 'A_899',
  /** 900x */
  A_900 = 'A_900',
  /** 901x */
  A_901 = 'A_901',
  /** 902x */
  A_902 = 'A_902',
  /** 903x */
  A_903 = 'A_903',
  /** 904x */
  A_904 = 'A_904',
  /** 905x */
  A_905 = 'A_905',
  /** 906x */
  A_906 = 'A_906',
  /** 907x */
  A_907 = 'A_907',
  /** 908x */
  A_908 = 'A_908',
  /** 909x */
  A_909 = 'A_909',
  /** 910x */
  A_910 = 'A_910',
  /** 911x */
  A_911 = 'A_911',
  /** 912x */
  A_912 = 'A_912',
  /** 913x */
  A_913 = 'A_913',
  /** 914x */
  A_914 = 'A_914',
  /** 915x */
  A_915 = 'A_915',
  /** 916x */
  A_916 = 'A_916',
  /** 917x */
  A_917 = 'A_917',
  /** 918x */
  A_918 = 'A_918',
  /** 919x */
  A_919 = 'A_919',
  /** 920x */
  A_920 = 'A_920',
  /** 921x */
  A_921 = 'A_921',
  /** 922x */
  A_922 = 'A_922',
  /** 923x */
  A_923 = 'A_923',
  /** 924x */
  A_924 = 'A_924',
  /** 925x */
  A_925 = 'A_925',
  /** 926x */
  A_926 = 'A_926',
  /** 927x */
  A_927 = 'A_927',
  /** 928x */
  A_928 = 'A_928',
  /** 929x */
  A_929 = 'A_929',
  /** 930x */
  A_930 = 'A_930',
  /** 931x */
  A_931 = 'A_931',
  /** 932x */
  A_932 = 'A_932',
  /** 933x */
  A_933 = 'A_933',
  /** 934x */
  A_934 = 'A_934',
  /** 935x */
  A_935 = 'A_935',
  /** 936x */
  A_936 = 'A_936',
  /** 937x */
  A_937 = 'A_937',
  /** 938x */
  A_938 = 'A_938',
  /** 939x */
  A_939 = 'A_939',
  /** 940x */
  A_940 = 'A_940',
  /** 941x */
  A_941 = 'A_941',
  /** 942x */
  A_942 = 'A_942',
  /** 943x */
  A_943 = 'A_943',
  /** 944x */
  A_944 = 'A_944',
  /** 945x */
  A_945 = 'A_945',
  /** 946x */
  A_946 = 'A_946',
  /** 947x */
  A_947 = 'A_947',
  /** 948x */
  A_948 = 'A_948',
  /** 949x */
  A_949 = 'A_949',
  /** 950x */
  A_950 = 'A_950',
  /** 951x */
  A_951 = 'A_951',
  /** 952x */
  A_952 = 'A_952',
  /** 953x */
  A_953 = 'A_953',
  /** 954x */
  A_954 = 'A_954',
  /** 955x */
  A_955 = 'A_955',
  /** 956x */
  A_956 = 'A_956',
  /** 957x */
  A_957 = 'A_957',
  /** 958x */
  A_958 = 'A_958',
  /** 959x */
  A_959 = 'A_959',
  /** 960x */
  A_960 = 'A_960',
  /** 961x */
  A_961 = 'A_961',
  /** 962x */
  A_962 = 'A_962',
  /** 963x */
  A_963 = 'A_963',
  /** 964x */
  A_964 = 'A_964',
  /** 965x */
  A_965 = 'A_965',
  /** 966x */
  A_966 = 'A_966',
  /** 967x */
  A_967 = 'A_967',
  /** 968x */
  A_968 = 'A_968',
  /** 969x */
  A_969 = 'A_969',
  /** 970x */
  A_970 = 'A_970',
  /** 971x */
  A_971 = 'A_971',
  /** 972x */
  A_972 = 'A_972',
  /** 973x */
  A_973 = 'A_973',
  /** 974x */
  A_974 = 'A_974',
  /** 975x */
  A_975 = 'A_975',
  /** 976x */
  A_976 = 'A_976',
  /** 977x */
  A_977 = 'A_977',
  /** 978x */
  A_978 = 'A_978',
  /** 979x */
  A_979 = 'A_979',
  /** 980x */
  A_980 = 'A_980',
  /** 981x */
  A_981 = 'A_981',
  /** 982x */
  A_982 = 'A_982',
  /** 983x */
  A_983 = 'A_983',
  /** 984x */
  A_984 = 'A_984',
  /** 985x */
  A_985 = 'A_985',
  /** 986x */
  A_986 = 'A_986',
  /** 987x */
  A_987 = 'A_987',
  /** 988x */
  A_988 = 'A_988',
  /** 989x */
  A_989 = 'A_989',
  /** 990x */
  A_990 = 'A_990',
  /** 991x */
  A_991 = 'A_991',
  /** 992x */
  A_992 = 'A_992',
  /** 993x */
  A_993 = 'A_993',
  /** 994x */
  A_994 = 'A_994',
  /** 995x */
  A_995 = 'A_995',
  /** 996x */
  A_996 = 'A_996',
  /** 997x */
  A_997 = 'A_997',
  /** 998x */
  A_998 = 'A_998',
  /** 999x */
  A_999 = 'A_999',
  /** 1000x */
  A_1000 = 'A_1000'
}

export type NsuRelatorioInput = {
  id?: Maybe<Scalars['Float']>,
  emprestimo_Entidade?: Maybe<Scalars['ID']>,
  emprestimo_Entidade_In?: Maybe<Scalars['ID']>,
  emprestimo_EntidadeId?: Maybe<Scalars['ID']>,
  emprestimo_EntidadeId_In?: Maybe<Scalars['ID']>,
  emprestimo_Id?: Maybe<Scalars['Float']>,
  nsuCv?: Maybe<Scalars['String']>,
  nsuCv_In?: Maybe<Scalars['String']>,
  valorNsuCv?: Maybe<Scalars['Float']>,
  valorNsuCv_In?: Maybe<Scalars['Float']>,
  emprestimo_ValorDesejado?: Maybe<Scalars['Float']>,
  emprestimo_ValorDesejado_In?: Maybe<Scalars['Float']>,
  emprestimo_TaxaAplicada?: Maybe<Scalars['Float']>,
  emprestimo_TaxaAplicada_In?: Maybe<Scalars['Float']>,
  emprestimo_Status?: Maybe<Scalars['String']>,
  emprestimo_Status_In?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['String']>,
  parcelas_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  /** Ordenando */
  orderBy?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
};

export type NsuRelatorioType = Node & {
   __typename?: 'NsuRelatorioType',
  /** The ID of the object. */
  id: Scalars['ID'],
  emprestimo: EmprestimoRelatorioType,
  bandeiraCartao?: Maybe<Scalars['String']>,
  nsuCv?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  valorNsuCv?: Maybe<Scalars['Float']>,
  idPagamento?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  nomeNoCartao?: Maybe<Scalars['String']>,
  validade?: Maybe<Scalars['DateTime']>,
  numeroCartao?: Maybe<Scalars['String']>,
  idPagcetoCartao?: Maybe<Scalars['String']>,
  pagcertoPagamentoPayload?: Maybe<Scalars['JSONString']>,
  maquinaOld?: Maybe<Scalars['String']>,
  maquina?: Maybe<MaquinaNode>,
  limiteMaquinaAlterado: Scalars['Boolean'],
  parcelas?: Maybe<NsuParcelas>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  titularDivergente?: Maybe<NsuTitularDivergenteType>,
  valorRetirado?: Maybe<Scalars['Decimal']>,
  valorPassado?: Maybe<Scalars['Decimal']>,
};

export type NsuRelatorioTypeConnection = {
   __typename?: 'NsuRelatorioTypeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NsuRelatorioTypeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `NsuRelatorioType` and its cursor. */
export type NsuRelatorioTypeEdge = {
   __typename?: 'NsuRelatorioTypeEdge',
  /** The item at the end of the edge */
  node?: Maybe<NsuRelatorioType>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type NsusAgregations = {
   __typename?: 'NsusAgregations',
  somaValoresPassados?: Maybe<Scalars['Decimal']>,
  somaValorRetirado?: Maybe<Scalars['Decimal']>,
  taxaMediaTotal?: Maybe<Scalars['Decimal']>,
};

export type NsuTitularDivergenteType = {
   __typename?: 'NsuTitularDivergenteType',
  id: Scalars['ID'],
  nsu: NsuRelatorioType,
  nome: Scalars['String'],
  anexoCpf: Scalars['String'],
  anexoRg: Scalars['String'],
  cpf: Scalars['String'],
  rg?: Maybe<Scalars['String']>,
  cep: Scalars['String'],
  endereco: Scalars['String'],
  complemento: Scalars['String'],
  bairro: Scalars['String'],
  municipio: Scalars['String'],
  uf: Scalars['String'],
  pais: Scalars['String'],
  comprovanteEndereco?: Maybe<Scalars['String']>,
};

export type NsuType = {
   __typename?: 'NsuType',
  id: Scalars['ID'],
  emprestimo: EmprestimoRelatorioType,
  bandeiraCartao?: Maybe<Scalars['String']>,
  nsuCv?: Maybe<Scalars['String']>,
  anexoNsuCartao?: Maybe<Scalars['String']>,
  valorNsuCv?: Maybe<Scalars['Float']>,
  idPagamento?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  nomeNoCartao?: Maybe<Scalars['String']>,
  validade?: Maybe<Scalars['DateTime']>,
  numeroCartao?: Maybe<Scalars['String']>,
  idPagcetoCartao?: Maybe<Scalars['String']>,
  pagcertoPagamentoPayload?: Maybe<Scalars['JSONString']>,
  maquinaOld?: Maybe<Scalars['String']>,
  maquina?: Maybe<MaquinaNode>,
  limiteMaquinaAlterado: Scalars['Boolean'],
  parcelas?: Maybe<NsuParcelas>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  titularDivergente?: Maybe<NsuTitularDivergenteType>,
  numeroMascara?: Maybe<Scalars['String']>,
};

export type OcorrenciaComMaquinaNode = Node & {
   __typename?: 'OcorrenciaComMaquinaNode',
  /** The ID of the object. */
  id: Scalars['ID'],
  maquina: MaquinaNode,
  funcionario: FuncionarioTypeRelay,
  dataHora: Scalars['DateTime'],
  tipo: OcorrenciaComMaquinaTipo,
  entidade?: Maybe<EntidadeTypeRelay>,
  entidadeAnterior?: Maybe<EntidadeTypeRelay>,
  detalhamento?: Maybe<Scalars['String']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
};

export type OcorrenciaComMaquinaNodeConnection = {
   __typename?: 'OcorrenciaComMaquinaNodeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OcorrenciaComMaquinaNodeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `OcorrenciaComMaquinaNode` and its cursor. */
export type OcorrenciaComMaquinaNodeEdge = {
   __typename?: 'OcorrenciaComMaquinaNodeEdge',
  /** The item at the end of the edge */
  node?: Maybe<OcorrenciaComMaquinaNode>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum OcorrenciaComMaquinaTipo {
  /** Habilitar */
  Habilitar = 'HABILITAR',
  /** Desabilitar */
  Desabilitar = 'DESABILITAR',
  /** Bloquear */
  Bloquear = 'BLOQUEAR',
  /** Desbloquear */
  Desbloquear = 'DESBLOQUEAR',
  /** Reportar Problema */
  ReportarProblema = 'REPORTAR_PROBLEMA'
}

export type OrigensMetasDash = {
   __typename?: 'OrigensMetasDash',
  id?: Maybe<Scalars['String']>,
  label?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['Decimal']>,
};

export type OrigensType = {
   __typename?: 'OrigensType',
  id: Scalars['ID'],
  origem: Scalars['String'],
  excluido: Scalars['Boolean'],
};

export type PagarContaAPagarMutation = {
   __typename?: 'PagarContaAPagarMutation',
  ok?: Maybe<Scalars['Boolean']>,
  recorrenciaAtualizada?: Maybe<ContaAPagarNode>,
  contaPagar?: Maybe<ContaAPagarNode>,
};

export type PagarEmprestimoMutation = {
   __typename?: 'PagarEmprestimoMutation',
  ok?: Maybe<Scalars['Boolean']>,
  emprestimo?: Maybe<EmprestimoNode>,
};

export type PagarPedidoDeReembolsoMutation = {
   __typename?: 'PagarPedidoDeReembolsoMutation',
  ok?: Maybe<Scalars['Boolean']>,
  pedidoReembolso?: Maybe<PedidoDeReembolsoNode>,
};

export type PagcertoCreditCardPayloadType = {
   __typename?: 'PagcertoCreditCardPayloadType',
  id?: Maybe<Scalars['String']>,
  holderName?: Maybe<Scalars['String']>,
  number?: Maybe<Scalars['String']>,
  brand?: Maybe<Scalars['String']>,
  expirationMonth?: Maybe<Scalars['Int']>,
  expirationYear?: Maybe<Scalars['Int']>,
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
   __typename?: 'PageInfo',
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'],
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'],
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>,
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>,
};

/** An enumeration. */
export enum ParceirosDiasRepasse {
  /** 0 */
  D_0 = 'D_0',
  /** 1 */
  D_1 = 'D_1',
  /** 2 */
  D_2 = 'D_2',
  /** 14 */
  D_14 = 'D_14',
  /** 20 */
  D_20 = 'D_20',
  /** 30 */
  D_30 = 'D_30'
}

export type ParceirosNodeTypeRelay = Node & {
   __typename?: 'ParceirosNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  lojaRepasse?: Maybe<EntidadeTypeRelay>,
  diasRepasse: ParceirosDiasRepasse,
  funcionario: FuncionarioTypeRelay,
  funcionariosPermitidos: FuncionarioTypeRelayConnection,
  gruposPermitidos: GrupoDePermissoesTypeRelayConnection,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  tabela?: Maybe<TabelasNodeTypeRelay>,
  idsLojas?: Maybe<Array<Scalars['Int']>>,
  gruposDePermissoes: GrupoDePermissoesTypeRelayConnection,
  lojaparceiroSet: Array<LojaParceiroType>,
  contaparceirosSet: Array<ContaParceirosType>,
  resgateparceiroSet: HistoricoResgateNodeTypeRelayConnection,
  resgateautomaticoparceiros?: Maybe<ResgateAutomaticoParceirosType>,
  comissaoparceirosSet: ComissaoNodeTypeRelayConnection,
};


export type ParceirosNodeTypeRelayFuncionariosPermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  categoria?: Maybe<Scalars['String']>,
  tipoFuncionario_Nome?: Maybe<Scalars['String']>,
  tipoContrato?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_Icontains?: Maybe<Scalars['String']>,
  cpf?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  user_IsActive?: Maybe<Scalars['Boolean']>,
  orderBy?: Maybe<Scalars['String']>
};


export type ParceirosNodeTypeRelayGruposPermitidosArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Id?: Maybe<Scalars['ID']>,
  entidade_Entidade_Nome?: Maybe<Scalars['String']>,
  entidade_Entidade_Nome_Icontains?: Maybe<Scalars['String']>,
  entidade_Entidade_Id?: Maybe<Scalars['ID']>,
  permissao_Descricao?: Maybe<Scalars['String']>,
  permissao_Descricao_Icontains?: Maybe<Scalars['String']>,
  permissao_Descricao_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type ParceirosNodeTypeRelayGruposDePermissoesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Id?: Maybe<Scalars['ID']>,
  entidade_Entidade_Nome?: Maybe<Scalars['String']>,
  entidade_Entidade_Nome_Icontains?: Maybe<Scalars['String']>,
  entidade_Entidade_Id?: Maybe<Scalars['ID']>,
  permissao_Descricao?: Maybe<Scalars['String']>,
  permissao_Descricao_Icontains?: Maybe<Scalars['String']>,
  permissao_Descricao_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type ParceirosNodeTypeRelayResgateparceiroSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  valorResgate?: Maybe<Scalars['Float']>,
  valorResgate_Icontains?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  parceiroId_In?: Maybe<Scalars['String']>,
  conta_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type ParceirosNodeTypeRelayComissaoparceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Nsu_Parcelas?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_In?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_Iexact?: Maybe<Scalars['String']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  dataRepasse?: Maybe<Scalars['Date']>,
  dataRepasse_Gte?: Maybe<Scalars['Date']>,
  dataRepasse_Gt?: Maybe<Scalars['Date']>,
  dataRepasse_Lt?: Maybe<Scalars['Date']>,
  dataRepasse_Lte?: Maybe<Scalars['Date']>,
  emprestimo_CriadoEm?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gte?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lte?: Maybe<Scalars['DateTime']>,
  emprestimo_Data?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gte?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lte?: Maybe<Scalars['Date']>,
  valorComissao?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};

export type ParceirosNodeTypeRelayConnection = {
   __typename?: 'ParceirosNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ParceirosNodeTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `ParceirosNodeTypeRelay` and its cursor. */
export type ParceirosNodeTypeRelayEdge = {
   __typename?: 'ParceirosNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<ParceirosNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type ParceirosType = {
   __typename?: 'ParceirosType',
  id: Scalars['ID'],
  nome: Scalars['String'],
  lojaRepasse?: Maybe<EntidadeTypeRelay>,
  diasRepasse: ParceirosDiasRepasse,
  funcionario: FuncionarioTypeRelay,
  funcionariosPermitidos?: Maybe<Array<Maybe<FuncionarioType>>>,
  gruposPermitidos?: Maybe<Array<Maybe<GrupoDePermissoesType>>>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  tabela?: Maybe<TabelasNodeTypeRelay>,
  idsLojas?: Maybe<Array<Scalars['Int']>>,
  gruposDePermissoes?: Maybe<Array<Maybe<GrupoDePermissoesType>>>,
  lojaparceiroSet: Array<LojaParceiroType>,
  contaparceirosSet: Array<ContaParceirosType>,
  resgateparceiroSet: HistoricoResgateNodeTypeRelayConnection,
  resgateautomaticoparceiros?: Maybe<ResgateAutomaticoParceirosType>,
  comissaoparceirosSet: ComissaoNodeTypeRelayConnection,
};


export type ParceirosTypeResgateparceiroSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  valorResgate?: Maybe<Scalars['Float']>,
  valorResgate_Icontains?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  parceiroId_In?: Maybe<Scalars['String']>,
  conta_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type ParceirosTypeComissaoparceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Nsu_Parcelas?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_In?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_Iexact?: Maybe<Scalars['String']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  dataRepasse?: Maybe<Scalars['Date']>,
  dataRepasse_Gte?: Maybe<Scalars['Date']>,
  dataRepasse_Gt?: Maybe<Scalars['Date']>,
  dataRepasse_Lt?: Maybe<Scalars['Date']>,
  dataRepasse_Lte?: Maybe<Scalars['Date']>,
  emprestimo_CriadoEm?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gte?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lte?: Maybe<Scalars['DateTime']>,
  emprestimo_Data?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gte?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lte?: Maybe<Scalars['Date']>,
  valorComissao?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};

export type ParceirosTypeInput = {
  nome?: Maybe<Scalars['String']>,
  idParceiro?: Maybe<Scalars['ID']>,
  idFuncionario: Scalars['ID'],
  idLojaRepasse: Scalars['ID'],
  diasRepasse?: Maybe<Scalars['String']>,
};

export type ParcelasMetasDash = {
   __typename?: 'ParcelasMetasDash',
  id?: Maybe<Scalars['String']>,
  label?: Maybe<Scalars['String']>,
  value?: Maybe<Scalars['Decimal']>,
};

export type PausarLead = {
   __typename?: 'PausarLead',
  lead?: Maybe<LeadsType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type PedidoDeReembolsoNode = Node & {
   __typename?: 'PedidoDeReembolsoNode',
  /** The ID of the object. */
  id: Scalars['ID'],
  entidade?: Maybe<EntidadeTypeRelay>,
  funcionario: FuncionarioTypeRelay,
  descricao: Scalars['String'],
  data: Scalars['DateTime'],
  valor: Scalars['Float'],
  categoria: Scalars['String'],
  status: PedidoDeReembolsoStatus,
  tipoDespesa?: Maybe<PedidoDeReembolsoTipoDespesa>,
  nome: Scalars['String'],
  tipoPix: Scalars['String'],
  pix: Scalars['String'],
  banco: Scalars['String'],
  agencia: Scalars['String'],
  tipoConta: PedidoDeReembolsoTipoConta,
  conta: Scalars['String'],
  variacao?: Maybe<Scalars['String']>,
  cpfCnpj: Scalars['String'],
  justificativaCancelamento?: Maybe<Scalars['String']>,
  anexoPagamento?: Maybe<Scalars['String']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  anexos: Array<AnexoDePedidoDeReembolsoType>,
};

export type PedidoDeReembolsoNodeConnection = {
   __typename?: 'PedidoDeReembolsoNodeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PedidoDeReembolsoNodeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `PedidoDeReembolsoNode` and its cursor. */
export type PedidoDeReembolsoNodeEdge = {
   __typename?: 'PedidoDeReembolsoNodeEdge',
  /** The item at the end of the edge */
  node?: Maybe<PedidoDeReembolsoNode>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum PedidoDeReembolsoStatus {
  /** Pendente */
  Pendente = 'PENDENTE',
  /** Aprovado */
  Aprovado = 'APROVADO',
  /** Reprovado */
  Reprovado = 'REPROVADO',
  /** Pago */
  Pago = 'PAGO',
  /** Vencido */
  Vencido = 'VENCIDO',
  /** Cancelado */
  Cancelado = 'CANCELADO',
  /** Informações Incompletas */
  InformacoesIncompletas = 'INFORMACOES_INCOMPLETAS'
}

/** An enumeration. */
export enum PedidoDeReembolsoTipoConta {
  /** Corrente */
  Corrente = 'CORRENTE',
  /** Poupança */
  Poupanca = 'POUPANCA',
  /** Fácil */
  Facil = 'FACIL'
}

/** An enumeration. */
export enum PedidoDeReembolsoTipoDespesa {
  /** Fixa */
  Fixa = 'FIXA',
  /** Variável */
  Variavel = 'VARIAVEL'
}

export type PerdaLead = {
   __typename?: 'PerdaLead',
  lead?: Maybe<LeadsType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type PerformanceMetaType = {
   __typename?: 'PerformanceMetaType',
  valorMetaDiaria?: Maybe<Scalars['Decimal']>,
  valorAlcancadoMetaDiaria?: Maybe<Scalars['Decimal']>,
  valorFaltaMetaDiaria?: Maybe<Scalars['Decimal']>,
  valorMetaGeral?: Maybe<Scalars['Decimal']>,
  valorAlcancadoMetaGeral?: Maybe<Scalars['Decimal']>,
  valorFaltaMetaGeral?: Maybe<Scalars['Decimal']>,
  statusSaudeGeral?: Maybe<Scalars['String']>,
  statusSaudeDiaria?: Maybe<Scalars['String']>,
};

/** An enumeration. */
export enum PermissaoDeGrupoDescricao {
  /** VER BOT ZEKI */
  VerBotZeki = 'VER_BOT_ZEKI',
  /** EDITAR BOT ZEKI */
  EditarBotZeki = 'EDITAR_BOT_ZEKI',
  /** Ver Entidade */
  VerEntidade = 'VER_ENTIDADE',
  /** Criar Entidade */
  CriarEntidade = 'CRIAR_ENTIDADE',
  /** Editar Entidade */
  EditarEntidade = 'EDITAR_ENTIDADE',
  /** Excluir Entidade */
  ExcluirEntidade = 'EXCLUIR_ENTIDADE',
  /** Definir Taxa de segurança da Entidade */
  DefinirTaxaSegurancaEntidade = 'DEFINIR_TAXA_SEGURANCA_ENTIDADE',
  /** Definir Taxa mínima da Entidade */
  DefinirTaxaMinimaEntidade = 'DEFINIR_TAXA_MINIMA_ENTIDADE',
  /** Definir Taxa de lucratividade da Entidade */
  DefinirTaxaLucroEntidade = 'DEFINIR_TAXA_LUCRO_ENTIDADE',
  /** Ver Funcionário */
  VerFuncionario = 'VER_FUNCIONARIO',
  /** Criar Funcionário */
  CriarFuncionario = 'CRIAR_FUNCIONARIO',
  /** Editar Funcionário */
  EditarFuncionario = 'EDITAR_FUNCIONARIO',
  /** Excluir Funcionário */
  ExcluirFuncionario = 'EXCLUIR_FUNCIONARIO',
  /** Bloquear Funcionário */
  BloquearFuncionario = 'BLOQUEAR_FUNCIONARIO',
  /** Desbloquear Funcionário */
  DesbloquearFuncionario = 'DESBLOQUEAR_FUNCIONARIO',
  /** Ver Cliente */
  VerCliente = 'VER_CLIENTE',
  /** Criar Cliente */
  CriarCliente = 'CRIAR_CLIENTE',
  /** Editar Cliente */
  EditarCliente = 'EDITAR_CLIENTE',
  /** Ver Somatório de Empréstimos cliente */
  VerSomatorioEmprestimoCliente = 'VER_SOMATORIO_EMPRESTIMO_CLIENTE',
  /** Ver Pedido de Reembolso */
  VerPedidoReembolso = 'VER_PEDIDO_REEMBOLSO',
  /** Criar Pedido de Reembolso */
  CriarPedidoReembolso = 'CRIAR_PEDIDO_REEMBOLSO',
  /** Editar Pedido de Reembolso */
  EditarPedidoReembolso = 'EDITAR_PEDIDO_REEMBOLSO',
  /** Excluir Pedido de Reembolso */
  ExcluirPedidoReembolso = 'EXCLUIR_PEDIDO_REEMBOLSO',
  /** Aprovar Pedido de Reembolso */
  AprovarPedidoReembolso = 'APROVAR_PEDIDO_REEMBOLSO',
  /** Pagar Pedido de Reembolso */
  PagarPedidoReembolso = 'PAGAR_PEDIDO_REEMBOLSO',
  /** Ver Conta a Pagar */
  VerContaPagar = 'VER_CONTA_PAGAR',
  /** Criar Conta a Pagar */
  CriarContaPagar = 'CRIAR_CONTA_PAGAR',
  /** Editar Conta a Pagar */
  EditarContaPagar = 'EDITAR_CONTA_PAGAR',
  /** Editar a Loja da Conta a Pagar */
  EditarLojaContaPagar = 'EDITAR_LOJA_CONTA_PAGAR',
  /** Excluir Conta a Pagar */
  ExcluirContaPagar = 'EXCLUIR_CONTA_PAGAR',
  /** Aprovar Conta a Pagar */
  AprovarContaPagar = 'APROVAR_CONTA_PAGAR',
  /** Pagar Conta a Pagar */
  PagarContaPagar = 'PAGAR_CONTA_PAGAR',
  /** Ver Empréstimo */
  VerEmprestimo = 'VER_EMPRESTIMO',
  /** Criar Empréstimo */
  CriarEmprestimo = 'CRIAR_EMPRESTIMO',
  /** Editar Empréstimo */
  EditarEmprestimo = 'EDITAR_EMPRESTIMO',
  /** Simular Empréstimo */
  SimularEmprestimo = 'SIMULAR_EMPRESTIMO',
  /** Usar simulação bonificada de empréstimo */
  SimulacaoBonificadaEmprestimo = 'SIMULACAO_BONIFICADA_EMPRESTIMO',
  /** Aprovar Empréstimo */
  AprovarEmprestimo = 'APROVAR_EMPRESTIMO',
  /** Pagar Empréstimo */
  PagarEmprestimo = 'PAGAR_EMPRESTIMO',
  /** Editar Empréstimo pago */
  EditarStatuspagoEmprestimo = 'EDITAR_STATUSPAGO_EMPRESTIMO',
  /** Criar Empréstimo por Tipo */
  CriarEmprestimoPorTipo = 'CRIAR_EMPRESTIMO_POR_TIPO',
  /** Editar Empréstimo por Tipo */
  EditarEmprestimoPorTipo = 'EDITAR_EMPRESTIMO_POR_TIPO',
  /** Pagar Empréstimo por Tipo */
  PagarEmprestimoPorTipo = 'PAGAR_EMPRESTIMO_POR_TIPO',
  /** Aprovar Empréstimo por Tipo */
  AprovarEmprestimoPorTipo = 'APROVAR_EMPRESTIMO_POR_TIPO',
  /** Ver Empréstimo por Tipo */
  VerEmprestimoPorTipo = 'VER_EMPRESTIMO_POR_TIPO',
  /** Ver Grupo de Permissões */
  VerGrupoPermissoes = 'VER_GRUPO_PERMISSOES',
  /** Criar Grupo de Permissões */
  CriarGrupoPermissoes = 'CRIAR_GRUPO_PERMISSOES',
  /** Editar Grupo de Permissões */
  EditarGrupoPermissoes = 'EDITAR_GRUPO_PERMISSOES',
  /** Excluir Grupo de Permissões */
  ExcluirGrupoPermissoes = 'EXCLUIR_GRUPO_PERMISSOES',
  /** Ver Máquina */
  VerMaquina = 'VER_MAQUINA',
  /** Criar Máquina */
  CriarMaquina = 'CRIAR_MAQUINA',
  /** Editar Máquina */
  EditarMaquina = 'EDITAR_MAQUINA',
  /** Habilitar Máquina */
  HabilitarMaquina = 'HABILITAR_MAQUINA',
  /** Bloquear Máquina */
  BloquearMaquina = 'BLOQUEAR_MAQUINA',
  /** Fechamento de Caixa Relatório */
  FechamentoCaixaRelatorio = 'FECHAMENTO_CAIXA_RELATORIO',
  /** Exibir somatório repasse parceiro */
  SomatorioRepasseEmprestimoRelatorio = 'SOMATORIO_REPASSE_EMPRESTIMO_RELATORIO',
  /** Pedido de Reembolso Relatório */
  PedidoReembolsoRelatorio = 'PEDIDO_REEMBOLSO_RELATORIO',
  /** Conta a Pagar Relatório */
  ContaPagarRelatorio = 'CONTA_PAGAR_RELATORIO',
  /** Lead Relatório */
  LeadRelatorio = 'LEAD_RELATORIO',
  /** Lead Relatório Marketing */
  LeadMarketingRelatorio = 'LEAD_MARKETING_RELATORIO',
  /** Cards Lead Relatório Marketing */
  CardsLeadMarketingRelatorio = 'CARDS_LEAD_MARKETING_RELATORIO',
  /** NSU Relatório */
  NsuRelatorio = 'NSU_RELATORIO',
  /** Cliente Relatório */
  ClienteRelatorio = 'CLIENTE_RELATORIO',
  /** Empréstimo Cliente Relatório */
  EmprestimoClienteRelatorio = 'EMPRESTIMO_CLIENTE_RELATORIO',
  /** Bônus Funcionário Relatório */
  BonusFuncionarioRelatorio = 'BONUS_FUNCIONARIO_RELATORIO',
  /** Ver Meta */
  VerMeta = 'VER_META',
  /** Criar Meta */
  CriarMeta = 'CRIAR_META',
  /** Editar Meta */
  EditarMeta = 'EDITAR_META',
  /** Excluir Meta */
  ExcluirMeta = 'EXCLUIR_META',
  /** Dashboard de Metas */
  DashboardMeta = 'DASHBOARD_META',
  /** Criar Leads */
  CriarLeads = 'CRIAR_LEADS',
  /** Ver Leads */
  VerLeads = 'VER_LEADS',
  /** Editar Leads */
  EditarLeads = 'EDITAR_LEADS',
  /** Gerenciar Leads */
  GerenciarLeads = 'GERENCIAR_LEADS',
  /** Ver Tarefas */
  VerTarefas = 'VER_TAREFAS',
  /** Criar Tarefas */
  CriarTarefas = 'CRIAR_TAREFAS',
  /** Editar Tarefas */
  EditarTarefas = 'EDITAR_TAREFAS',
  /** Excluir Tarefas */
  ExcluirTarefas = 'EXCLUIR_TAREFAS',
  /** Ver Histórico e Anotações */
  VerAnotacoesHistorico = 'VER_ANOTACOES_HISTORICO',
  /** Criar Anotações */
  CriarAnotacoesHistorico = 'CRIAR_ANOTACOES_HISTORICO',
  /** Editar Anotações */
  EditarAnotacoesHistorico = 'EDITAR_ANOTACOES_HISTORICO',
  /** Excluir Anotações */
  ExcluirAnotacoesHistorico = 'EXCLUIR_ANOTACOES_HISTORICO',
  /** Ver parceiro */
  VerParceiro = 'VER_PARCEIRO',
  /** Criar parceiro */
  CriarParceiro = 'CRIAR_PARCEIRO',
  /** Editar parceiro */
  EditarParceiro = 'EDITAR_PARCEIRO',
  /** Ver tabela */
  VerTabelaParceiro = 'VER_TABELA_PARCEIRO',
  /** Criar tabela */
  CriarTabelaParceiro = 'CRIAR_TABELA_PARCEIRO',
  /** Editar tabela */
  EditarTabelaParceiro = 'EDITAR_TABELA_PARCEIRO',
  /** Dashboard parceiro */
  DashboardParceiro = 'DASHBOARD_PARCEIRO',
  /** Dashboard funcionario */
  DashboardFuncionarioParceiro = 'DASHBOARD_FUNCIONARIO_PARCEIRO',
  /** Solicitar Resgate */
  SolicitarResgateParceiro = 'SOLICITAR_RESGATE_PARCEIRO',
  /** Histórico de Resgate */
  HistoricoResgateParceiro = 'HISTORICO_RESGATE_PARCEIRO',
  /** Ver funcionários repasse */
  VerFuncionariosRepasseParceiro = 'VER_FUNCIONARIOS_REPASSE_PARCEIRO',
  /** Criar funcionários repasse */
  CriarFuncionariosRepasseParceiro = 'CRIAR_FUNCIONARIOS_REPASSE_PARCEIRO',
  /** Editar funcionários repasse */
  EditarFuncionariosRepasseParceiro = 'EDITAR_FUNCIONARIOS_REPASSE_PARCEIRO',
  /** Histórico de resgate de Funcionário */
  HistoricoResgateFuncionarioParceiro = 'HISTORICO_RESGATE_FUNCIONARIO_PARCEIRO',
  /** Ver mensagem */
  VerMensagemSms = 'VER_MENSAGEM_SMS',
  /** Criar mensagem */
  CriarMensagemSms = 'CRIAR_MENSAGEM_SMS',
  /** Ver lista sms */
  VerListaSms = 'VER_LISTA_SMS',
  /** Criar lista */
  CriarListaSms = 'CRIAR_LISTA_SMS',
  /** Editar lista */
  EditarListaSms = 'EDITAR_LISTA_SMS',
  /** Excluir lista */
  ExcluirListaSms = 'EXCLUIR_LISTA_SMS',
  /** Ver envios */
  VerEnviosSms = 'VER_ENVIOS_SMS',
  /** Criar envios */
  CriarEnviosSms = 'CRIAR_ENVIOS_SMS',
  /** Criar envios email */
  CriarEnviosEmail = 'CRIAR_ENVIOS_EMAIL',
  /** Dashboard envios */
  DashboardEnviosSms = 'DASHBOARD_ENVIOS_SMS',
  /** SMS Relatório */
  SmsRelatorio = 'SMS_RELATORIO',
  /** Comissão Funcionário Relatório */
  ComissaoFuncionarioRelatorio = 'COMISSAO_FUNCIONARIO_RELATORIO',
  /** Regramento entidade */
  RegramentoEntidadeConfiguracoes = 'REGRAMENTO_ENTIDADE_CONFIGURACOES',
  /** Criar Fornecedor */
  CriarFornecedor = 'CRIAR_FORNECEDOR',
  /** Ver Fornecedor */
  VerFornecedor = 'VER_FORNECEDOR',
  /** Editar Fornecedor */
  EditarFornecedor = 'EDITAR_FORNECEDOR',
  /** Ver Tipo de Empréstimo */
  VerTipoEmprestimo = 'VER_TIPO_EMPRESTIMO',
  /** Criar Tipo de Empréstimo */
  CriarTipoEmprestimo = 'CRIAR_TIPO_EMPRESTIMO',
  /** Editar Tipo de Empréstimo */
  EditarTipoEmprestimo = 'EDITAR_TIPO_EMPRESTIMO',
  /** Alterar Status do Tipo de Empréstimo */
  AlterarStatusTipoEmprestimo = 'ALTERAR_STATUS_TIPO_EMPRESTIMO'
}

export type PermissaoDeGrupoType = {
   __typename?: 'PermissaoDeGrupoType',
  id: Scalars['ID'],
  grupo: GrupoDePermissoesTypeRelay,
  descricao: PermissaoDeGrupoDescricao,
};

/** An enumeration. */
export enum PermissaoDescricao {
  /** VER BOT ZEKI */
  VerBotZeki = 'VER_BOT_ZEKI',
  /** EDITAR BOT ZEKI */
  EditarBotZeki = 'EDITAR_BOT_ZEKI',
  /** Ver Entidade */
  VerEntidade = 'VER_ENTIDADE',
  /** Criar Entidade */
  CriarEntidade = 'CRIAR_ENTIDADE',
  /** Editar Entidade */
  EditarEntidade = 'EDITAR_ENTIDADE',
  /** Excluir Entidade */
  ExcluirEntidade = 'EXCLUIR_ENTIDADE',
  /** Definir Taxa de segurança da Entidade */
  DefinirTaxaSegurancaEntidade = 'DEFINIR_TAXA_SEGURANCA_ENTIDADE',
  /** Definir Taxa mínima da Entidade */
  DefinirTaxaMinimaEntidade = 'DEFINIR_TAXA_MINIMA_ENTIDADE',
  /** Definir Taxa de lucratividade da Entidade */
  DefinirTaxaLucroEntidade = 'DEFINIR_TAXA_LUCRO_ENTIDADE',
  /** Ver Funcionário */
  VerFuncionario = 'VER_FUNCIONARIO',
  /** Criar Funcionário */
  CriarFuncionario = 'CRIAR_FUNCIONARIO',
  /** Editar Funcionário */
  EditarFuncionario = 'EDITAR_FUNCIONARIO',
  /** Excluir Funcionário */
  ExcluirFuncionario = 'EXCLUIR_FUNCIONARIO',
  /** Bloquear Funcionário */
  BloquearFuncionario = 'BLOQUEAR_FUNCIONARIO',
  /** Desbloquear Funcionário */
  DesbloquearFuncionario = 'DESBLOQUEAR_FUNCIONARIO',
  /** Ver Cliente */
  VerCliente = 'VER_CLIENTE',
  /** Criar Cliente */
  CriarCliente = 'CRIAR_CLIENTE',
  /** Editar Cliente */
  EditarCliente = 'EDITAR_CLIENTE',
  /** Ver Somatório de Empréstimos cliente */
  VerSomatorioEmprestimoCliente = 'VER_SOMATORIO_EMPRESTIMO_CLIENTE',
  /** Ver Pedido de Reembolso */
  VerPedidoReembolso = 'VER_PEDIDO_REEMBOLSO',
  /** Criar Pedido de Reembolso */
  CriarPedidoReembolso = 'CRIAR_PEDIDO_REEMBOLSO',
  /** Editar Pedido de Reembolso */
  EditarPedidoReembolso = 'EDITAR_PEDIDO_REEMBOLSO',
  /** Excluir Pedido de Reembolso */
  ExcluirPedidoReembolso = 'EXCLUIR_PEDIDO_REEMBOLSO',
  /** Aprovar Pedido de Reembolso */
  AprovarPedidoReembolso = 'APROVAR_PEDIDO_REEMBOLSO',
  /** Pagar Pedido de Reembolso */
  PagarPedidoReembolso = 'PAGAR_PEDIDO_REEMBOLSO',
  /** Ver Conta a Pagar */
  VerContaPagar = 'VER_CONTA_PAGAR',
  /** Criar Conta a Pagar */
  CriarContaPagar = 'CRIAR_CONTA_PAGAR',
  /** Editar Conta a Pagar */
  EditarContaPagar = 'EDITAR_CONTA_PAGAR',
  /** Editar a Loja da Conta a Pagar */
  EditarLojaContaPagar = 'EDITAR_LOJA_CONTA_PAGAR',
  /** Excluir Conta a Pagar */
  ExcluirContaPagar = 'EXCLUIR_CONTA_PAGAR',
  /** Aprovar Conta a Pagar */
  AprovarContaPagar = 'APROVAR_CONTA_PAGAR',
  /** Pagar Conta a Pagar */
  PagarContaPagar = 'PAGAR_CONTA_PAGAR',
  /** Ver Empréstimo */
  VerEmprestimo = 'VER_EMPRESTIMO',
  /** Criar Empréstimo */
  CriarEmprestimo = 'CRIAR_EMPRESTIMO',
  /** Editar Empréstimo */
  EditarEmprestimo = 'EDITAR_EMPRESTIMO',
  /** Simular Empréstimo */
  SimularEmprestimo = 'SIMULAR_EMPRESTIMO',
  /** Usar simulação bonificada de empréstimo */
  SimulacaoBonificadaEmprestimo = 'SIMULACAO_BONIFICADA_EMPRESTIMO',
  /** Aprovar Empréstimo */
  AprovarEmprestimo = 'APROVAR_EMPRESTIMO',
  /** Pagar Empréstimo */
  PagarEmprestimo = 'PAGAR_EMPRESTIMO',
  /** Editar Empréstimo pago */
  EditarStatuspagoEmprestimo = 'EDITAR_STATUSPAGO_EMPRESTIMO',
  /** Criar Empréstimo por Tipo */
  CriarEmprestimoPorTipo = 'CRIAR_EMPRESTIMO_POR_TIPO',
  /** Editar Empréstimo por Tipo */
  EditarEmprestimoPorTipo = 'EDITAR_EMPRESTIMO_POR_TIPO',
  /** Pagar Empréstimo por Tipo */
  PagarEmprestimoPorTipo = 'PAGAR_EMPRESTIMO_POR_TIPO',
  /** Aprovar Empréstimo por Tipo */
  AprovarEmprestimoPorTipo = 'APROVAR_EMPRESTIMO_POR_TIPO',
  /** Ver Empréstimo por Tipo */
  VerEmprestimoPorTipo = 'VER_EMPRESTIMO_POR_TIPO',
  /** Ver Grupo de Permissões */
  VerGrupoPermissoes = 'VER_GRUPO_PERMISSOES',
  /** Criar Grupo de Permissões */
  CriarGrupoPermissoes = 'CRIAR_GRUPO_PERMISSOES',
  /** Editar Grupo de Permissões */
  EditarGrupoPermissoes = 'EDITAR_GRUPO_PERMISSOES',
  /** Excluir Grupo de Permissões */
  ExcluirGrupoPermissoes = 'EXCLUIR_GRUPO_PERMISSOES',
  /** Ver Máquina */
  VerMaquina = 'VER_MAQUINA',
  /** Criar Máquina */
  CriarMaquina = 'CRIAR_MAQUINA',
  /** Editar Máquina */
  EditarMaquina = 'EDITAR_MAQUINA',
  /** Habilitar Máquina */
  HabilitarMaquina = 'HABILITAR_MAQUINA',
  /** Bloquear Máquina */
  BloquearMaquina = 'BLOQUEAR_MAQUINA',
  /** Fechamento de Caixa Relatório */
  FechamentoCaixaRelatorio = 'FECHAMENTO_CAIXA_RELATORIO',
  /** Exibir somatório repasse parceiro */
  SomatorioRepasseEmprestimoRelatorio = 'SOMATORIO_REPASSE_EMPRESTIMO_RELATORIO',
  /** Pedido de Reembolso Relatório */
  PedidoReembolsoRelatorio = 'PEDIDO_REEMBOLSO_RELATORIO',
  /** Conta a Pagar Relatório */
  ContaPagarRelatorio = 'CONTA_PAGAR_RELATORIO',
  /** Lead Relatório */
  LeadRelatorio = 'LEAD_RELATORIO',
  /** Lead Relatório Marketing */
  LeadMarketingRelatorio = 'LEAD_MARKETING_RELATORIO',
  /** Cards Lead Relatório Marketing */
  CardsLeadMarketingRelatorio = 'CARDS_LEAD_MARKETING_RELATORIO',
  /** NSU Relatório */
  NsuRelatorio = 'NSU_RELATORIO',
  /** Cliente Relatório */
  ClienteRelatorio = 'CLIENTE_RELATORIO',
  /** Empréstimo Cliente Relatório */
  EmprestimoClienteRelatorio = 'EMPRESTIMO_CLIENTE_RELATORIO',
  /** Bônus Funcionário Relatório */
  BonusFuncionarioRelatorio = 'BONUS_FUNCIONARIO_RELATORIO',
  /** Ver Meta */
  VerMeta = 'VER_META',
  /** Criar Meta */
  CriarMeta = 'CRIAR_META',
  /** Editar Meta */
  EditarMeta = 'EDITAR_META',
  /** Excluir Meta */
  ExcluirMeta = 'EXCLUIR_META',
  /** Dashboard de Metas */
  DashboardMeta = 'DASHBOARD_META',
  /** Criar Leads */
  CriarLeads = 'CRIAR_LEADS',
  /** Ver Leads */
  VerLeads = 'VER_LEADS',
  /** Editar Leads */
  EditarLeads = 'EDITAR_LEADS',
  /** Gerenciar Leads */
  GerenciarLeads = 'GERENCIAR_LEADS',
  /** Ver Tarefas */
  VerTarefas = 'VER_TAREFAS',
  /** Criar Tarefas */
  CriarTarefas = 'CRIAR_TAREFAS',
  /** Editar Tarefas */
  EditarTarefas = 'EDITAR_TAREFAS',
  /** Excluir Tarefas */
  ExcluirTarefas = 'EXCLUIR_TAREFAS',
  /** Ver Histórico e Anotações */
  VerAnotacoesHistorico = 'VER_ANOTACOES_HISTORICO',
  /** Criar Anotações */
  CriarAnotacoesHistorico = 'CRIAR_ANOTACOES_HISTORICO',
  /** Editar Anotações */
  EditarAnotacoesHistorico = 'EDITAR_ANOTACOES_HISTORICO',
  /** Excluir Anotações */
  ExcluirAnotacoesHistorico = 'EXCLUIR_ANOTACOES_HISTORICO',
  /** Ver parceiro */
  VerParceiro = 'VER_PARCEIRO',
  /** Criar parceiro */
  CriarParceiro = 'CRIAR_PARCEIRO',
  /** Editar parceiro */
  EditarParceiro = 'EDITAR_PARCEIRO',
  /** Ver tabela */
  VerTabelaParceiro = 'VER_TABELA_PARCEIRO',
  /** Criar tabela */
  CriarTabelaParceiro = 'CRIAR_TABELA_PARCEIRO',
  /** Editar tabela */
  EditarTabelaParceiro = 'EDITAR_TABELA_PARCEIRO',
  /** Dashboard parceiro */
  DashboardParceiro = 'DASHBOARD_PARCEIRO',
  /** Dashboard funcionario */
  DashboardFuncionarioParceiro = 'DASHBOARD_FUNCIONARIO_PARCEIRO',
  /** Solicitar Resgate */
  SolicitarResgateParceiro = 'SOLICITAR_RESGATE_PARCEIRO',
  /** Histórico de Resgate */
  HistoricoResgateParceiro = 'HISTORICO_RESGATE_PARCEIRO',
  /** Ver funcionários repasse */
  VerFuncionariosRepasseParceiro = 'VER_FUNCIONARIOS_REPASSE_PARCEIRO',
  /** Criar funcionários repasse */
  CriarFuncionariosRepasseParceiro = 'CRIAR_FUNCIONARIOS_REPASSE_PARCEIRO',
  /** Editar funcionários repasse */
  EditarFuncionariosRepasseParceiro = 'EDITAR_FUNCIONARIOS_REPASSE_PARCEIRO',
  /** Histórico de resgate de Funcionário */
  HistoricoResgateFuncionarioParceiro = 'HISTORICO_RESGATE_FUNCIONARIO_PARCEIRO',
  /** Ver mensagem */
  VerMensagemSms = 'VER_MENSAGEM_SMS',
  /** Criar mensagem */
  CriarMensagemSms = 'CRIAR_MENSAGEM_SMS',
  /** Ver lista sms */
  VerListaSms = 'VER_LISTA_SMS',
  /** Criar lista */
  CriarListaSms = 'CRIAR_LISTA_SMS',
  /** Editar lista */
  EditarListaSms = 'EDITAR_LISTA_SMS',
  /** Excluir lista */
  ExcluirListaSms = 'EXCLUIR_LISTA_SMS',
  /** Ver envios */
  VerEnviosSms = 'VER_ENVIOS_SMS',
  /** Criar envios */
  CriarEnviosSms = 'CRIAR_ENVIOS_SMS',
  /** Criar envios email */
  CriarEnviosEmail = 'CRIAR_ENVIOS_EMAIL',
  /** Dashboard envios */
  DashboardEnviosSms = 'DASHBOARD_ENVIOS_SMS',
  /** SMS Relatório */
  SmsRelatorio = 'SMS_RELATORIO',
  /** Comissão Funcionário Relatório */
  ComissaoFuncionarioRelatorio = 'COMISSAO_FUNCIONARIO_RELATORIO',
  /** Regramento entidade */
  RegramentoEntidadeConfiguracoes = 'REGRAMENTO_ENTIDADE_CONFIGURACOES',
  /** Criar Fornecedor */
  CriarFornecedor = 'CRIAR_FORNECEDOR',
  /** Ver Fornecedor */
  VerFornecedor = 'VER_FORNECEDOR',
  /** Editar Fornecedor */
  EditarFornecedor = 'EDITAR_FORNECEDOR',
  /** Ver Tipo de Empréstimo */
  VerTipoEmprestimo = 'VER_TIPO_EMPRESTIMO',
  /** Criar Tipo de Empréstimo */
  CriarTipoEmprestimo = 'CRIAR_TIPO_EMPRESTIMO',
  /** Editar Tipo de Empréstimo */
  EditarTipoEmprestimo = 'EDITAR_TIPO_EMPRESTIMO',
  /** Alterar Status do Tipo de Empréstimo */
  AlterarStatusTipoEmprestimo = 'ALTERAR_STATUS_TIPO_EMPRESTIMO'
}

export type PermissaoGlobalType = {
   __typename?: 'PermissaoGlobalType',
  id: Scalars['ID'],
  funcionario: FuncionarioTypeRelay,
  origens: Scalars['Boolean'],
  contasAPagar: Scalars['Boolean'],
  funcionarios: Scalars['Boolean'],
  lojas: Scalars['Boolean'],
  emprestimos: Scalars['Boolean'],
};

export type PermissaoSimplificadaType = {
   __typename?: 'PermissaoSimplificadaType',
  descricaoPorGrupos?: Maybe<Array<Maybe<DescricaoPorGruposType>>>,
  grupoPorDescricoes?: Maybe<Array<Maybe<GrupoPorDescricoesType>>>,
  agrupadoPorLoja?: Maybe<Array<Maybe<AgrupadoPorLojaType>>>,
  agrupadoPorDescricao?: Maybe<Array<Maybe<AgrupadoPorDescricaoType>>>,
};

export type PermissaoType = {
   __typename?: 'PermissaoType',
  id: Scalars['ID'],
  funcionario: FuncionarioTypeRelay,
  entidade?: Maybe<EntidadeTypeRelay>,
  descricao: PermissaoDescricao,
};

export type PermissaoTypeMeta = {
   __typename?: 'PermissaoTypeMeta',
  id: Scalars['ID'],
  funcionario: FuncionarioTypeRelay,
  entidade?: Maybe<EntidadeTypeRelay>,
  descricao: PermissaoDescricao,
};

export type ProdutoDeInteresse = {
   __typename?: 'ProdutoDeInteresse',
  ok?: Maybe<Scalars['Boolean']>,
  lead?: Maybe<LeadsType>,
};

export type PropostasType = {
   __typename?: 'PropostasType',
  id: Scalars['ID'],
  lead: LeadsNodeTypeRelayProp,
  valorDesejado?: Maybe<Scalars['Float']>,
  data?: Maybe<Scalars['Date']>,
  parcelas?: Maybe<Scalars['Int']>,
  valorParcela?: Maybe<Scalars['Float']>,
  valorTotal?: Maybe<Scalars['Float']>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  comentario?: Maybe<Scalars['String']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
};

export type PropostaTypeInput = {
  leadId: Scalars['ID'],
  valorDesejado?: Maybe<Scalars['Float']>,
  parcelas?: Maybe<Scalars['Int']>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  valorParcela?: Maybe<Scalars['Float']>,
  valorTotal?: Maybe<Scalars['Float']>,
};

export type QualificaLead = {
   __typename?: 'QualificaLead',
  lead?: Maybe<LeadsType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type Query = {
   __typename?: 'Query',
  instanciasFilter?: Maybe<InstanciaZApiNodeConnection>,
  detalheInstancia?: Maybe<InstanciaZApiType>,
  pegarTipoEmprestimo?: Maybe<TipoDeEmprestimoType>,
  listarTiposDeEmprestimo?: Maybe<TipoDeEmprestimoRelayTypeConnection>,
  listaFornecedores?: Maybe<FornecedorNodeTypeConnection>,
  visualizarFornecedor?: Maybe<FornecedorViewNodeTypeConnection>,
  relatorioComissaoFuncionarios?: Maybe<ComissaoFuncionariosTypeRelayConnection>,
  somatorioComissaoFuncionariosAgregacoes?: Maybe<ComissaoFuncionariosAgregations>,
  relatorioComissaoFuncionariosAgregacoes?: Maybe<Array<Maybe<RelatorioComissaoFuncionariosNode>>>,
  relatorioComissaoFuncionariosExcel?: Maybe<RelatorioExcelType>,
  relatorioTelefonesSms?: Maybe<RelatorioTelefonesSmsType>,
  relatorioTelefonesSmsTxt?: Maybe<RelatorioTxtType>,
  relatorioEmprestimoCliente?: Maybe<EmprestimoClienteRelatorioTypeConnection>,
  emprestimoClienteAgregacoes?: Maybe<EmprestimoClienteAgregations>,
  relatorioEmprestimoClienteAgregacoes?: Maybe<Array<Maybe<RelatorioEmprestimoClienteNode>>>,
  relatorioEmprestimoClienteExcel?: Maybe<RelatorioExcelType>,
  relatorioLeadsMarketing?: Maybe<LeadsNodeTypeRelayConnection>,
  leadsMarketingAgregacoes?: Maybe<LeadMarketingAgregations>,
  relatorioLeadsMarketingExcel?: Maybe<RelatorioExcelType>,
  relatorioNsu?: Maybe<NsuRelatorioTypeConnection>,
  relatorioNsuExcel?: Maybe<RelatorioExcelType>,
  relatorioNsuAgregacoes?: Maybe<Array<Maybe<RelatorioNsuAgregacaoNode>>>,
  relatorioClientes?: Maybe<ClienteTypeRelayConnection>,
  relatorioClientesExcel?: Maybe<RelatorioExcelType>,
  relatorioClienteEmprestimos?: Maybe<RelatorioExcelType>,
  relatorioLeads?: Maybe<LeadsNodeTypeRelayConnection>,
  relatorioLeadsExcel?: Maybe<RelatorioExcelType>,
  relatorioReembolso?: Maybe<PedidoDeReembolsoNodeConnection>,
  relatorioReembolsoExcel?: Maybe<RelatorioExcelType>,
  relatorioReembolsoAgregacoes?: Maybe<Array<Maybe<RelatorioReembolsoAgregacaoNode>>>,
  relatorioContaPagar?: Maybe<ContaAPagarNodeConnection>,
  relatorioContaPagarExcel?: Maybe<RelatorioExcelType>,
  relatorioContaPagarAgregacoes?: Maybe<Array<Maybe<RelatorioContaPagarAgregacaoNode>>>,
  relatorioEmprestimo?: Maybe<EmprestimoRelatorioTypeConnection>,
  relatorioEmprestimoExcel?: Maybe<RelatorioExcelType>,
  relatorioEmprestimoAgregacoes?: Maybe<Array<Maybe<RelatorioEmprestimoAgregacaoNode>>>,
  listaParceirosRelay?: Maybe<ParceirosNodeTypeRelayConnection>,
  pegaParceiros?: Maybe<ParceirosType>,
  pegaTabela?: Maybe<TabelaParceirosType>,
  listaTabelasParceirosRelay?: Maybe<TabelasNodeTypeRelayConnection>,
  listaTabelasParceiros?: Maybe<Array<Maybe<TabelaParceirosType>>>,
  listaLojasParceiros?: Maybe<Array<Maybe<LojaParceiroType>>>,
  listaLojasComissaoFuncionarios?: Maybe<Array<Maybe<EntidadeType>>>,
  dashParceiros?: Maybe<ComissaoNodeTypeRelayConnection>,
  dashboardComissoesFuncionarios?: Maybe<ComissaoFuncionarioNodeTypeRelayConnection>,
  historicoResgate?: Maybe<HistoricoResgateNodeTypeRelayConnection>,
  detalhesResgate?: Maybe<Array<Maybe<ResgateParceiroType>>>,
  detalhesResgateFuncionario?: Maybe<Array<Maybe<ResgateFuncionarioType>>>,
  listaBandeirasTabelas?: Maybe<Array<Maybe<BandeiraTabelaParceirosType>>>,
  listaFuncionariosRepasseRelay?: Maybe<FuncionariosRepasseNodeTypeRelayConnection>,
  listaFuncionariosComPermissaoEmRepasse?: Maybe<Array<Maybe<FuncionarioType>>>,
  listaFuncionarioRepasseDashboardFuncionarioParceiro?: Maybe<Array<Maybe<FuncionariosRepasseType>>>,
  dashFuncionarioGeral?: Maybe<EmprestimoFuncionarioNodeTypeRalayConnection>,
  calculaComissaoRepasse?: Maybe<Scalars['Decimal']>,
  detalheComissaoParceiro?: Maybe<ComissaoParceiroType>,
  detalheComissaoFuncionario?: Maybe<ComissaoFuncionariosType>,
  historicoResgateFuncionario?: Maybe<HistoricoResgateFuncionarioNodeTypeRelayConnection>,
  historicoResgateFuncionarioExcel?: Maybe<HistoricoResgateExcelType>,
  todasSolicitacoesEmprestimo?: Maybe<EmprestimoNodeConnection>,
  todasSolicitacoesNsus?: Maybe<NsuNodeConnection>,
  solicitacaoEmprestimo?: Maybe<EmprestimoNode>,
  historicoEmprestimo?: Maybe<Array<Maybe<Array<Maybe<HistoricoEmprestimoType>>>>>,
  emprestimosAgregacoes?: Maybe<EmprestimoAgregations>,
  nsusAgregacoes?: Maybe<NsusAgregations>,
  emprestimosRascunho?: Maybe<EmprestimoNodeConnection>,
  pegaTaxasEmprestimo?: Maybe<Array<Maybe<ColunaTaxasParcelasType>>>,
  historicoClienteEmprestimo?: Maybe<HistoricoEmprestimoClienteTypeConnection>,
  historicoClienteEmprestimoAgregacoes?: Maybe<EmprestimoClienteAgregations>,
  simulacaoEmprestimo?: Maybe<SimulacaoEmprestimoType>,
  todasMaquinas?: Maybe<MaquinaNodeConnection>,
  todasMaquinasSistema?: Maybe<MaquinaNodeConnection>,
  maquina?: Maybe<MaquinaNode>,
  maquinaSistema?: Maybe<MaquinaNode>,
  listaMensagensRelay?: Maybe<MensagemSmsTypeRelayConnection>,
  listaSmsRelay?: Maybe<ListaSmsTypeRelayConnection>,
  detalhesListaSms?: Maybe<ListaSmsType>,
  listaTemplatesEmail?: Maybe<Array<Maybe<TemplatesEmailType>>>,
  listaEmailsRemetente?: Maybe<Array<Maybe<EmailRemetenteType>>>,
  listaEnviosRelay?: Maybe<EnvioSmsTypeRelayConnection>,
  listaEnviosEmailRelay?: Maybe<EnvioEmailTypeRelayConnection>,
  dashboardSms?: Maybe<Array<Maybe<DashboardSms>>>,
  dashboardEmails?: Maybe<Array<Maybe<DashboardEmail>>>,
  widgetPerformanceMetas?: Maybe<PerformanceMetaType>,
  dashboardTipoFuncionariosRelay?: Maybe<TipoFuncionarioTypeRelayConnection>,
  dashboardMetaKpiCards?: Maybe<DashboardMetaKpiCardsType>,
  dashboardTiposDeEmprestimosGrafico?: Maybe<DashboardMetaTiposDeEmprestimosType>,
  dashboardEmprestimosPorLojaGrafico?: Maybe<DashboardEmprestimosPorLojaType>,
  dashboardTopRankingLojas?: Maybe<DashboardTopRankingLojasType>,
  dashboardTopRankingFuncionarios?: Maybe<DashboardTopRankingFuncionariosType>,
  dashboardDetalhePorUnidade?: Maybe<DashboardMetaDetalhePorUnidadeType>,
  dashboardCategoriasRelay?: Maybe<CategoriaTypeRelayConnection>,
  listaSubcategorias?: Maybe<SubCategoriasTypeRelayConnection>,
  listaTodasLeadsRelay?: Maybe<LeadsNodeTypeRelayPropConnection>,
  listaTarefasEntidades?: Maybe<TarefasNodeTypeRelayConnection>,
  todasMetasRelay?: Maybe<MetaNodeTypeRelayConnection>,
  buscaMeta?: Maybe<MetaType>,
  listaFuncinariosMetax?: Maybe<Array<Maybe<PermissaoTypeMeta>>>,
  metaDiaria?: Maybe<MetaDiariaTypeRelayConnection>,
  todasMetasDiarias?: Maybe<MetaDiariaTypeRelayConnection>,
  gruposPermissoes?: Maybe<Array<Maybe<GrupoDePermissoesType>>>,
  gruposPermissoesRelay?: Maybe<GrupoDePermissoesTypeRelayConnection>,
  gruposPermissoesUserLogado?: Maybe<GrupoDePermissoesTypeRelayConnection>,
  listaGruposFuncionarios?: Maybe<Array<Maybe<GrupoDePermissoesType>>>,
  gruposLojasPermissoesUserLogado?: Maybe<GrupoDePermissoesTypeRelayConnection>,
  grupoLojas?: Maybe<Array<Maybe<EntidadeDeGrupoType>>>,
  contaPagar?: Maybe<ContaAPagarNode>,
  contaPagarRelay?: Maybe<ContaAPagarNode>,
  todasContasPagarRelay?: Maybe<ContaAPagarNodeConnection>,
  todosClientes?: Maybe<Array<Maybe<ClienteType>>>,
  todosClientesRelay?: Maybe<ClienteTypeRelayConnection>,
  todosLeads?: Maybe<ClienteTypeRelayConnection>,
  cliente?: Maybe<Array<Maybe<ClienteType>>>,
  buscarClienteOutrasEntidades?: Maybe<ClienteType>,
  todosPedidosReembolso?: Maybe<PedidoDeReembolsoNodeConnection>,
  pedidoReembolso?: Maybe<PedidoDeReembolsoNode>,
  todosFuncionarios?: Maybe<Array<Maybe<FuncionarioType>>>,
  todosFuncionariosSistema?: Maybe<Array<Maybe<FuncionarioType>>>,
  todosFuncionariosRelay?: Maybe<FuncionarioTypeRelayConnection>,
  todosFuncionariosSistemaRelay?: Maybe<FuncionarioTypeRelayConnection>,
  funcionario?: Maybe<FuncionarioType>,
  todasEntidades?: Maybe<Array<Maybe<EntidadeType>>>,
  todasEntidadesSistema?: Maybe<Array<Maybe<EntidadeType>>>,
  todasEntidadesRelay?: Maybe<EntidadeTypeRelayConnection>,
  filtroEntidadesPermissao?: Maybe<EntidadeTypeRelayConnection>,
  todasEntidadesSistemaRelay?: Maybe<EntidadeTypeRelayConnection>,
  todasEntidadesPermissao?: Maybe<EntidadeTypeRelayConnection>,
  listaTabelataxaEntidade?: Maybe<Array<Maybe<TabelaTaxaParcelasType>>>,
  entidade?: Maybe<EntidadeType>,
  contarEntidadesPorCategoria?: Maybe<ContagemDeCategoriaType>,
  listaColunas?: Maybe<Array<Maybe<ColunaTaxasParcelasType>>>,
  permissoes?: Maybe<Array<Maybe<PermissaoType>>>,
  permissoesSimplificadas?: Maybe<PermissaoSimplificadaType>,
  node?: Maybe<Node>,
  regramentoTipoLoja?: Maybe<RegramentoTiposEntidadesNodeTypeConnection>,
  regramentoLoja?: Maybe<EntidadeTypeRelayConnection>,
  criarRegramentoLoja?: Maybe<EntidadeTypeRelayConnection>,
  tiposLojas?: Maybe<TiposEntidadesNodeTypeConnection>,
  listaHistoricoRelay?: Maybe<HistoricoNodeTypeRelayConnection>,
  listaLeadsRelay?: Maybe<LeadsNodeTypeRelayConnection>,
  listarTarefasLead?: Maybe<Array<Maybe<TarefasType>>>,
  pegaLead?: Maybe<LeadsType>,
  listaFuncionarioPermissao?: Maybe<Array<Maybe<FuncionarioType>>>,
  listaFuncionarioEntidade?: Maybe<Array<Maybe<FuncionarioType>>>,
  listaEmprestimosClientes?: Maybe<Array<Maybe<EmprestimoType>>>,
  listaEntidadeFuncionario?: Maybe<Array<Maybe<EntidadeType>>>,
  listarAnotacoesLead?: Maybe<Array<Maybe<AnotacaoType>>>,
  listaOrigens?: Maybe<Array<Maybe<OrigensType>>>,
  listaVagas?: Maybe<Array<Maybe<VagaType>>>,
  listaStatusCrm?: Maybe<Array<Maybe<StatusLeadType>>>,
  listaEmprestimoClientesMobileRelay?: Maybe<EmprestimoNodeTypeRelayConnection>,
  listaCartoesClientesMobileRelay?: Maybe<CartaoDeCreditoNodeTypeRelayConnection>,
  sourceList?: Maybe<Array<Maybe<OrigensType>>>,
  listaTaxasEmprestimoMobile?: Maybe<Array<Maybe<TabelaTaxaParcelasType>>>,
  listaClientes?: Maybe<Array<Maybe<ClienteType>>>,
  listaEntidades?: Maybe<Array<Maybe<EntidadeType>>>,
  perfilClienteMobile?: Maybe<ClienteType>,
  profileUserMobile?: Maybe<LeadsType>,
  simulaEmprestimo?: Maybe<EntidadeType>,
  dadosClientes?: Maybe<ClienteType>,
  listaEmprestimoClientesMobile?: Maybe<Array<Maybe<EmprestimoType>>>,
  listaEmprestimoCartoesMobile?: Maybe<Array<Maybe<NsuType>>>,
  detalhesEmprestimoClientesMobile?: Maybe<EmprestimoType>,
  detalhesContaClientesMobile?: Maybe<ContaDeClienteType>,
  ultimoEmprestimoClientesMobile?: Maybe<EmprestimoType>,
  listaCartoesClientesMobile?: Maybe<Array<Maybe<CartaoDeCreditoType>>>,
  listaContasClientesMobile?: Maybe<Array<Maybe<ContaDeClienteType>>>,
  listaCartoesEmprestimoMobile?: Maybe<Array<Maybe<CartaoDeCreditoType>>>,
  faleConosco?: Maybe<AppConfigType>,
  slideInicial?: Maybe<Array<Maybe<AppSlideType>>>,
  politicaPrivacidade?: Maybe<Array<Maybe<AppPoliticaPrivacideType>>>,
  faqApp?: Maybe<Array<Maybe<AppFaqType>>>,
  termosUso?: Maybe<Array<Maybe<AppTermosUsoType>>>,
  aloMundo?: Maybe<Scalars['String']>,
  me?: Maybe<FuncionarioType>,
};


export type QueryInstanciasFilterArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  entidade?: Maybe<Scalars['ID']>,
  entidade_In?: Maybe<Scalars['String']>,
  isActived?: Maybe<Scalars['Boolean']>,
  isConnected?: Maybe<Scalars['Boolean']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Float']>
};


export type QueryDetalheInstanciaArgs = {
  id: Scalars['ID']
};


export type QueryPegarTipoEmprestimoArgs = {
  id: Scalars['ID']
};


export type QueryListarTiposDeEmprestimoArgs = {
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  ativo?: Maybe<Scalars['Boolean']>,
  modalidadeCliente?: Maybe<Scalars['String']>,
  modalidadeCliente_In?: Maybe<Scalars['String']>,
  periodicidadeRecorrencia?: Maybe<Scalars['String']>,
  periodicidadeRecorrencia_In?: Maybe<Scalars['String']>,
  tipoUso?: Maybe<Scalars['String']>,
  tipoUso_In?: Maybe<Scalars['String']>,
  valorMinimo?: Maybe<Scalars['Float']>,
  valorMinimo_Gte?: Maybe<Scalars['Float']>,
  valorMinimo_Lte?: Maybe<Scalars['Float']>,
  valorMaximo?: Maybe<Scalars['Float']>,
  valorMaximo_Gte?: Maybe<Scalars['Float']>,
  valorMaximo_Lte?: Maybe<Scalars['Float']>,
  parcelasMinimas?: Maybe<Scalars['Int']>,
  parcelasMinimas_Gte?: Maybe<Scalars['Int']>,
  parcelasMinimas_Lte?: Maybe<Scalars['Int']>,
  parcelasMaximas?: Maybe<Scalars['Int']>,
  parcelasMaximas_Gte?: Maybe<Scalars['Int']>,
  parcelasMaximas_Lte?: Maybe<Scalars['Int']>,
  taxaJuros?: Maybe<Scalars['Float']>,
  taxaJuros_Gte?: Maybe<Scalars['Float']>,
  taxaJuros_Lte?: Maybe<Scalars['Float']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryListaFornecedoresArgs = {
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_In?: Maybe<Scalars['String']>,
  nome_Istartswith?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  cpfCnpj?: Maybe<Scalars['String']>,
  cpfCnpj_Icontains?: Maybe<Scalars['String']>,
  categorias_Nome?: Maybe<Scalars['String']>,
  categorias_Nome_In?: Maybe<Scalars['String']>,
  subcategorias_Nome?: Maybe<Scalars['String']>,
  subcategorias_Nome_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryVisualizarFornecedorArgs = {
  id?: Maybe<Scalars['ID']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryRelatorioComissaoFuncionariosArgs = {
  tipoComissao?: Maybe<Scalars['String']>,
  funcionario?: Maybe<Scalars['ID']>,
  funcionario_In?: Maybe<Scalars['ID']>,
  valorComissao?: Maybe<Scalars['Float']>,
  emprestimo_Entidade?: Maybe<Scalars['ID']>,
  emprestimo_Entidade_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgate_InicioPeriodo?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Gte?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Gt?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Lt?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Lte?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Gte?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Gt?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Lt?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Lte?: Maybe<Scalars['Date']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySomatorioComissaoFuncionariosAgregacoesArgs = {
  tipoComissao?: Maybe<Scalars['String']>,
  funcionario?: Maybe<Scalars['ID']>,
  funcionario_In?: Maybe<Scalars['ID']>,
  valorComissao?: Maybe<Scalars['Float']>,
  emprestimo_Entidade?: Maybe<Scalars['ID']>,
  emprestimo_Entidade_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgate_InicioPeriodo?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Gte?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Gt?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Lt?: Maybe<Scalars['Date']>,
  resgate_InicioPeriodo_Lte?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Gte?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Gt?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Lt?: Maybe<Scalars['Date']>,
  resgate_FimPeriodo_Lte?: Maybe<Scalars['Date']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type QueryRelatorioComissaoFuncionariosAgregacoesArgs = {
  input?: Maybe<ComissaoFuncionariosRelatorioInput>
};


export type QueryRelatorioComissaoFuncionariosExcelArgs = {
  input?: Maybe<ComissaoFuncionariosRelatorioInput>
};


export type QueryRelatorioTelefonesSmsArgs = {
  clienteFiltro?: Maybe<ClienteRelatorioInput>,
  leadsFiltro?: Maybe<LeadRelatorioInput>,
  clienteOuLeadsFiltro?: Maybe<Scalars['String']>
};


export type QueryRelatorioTelefonesSmsTxtArgs = {
  clienteFiltro?: Maybe<ClienteRelatorioInput>,
  leadsFiltro?: Maybe<LeadRelatorioInput>,
  clienteOuLeadsFiltro?: Maybe<Scalars['String']>
};


export type QueryRelatorioEmprestimoClienteArgs = {
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  cliente_Id?: Maybe<Scalars['Float']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_In?: Maybe<Scalars['String']>,
  cliente_Sexo?: Maybe<Scalars['String']>,
  cliente_Sexo_In?: Maybe<Scalars['String']>,
  cliente_Municipio?: Maybe<Scalars['String']>,
  cliente_Municipio_In?: Maybe<Scalars['String']>,
  cliente_Municipio_Icontains?: Maybe<Scalars['String']>,
  entidade?: Maybe<Scalars['ID']>,
  entidade_In?: Maybe<Scalars['ID']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  quantidadeEmprestimo?: Maybe<Scalars['Float']>,
  taxaMedia?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryEmprestimoClienteAgregacoesArgs = {
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  cliente_Id?: Maybe<Scalars['Float']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_In?: Maybe<Scalars['String']>,
  cliente_Sexo?: Maybe<Scalars['String']>,
  cliente_Sexo_In?: Maybe<Scalars['String']>,
  cliente_Municipio?: Maybe<Scalars['String']>,
  cliente_Municipio_In?: Maybe<Scalars['String']>,
  cliente_Municipio_Icontains?: Maybe<Scalars['String']>,
  entidade?: Maybe<Scalars['ID']>,
  entidade_In?: Maybe<Scalars['ID']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  quantidadeEmprestimo?: Maybe<Scalars['Float']>,
  taxaMedia?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type QueryRelatorioEmprestimoClienteAgregacoesArgs = {
  input?: Maybe<EmprestimoClienteRelatorioInput>
};


export type QueryRelatorioEmprestimoClienteExcelArgs = {
  input?: Maybe<EmprestimoClienteRelatorioInput>
};


export type QueryRelatorioLeadsMarketingArgs = {
  nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  tarefas_Funcionario_Id?: Maybe<Scalars['ID']>,
  pausado?: Maybe<Scalars['Boolean']>,
  email_Isnull?: Maybe<Scalars['Boolean']>,
  telefone_Isnull?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  qualificacao?: Maybe<Scalars['Int']>,
  clienteId?: Maybe<Scalars['ID']>,
  cliente_Sexo?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  responsavelId?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  possuiCartao?: Maybe<Scalars['Boolean']>,
  statusLead_Index?: Maybe<Scalars['Int']>,
  statusLead_Nome?: Maybe<Scalars['String']>,
  tarefas_Tipo_Icontains?: Maybe<Scalars['String']>,
  tarefas_Status?: Maybe<Scalars['String']>,
  tarefas_Hora?: Maybe<Scalars['Time']>,
  tarefas_Hora_Gte?: Maybe<Scalars['Time']>,
  tarefas_Hora_Gt?: Maybe<Scalars['Time']>,
  tarefas_Hora_Lt?: Maybe<Scalars['Time']>,
  tarefas_Hora_Lte?: Maybe<Scalars['Time']>,
  tarefas_Data?: Maybe<Scalars['Date']>,
  tarefas_Data_Gte?: Maybe<Scalars['Date']>,
  tarefas_Data_Gt?: Maybe<Scalars['Date']>,
  tarefas_Data_Lt?: Maybe<Scalars['Date']>,
  tarefas_Data_Lte?: Maybe<Scalars['Date']>,
  tarefas_DataHora?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Gte?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Gt?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Lt?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Lte?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  produtoInteresse_Icontains?: Maybe<Scalars['String']>,
  app?: Maybe<Scalars['Boolean']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  statusLeadId?: Maybe<Scalars['ID']>,
  tarefas_Id?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryLeadsMarketingAgregacoesArgs = {
  nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  tarefas_Funcionario_Id?: Maybe<Scalars['ID']>,
  pausado?: Maybe<Scalars['Boolean']>,
  email_Isnull?: Maybe<Scalars['Boolean']>,
  telefone_Isnull?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  qualificacao?: Maybe<Scalars['Int']>,
  clienteId?: Maybe<Scalars['ID']>,
  cliente_Sexo?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  responsavelId?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  possuiCartao?: Maybe<Scalars['Boolean']>,
  statusLead_Index?: Maybe<Scalars['Int']>,
  statusLead_Nome?: Maybe<Scalars['String']>,
  tarefas_Tipo_Icontains?: Maybe<Scalars['String']>,
  tarefas_Status?: Maybe<Scalars['String']>,
  tarefas_Hora?: Maybe<Scalars['Time']>,
  tarefas_Hora_Gte?: Maybe<Scalars['Time']>,
  tarefas_Hora_Gt?: Maybe<Scalars['Time']>,
  tarefas_Hora_Lt?: Maybe<Scalars['Time']>,
  tarefas_Hora_Lte?: Maybe<Scalars['Time']>,
  tarefas_Data?: Maybe<Scalars['Date']>,
  tarefas_Data_Gte?: Maybe<Scalars['Date']>,
  tarefas_Data_Gt?: Maybe<Scalars['Date']>,
  tarefas_Data_Lt?: Maybe<Scalars['Date']>,
  tarefas_Data_Lte?: Maybe<Scalars['Date']>,
  tarefas_DataHora?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Gte?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Gt?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Lt?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Lte?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  produtoInteresse_Icontains?: Maybe<Scalars['String']>,
  app?: Maybe<Scalars['Boolean']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  statusLeadId?: Maybe<Scalars['ID']>,
  tarefas_Id?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryRelatorioLeadsMarketingExcelArgs = {
  input?: Maybe<LeadRelatorioInput>
};


export type QueryRelatorioNsuArgs = {
  id?: Maybe<Scalars['Float']>,
  emprestimo_Entidade?: Maybe<Scalars['ID']>,
  emprestimo_Entidade_In?: Maybe<Scalars['ID']>,
  emprestimo_EntidadeId?: Maybe<Scalars['ID']>,
  emprestimo_EntidadeId_In?: Maybe<Scalars['ID']>,
  emprestimo_Id?: Maybe<Scalars['Float']>,
  nsuCv?: Maybe<Scalars['String']>,
  nsuCv_In?: Maybe<Scalars['String']>,
  valorNsuCv?: Maybe<Scalars['Float']>,
  valorNsuCv_In?: Maybe<Scalars['Float']>,
  emprestimo_ValorDesejado?: Maybe<Scalars['Float']>,
  emprestimo_ValorDesejado_In?: Maybe<Scalars['Float']>,
  emprestimo_TaxaAplicada?: Maybe<Scalars['Float']>,
  emprestimo_TaxaAplicada_In?: Maybe<Scalars['Float']>,
  emprestimo_Status?: Maybe<Scalars['String']>,
  emprestimo_Status_In?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['String']>,
  parcelas_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryRelatorioNsuExcelArgs = {
  input?: Maybe<NsuRelatorioInput>
};


export type QueryRelatorioNsuAgregacoesArgs = {
  input?: Maybe<NsuRelatorioInput>
};


export type QueryRelatorioClientesArgs = {
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  entidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  lead?: Maybe<Scalars['Boolean']>,
  cpf?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  nascimento?: Maybe<Scalars['Date']>,
  nascimento_Lte?: Maybe<Scalars['Date']>,
  nascimento_Gte?: Maybe<Scalars['Date']>,
  nascimento_Month_In?: Maybe<Scalars['String']>,
  nascimento_Day_In?: Maybe<Scalars['String']>,
  sexo?: Maybe<Scalars['String']>,
  sexo_In?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_Icontains?: Maybe<Scalars['String']>,
  telefone_Numero?: Maybe<Scalars['String']>,
  telefone_Numero_Icontains?: Maybe<Scalars['String']>,
  telefone_Ddd?: Maybe<Scalars['String']>,
  telefone_Ddd_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  uf_Icontains?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  bairro_Icontains?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  profissao_Icontains?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryRelatorioClientesExcelArgs = {
  input?: Maybe<ClienteRelatorioInput>
};


export type QueryRelatorioClienteEmprestimosArgs = {
  input?: Maybe<ClienteRelatorioInput>
};


export type QueryRelatorioLeadsArgs = {
  nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  tarefas_Funcionario_Id?: Maybe<Scalars['ID']>,
  pausado?: Maybe<Scalars['Boolean']>,
  email_Isnull?: Maybe<Scalars['Boolean']>,
  telefone_Isnull?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  qualificacao?: Maybe<Scalars['Int']>,
  clienteId?: Maybe<Scalars['ID']>,
  cliente_Sexo?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  responsavelId?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  possuiCartao?: Maybe<Scalars['Boolean']>,
  statusLead_Index?: Maybe<Scalars['Int']>,
  statusLead_Nome?: Maybe<Scalars['String']>,
  tarefas_Tipo_Icontains?: Maybe<Scalars['String']>,
  tarefas_Status?: Maybe<Scalars['String']>,
  tarefas_Hora?: Maybe<Scalars['Time']>,
  tarefas_Hora_Gte?: Maybe<Scalars['Time']>,
  tarefas_Hora_Gt?: Maybe<Scalars['Time']>,
  tarefas_Hora_Lt?: Maybe<Scalars['Time']>,
  tarefas_Hora_Lte?: Maybe<Scalars['Time']>,
  tarefas_Data?: Maybe<Scalars['Date']>,
  tarefas_Data_Gte?: Maybe<Scalars['Date']>,
  tarefas_Data_Gt?: Maybe<Scalars['Date']>,
  tarefas_Data_Lt?: Maybe<Scalars['Date']>,
  tarefas_Data_Lte?: Maybe<Scalars['Date']>,
  tarefas_DataHora?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Gte?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Gt?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Lt?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Lte?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  produtoInteresse_Icontains?: Maybe<Scalars['String']>,
  app?: Maybe<Scalars['Boolean']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  statusLeadId?: Maybe<Scalars['ID']>,
  tarefas_Id?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryRelatorioLeadsExcelArgs = {
  input?: Maybe<LeadRelatorioInput>
};


export type QueryRelatorioReembolsoArgs = {
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  tipoConta_In?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_Icontains?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  conta_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Icontains?: Maybe<Scalars['Float']>,
  data?: Maybe<Scalars['DateTime']>,
  data_Lt?: Maybe<Scalars['DateTime']>,
  data_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryRelatorioReembolsoExcelArgs = {
  input?: Maybe<ReembolsoRelatorioInput>
};


export type QueryRelatorioReembolsoAgregacoesArgs = {
  input?: Maybe<ReembolsoRelatorioInput>
};


export type QueryRelatorioContaPagarArgs = {
  id?: Maybe<Scalars['Float']>,
  titulo?: Maybe<Scalars['String']>,
  titulo_Icontains?: Maybe<Scalars['String']>,
  titulo_Istartswith?: Maybe<Scalars['String']>,
  destinatario?: Maybe<Scalars['String']>,
  destinatario_Icontains?: Maybe<Scalars['String']>,
  destinatario_Istartswith?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  recorrencia?: Maybe<Scalars['String']>,
  recorrencia_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>,
  dataVencimento?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gte?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lte?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gte?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lte?: Maybe<Scalars['DateTime']>,
  transferenciaConta?: Maybe<Scalars['String']>,
  transferenciaConta_Icontains?: Maybe<Scalars['String']>,
  formaPagamento?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Lt?: Maybe<Scalars['Float']>,
  valor_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryRelatorioContaPagarExcelArgs = {
  input?: Maybe<ContaPagarRelatorioInput>
};


export type QueryRelatorioContaPagarAgregacoesArgs = {
  input?: Maybe<ContaPagarRelatorioInput>
};


export type QueryRelatorioEmprestimoArgs = {
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  entidade_EntidadeGrupo_In?: Maybe<Array<Maybe<Scalars['ID']>>>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Cpf?: Maybe<Scalars['String']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  nsu_NsuCv?: Maybe<Scalars['String']>,
  nsu_NsuCv_Icontains?: Maybe<Scalars['String']>,
  nsu_NsuCv_In?: Maybe<Scalars['String']>,
  valorTotal?: Maybe<Scalars['Float']>,
  valorTotal_In?: Maybe<Scalars['Float']>,
  valorDesejado?: Maybe<Scalars['Float']>,
  valorDesejado_In?: Maybe<Scalars['Float']>,
  valorDesejado_Gte?: Maybe<Scalars['Float']>,
  valorDesejado_Lte?: Maybe<Scalars['Float']>,
  nsu_TitularDivergente_Cpf?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_In?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  bandeiraCartao_In?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['String']>,
  parcelas_In?: Maybe<Scalars['String']>,
  parcelas_Lt?: Maybe<Scalars['String']>,
  parcelas_Gt?: Maybe<Scalars['String']>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  entidade_Id?: Maybe<Scalars['ID']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  tipoEmprestimo_Id_In?: Maybe<Scalars['String']>,
  tipoEmprestimo_Modalidade_In?: Maybe<Scalars['String']>,
  tipoEmprestimoUso_In?: Maybe<Scalars['String']>,
  cartaoCredito?: Maybe<Scalars['Boolean']>,
  loanType_Isnull?: Maybe<Scalars['Boolean']>,
  status_In?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryRelatorioEmprestimoExcelArgs = {
  input?: Maybe<EmprestimoRelatorioInput>
};


export type QueryRelatorioEmprestimoAgregacoesArgs = {
  input?: Maybe<EmprestimoRelatorioInput>
};


export type QueryListaParceirosRelayArgs = {
  lojasRepasseIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  lojasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  tabelasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  funcionariosIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  permissoesRequeridas?: Maybe<Array<Maybe<GrapheneListaPermissionsEnum>>>,
  filtrarLojasComParceirosEmComun?: Maybe<Scalars['Boolean']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type QueryPegaParceirosArgs = {
  id: Scalars['ID']
};


export type QueryPegaTabelaArgs = {
  id: Scalars['ID']
};


export type QueryListaTabelasParceirosRelayArgs = {
  lojasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  gruposIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  parceiroIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  funcionariosIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  categoriaTabela?: Maybe<Scalars['String']>,
  categoriaTabela_Icontains?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  parceiros_Nome_Icontains?: Maybe<Scalars['String']>,
  parceiros_Id?: Maybe<Scalars['ID']>,
  parceiros_Id_In?: Maybe<Scalars['ID']>,
  parceiros_Lojaparceiro_Loja_Id?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type QueryListaTabelasParceirosArgs = {
  lojasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  gruposIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  parceiroIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  funcionariosIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  orderBy?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>
};


export type QueryListaLojasParceirosArgs = {
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type QueryListaLojasComissaoFuncionariosArgs = {
  funcionariosIds?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type QueryDashParceirosArgs = {
  lojasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  parceiroIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Nsu_Parcelas?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_In?: Maybe<Scalars['String']>,
  emprestimo_Nsu_Parcelas_Iexact?: Maybe<Scalars['String']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  dataRepasse?: Maybe<Scalars['Date']>,
  dataRepasse_Gte?: Maybe<Scalars['Date']>,
  dataRepasse_Gt?: Maybe<Scalars['Date']>,
  dataRepasse_Lt?: Maybe<Scalars['Date']>,
  dataRepasse_Lte?: Maybe<Scalars['Date']>,
  emprestimo_CriadoEm?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gte?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Gt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lt?: Maybe<Scalars['DateTime']>,
  emprestimo_CriadoEm_Lte?: Maybe<Scalars['DateTime']>,
  emprestimo_Data?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gte?: Maybe<Scalars['Date']>,
  emprestimo_Data_Gt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lt?: Maybe<Scalars['Date']>,
  emprestimo_Data_Lte?: Maybe<Scalars['Date']>,
  valorComissao?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryDashboardComissoesFuncionariosArgs = {
  funcionariosIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  lojasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  tipoFuncionario?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  emprestimo_Id?: Maybe<Scalars['ID']>,
  emprestimo_Id_In?: Maybe<Scalars['String']>,
  emprestimo_Funcionario_Id?: Maybe<Scalars['ID']>,
  emprestimo_Parcelas?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  tipoComissao?: Maybe<Scalars['String']>,
  valorComissao?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryHistoricoResgateArgs = {
  emprestimosIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  lojasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  valorResgate?: Maybe<Scalars['Float']>,
  valorResgate_Icontains?: Maybe<Scalars['Float']>,
  parceiroId?: Maybe<Scalars['ID']>,
  parceiroId_In?: Maybe<Scalars['String']>,
  conta_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type QueryDetalhesResgateArgs = {
  id: Scalars['ID']
};


export type QueryDetalhesResgateFuncionarioArgs = {
  idResgate: Scalars['ID']
};


export type QueryListaFuncionariosRepasseRelayArgs = {
  funcionariosRepasse?: Maybe<Array<Maybe<Scalars['ID']>>>,
  lojasIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  funcionario_Id?: Maybe<Scalars['ID']>,
  funcionario_Id_In?: Maybe<Scalars['ID']>,
  tipoFuncionario?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Id?: Maybe<Scalars['ID']>,
  tabelaDeParceiro_Id_In?: Maybe<Scalars['String']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome?: Maybe<Scalars['String']>,
  tabelaDeParceiro_Nome_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type QueryDashFuncionarioGeralArgs = {
  tipo?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  parcelas?: Maybe<Scalars['String']>,
  comissaofuncionarios_ValorComissao?: Maybe<Scalars['Float']>,
  comissaofuncionarios_TipoComissao?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  comissaofuncionarios_Id?: Maybe<Scalars['ID']>
};


export type QueryCalculaComissaoRepasseArgs = {
  entidadeId: Scalars['ID'],
  valorDesejado: Scalars['Decimal'],
  parcelas: Scalars['String'],
  taxaAplicada: Scalars['Decimal']
};


export type QueryDetalheComissaoParceiroArgs = {
  id: Scalars['ID']
};


export type QueryDetalheComissaoFuncionarioArgs = {
  id: Scalars['ID']
};


export type QueryHistoricoResgateFuncionarioArgs = {
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  valorResgate?: Maybe<Scalars['Float']>,
  valorResgate_Icontains?: Maybe<Scalars['Float']>,
  comissaofuncionarios_TipoComissao?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  respassefuncionario_FuncionarioId?: Maybe<Scalars['ID']>,
  respassefuncionario_FuncionarioId_In?: Maybe<Scalars['String']>,
  respassefuncionario_LojaId?: Maybe<Scalars['ID']>,
  respassefuncionario_LojaId_In?: Maybe<Scalars['String']>
};


export type QueryHistoricoResgateFuncionarioExcelArgs = {
  input?: Maybe<ResgateFuncionarioRelatorioInput>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type QueryTodasSolicitacoesEmprestimoArgs = {
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  entidade_EntidadeGrupo_In?: Maybe<Array<Maybe<Scalars['ID']>>>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Cpf?: Maybe<Scalars['String']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  nsu_NsuCv?: Maybe<Scalars['String']>,
  nsu_NsuCv_Icontains?: Maybe<Scalars['String']>,
  nsu_NsuCv_In?: Maybe<Scalars['String']>,
  valorTotal?: Maybe<Scalars['Float']>,
  valorTotal_In?: Maybe<Scalars['Float']>,
  valorDesejado?: Maybe<Scalars['Float']>,
  valorDesejado_In?: Maybe<Scalars['Float']>,
  valorDesejado_Gte?: Maybe<Scalars['Float']>,
  valorDesejado_Lte?: Maybe<Scalars['Float']>,
  nsu_TitularDivergente_Cpf?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_In?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  bandeiraCartao_In?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['String']>,
  parcelas_In?: Maybe<Scalars['String']>,
  parcelas_Lt?: Maybe<Scalars['String']>,
  parcelas_Gt?: Maybe<Scalars['String']>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  entidade_Id?: Maybe<Scalars['ID']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  tipoEmprestimo_Id_In?: Maybe<Scalars['String']>,
  tipoEmprestimo_Modalidade_In?: Maybe<Scalars['String']>,
  tipoEmprestimoUso_In?: Maybe<Scalars['String']>,
  cartaoCredito?: Maybe<Scalars['Boolean']>,
  loanType_Isnull?: Maybe<Scalars['Boolean']>,
  status_In?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryTodasSolicitacoesNsusArgs = {
  id?: Maybe<Scalars['Float']>,
  emprestimo_Entidade?: Maybe<Scalars['ID']>,
  emprestimo_Entidade_In?: Maybe<Scalars['ID']>,
  emprestimo_EntidadeId?: Maybe<Scalars['ID']>,
  emprestimo_EntidadeId_In?: Maybe<Scalars['ID']>,
  emprestimo_Id?: Maybe<Scalars['Float']>,
  nsuCv?: Maybe<Scalars['String']>,
  nsuCv_In?: Maybe<Scalars['String']>,
  valorNsuCv?: Maybe<Scalars['Float']>,
  valorNsuCv_In?: Maybe<Scalars['Float']>,
  emprestimo_ValorDesejado?: Maybe<Scalars['Float']>,
  emprestimo_ValorDesejado_In?: Maybe<Scalars['Float']>,
  emprestimo_TaxaAplicada?: Maybe<Scalars['Float']>,
  emprestimo_TaxaAplicada_In?: Maybe<Scalars['Float']>,
  emprestimo_Status?: Maybe<Scalars['String']>,
  emprestimo_Status_In?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['String']>,
  parcelas_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QuerySolicitacaoEmprestimoArgs = {
  id: Scalars['ID']
};


export type QueryHistoricoEmprestimoArgs = {
  id?: Maybe<Scalars['Int']>
};


export type QueryEmprestimosAgregacoesArgs = {
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  entidade_EntidadeGrupo_In?: Maybe<Array<Maybe<Scalars['ID']>>>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Cpf?: Maybe<Scalars['String']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  nsu_NsuCv?: Maybe<Scalars['String']>,
  nsu_NsuCv_Icontains?: Maybe<Scalars['String']>,
  nsu_NsuCv_In?: Maybe<Scalars['String']>,
  valorTotal?: Maybe<Scalars['Float']>,
  valorTotal_In?: Maybe<Scalars['Float']>,
  valorDesejado?: Maybe<Scalars['Float']>,
  valorDesejado_In?: Maybe<Scalars['Float']>,
  valorDesejado_Gte?: Maybe<Scalars['Float']>,
  valorDesejado_Lte?: Maybe<Scalars['Float']>,
  nsu_TitularDivergente_Cpf?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_In?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  bandeiraCartao_In?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['String']>,
  parcelas_In?: Maybe<Scalars['String']>,
  parcelas_Lt?: Maybe<Scalars['String']>,
  parcelas_Gt?: Maybe<Scalars['String']>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  entidade_Id?: Maybe<Scalars['ID']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  tipoEmprestimo_Id_In?: Maybe<Scalars['String']>,
  tipoEmprestimo_Modalidade_In?: Maybe<Scalars['String']>,
  tipoEmprestimoUso_In?: Maybe<Scalars['String']>,
  cartaoCredito?: Maybe<Scalars['Boolean']>,
  loanType_Isnull?: Maybe<Scalars['Boolean']>,
  status_In?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type QueryNsusAgregacoesArgs = {
  id?: Maybe<Scalars['Float']>,
  emprestimo_Entidade?: Maybe<Scalars['ID']>,
  emprestimo_Entidade_In?: Maybe<Scalars['ID']>,
  emprestimo_EntidadeId?: Maybe<Scalars['ID']>,
  emprestimo_EntidadeId_In?: Maybe<Scalars['ID']>,
  emprestimo_Id?: Maybe<Scalars['Float']>,
  nsuCv?: Maybe<Scalars['String']>,
  nsuCv_In?: Maybe<Scalars['String']>,
  valorNsuCv?: Maybe<Scalars['Float']>,
  valorNsuCv_In?: Maybe<Scalars['Float']>,
  emprestimo_ValorDesejado?: Maybe<Scalars['Float']>,
  emprestimo_ValorDesejado_In?: Maybe<Scalars['Float']>,
  emprestimo_TaxaAplicada?: Maybe<Scalars['Float']>,
  emprestimo_TaxaAplicada_In?: Maybe<Scalars['Float']>,
  emprestimo_Status?: Maybe<Scalars['String']>,
  emprestimo_Status_In?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['String']>,
  parcelas_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type QueryEmprestimosRascunhoArgs = {
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  entidade_EntidadeGrupo_In?: Maybe<Array<Maybe<Scalars['ID']>>>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Cpf?: Maybe<Scalars['String']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  nsu_NsuCv?: Maybe<Scalars['String']>,
  nsu_NsuCv_Icontains?: Maybe<Scalars['String']>,
  nsu_NsuCv_In?: Maybe<Scalars['String']>,
  valorTotal?: Maybe<Scalars['Float']>,
  valorTotal_In?: Maybe<Scalars['Float']>,
  valorDesejado?: Maybe<Scalars['Float']>,
  valorDesejado_In?: Maybe<Scalars['Float']>,
  valorDesejado_Gte?: Maybe<Scalars['Float']>,
  valorDesejado_Lte?: Maybe<Scalars['Float']>,
  nsu_TitularDivergente_Cpf?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_In?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  bandeiraCartao_In?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['String']>,
  parcelas_In?: Maybe<Scalars['String']>,
  parcelas_Lt?: Maybe<Scalars['String']>,
  parcelas_Gt?: Maybe<Scalars['String']>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  entidade_Id?: Maybe<Scalars['ID']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  tipoEmprestimo_Id_In?: Maybe<Scalars['String']>,
  tipoEmprestimo_Modalidade_In?: Maybe<Scalars['String']>,
  tipoEmprestimoUso_In?: Maybe<Scalars['String']>,
  cartaoCredito?: Maybe<Scalars['Boolean']>,
  loanType_Isnull?: Maybe<Scalars['Boolean']>,
  status_In?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryPegaTaxasEmprestimoArgs = {
  idLoja: Scalars['ID'],
  valorDesejado: Scalars['Float'],
  parcela: Scalars['String']
};


export type QueryHistoricoClienteEmprestimoArgs = {
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  entidade_EntidadeGrupo_In?: Maybe<Array<Maybe<Scalars['ID']>>>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Cpf?: Maybe<Scalars['String']>,
  cliente_Nome?: Maybe<Scalars['String']>,
  cliente_Nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem?: Maybe<Scalars['String']>,
  cliente_Origem_Icontains?: Maybe<Scalars['String']>,
  cliente_Origem_In?: Maybe<Scalars['String']>,
  nsu_NsuCv?: Maybe<Scalars['String']>,
  nsu_NsuCv_Icontains?: Maybe<Scalars['String']>,
  nsu_NsuCv_In?: Maybe<Scalars['String']>,
  valorTotal?: Maybe<Scalars['Float']>,
  valorTotal_In?: Maybe<Scalars['Float']>,
  valorDesejado?: Maybe<Scalars['Float']>,
  valorDesejado_In?: Maybe<Scalars['Float']>,
  valorDesejado_Gte?: Maybe<Scalars['Float']>,
  valorDesejado_Lte?: Maybe<Scalars['Float']>,
  nsu_TitularDivergente_Cpf?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Cpf_In?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_Icontains?: Maybe<Scalars['String']>,
  nsu_TitularDivergente_Nome_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  bandeiraCartao?: Maybe<Scalars['String']>,
  bandeiraCartao_In?: Maybe<Scalars['String']>,
  parcelas?: Maybe<Scalars['String']>,
  parcelas_In?: Maybe<Scalars['String']>,
  parcelas_Lt?: Maybe<Scalars['String']>,
  parcelas_Gt?: Maybe<Scalars['String']>,
  taxaAplicada?: Maybe<Scalars['Float']>,
  entidade_Id?: Maybe<Scalars['ID']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  lucroBruto?: Maybe<Scalars['Float']>,
  tipoEmprestimo_Id_In?: Maybe<Scalars['String']>,
  tipoEmprestimo_Modalidade_In?: Maybe<Scalars['String']>,
  tipoEmprestimoUso_In?: Maybe<Scalars['String']>,
  cartaoCredito?: Maybe<Scalars['Boolean']>,
  loanType_Isnull?: Maybe<Scalars['Boolean']>,
  status_In?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type QueryHistoricoClienteEmprestimoAgregacoesArgs = {
  input?: Maybe<HistoricoEmprestimoClienteInput>
};


export type QuerySimulacaoEmprestimoArgs = {
  input?: Maybe<SimulacaoEmprestimoInput>
};


export type QueryTodasMaquinasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  cnpj?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  etiquetagem?: Maybe<Scalars['String']>,
  etiquetagem_Icontains?: Maybe<Scalars['String']>,
  numeroTerminal?: Maybe<Scalars['String']>,
  numeroTerminal_Icontains?: Maybe<Scalars['String']>,
  serialNumber?: Maybe<Scalars['String']>,
  serialNumber_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryTodasMaquinasSistemaArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  cnpj?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  etiquetagem?: Maybe<Scalars['String']>,
  etiquetagem_Icontains?: Maybe<Scalars['String']>,
  numeroTerminal?: Maybe<Scalars['String']>,
  numeroTerminal_Icontains?: Maybe<Scalars['String']>,
  serialNumber?: Maybe<Scalars['String']>,
  serialNumber_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryMaquinaArgs = {
  id: Scalars['ID']
};


export type QueryMaquinaSistemaArgs = {
  id: Scalars['ID']
};


export type QueryListaMensagensRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  titulo_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type QueryListaSmsRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  entidades_Id?: Maybe<Scalars['ID']>,
  entidades_Id_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type QueryDetalhesListaSmsArgs = {
  id: Scalars['ID']
};


export type QueryListaEnviosRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  listas_Id?: Maybe<Scalars['ID']>,
  listas_Id_In?: Maybe<Scalars['String']>,
  apiSmsFlag?: Maybe<Scalars['Boolean']>,
  hora?: Maybe<Scalars['Time']>,
  hora_Gte?: Maybe<Scalars['Time']>,
  hora_Gt?: Maybe<Scalars['Time']>,
  hora_Lt?: Maybe<Scalars['Time']>,
  hora_Lte?: Maybe<Scalars['Time']>,
  data?: Maybe<Scalars['Date']>,
  data_Gte?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Lte?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type QueryListaEnviosEmailRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  listas_Id?: Maybe<Scalars['ID']>,
  listas_Id_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  hora?: Maybe<Scalars['Time']>,
  hora_Gte?: Maybe<Scalars['Time']>,
  hora_Gt?: Maybe<Scalars['Time']>,
  hora_Lt?: Maybe<Scalars['Time']>,
  hora_Lte?: Maybe<Scalars['Time']>,
  data?: Maybe<Scalars['Date']>,
  data_Gte?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Lte?: Maybe<Scalars['Date']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>
};


export type QueryDashboardSmsArgs = {
  dataIni?: Maybe<Scalars['Date']>,
  dataFim?: Maybe<Scalars['Date']>
};


export type QueryDashboardEmailsArgs = {
  dataIni?: Maybe<Scalars['Date']>,
  dataFim?: Maybe<Scalars['Date']>
};


export type QueryWidgetPerformanceMetasArgs = {
  entidadeId: Scalars['ID'],
  metaId: Scalars['ID']
};


export type QueryDashboardTipoFuncionariosRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  nome_Iexact?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  excluido?: Maybe<Scalars['Boolean']>
};


export type QueryDashboardMetaKpiCardsArgs = {
  filtros?: Maybe<MetaFilterSetInput>
};


export type QueryDashboardTiposDeEmprestimosGraficoArgs = {
  filtros?: Maybe<MetaFilterSetInput>
};


export type QueryDashboardEmprestimosPorLojaGraficoArgs = {
  filtros?: Maybe<MetaFilterSetInput>
};


export type QueryDashboardTopRankingLojasArgs = {
  filtros?: Maybe<MetaFilterSetInput>
};


export type QueryDashboardTopRankingFuncionariosArgs = {
  filtros?: Maybe<MetaFilterSetInput>
};


export type QueryDashboardDetalhePorUnidadeArgs = {
  filtros?: Maybe<MetaFilterSetInput>
};


export type QueryDashboardCategoriasRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Iexact?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  subcategorias_Nome_Iexact?: Maybe<Scalars['String']>,
  subcategorias_Nome_Icontains?: Maybe<Scalars['String']>,
  excluido?: Maybe<Scalars['Boolean']>
};


export type QueryListaSubcategoriasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['Float']>,
  excluido?: Maybe<Scalars['Boolean']>
};


export type QueryListaTodasLeadsRelayArgs = {
  entidadesIn?: Maybe<Array<Maybe<Scalars['ID']>>>,
  ddd?: Maybe<Scalars['String']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryListaTarefasEntidadesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  assunto_Icontains?: Maybe<Scalars['String']>,
  tipo?: Maybe<Scalars['String']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lead_Nome?: Maybe<Scalars['String']>,
  lead_Nome_Icontains?: Maybe<Scalars['String']>,
  lead_Entidade_Id?: Maybe<Scalars['ID']>,
  hora?: Maybe<Scalars['Time']>,
  hora_Gte?: Maybe<Scalars['Time']>,
  hora_Gt?: Maybe<Scalars['Time']>,
  hora_Lt?: Maybe<Scalars['Time']>,
  hora_Lte?: Maybe<Scalars['Time']>,
  data?: Maybe<Scalars['Date']>,
  data_Gte?: Maybe<Scalars['Date']>,
  data_Gt?: Maybe<Scalars['Date']>,
  data_Lt?: Maybe<Scalars['Date']>,
  data_Lte?: Maybe<Scalars['Date']>,
  dataHora?: Maybe<Scalars['DateTime']>,
  dataHora_Gte?: Maybe<Scalars['DateTime']>,
  dataHora_Gt?: Maybe<Scalars['DateTime']>,
  dataHora_Lt?: Maybe<Scalars['DateTime']>,
  dataHora_Lte?: Maybe<Scalars['DateTime']>,
  status?: Maybe<Scalars['String']>,
  leadId?: Maybe<Scalars['ID']>
};


export type QueryTodasMetasRelayArgs = {
  lojaId?: Maybe<Scalars['ID']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  valorMeta?: Maybe<Scalars['Float']>,
  taxaMeta?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['String']>,
  inicioMeta?: Maybe<Scalars['String']>,
  inicioMeta_Gte?: Maybe<Scalars['Date']>,
  inicioMeta_Gt?: Maybe<Scalars['Date']>,
  inicioMeta_Lt?: Maybe<Scalars['Date']>,
  inicioMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta?: Maybe<Scalars['String']>,
  fimMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta_Lt?: Maybe<Scalars['Date']>,
  fimMeta_Gte?: Maybe<Scalars['Date']>,
  fimMeta_Gt?: Maybe<Scalars['Date']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  tipoRegramento?: Maybe<Scalars['String']>,
  tipoRegramento_In?: Maybe<Scalars['String']>,
  vinculoProduto?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  statusSaude?: Maybe<Scalars['String']>,
  grupoIds_In?: Maybe<Scalars['String']>,
  vinculoProduto_In?: Maybe<Scalars['String']>
};


export type QueryBuscaMetaArgs = {
  id: Scalars['ID']
};


export type QueryListaFuncinariosMetaxArgs = {
  idEntidade?: Maybe<Scalars['Int']>
};


export type QueryMetaDiariaArgs = {
  id: Scalars['ID'],
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  dataDia?: Maybe<Scalars['Date']>,
  dataDia_Gte?: Maybe<Scalars['Date']>,
  dataDia_Lte?: Maybe<Scalars['Date']>,
  dataDia_Gt?: Maybe<Scalars['Date']>,
  dataDia_Lt?: Maybe<Scalars['Date']>,
  valorPassado?: Maybe<Scalars['Float']>,
  valorAcumulada?: Maybe<Scalars['Float']>,
  taxaPassado?: Maybe<Scalars['Float']>,
  taxaAcumulada?: Maybe<Scalars['Float']>,
  meta?: Maybe<Scalars['ID']>,
  meta_In?: Maybe<Scalars['ID']>,
  statusSaude?: Maybe<Scalars['String']>,
  meta_Id_In?: Maybe<Scalars['String']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryTodasMetasDiariasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  dataDia?: Maybe<Scalars['Date']>,
  dataDia_Gte?: Maybe<Scalars['Date']>,
  dataDia_Lte?: Maybe<Scalars['Date']>,
  dataDia_Gt?: Maybe<Scalars['Date']>,
  dataDia_Lt?: Maybe<Scalars['Date']>,
  valorPassado?: Maybe<Scalars['Float']>,
  valorAcumulada?: Maybe<Scalars['Float']>,
  taxaPassado?: Maybe<Scalars['Float']>,
  taxaAcumulada?: Maybe<Scalars['Float']>,
  meta?: Maybe<Scalars['ID']>,
  meta_In?: Maybe<Scalars['ID']>,
  statusSaude?: Maybe<Scalars['String']>,
  meta_Id_In?: Maybe<Scalars['String']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryGruposPermissoesArgs = {
  id?: Maybe<Scalars['ID']>,
  nome?: Maybe<Scalars['String']>
};


export type QueryGruposPermissoesRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Id?: Maybe<Scalars['ID']>,
  entidade_Entidade_Nome?: Maybe<Scalars['String']>,
  entidade_Entidade_Nome_Icontains?: Maybe<Scalars['String']>,
  entidade_Entidade_Id?: Maybe<Scalars['ID']>,
  permissao_Descricao?: Maybe<Scalars['String']>,
  permissao_Descricao_Icontains?: Maybe<Scalars['String']>,
  permissao_Descricao_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryGruposPermissoesUserLogadoArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Id?: Maybe<Scalars['ID']>,
  entidade_Entidade_Nome?: Maybe<Scalars['String']>,
  entidade_Entidade_Nome_Icontains?: Maybe<Scalars['String']>,
  entidade_Entidade_Id?: Maybe<Scalars['ID']>,
  permissao_Descricao?: Maybe<Scalars['String']>,
  permissao_Descricao_Icontains?: Maybe<Scalars['String']>,
  permissao_Descricao_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryListaGruposFuncionariosArgs = {
  funcionarioIds?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type QueryGruposLojasPermissoesUserLogadoArgs = {
  permissoesFuncionario?: Maybe<Array<Maybe<Scalars['String']>>>,
  permissoesGrupo?: Maybe<Array<Maybe<Scalars['String']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Id?: Maybe<Scalars['ID']>,
  entidade_Entidade_Nome?: Maybe<Scalars['String']>,
  entidade_Entidade_Nome_Icontains?: Maybe<Scalars['String']>,
  entidade_Entidade_Id?: Maybe<Scalars['ID']>,
  permissao_Descricao?: Maybe<Scalars['String']>,
  permissao_Descricao_Icontains?: Maybe<Scalars['String']>,
  permissao_Descricao_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryContaPagarArgs = {
  pk: Scalars['ID']
};


export type QueryContaPagarRelayArgs = {
  id: Scalars['ID']
};


export type QueryTodasContasPagarRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  titulo?: Maybe<Scalars['String']>,
  titulo_Icontains?: Maybe<Scalars['String']>,
  titulo_Istartswith?: Maybe<Scalars['String']>,
  destinatario?: Maybe<Scalars['String']>,
  destinatario_Icontains?: Maybe<Scalars['String']>,
  destinatario_Istartswith?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  recorrencia?: Maybe<Scalars['String']>,
  recorrencia_In?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lte?: Maybe<Scalars['DateTime']>,
  dataVencimento?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gt?: Maybe<Scalars['DateTime']>,
  dataVencimento_Gte?: Maybe<Scalars['DateTime']>,
  dataVencimento_Lte?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gte?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lte?: Maybe<Scalars['DateTime']>,
  transferenciaConta?: Maybe<Scalars['String']>,
  transferenciaConta_Icontains?: Maybe<Scalars['String']>,
  formaPagamento?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Lt?: Maybe<Scalars['Float']>,
  valor_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryTodosClientesArgs = {
  idEntidade?: Maybe<Scalars['ID']>
};


export type QueryTodosClientesRelayArgs = {
  entidadesIn?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  entidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  lead?: Maybe<Scalars['Boolean']>,
  cpf?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  nascimento?: Maybe<Scalars['Date']>,
  nascimento_Lte?: Maybe<Scalars['Date']>,
  nascimento_Gte?: Maybe<Scalars['Date']>,
  nascimento_Month_In?: Maybe<Scalars['String']>,
  nascimento_Day_In?: Maybe<Scalars['String']>,
  sexo?: Maybe<Scalars['String']>,
  sexo_In?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_Icontains?: Maybe<Scalars['String']>,
  telefone_Numero?: Maybe<Scalars['String']>,
  telefone_Numero_Icontains?: Maybe<Scalars['String']>,
  telefone_Ddd?: Maybe<Scalars['String']>,
  telefone_Ddd_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  uf_Icontains?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  bairro_Icontains?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  profissao_Icontains?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryTodosLeadsArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  entidades?: Maybe<Array<Maybe<Scalars['ID']>>>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  lead?: Maybe<Scalars['Boolean']>,
  cpf?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  nascimento?: Maybe<Scalars['Date']>,
  nascimento_Lte?: Maybe<Scalars['Date']>,
  nascimento_Gte?: Maybe<Scalars['Date']>,
  nascimento_Month_In?: Maybe<Scalars['String']>,
  nascimento_Day_In?: Maybe<Scalars['String']>,
  sexo?: Maybe<Scalars['String']>,
  sexo_In?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_Icontains?: Maybe<Scalars['String']>,
  telefone_Numero?: Maybe<Scalars['String']>,
  telefone_Numero_Icontains?: Maybe<Scalars['String']>,
  telefone_Ddd?: Maybe<Scalars['String']>,
  telefone_Ddd_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  uf_Icontains?: Maybe<Scalars['String']>,
  bairro?: Maybe<Scalars['String']>,
  bairro_Icontains?: Maybe<Scalars['String']>,
  profissao?: Maybe<Scalars['String']>,
  profissao_Icontains?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryClienteArgs = {
  id?: Maybe<Scalars['Int']>,
  cpf?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>
};


export type QueryBuscarClienteOutrasEntidadesArgs = {
  id?: Maybe<Scalars['Int']>,
  cpf?: Maybe<Scalars['String']>
};


export type QueryTodosPedidosReembolsoArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  tipoConta_In?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_Icontains?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  conta_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Icontains?: Maybe<Scalars['Float']>,
  data?: Maybe<Scalars['DateTime']>,
  data_Lt?: Maybe<Scalars['DateTime']>,
  data_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryPedidoReembolsoArgs = {
  id: Scalars['ID']
};


export type QueryTodosFuncionariosArgs = {
  idEntidade?: Maybe<Scalars['Int']>
};


export type QueryTodosFuncionariosSistemaArgs = {
  idEntidade?: Maybe<Scalars['Int']>
};


export type QueryTodosFuncionariosRelayArgs = {
  entidadeId?: Maybe<Scalars['ID']>,
  permissao_Descricao?: Maybe<Array<Maybe<Scalars['String']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  categoria?: Maybe<Scalars['String']>,
  tipoFuncionario_Nome?: Maybe<Scalars['String']>,
  tipoContrato?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_Icontains?: Maybe<Scalars['String']>,
  cpf?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  user_IsActive?: Maybe<Scalars['Boolean']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryTodosFuncionariosSistemaRelayArgs = {
  entidadeId?: Maybe<Scalars['ID']>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  categoria?: Maybe<Scalars['String']>,
  tipoFuncionario_Nome?: Maybe<Scalars['String']>,
  tipoContrato?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_Icontains?: Maybe<Scalars['String']>,
  cpf?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  user_IsActive?: Maybe<Scalars['Boolean']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryFuncionarioArgs = {
  id?: Maybe<Scalars['Int']>,
  cpf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>
};


export type QueryTodasEntidadesRelayArgs = {
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryFiltroEntidadesPermissaoArgs = {
  permissoes?: Maybe<Array<Maybe<Scalars['String']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryTodasEntidadesSistemaRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryTodasEntidadesPermissaoArgs = {
  permissoes: Array<Maybe<Scalars['String']>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryListaTabelataxaEntidadeArgs = {
  idEntidade?: Maybe<Scalars['ID']>
};


export type QueryEntidadeArgs = {
  id?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>
};


export type QueryContarEntidadesPorCategoriaArgs = {
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>
};


export type QueryListaColunasArgs = {
  idEntidade?: Maybe<Scalars['ID']>
};


export type QueryPermissoesArgs = {
  idEntidade?: Maybe<Scalars['Int']>,
  idFuncionario?: Maybe<Scalars['Int']>
};


export type QueryPermissoesSimplificadasArgs = {
  idFuncionario?: Maybe<Scalars['Int']>
};


export type QueryNodeArgs = {
  id: Scalars['ID']
};


export type QueryRegramentoTipoLojaArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  tipoLoja?: Maybe<Scalars['String']>,
  tipoLoja_Iexact?: Maybe<Scalars['String']>,
  tipoLoja_In?: Maybe<Scalars['String']>,
  tipoLoja_Icontains?: Maybe<Scalars['String']>,
  tipoLoja_Istartswith?: Maybe<Scalars['String']>,
  valorAcimaTipo?: Maybe<Scalars['Float']>,
  valorAcimaTipo_In?: Maybe<Scalars['Float']>,
  valorAcimaTipo_Gt?: Maybe<Scalars['Float']>,
  default?: Maybe<Scalars['Boolean']>,
  excluido?: Maybe<Scalars['Boolean']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryRegramentoLojaArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryCriarRegramentoLojaArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryTiposLojasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  tipoLoja?: Maybe<Scalars['String']>,
  tipoLoja_Iexact?: Maybe<Scalars['String']>,
  tipoLoja_In?: Maybe<Scalars['String']>,
  tipoLoja_Icontains?: Maybe<Scalars['String']>,
  tipoLoja_Istartswith?: Maybe<Scalars['String']>,
  valorAcimaTipo?: Maybe<Scalars['Float']>,
  valorAcimaTipo_In?: Maybe<Scalars['Float']>,
  valorAcimaTipo_Gt?: Maybe<Scalars['Float']>,
  default?: Maybe<Scalars['Boolean']>,
  excluido?: Maybe<Scalars['Boolean']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryListaHistoricoRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  leadId?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryListaLeadsRelayArgs = {
  lojas?: Maybe<Array<Maybe<Scalars['ID']>>>,
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  tarefas_Funcionario_Id?: Maybe<Scalars['ID']>,
  pausado?: Maybe<Scalars['Boolean']>,
  email_Isnull?: Maybe<Scalars['Boolean']>,
  telefone_Isnull?: Maybe<Scalars['Boolean']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  qualificacao?: Maybe<Scalars['Int']>,
  clienteId?: Maybe<Scalars['ID']>,
  cliente_Sexo?: Maybe<Scalars['String']>,
  entidadeId?: Maybe<Scalars['ID']>,
  responsavelId?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  possuiCartao?: Maybe<Scalars['Boolean']>,
  statusLead_Index?: Maybe<Scalars['Int']>,
  statusLead_Nome?: Maybe<Scalars['String']>,
  tarefas_Tipo_Icontains?: Maybe<Scalars['String']>,
  tarefas_Status?: Maybe<Scalars['String']>,
  tarefas_Hora?: Maybe<Scalars['Time']>,
  tarefas_Hora_Gte?: Maybe<Scalars['Time']>,
  tarefas_Hora_Gt?: Maybe<Scalars['Time']>,
  tarefas_Hora_Lt?: Maybe<Scalars['Time']>,
  tarefas_Hora_Lte?: Maybe<Scalars['Time']>,
  tarefas_Data?: Maybe<Scalars['Date']>,
  tarefas_Data_Gte?: Maybe<Scalars['Date']>,
  tarefas_Data_Gt?: Maybe<Scalars['Date']>,
  tarefas_Data_Lt?: Maybe<Scalars['Date']>,
  tarefas_Data_Lte?: Maybe<Scalars['Date']>,
  tarefas_DataHora?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Gte?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Gt?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Lt?: Maybe<Scalars['DateTime']>,
  tarefas_DataHora_Lte?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  produtoInteresse_Icontains?: Maybe<Scalars['String']>,
  app?: Maybe<Scalars['Boolean']>,
  entidade_Id_In?: Maybe<Scalars['String']>,
  statusLeadId?: Maybe<Scalars['ID']>,
  tarefas_Id?: Maybe<Scalars['ID']>,
  orderBy?: Maybe<Scalars['String']>
};


export type QueryListarTarefasLeadArgs = {
  idLead: Scalars['ID']
};


export type QueryPegaLeadArgs = {
  id: Scalars['ID']
};


export type QueryListaFuncionarioPermissaoArgs = {
  permissao?: Maybe<Scalars['String']>
};


export type QueryListaEmprestimosClientesArgs = {
  idCliente: Scalars['ID']
};


export type QueryListaEntidadeFuncionarioArgs = {
  permissoesRequeridas?: Maybe<Array<Maybe<ListaEntidadeFuncionarioPermissionsEnum>>>
};


export type QueryListarAnotacoesLeadArgs = {
  idLead: Scalars['ID']
};


export type QueryListaOrigensArgs = {
  id?: Maybe<Scalars['Float']>,
  origem?: Maybe<Scalars['String']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  excluido?: Maybe<Scalars['Boolean']>
};


export type QueryListaEmprestimoClientesMobileRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  clienteId?: Maybe<Scalars['ID']>
};


export type QueryListaCartoesClientesMobileRelayArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['ID']>
};


export type QueryListaEntidadesArgs = {
  latitude: Scalars['Float'],
  longitude: Scalars['Float']
};


export type QueryPerfilClienteMobileArgs = {
  id: Scalars['Int']
};


export type QuerySimulaEmprestimoArgs = {
  idCliente: Scalars['ID']
};


export type QueryDadosClientesArgs = {
  cpf: Scalars['String'],
  nascimento: Scalars['Date']
};


export type QueryListaEmprestimoClientesMobileArgs = {
  id: Scalars['ID']
};


export type QueryListaEmprestimoCartoesMobileArgs = {
  id: Scalars['ID']
};


export type QueryDetalhesEmprestimoClientesMobileArgs = {
  idEmprestimo: Scalars['ID']
};


export type QueryDetalhesContaClientesMobileArgs = {
  idConta: Scalars['ID']
};


export type QueryUltimoEmprestimoClientesMobileArgs = {
  idCliente: Scalars['ID']
};


export type QueryListaCartoesClientesMobileArgs = {
  idCliente: Scalars['ID']
};


export type QueryListaContasClientesMobileArgs = {
  idCliente: Scalars['ID']
};


export type QueryListaCartoesEmprestimoMobileArgs = {
  emprestimoId: Scalars['ID']
};


export type QueryAloMundoArgs = {
  nome?: Maybe<Scalars['String']>
};

export type RankingFuncionarioType = {
   __typename?: 'RankingFuncionarioType',
  nomeFuncionario?: Maybe<Scalars['String']>,
  faturamento?: Maybe<Scalars['Decimal']>,
  porcentagem?: Maybe<Scalars['Float']>,
  numeroRanking?: Maybe<Scalars['Int']>,
};

export type RankingLojaType = {
   __typename?: 'RankingLojaType',
  nomeLoja?: Maybe<Scalars['String']>,
  porcentagem?: Maybe<Scalars['Float']>,
  numeroRanking?: Maybe<Scalars['Int']>,
};

export type ReembolsoRelatorioInput = {
  id?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Nome_Istartswith?: Maybe<Scalars['String']>,
  status?: Maybe<Scalars['String']>,
  status_In?: Maybe<Scalars['String']>,
  tipoConta?: Maybe<Scalars['String']>,
  tipoConta_In?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  categoria_Icontains?: Maybe<Scalars['String']>,
  categoria_In?: Maybe<Scalars['String']>,
  conta?: Maybe<Scalars['String']>,
  conta_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  valor?: Maybe<Scalars['Float']>,
  valor_Icontains?: Maybe<Scalars['Float']>,
  data?: Maybe<Scalars['DateTime']>,
  data_Lt?: Maybe<Scalars['DateTime']>,
  data_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  dataPagamento?: Maybe<Scalars['DateTime']>,
  dataPagamento_Lt?: Maybe<Scalars['DateTime']>,
  dataPagamento_Gt?: Maybe<Scalars['DateTime']>,
  /** Ordenando */
  orderBy?: Maybe<Scalars['String']>,
};

export type Refresh = {
   __typename?: 'Refresh',
  payload: Scalars['GenericScalar'],
  refreshExpiresIn: Scalars['Int'],
  token: Scalars['String'],
};

export type RegramentoTiposEntidadesNodeType = Node & {
   __typename?: 'RegramentoTiposEntidadesNodeType',
  /** The ID of the object. */
  id: Scalars['ID'],
  tipoLoja: Scalars['String'],
  valorAcimaTipo: Scalars['Float'],
  default: Scalars['Boolean'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  excluido: Scalars['Boolean'],
  entidades: EntidadeTypeRelayConnection,
};


export type RegramentoTiposEntidadesNodeTypeEntidadesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

export type RegramentoTiposEntidadesNodeTypeConnection = {
   __typename?: 'RegramentoTiposEntidadesNodeTypeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RegramentoTiposEntidadesNodeTypeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `RegramentoTiposEntidadesNodeType` and its cursor. */
export type RegramentoTiposEntidadesNodeTypeEdge = {
   __typename?: 'RegramentoTiposEntidadesNodeTypeEdge',
  /** The item at the end of the edge */
  node?: Maybe<RegramentoTiposEntidadesNodeType>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type RelatorioComissaoFuncionariosNode = {
   __typename?: 'RelatorioComissaoFuncionariosNode',
  emprestimo_Entidade?: Maybe<Scalars['ID']>,
  emprestimo_EntidadeNome?: Maybe<Scalars['String']>,
  somaRepasseFuncionario?: Maybe<Scalars['Decimal']>,
};

export type RelatorioContaPagarAgregacaoNode = {
   __typename?: 'RelatorioContaPagarAgregacaoNode',
  entidade?: Maybe<Scalars['ID']>,
  totalValor?: Maybe<Scalars['Decimal']>,
  entidadeNome?: Maybe<Scalars['String']>,
};

export type RelatorioEmprestimoAgregacaoNode = {
   __typename?: 'RelatorioEmprestimoAgregacaoNode',
  entidade?: Maybe<Scalars['ID']>,
  entidadeNome?: Maybe<Scalars['String']>,
  totalValorPassado?: Maybe<Scalars['Decimal']>,
  totalValorRetirado?: Maybe<Scalars['Decimal']>,
  mediaTaxa?: Maybe<Scalars['Decimal']>,
  somaRepasseParceiro?: Maybe<Scalars['String']>,
  lucroBruto?: Maybe<Scalars['Decimal']>,
};

export type RelatorioEmprestimoClienteNode = {
   __typename?: 'RelatorioEmprestimoClienteNode',
  emprestimo_Entidade?: Maybe<Scalars['ID']>,
  emprestimo_EntidadeNome?: Maybe<Scalars['String']>,
  totalValorPassado?: Maybe<Scalars['Decimal']>,
  totalValorRetirado?: Maybe<Scalars['Decimal']>,
  mediaTaxa?: Maybe<Scalars['Decimal']>,
};

export type RelatorioExcelType = {
   __typename?: 'RelatorioExcelType',
  relatorio?: Maybe<Scalars['String']>,
  background?: Maybe<Scalars['Boolean']>,
};

export type RelatorioNode = {
   __typename?: 'RelatorioNode',
  id: Scalars['ID'],
  funcionario: FuncionarioTypeRelay,
  nome: Scalars['String'],
  status: RelatorioStatus,
  url?: Maybe<Scalars['String']>,
  filters?: Maybe<Scalars['JSONString']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
};

export type RelatorioNsuAgregacaoNode = {
   __typename?: 'RelatorioNsuAgregacaoNode',
  emprestimo_Entidade?: Maybe<Scalars['ID']>,
  emprestimo_EntidadeNome?: Maybe<Scalars['String']>,
  totalValorPassado?: Maybe<Scalars['Decimal']>,
  totalValorRetirado?: Maybe<Scalars['Decimal']>,
  mediaTaxa?: Maybe<Scalars['Decimal']>,
};

export type RelatorioReembolsoAgregacaoNode = {
   __typename?: 'RelatorioReembolsoAgregacaoNode',
  entidade?: Maybe<Scalars['ID']>,
  totalValor?: Maybe<Scalars['Decimal']>,
  entidadeNome?: Maybe<Scalars['String']>,
};

/** An enumeration. */
export enum RelatorioStatus {
  /** iniciado */
  Iniciado = 'INICIADO',
  /** completo */
  Completo = 'COMPLETO',
  /** erro */
  Erro = 'ERRO'
}

export type RelatorioTelefonesSmsType = {
   __typename?: 'RelatorioTelefonesSmsType',
  totalTelefones?: Maybe<Scalars['Int']>,
  telefones?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type RelatorioTxtType = {
   __typename?: 'RelatorioTxtType',
  relatorio?: Maybe<Scalars['String']>,
  background?: Maybe<Scalars['Boolean']>,
};

export type RemoverAnexosTaxaAbaixoDeEmprestimo = {
   __typename?: 'RemoverAnexosTaxaAbaixoDeEmprestimo',
  emprestimo?: Maybe<EmprestimoNode>,
};

export type RemoverEmprestimoNsus = {
   __typename?: 'RemoverEmprestimoNsus',
  emprestimo?: Maybe<EmprestimoNode>,
};

export type RemoverPagamentoEmprestimo = {
   __typename?: 'RemoverPagamentoEmprestimo',
  ok?: Maybe<Scalars['Boolean']>,
  emprestimo?: Maybe<EmprestimoNode>,
};

export type RemoverRascunhos = {
   __typename?: 'RemoverRascunhos',
  ok?: Maybe<Scalars['Boolean']>,
};

export type RemoverRelatorio = {
   __typename?: 'RemoverRelatorio',
  relatorios?: Maybe<Array<Maybe<RelatorioNode>>>,
};

export type ReportarProblemaMaquinaMutation = {
   __typename?: 'ReportarProblemaMaquinaMutation',
  maquina?: Maybe<MaquinaNode>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type ResgatarSaldo = {
   __typename?: 'ResgatarSaldo',
  ok?: Maybe<Scalars['Boolean']>,
};

export type ResgateAutomaticoParceirosType = {
   __typename?: 'ResgateAutomaticoParceirosType',
  id: Scalars['ID'],
  ativo: Scalars['Boolean'],
  parceiro: ParceirosNodeTypeRelay,
  contaBancaria: ContaParceirosType,
  segunda: Scalars['Boolean'],
  terca: Scalars['Boolean'],
  quarta: Scalars['Boolean'],
  quinta: Scalars['Boolean'],
  sexta: Scalars['Boolean'],
  sabado: Scalars['Boolean'],
};

export type ResgateAutomaticoParceirosTypeInput = {
  contaBancariaIdx?: Maybe<Scalars['Int']>,
  ativo?: Maybe<Scalars['Boolean']>,
  segunda?: Maybe<Scalars['Boolean']>,
  terca?: Maybe<Scalars['Boolean']>,
  quarta?: Maybe<Scalars['Boolean']>,
  quinta?: Maybe<Scalars['Boolean']>,
  sexta?: Maybe<Scalars['Boolean']>,
  sabado?: Maybe<Scalars['Boolean']>,
};

export type ResgateFuncionarioRelatorioInput = {
  valorResgate?: Maybe<Scalars['Float']>,
  valorResgate_Icontains?: Maybe<Scalars['Float']>,
  comissaofuncionarios_TipoComissao?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  respassefuncionario_FuncionarioId?: Maybe<Scalars['ID']>,
  respassefuncionario_FuncionarioId_In?: Maybe<Scalars['String']>,
  respassefuncionario_LojaId?: Maybe<Scalars['ID']>,
  respassefuncionario_LojaId_In?: Maybe<Scalars['String']>,
  grupoIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  grupoId?: Maybe<Scalars['ID']>,
};

export type ResgateFuncionarioType = {
   __typename?: 'ResgateFuncionarioType',
  id: Scalars['ID'],
  inicioPeriodo: Scalars['Date'],
  fimPeriodo: Scalars['Date'],
  valorResgate: Scalars['Float'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  respassefuncionarioSet: Array<RespasseFuncionarioType>,
  comissaofuncionariosSet?: Maybe<Array<Maybe<ComissaoFuncionariosType>>>,
};

export type ResgateParceiroType = {
   __typename?: 'ResgateParceiroType',
  id: Scalars['ID'],
  valorResgate: Scalars['Float'],
  valorPago?: Maybe<Scalars['Float']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  parceiro: ParceirosNodeTypeRelay,
  tipoPix: Scalars['String'],
  pix: Scalars['String'],
  banco: Scalars['String'],
  agencia: Scalars['String'],
  conta: Scalars['String'],
  emprestimoSet?: Maybe<Array<Maybe<EmprestimoType>>>,
  comissaoparceirosSet?: Maybe<Array<Maybe<ComissaoParceirosType>>>,
};

export type RespasseFuncionarioType = {
   __typename?: 'RespasseFuncionarioType',
  id: Scalars['ID'],
  valorTotal: Scalars['Float'],
  funcionario: FuncionarioTypeRelay,
  emprestimo?: Maybe<EmprestimoRelatorioType>,
  loja: EntidadeTypeRelay,
  criadoEm: Scalars['DateTime'],
  resgate: HistoricoResgateFuncionarioNodeTypeRelay,
};

export type ResponsavelLead = {
   __typename?: 'ResponsavelLead',
  ok?: Maybe<Scalars['Boolean']>,
  lead?: Maybe<LeadsType>,
};

export type RespostaSmsType = {
   __typename?: 'RespostaSMSType',
  id: Scalars['ID'],
  response?: Maybe<Scalars['JSONString']>,
  envios: EnvioSmsTypeRelay,
};

export type RetirarPermissoesGrupoMutation = {
   __typename?: 'RetirarPermissoesGrupoMutation',
  ok?: Maybe<Scalars['Boolean']>,
};

export type RetomarOportunidadeLead = {
   __typename?: 'RetomarOportunidadeLead',
  lead?: Maybe<LeadsType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type SimulacaoEmprestimoInput = {
  valorDesejado: Scalars['Decimal'],
  valorTaxa: Scalars['Decimal'],
  tipoSimulacao: Scalars['String'],
  tcc?: Maybe<Scalars['Decimal']>,
  iof?: Maybe<Scalars['Decimal']>,
  parcelas?: Maybe<Scalars['Int']>,
  tipoCalculo?: Maybe<Scalars['String']>,
};

export type SimulacaoEmprestimoType = {
   __typename?: 'SimulacaoEmprestimoType',
  valorTotal?: Maybe<Scalars['Decimal']>,
  bonusFuncionario?: Maybe<Scalars['Decimal']>,
  simulacaoBonificada?: Maybe<Scalars['Boolean']>,
};

export type SimulaEmprestimoLead = {
   __typename?: 'simulaEmprestimoLead',
  proposta?: Maybe<PropostasType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type StatusLeadType = {
   __typename?: 'StatusLeadType',
  id: Scalars['ID'],
  nome: Scalars['String'],
  index?: Maybe<Scalars['Int']>,
  leadsSet: LeadsNodeTypeRelayPropConnection,
  mensagemzapiSet: Array<MensagemZApiType>,
};


export type StatusLeadTypeLeadsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};

export type SubCategoriasTypeRelay = Node & {
   __typename?: 'SubCategoriasTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome?: Maybe<Scalars['String']>,
  categoria: CategoriaTypeRelay,
  excluido: Scalars['Boolean'],
  fornecedorSet: FornecedorViewNodeTypeConnection,
};


export type SubCategoriasTypeRelayFornecedorSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};

export type SubCategoriasTypeRelayConnection = {
   __typename?: 'SubCategoriasTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SubCategoriasTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `SubCategoriasTypeRelay` and its cursor. */
export type SubCategoriasTypeRelayEdge = {
   __typename?: 'SubCategoriasTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<SubCategoriasTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum TabelaParceirosBandeiraTabela {
  /** Visa */
  Visa = 'VISA',
  /** Mastercard */
  Mastercard = 'MASTERCARD'
}

/** An enumeration. */
export enum TabelaParceirosCategoriaTabela {
  /** Funcionario */
  Funcionario = 'FUNCIONARIO',
  /** Parceiro */
  Parceiro = 'PARCEIRO'
}

/** An enumeration. */
export enum TabelaParceirosTipoTabela {
  /** Tabela comissão */
  TabelaComissao = 'TABELA_COMISSAO',
  /** Tabela subadquirente */
  TabelaSubadquirente = 'TABELA_SUBADQUIRENTE',
  /** Tabela subadquirente + financeiro */
  TabelaSubadquirenteFinanceiro = 'TABELA_SUBADQUIRENTE_FINANCEIRO'
}

export type TabelaParceirosType = {
   __typename?: 'TabelaParceirosType',
  id: Scalars['ID'],
  nome: Scalars['String'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  categoriaTabela?: Maybe<TabelaParceirosCategoriaTabela>,
  tipoTabela?: Maybe<TabelaParceirosTipoTabela>,
  bandeiraTabela?: Maybe<TabelaParceirosBandeiraTabela>,
  grupodepermissoesSet?: Maybe<Array<Maybe<GrupoDePermissoesType>>>,
  funcionariodegrupoSet: Array<FuncionarioDeGrupoType>,
  colunatabelaparceirosSet?: Maybe<Array<Maybe<ColunaTabelaType>>>,
  parceirosSet: ParceirosNodeTypeRelayConnection,
  lojaparceiroSet: Array<Maybe<LojaParceiroType>>,
  funcionariosrepasseSet?: Maybe<Array<Maybe<FuncionariosRepasseType>>>,
  grupofuncionariosrepasseSet: Array<GrupoFuncionariosRepasseType>,
};


export type TabelaParceirosTypeColunatabelaparceirosSetArgs = {
  orderBy?: Maybe<Scalars['String']>
};


export type TabelaParceirosTypeParceirosSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Id?: Maybe<Scalars['ID']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  lojaparceiro_Loja_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela?: Maybe<Scalars['String']>,
  lojaparceiro_Tabela_TipoTabela_Icontains?: Maybe<Scalars['String']>,
  tabela_Nome_Icontains?: Maybe<Scalars['String']>,
  lojaRepasseId?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  resgateautomaticoparceiros_Segunda?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Terca?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quarta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Quinta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sexta?: Maybe<Scalars['Boolean']>,
  resgateautomaticoparceiros_Sabado?: Maybe<Scalars['Boolean']>,
  tabelaId?: Maybe<Scalars['ID']>
};


export type TabelaParceirosTypeLojaparceiroSetArgs = {
  parceirosIds?: Maybe<Array<Maybe<Scalars['ID']>>>,
  comDistinct?: Maybe<Scalars['Boolean']>
};

export type TabelasNodeTypeRelay = Node & {
   __typename?: 'TabelasNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  categoriaTabela?: Maybe<TabelaParceirosCategoriaTabela>,
  tipoTabela?: Maybe<TabelaParceirosTipoTabela>,
  bandeiraTabela?: Maybe<TabelaParceirosBandeiraTabela>,
  grupodepermissoesSet: GrupoDePermissoesTypeRelayConnection,
  funcionariodegrupoSet: Array<FuncionarioDeGrupoType>,
  colunatabelaparceirosSet: Array<ColunaTabelaType>,
  parceirosSet?: Maybe<Array<Maybe<ParceirosType>>>,
  lojaparceiroSet: Array<LojaParceiroType>,
  funcionariosrepasseSet?: Maybe<Array<Maybe<FuncionariosRepasseType>>>,
  grupofuncionariosrepasseSet: Array<GrupoFuncionariosRepasseType>,
};


export type TabelasNodeTypeRelayGrupodepermissoesSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  descricao?: Maybe<Scalars['String']>,
  descricao_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Nome_Icontains?: Maybe<Scalars['String']>,
  funcionario_Funcionario_Id?: Maybe<Scalars['ID']>,
  entidade_Entidade_Nome?: Maybe<Scalars['String']>,
  entidade_Entidade_Nome_Icontains?: Maybe<Scalars['String']>,
  entidade_Entidade_Id?: Maybe<Scalars['ID']>,
  permissao_Descricao?: Maybe<Scalars['String']>,
  permissao_Descricao_Icontains?: Maybe<Scalars['String']>,
  permissao_Descricao_In?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};

export type TabelasNodeTypeRelayConnection = {
   __typename?: 'TabelasNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TabelasNodeTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `TabelasNodeTypeRelay` and its cursor. */
export type TabelasNodeTypeRelayEdge = {
   __typename?: 'TabelasNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<TabelasNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type TabelaTaxaParcelasType = {
   __typename?: 'TabelaTaxaParcelasType',
  id: Scalars['ID'],
  valorTabela?: Maybe<Scalars['Float']>,
  entidade: EntidadeTypeRelay,
  tabelaParcelas: Array<ColunaTaxasParcelasType>,
  parcelas?: Maybe<Scalars['String']>,
  taxaMinima?: Maybe<Scalars['Float']>,
};

export type TabelaTaxasInput = {
  valorTabela: Scalars['Float'],
  parcelas: Array<Maybe<TaxasParcelasInput>>,
};

export type TarefasNodeTypeRelay = Node & {
   __typename?: 'TarefasNodeTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  lead: LeadsNodeTypeRelayProp,
  assunto: Scalars['String'],
  tipo: TarefasTipo,
  funcionario?: Maybe<FuncionarioTypeRelay>,
  comentario?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['Date']>,
  hora?: Maybe<Scalars['Time']>,
  dataHora?: Maybe<Scalars['DateTime']>,
  status?: Maybe<TarefasStatus>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
};

export type TarefasNodeTypeRelayConnection = {
   __typename?: 'TarefasNodeTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TarefasNodeTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `TarefasNodeTypeRelay` and its cursor. */
export type TarefasNodeTypeRelayEdge = {
   __typename?: 'TarefasNodeTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<TarefasNodeTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum TarefasStatus {
  /** Pendente */
  Pendente = 'PENDENTE',
  /** Concluída */
  Concluida = 'CONCLUIDA'
}

/** An enumeration. */
export enum TarefasTipo {
  /** Visita à loja */
  Loja = 'LOJA',
  /** Ligação */
  Ligacao = 'LIGACAO',
  /** Whatsapp */
  Whatsapp = 'WHATSAPP',
  /** Email */
  Email = 'EMAIL',
  /** SMS */
  Sms = 'SMS',
  /** Redes Sociais */
  SocialNetwork = 'SOCIAL_NETWORK'
}

export type TarefasType = {
   __typename?: 'TarefasType',
  id: Scalars['ID'],
  lead: LeadsNodeTypeRelayProp,
  assunto: Scalars['String'],
  tipo: TarefasTipo,
  funcionario?: Maybe<FuncionarioTypeRelay>,
  comentario?: Maybe<Scalars['String']>,
  data?: Maybe<Scalars['Date']>,
  hora?: Maybe<Scalars['Time']>,
  dataHora?: Maybe<Scalars['DateTime']>,
  status?: Maybe<TarefasStatus>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
};

export type TaxaColunaType = {
   __typename?: 'TaxaColunaType',
  taxaMinima?: Maybe<Scalars['Float']>,
  taxaSeguranca?: Maybe<Scalars['Float']>,
};

export type TaxasParcelasInput = {
  taxaMinima?: Maybe<Scalars['Float']>,
  taxaSeguranca?: Maybe<Scalars['Float']>,
  parcelas: Scalars['String'],
};

export type TaxasParcelasMaquinaInput = {
  parcelas: TaxasParcelasMaquinaParcelas,
  bandeiras: Scalars['String'],
  taxaAdministrativa?: Maybe<Scalars['Float']>,
  taxaAntecipacao?: Maybe<Scalars['Float']>,
  limite?: Maybe<Scalars['Float']>,
  meta?: Maybe<Scalars['Float']>,
};

export type TaxasParcelasMaquinaNode = Node & {
   __typename?: 'TaxasParcelasMaquinaNode',
  /** The ID of the object. */
  id: Scalars['ID'],
  maquina: MaquinaNode,
  parcelas: TaxasParcelasMaquinaParcelas,
  bandeiras: Scalars['String'],
  taxaAdministrativa?: Maybe<Scalars['Float']>,
  taxaAntecipacao?: Maybe<Scalars['Float']>,
  limite: Scalars['Float'],
  meta: Scalars['Float'],
};

export type TaxasParcelasMaquinaNodeConnection = {
   __typename?: 'TaxasParcelasMaquinaNodeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TaxasParcelasMaquinaNodeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `TaxasParcelasMaquinaNode` and its cursor. */
export type TaxasParcelasMaquinaNodeEdge = {
   __typename?: 'TaxasParcelasMaquinaNodeEdge',
  /** The item at the end of the edge */
  node?: Maybe<TaxasParcelasMaquinaNode>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum TaxasParcelasMaquinaParcelas {
  /** 1x */
  A_1 = 'A_1',
  /** 2x */
  A_2 = 'A_2',
  /** 3x */
  A_3 = 'A_3',
  /** 4x */
  A_4 = 'A_4',
  /** 5x */
  A_5 = 'A_5',
  /** 6x */
  A_6 = 'A_6',
  /** 7x */
  A_7 = 'A_7',
  /** 8x */
  A_8 = 'A_8',
  /** 9x */
  A_9 = 'A_9',
  /** 10x */
  A_10 = 'A_10',
  /** 11x */
  A_11 = 'A_11',
  /** 12x */
  A_12 = 'A_12',
  /** 13x */
  A_13 = 'A_13',
  /** 14x */
  A_14 = 'A_14',
  /** 15x */
  A_15 = 'A_15',
  /** 16x */
  A_16 = 'A_16',
  /** 17x */
  A_17 = 'A_17',
  /** 18x */
  A_18 = 'A_18',
  /** 19x */
  A_19 = 'A_19',
  /** 20x */
  A_20 = 'A_20',
  /** 21x */
  A_21 = 'A_21',
  /** 22x */
  A_22 = 'A_22',
  /** 23x */
  A_23 = 'A_23',
  /** 24x */
  A_24 = 'A_24',
  /** 25x */
  A_25 = 'A_25',
  /** 26x */
  A_26 = 'A_26',
  /** 27x */
  A_27 = 'A_27',
  /** 28x */
  A_28 = 'A_28',
  /** 29x */
  A_29 = 'A_29',
  /** 30x */
  A_30 = 'A_30',
  /** 31x */
  A_31 = 'A_31',
  /** 32x */
  A_32 = 'A_32',
  /** 33x */
  A_33 = 'A_33',
  /** 34x */
  A_34 = 'A_34',
  /** 35x */
  A_35 = 'A_35',
  /** 36x */
  A_36 = 'A_36',
  /** 37x */
  A_37 = 'A_37',
  /** 38x */
  A_38 = 'A_38',
  /** 39x */
  A_39 = 'A_39',
  /** 40x */
  A_40 = 'A_40',
  /** 41x */
  A_41 = 'A_41',
  /** 42x */
  A_42 = 'A_42',
  /** 43x */
  A_43 = 'A_43',
  /** 44x */
  A_44 = 'A_44',
  /** 45x */
  A_45 = 'A_45',
  /** 46x */
  A_46 = 'A_46',
  /** 47x */
  A_47 = 'A_47',
  /** 48x */
  A_48 = 'A_48',
  /** 49x */
  A_49 = 'A_49',
  /** 50x */
  A_50 = 'A_50',
  /** 51x */
  A_51 = 'A_51',
  /** 52x */
  A_52 = 'A_52',
  /** 53x */
  A_53 = 'A_53',
  /** 54x */
  A_54 = 'A_54',
  /** 55x */
  A_55 = 'A_55',
  /** 56x */
  A_56 = 'A_56',
  /** 57x */
  A_57 = 'A_57',
  /** 58x */
  A_58 = 'A_58',
  /** 59x */
  A_59 = 'A_59',
  /** 60x */
  A_60 = 'A_60',
  /** 61x */
  A_61 = 'A_61',
  /** 62x */
  A_62 = 'A_62',
  /** 63x */
  A_63 = 'A_63',
  /** 64x */
  A_64 = 'A_64',
  /** 65x */
  A_65 = 'A_65',
  /** 66x */
  A_66 = 'A_66',
  /** 67x */
  A_67 = 'A_67',
  /** 68x */
  A_68 = 'A_68',
  /** 69x */
  A_69 = 'A_69',
  /** 70x */
  A_70 = 'A_70',
  /** 71x */
  A_71 = 'A_71',
  /** 72x */
  A_72 = 'A_72',
  /** 73x */
  A_73 = 'A_73',
  /** 74x */
  A_74 = 'A_74',
  /** 75x */
  A_75 = 'A_75',
  /** 76x */
  A_76 = 'A_76',
  /** 77x */
  A_77 = 'A_77',
  /** 78x */
  A_78 = 'A_78',
  /** 79x */
  A_79 = 'A_79',
  /** 80x */
  A_80 = 'A_80',
  /** 81x */
  A_81 = 'A_81',
  /** 82x */
  A_82 = 'A_82',
  /** 83x */
  A_83 = 'A_83',
  /** 84x */
  A_84 = 'A_84',
  /** 85x */
  A_85 = 'A_85',
  /** 86x */
  A_86 = 'A_86',
  /** 87x */
  A_87 = 'A_87',
  /** 88x */
  A_88 = 'A_88',
  /** 89x */
  A_89 = 'A_89',
  /** 90x */
  A_90 = 'A_90',
  /** 91x */
  A_91 = 'A_91',
  /** 92x */
  A_92 = 'A_92',
  /** 93x */
  A_93 = 'A_93',
  /** 94x */
  A_94 = 'A_94',
  /** 95x */
  A_95 = 'A_95',
  /** 96x */
  A_96 = 'A_96',
  /** 97x */
  A_97 = 'A_97',
  /** 98x */
  A_98 = 'A_98',
  /** 99x */
  A_99 = 'A_99',
  /** 100x */
  A_100 = 'A_100',
  /** 101x */
  A_101 = 'A_101',
  /** 102x */
  A_102 = 'A_102',
  /** 103x */
  A_103 = 'A_103',
  /** 104x */
  A_104 = 'A_104',
  /** 105x */
  A_105 = 'A_105',
  /** 106x */
  A_106 = 'A_106',
  /** 107x */
  A_107 = 'A_107',
  /** 108x */
  A_108 = 'A_108',
  /** 109x */
  A_109 = 'A_109',
  /** 110x */
  A_110 = 'A_110',
  /** 111x */
  A_111 = 'A_111',
  /** 112x */
  A_112 = 'A_112',
  /** 113x */
  A_113 = 'A_113',
  /** 114x */
  A_114 = 'A_114',
  /** 115x */
  A_115 = 'A_115',
  /** 116x */
  A_116 = 'A_116',
  /** 117x */
  A_117 = 'A_117',
  /** 118x */
  A_118 = 'A_118',
  /** 119x */
  A_119 = 'A_119',
  /** 120x */
  A_120 = 'A_120',
  /** 121x */
  A_121 = 'A_121',
  /** 122x */
  A_122 = 'A_122',
  /** 123x */
  A_123 = 'A_123',
  /** 124x */
  A_124 = 'A_124',
  /** 125x */
  A_125 = 'A_125',
  /** 126x */
  A_126 = 'A_126',
  /** 127x */
  A_127 = 'A_127',
  /** 128x */
  A_128 = 'A_128',
  /** 129x */
  A_129 = 'A_129',
  /** 130x */
  A_130 = 'A_130',
  /** 131x */
  A_131 = 'A_131',
  /** 132x */
  A_132 = 'A_132',
  /** 133x */
  A_133 = 'A_133',
  /** 134x */
  A_134 = 'A_134',
  /** 135x */
  A_135 = 'A_135',
  /** 136x */
  A_136 = 'A_136',
  /** 137x */
  A_137 = 'A_137',
  /** 138x */
  A_138 = 'A_138',
  /** 139x */
  A_139 = 'A_139',
  /** 140x */
  A_140 = 'A_140',
  /** 141x */
  A_141 = 'A_141',
  /** 142x */
  A_142 = 'A_142',
  /** 143x */
  A_143 = 'A_143',
  /** 144x */
  A_144 = 'A_144',
  /** 145x */
  A_145 = 'A_145',
  /** 146x */
  A_146 = 'A_146',
  /** 147x */
  A_147 = 'A_147',
  /** 148x */
  A_148 = 'A_148',
  /** 149x */
  A_149 = 'A_149',
  /** 150x */
  A_150 = 'A_150',
  /** 151x */
  A_151 = 'A_151',
  /** 152x */
  A_152 = 'A_152',
  /** 153x */
  A_153 = 'A_153',
  /** 154x */
  A_154 = 'A_154',
  /** 155x */
  A_155 = 'A_155',
  /** 156x */
  A_156 = 'A_156',
  /** 157x */
  A_157 = 'A_157',
  /** 158x */
  A_158 = 'A_158',
  /** 159x */
  A_159 = 'A_159',
  /** 160x */
  A_160 = 'A_160',
  /** 161x */
  A_161 = 'A_161',
  /** 162x */
  A_162 = 'A_162',
  /** 163x */
  A_163 = 'A_163',
  /** 164x */
  A_164 = 'A_164',
  /** 165x */
  A_165 = 'A_165',
  /** 166x */
  A_166 = 'A_166',
  /** 167x */
  A_167 = 'A_167',
  /** 168x */
  A_168 = 'A_168',
  /** 169x */
  A_169 = 'A_169',
  /** 170x */
  A_170 = 'A_170',
  /** 171x */
  A_171 = 'A_171',
  /** 172x */
  A_172 = 'A_172',
  /** 173x */
  A_173 = 'A_173',
  /** 174x */
  A_174 = 'A_174',
  /** 175x */
  A_175 = 'A_175',
  /** 176x */
  A_176 = 'A_176',
  /** 177x */
  A_177 = 'A_177',
  /** 178x */
  A_178 = 'A_178',
  /** 179x */
  A_179 = 'A_179',
  /** 180x */
  A_180 = 'A_180',
  /** 181x */
  A_181 = 'A_181',
  /** 182x */
  A_182 = 'A_182',
  /** 183x */
  A_183 = 'A_183',
  /** 184x */
  A_184 = 'A_184',
  /** 185x */
  A_185 = 'A_185',
  /** 186x */
  A_186 = 'A_186',
  /** 187x */
  A_187 = 'A_187',
  /** 188x */
  A_188 = 'A_188',
  /** 189x */
  A_189 = 'A_189',
  /** 190x */
  A_190 = 'A_190',
  /** 191x */
  A_191 = 'A_191',
  /** 192x */
  A_192 = 'A_192',
  /** 193x */
  A_193 = 'A_193',
  /** 194x */
  A_194 = 'A_194',
  /** 195x */
  A_195 = 'A_195',
  /** 196x */
  A_196 = 'A_196',
  /** 197x */
  A_197 = 'A_197',
  /** 198x */
  A_198 = 'A_198',
  /** 199x */
  A_199 = 'A_199',
  /** 200x */
  A_200 = 'A_200',
  /** 201x */
  A_201 = 'A_201',
  /** 202x */
  A_202 = 'A_202',
  /** 203x */
  A_203 = 'A_203',
  /** 204x */
  A_204 = 'A_204',
  /** 205x */
  A_205 = 'A_205',
  /** 206x */
  A_206 = 'A_206',
  /** 207x */
  A_207 = 'A_207',
  /** 208x */
  A_208 = 'A_208',
  /** 209x */
  A_209 = 'A_209',
  /** 210x */
  A_210 = 'A_210',
  /** 211x */
  A_211 = 'A_211',
  /** 212x */
  A_212 = 'A_212',
  /** 213x */
  A_213 = 'A_213',
  /** 214x */
  A_214 = 'A_214',
  /** 215x */
  A_215 = 'A_215',
  /** 216x */
  A_216 = 'A_216',
  /** 217x */
  A_217 = 'A_217',
  /** 218x */
  A_218 = 'A_218',
  /** 219x */
  A_219 = 'A_219',
  /** 220x */
  A_220 = 'A_220',
  /** 221x */
  A_221 = 'A_221',
  /** 222x */
  A_222 = 'A_222',
  /** 223x */
  A_223 = 'A_223',
  /** 224x */
  A_224 = 'A_224',
  /** 225x */
  A_225 = 'A_225',
  /** 226x */
  A_226 = 'A_226',
  /** 227x */
  A_227 = 'A_227',
  /** 228x */
  A_228 = 'A_228',
  /** 229x */
  A_229 = 'A_229',
  /** 230x */
  A_230 = 'A_230',
  /** 231x */
  A_231 = 'A_231',
  /** 232x */
  A_232 = 'A_232',
  /** 233x */
  A_233 = 'A_233',
  /** 234x */
  A_234 = 'A_234',
  /** 235x */
  A_235 = 'A_235',
  /** 236x */
  A_236 = 'A_236',
  /** 237x */
  A_237 = 'A_237',
  /** 238x */
  A_238 = 'A_238',
  /** 239x */
  A_239 = 'A_239',
  /** 240x */
  A_240 = 'A_240',
  /** 241x */
  A_241 = 'A_241',
  /** 242x */
  A_242 = 'A_242',
  /** 243x */
  A_243 = 'A_243',
  /** 244x */
  A_244 = 'A_244',
  /** 245x */
  A_245 = 'A_245',
  /** 246x */
  A_246 = 'A_246',
  /** 247x */
  A_247 = 'A_247',
  /** 248x */
  A_248 = 'A_248',
  /** 249x */
  A_249 = 'A_249',
  /** 250x */
  A_250 = 'A_250',
  /** 251x */
  A_251 = 'A_251',
  /** 252x */
  A_252 = 'A_252',
  /** 253x */
  A_253 = 'A_253',
  /** 254x */
  A_254 = 'A_254',
  /** 255x */
  A_255 = 'A_255',
  /** 256x */
  A_256 = 'A_256',
  /** 257x */
  A_257 = 'A_257',
  /** 258x */
  A_258 = 'A_258',
  /** 259x */
  A_259 = 'A_259',
  /** 260x */
  A_260 = 'A_260',
  /** 261x */
  A_261 = 'A_261',
  /** 262x */
  A_262 = 'A_262',
  /** 263x */
  A_263 = 'A_263',
  /** 264x */
  A_264 = 'A_264',
  /** 265x */
  A_265 = 'A_265',
  /** 266x */
  A_266 = 'A_266',
  /** 267x */
  A_267 = 'A_267',
  /** 268x */
  A_268 = 'A_268',
  /** 269x */
  A_269 = 'A_269',
  /** 270x */
  A_270 = 'A_270',
  /** 271x */
  A_271 = 'A_271',
  /** 272x */
  A_272 = 'A_272',
  /** 273x */
  A_273 = 'A_273',
  /** 274x */
  A_274 = 'A_274',
  /** 275x */
  A_275 = 'A_275',
  /** 276x */
  A_276 = 'A_276',
  /** 277x */
  A_277 = 'A_277',
  /** 278x */
  A_278 = 'A_278',
  /** 279x */
  A_279 = 'A_279',
  /** 280x */
  A_280 = 'A_280',
  /** 281x */
  A_281 = 'A_281',
  /** 282x */
  A_282 = 'A_282',
  /** 283x */
  A_283 = 'A_283',
  /** 284x */
  A_284 = 'A_284',
  /** 285x */
  A_285 = 'A_285',
  /** 286x */
  A_286 = 'A_286',
  /** 287x */
  A_287 = 'A_287',
  /** 288x */
  A_288 = 'A_288',
  /** 289x */
  A_289 = 'A_289',
  /** 290x */
  A_290 = 'A_290',
  /** 291x */
  A_291 = 'A_291',
  /** 292x */
  A_292 = 'A_292',
  /** 293x */
  A_293 = 'A_293',
  /** 294x */
  A_294 = 'A_294',
  /** 295x */
  A_295 = 'A_295',
  /** 296x */
  A_296 = 'A_296',
  /** 297x */
  A_297 = 'A_297',
  /** 298x */
  A_298 = 'A_298',
  /** 299x */
  A_299 = 'A_299',
  /** 300x */
  A_300 = 'A_300',
  /** 301x */
  A_301 = 'A_301',
  /** 302x */
  A_302 = 'A_302',
  /** 303x */
  A_303 = 'A_303',
  /** 304x */
  A_304 = 'A_304',
  /** 305x */
  A_305 = 'A_305',
  /** 306x */
  A_306 = 'A_306',
  /** 307x */
  A_307 = 'A_307',
  /** 308x */
  A_308 = 'A_308',
  /** 309x */
  A_309 = 'A_309',
  /** 310x */
  A_310 = 'A_310',
  /** 311x */
  A_311 = 'A_311',
  /** 312x */
  A_312 = 'A_312',
  /** 313x */
  A_313 = 'A_313',
  /** 314x */
  A_314 = 'A_314',
  /** 315x */
  A_315 = 'A_315',
  /** 316x */
  A_316 = 'A_316',
  /** 317x */
  A_317 = 'A_317',
  /** 318x */
  A_318 = 'A_318',
  /** 319x */
  A_319 = 'A_319',
  /** 320x */
  A_320 = 'A_320',
  /** 321x */
  A_321 = 'A_321',
  /** 322x */
  A_322 = 'A_322',
  /** 323x */
  A_323 = 'A_323',
  /** 324x */
  A_324 = 'A_324',
  /** 325x */
  A_325 = 'A_325',
  /** 326x */
  A_326 = 'A_326',
  /** 327x */
  A_327 = 'A_327',
  /** 328x */
  A_328 = 'A_328',
  /** 329x */
  A_329 = 'A_329',
  /** 330x */
  A_330 = 'A_330',
  /** 331x */
  A_331 = 'A_331',
  /** 332x */
  A_332 = 'A_332',
  /** 333x */
  A_333 = 'A_333',
  /** 334x */
  A_334 = 'A_334',
  /** 335x */
  A_335 = 'A_335',
  /** 336x */
  A_336 = 'A_336',
  /** 337x */
  A_337 = 'A_337',
  /** 338x */
  A_338 = 'A_338',
  /** 339x */
  A_339 = 'A_339',
  /** 340x */
  A_340 = 'A_340',
  /** 341x */
  A_341 = 'A_341',
  /** 342x */
  A_342 = 'A_342',
  /** 343x */
  A_343 = 'A_343',
  /** 344x */
  A_344 = 'A_344',
  /** 345x */
  A_345 = 'A_345',
  /** 346x */
  A_346 = 'A_346',
  /** 347x */
  A_347 = 'A_347',
  /** 348x */
  A_348 = 'A_348',
  /** 349x */
  A_349 = 'A_349',
  /** 350x */
  A_350 = 'A_350',
  /** 351x */
  A_351 = 'A_351',
  /** 352x */
  A_352 = 'A_352',
  /** 353x */
  A_353 = 'A_353',
  /** 354x */
  A_354 = 'A_354',
  /** 355x */
  A_355 = 'A_355',
  /** 356x */
  A_356 = 'A_356',
  /** 357x */
  A_357 = 'A_357',
  /** 358x */
  A_358 = 'A_358',
  /** 359x */
  A_359 = 'A_359',
  /** 360x */
  A_360 = 'A_360',
  /** 361x */
  A_361 = 'A_361',
  /** 362x */
  A_362 = 'A_362',
  /** 363x */
  A_363 = 'A_363',
  /** 364x */
  A_364 = 'A_364',
  /** 365x */
  A_365 = 'A_365',
  /** 366x */
  A_366 = 'A_366',
  /** 367x */
  A_367 = 'A_367',
  /** 368x */
  A_368 = 'A_368',
  /** 369x */
  A_369 = 'A_369',
  /** 370x */
  A_370 = 'A_370',
  /** 371x */
  A_371 = 'A_371',
  /** 372x */
  A_372 = 'A_372',
  /** 373x */
  A_373 = 'A_373',
  /** 374x */
  A_374 = 'A_374',
  /** 375x */
  A_375 = 'A_375',
  /** 376x */
  A_376 = 'A_376',
  /** 377x */
  A_377 = 'A_377',
  /** 378x */
  A_378 = 'A_378',
  /** 379x */
  A_379 = 'A_379',
  /** 380x */
  A_380 = 'A_380',
  /** 381x */
  A_381 = 'A_381',
  /** 382x */
  A_382 = 'A_382',
  /** 383x */
  A_383 = 'A_383',
  /** 384x */
  A_384 = 'A_384',
  /** 385x */
  A_385 = 'A_385',
  /** 386x */
  A_386 = 'A_386',
  /** 387x */
  A_387 = 'A_387',
  /** 388x */
  A_388 = 'A_388',
  /** 389x */
  A_389 = 'A_389',
  /** 390x */
  A_390 = 'A_390',
  /** 391x */
  A_391 = 'A_391',
  /** 392x */
  A_392 = 'A_392',
  /** 393x */
  A_393 = 'A_393',
  /** 394x */
  A_394 = 'A_394',
  /** 395x */
  A_395 = 'A_395',
  /** 396x */
  A_396 = 'A_396',
  /** 397x */
  A_397 = 'A_397',
  /** 398x */
  A_398 = 'A_398',
  /** 399x */
  A_399 = 'A_399',
  /** 400x */
  A_400 = 'A_400',
  /** 401x */
  A_401 = 'A_401',
  /** 402x */
  A_402 = 'A_402',
  /** 403x */
  A_403 = 'A_403',
  /** 404x */
  A_404 = 'A_404',
  /** 405x */
  A_405 = 'A_405',
  /** 406x */
  A_406 = 'A_406',
  /** 407x */
  A_407 = 'A_407',
  /** 408x */
  A_408 = 'A_408',
  /** 409x */
  A_409 = 'A_409',
  /** 410x */
  A_410 = 'A_410',
  /** 411x */
  A_411 = 'A_411',
  /** 412x */
  A_412 = 'A_412',
  /** 413x */
  A_413 = 'A_413',
  /** 414x */
  A_414 = 'A_414',
  /** 415x */
  A_415 = 'A_415',
  /** 416x */
  A_416 = 'A_416',
  /** 417x */
  A_417 = 'A_417',
  /** 418x */
  A_418 = 'A_418',
  /** 419x */
  A_419 = 'A_419',
  /** 420x */
  A_420 = 'A_420',
  /** 421x */
  A_421 = 'A_421',
  /** 422x */
  A_422 = 'A_422',
  /** 423x */
  A_423 = 'A_423',
  /** 424x */
  A_424 = 'A_424',
  /** 425x */
  A_425 = 'A_425',
  /** 426x */
  A_426 = 'A_426',
  /** 427x */
  A_427 = 'A_427',
  /** 428x */
  A_428 = 'A_428',
  /** 429x */
  A_429 = 'A_429',
  /** 430x */
  A_430 = 'A_430',
  /** 431x */
  A_431 = 'A_431',
  /** 432x */
  A_432 = 'A_432',
  /** 433x */
  A_433 = 'A_433',
  /** 434x */
  A_434 = 'A_434',
  /** 435x */
  A_435 = 'A_435',
  /** 436x */
  A_436 = 'A_436',
  /** 437x */
  A_437 = 'A_437',
  /** 438x */
  A_438 = 'A_438',
  /** 439x */
  A_439 = 'A_439',
  /** 440x */
  A_440 = 'A_440',
  /** 441x */
  A_441 = 'A_441',
  /** 442x */
  A_442 = 'A_442',
  /** 443x */
  A_443 = 'A_443',
  /** 444x */
  A_444 = 'A_444',
  /** 445x */
  A_445 = 'A_445',
  /** 446x */
  A_446 = 'A_446',
  /** 447x */
  A_447 = 'A_447',
  /** 448x */
  A_448 = 'A_448',
  /** 449x */
  A_449 = 'A_449',
  /** 450x */
  A_450 = 'A_450',
  /** 451x */
  A_451 = 'A_451',
  /** 452x */
  A_452 = 'A_452',
  /** 453x */
  A_453 = 'A_453',
  /** 454x */
  A_454 = 'A_454',
  /** 455x */
  A_455 = 'A_455',
  /** 456x */
  A_456 = 'A_456',
  /** 457x */
  A_457 = 'A_457',
  /** 458x */
  A_458 = 'A_458',
  /** 459x */
  A_459 = 'A_459',
  /** 460x */
  A_460 = 'A_460',
  /** 461x */
  A_461 = 'A_461',
  /** 462x */
  A_462 = 'A_462',
  /** 463x */
  A_463 = 'A_463',
  /** 464x */
  A_464 = 'A_464',
  /** 465x */
  A_465 = 'A_465',
  /** 466x */
  A_466 = 'A_466',
  /** 467x */
  A_467 = 'A_467',
  /** 468x */
  A_468 = 'A_468',
  /** 469x */
  A_469 = 'A_469',
  /** 470x */
  A_470 = 'A_470',
  /** 471x */
  A_471 = 'A_471',
  /** 472x */
  A_472 = 'A_472',
  /** 473x */
  A_473 = 'A_473',
  /** 474x */
  A_474 = 'A_474',
  /** 475x */
  A_475 = 'A_475',
  /** 476x */
  A_476 = 'A_476',
  /** 477x */
  A_477 = 'A_477',
  /** 478x */
  A_478 = 'A_478',
  /** 479x */
  A_479 = 'A_479',
  /** 480x */
  A_480 = 'A_480',
  /** 481x */
  A_481 = 'A_481',
  /** 482x */
  A_482 = 'A_482',
  /** 483x */
  A_483 = 'A_483',
  /** 484x */
  A_484 = 'A_484',
  /** 485x */
  A_485 = 'A_485',
  /** 486x */
  A_486 = 'A_486',
  /** 487x */
  A_487 = 'A_487',
  /** 488x */
  A_488 = 'A_488',
  /** 489x */
  A_489 = 'A_489',
  /** 490x */
  A_490 = 'A_490',
  /** 491x */
  A_491 = 'A_491',
  /** 492x */
  A_492 = 'A_492',
  /** 493x */
  A_493 = 'A_493',
  /** 494x */
  A_494 = 'A_494',
  /** 495x */
  A_495 = 'A_495',
  /** 496x */
  A_496 = 'A_496',
  /** 497x */
  A_497 = 'A_497',
  /** 498x */
  A_498 = 'A_498',
  /** 499x */
  A_499 = 'A_499',
  /** 500x */
  A_500 = 'A_500',
  /** 501x */
  A_501 = 'A_501',
  /** 502x */
  A_502 = 'A_502',
  /** 503x */
  A_503 = 'A_503',
  /** 504x */
  A_504 = 'A_504',
  /** 505x */
  A_505 = 'A_505',
  /** 506x */
  A_506 = 'A_506',
  /** 507x */
  A_507 = 'A_507',
  /** 508x */
  A_508 = 'A_508',
  /** 509x */
  A_509 = 'A_509',
  /** 510x */
  A_510 = 'A_510',
  /** 511x */
  A_511 = 'A_511',
  /** 512x */
  A_512 = 'A_512',
  /** 513x */
  A_513 = 'A_513',
  /** 514x */
  A_514 = 'A_514',
  /** 515x */
  A_515 = 'A_515',
  /** 516x */
  A_516 = 'A_516',
  /** 517x */
  A_517 = 'A_517',
  /** 518x */
  A_518 = 'A_518',
  /** 519x */
  A_519 = 'A_519',
  /** 520x */
  A_520 = 'A_520',
  /** 521x */
  A_521 = 'A_521',
  /** 522x */
  A_522 = 'A_522',
  /** 523x */
  A_523 = 'A_523',
  /** 524x */
  A_524 = 'A_524',
  /** 525x */
  A_525 = 'A_525',
  /** 526x */
  A_526 = 'A_526',
  /** 527x */
  A_527 = 'A_527',
  /** 528x */
  A_528 = 'A_528',
  /** 529x */
  A_529 = 'A_529',
  /** 530x */
  A_530 = 'A_530',
  /** 531x */
  A_531 = 'A_531',
  /** 532x */
  A_532 = 'A_532',
  /** 533x */
  A_533 = 'A_533',
  /** 534x */
  A_534 = 'A_534',
  /** 535x */
  A_535 = 'A_535',
  /** 536x */
  A_536 = 'A_536',
  /** 537x */
  A_537 = 'A_537',
  /** 538x */
  A_538 = 'A_538',
  /** 539x */
  A_539 = 'A_539',
  /** 540x */
  A_540 = 'A_540',
  /** 541x */
  A_541 = 'A_541',
  /** 542x */
  A_542 = 'A_542',
  /** 543x */
  A_543 = 'A_543',
  /** 544x */
  A_544 = 'A_544',
  /** 545x */
  A_545 = 'A_545',
  /** 546x */
  A_546 = 'A_546',
  /** 547x */
  A_547 = 'A_547',
  /** 548x */
  A_548 = 'A_548',
  /** 549x */
  A_549 = 'A_549',
  /** 550x */
  A_550 = 'A_550',
  /** 551x */
  A_551 = 'A_551',
  /** 552x */
  A_552 = 'A_552',
  /** 553x */
  A_553 = 'A_553',
  /** 554x */
  A_554 = 'A_554',
  /** 555x */
  A_555 = 'A_555',
  /** 556x */
  A_556 = 'A_556',
  /** 557x */
  A_557 = 'A_557',
  /** 558x */
  A_558 = 'A_558',
  /** 559x */
  A_559 = 'A_559',
  /** 560x */
  A_560 = 'A_560',
  /** 561x */
  A_561 = 'A_561',
  /** 562x */
  A_562 = 'A_562',
  /** 563x */
  A_563 = 'A_563',
  /** 564x */
  A_564 = 'A_564',
  /** 565x */
  A_565 = 'A_565',
  /** 566x */
  A_566 = 'A_566',
  /** 567x */
  A_567 = 'A_567',
  /** 568x */
  A_568 = 'A_568',
  /** 569x */
  A_569 = 'A_569',
  /** 570x */
  A_570 = 'A_570',
  /** 571x */
  A_571 = 'A_571',
  /** 572x */
  A_572 = 'A_572',
  /** 573x */
  A_573 = 'A_573',
  /** 574x */
  A_574 = 'A_574',
  /** 575x */
  A_575 = 'A_575',
  /** 576x */
  A_576 = 'A_576',
  /** 577x */
  A_577 = 'A_577',
  /** 578x */
  A_578 = 'A_578',
  /** 579x */
  A_579 = 'A_579',
  /** 580x */
  A_580 = 'A_580',
  /** 581x */
  A_581 = 'A_581',
  /** 582x */
  A_582 = 'A_582',
  /** 583x */
  A_583 = 'A_583',
  /** 584x */
  A_584 = 'A_584',
  /** 585x */
  A_585 = 'A_585',
  /** 586x */
  A_586 = 'A_586',
  /** 587x */
  A_587 = 'A_587',
  /** 588x */
  A_588 = 'A_588',
  /** 589x */
  A_589 = 'A_589',
  /** 590x */
  A_590 = 'A_590',
  /** 591x */
  A_591 = 'A_591',
  /** 592x */
  A_592 = 'A_592',
  /** 593x */
  A_593 = 'A_593',
  /** 594x */
  A_594 = 'A_594',
  /** 595x */
  A_595 = 'A_595',
  /** 596x */
  A_596 = 'A_596',
  /** 597x */
  A_597 = 'A_597',
  /** 598x */
  A_598 = 'A_598',
  /** 599x */
  A_599 = 'A_599',
  /** 600x */
  A_600 = 'A_600',
  /** 601x */
  A_601 = 'A_601',
  /** 602x */
  A_602 = 'A_602',
  /** 603x */
  A_603 = 'A_603',
  /** 604x */
  A_604 = 'A_604',
  /** 605x */
  A_605 = 'A_605',
  /** 606x */
  A_606 = 'A_606',
  /** 607x */
  A_607 = 'A_607',
  /** 608x */
  A_608 = 'A_608',
  /** 609x */
  A_609 = 'A_609',
  /** 610x */
  A_610 = 'A_610',
  /** 611x */
  A_611 = 'A_611',
  /** 612x */
  A_612 = 'A_612',
  /** 613x */
  A_613 = 'A_613',
  /** 614x */
  A_614 = 'A_614',
  /** 615x */
  A_615 = 'A_615',
  /** 616x */
  A_616 = 'A_616',
  /** 617x */
  A_617 = 'A_617',
  /** 618x */
  A_618 = 'A_618',
  /** 619x */
  A_619 = 'A_619',
  /** 620x */
  A_620 = 'A_620',
  /** 621x */
  A_621 = 'A_621',
  /** 622x */
  A_622 = 'A_622',
  /** 623x */
  A_623 = 'A_623',
  /** 624x */
  A_624 = 'A_624',
  /** 625x */
  A_625 = 'A_625',
  /** 626x */
  A_626 = 'A_626',
  /** 627x */
  A_627 = 'A_627',
  /** 628x */
  A_628 = 'A_628',
  /** 629x */
  A_629 = 'A_629',
  /** 630x */
  A_630 = 'A_630',
  /** 631x */
  A_631 = 'A_631',
  /** 632x */
  A_632 = 'A_632',
  /** 633x */
  A_633 = 'A_633',
  /** 634x */
  A_634 = 'A_634',
  /** 635x */
  A_635 = 'A_635',
  /** 636x */
  A_636 = 'A_636',
  /** 637x */
  A_637 = 'A_637',
  /** 638x */
  A_638 = 'A_638',
  /** 639x */
  A_639 = 'A_639',
  /** 640x */
  A_640 = 'A_640',
  /** 641x */
  A_641 = 'A_641',
  /** 642x */
  A_642 = 'A_642',
  /** 643x */
  A_643 = 'A_643',
  /** 644x */
  A_644 = 'A_644',
  /** 645x */
  A_645 = 'A_645',
  /** 646x */
  A_646 = 'A_646',
  /** 647x */
  A_647 = 'A_647',
  /** 648x */
  A_648 = 'A_648',
  /** 649x */
  A_649 = 'A_649',
  /** 650x */
  A_650 = 'A_650',
  /** 651x */
  A_651 = 'A_651',
  /** 652x */
  A_652 = 'A_652',
  /** 653x */
  A_653 = 'A_653',
  /** 654x */
  A_654 = 'A_654',
  /** 655x */
  A_655 = 'A_655',
  /** 656x */
  A_656 = 'A_656',
  /** 657x */
  A_657 = 'A_657',
  /** 658x */
  A_658 = 'A_658',
  /** 659x */
  A_659 = 'A_659',
  /** 660x */
  A_660 = 'A_660',
  /** 661x */
  A_661 = 'A_661',
  /** 662x */
  A_662 = 'A_662',
  /** 663x */
  A_663 = 'A_663',
  /** 664x */
  A_664 = 'A_664',
  /** 665x */
  A_665 = 'A_665',
  /** 666x */
  A_666 = 'A_666',
  /** 667x */
  A_667 = 'A_667',
  /** 668x */
  A_668 = 'A_668',
  /** 669x */
  A_669 = 'A_669',
  /** 670x */
  A_670 = 'A_670',
  /** 671x */
  A_671 = 'A_671',
  /** 672x */
  A_672 = 'A_672',
  /** 673x */
  A_673 = 'A_673',
  /** 674x */
  A_674 = 'A_674',
  /** 675x */
  A_675 = 'A_675',
  /** 676x */
  A_676 = 'A_676',
  /** 677x */
  A_677 = 'A_677',
  /** 678x */
  A_678 = 'A_678',
  /** 679x */
  A_679 = 'A_679',
  /** 680x */
  A_680 = 'A_680',
  /** 681x */
  A_681 = 'A_681',
  /** 682x */
  A_682 = 'A_682',
  /** 683x */
  A_683 = 'A_683',
  /** 684x */
  A_684 = 'A_684',
  /** 685x */
  A_685 = 'A_685',
  /** 686x */
  A_686 = 'A_686',
  /** 687x */
  A_687 = 'A_687',
  /** 688x */
  A_688 = 'A_688',
  /** 689x */
  A_689 = 'A_689',
  /** 690x */
  A_690 = 'A_690',
  /** 691x */
  A_691 = 'A_691',
  /** 692x */
  A_692 = 'A_692',
  /** 693x */
  A_693 = 'A_693',
  /** 694x */
  A_694 = 'A_694',
  /** 695x */
  A_695 = 'A_695',
  /** 696x */
  A_696 = 'A_696',
  /** 697x */
  A_697 = 'A_697',
  /** 698x */
  A_698 = 'A_698',
  /** 699x */
  A_699 = 'A_699',
  /** 700x */
  A_700 = 'A_700',
  /** 701x */
  A_701 = 'A_701',
  /** 702x */
  A_702 = 'A_702',
  /** 703x */
  A_703 = 'A_703',
  /** 704x */
  A_704 = 'A_704',
  /** 705x */
  A_705 = 'A_705',
  /** 706x */
  A_706 = 'A_706',
  /** 707x */
  A_707 = 'A_707',
  /** 708x */
  A_708 = 'A_708',
  /** 709x */
  A_709 = 'A_709',
  /** 710x */
  A_710 = 'A_710',
  /** 711x */
  A_711 = 'A_711',
  /** 712x */
  A_712 = 'A_712',
  /** 713x */
  A_713 = 'A_713',
  /** 714x */
  A_714 = 'A_714',
  /** 715x */
  A_715 = 'A_715',
  /** 716x */
  A_716 = 'A_716',
  /** 717x */
  A_717 = 'A_717',
  /** 718x */
  A_718 = 'A_718',
  /** 719x */
  A_719 = 'A_719',
  /** 720x */
  A_720 = 'A_720',
  /** 721x */
  A_721 = 'A_721',
  /** 722x */
  A_722 = 'A_722',
  /** 723x */
  A_723 = 'A_723',
  /** 724x */
  A_724 = 'A_724',
  /** 725x */
  A_725 = 'A_725',
  /** 726x */
  A_726 = 'A_726',
  /** 727x */
  A_727 = 'A_727',
  /** 728x */
  A_728 = 'A_728',
  /** 729x */
  A_729 = 'A_729',
  /** 730x */
  A_730 = 'A_730',
  /** 731x */
  A_731 = 'A_731',
  /** 732x */
  A_732 = 'A_732',
  /** 733x */
  A_733 = 'A_733',
  /** 734x */
  A_734 = 'A_734',
  /** 735x */
  A_735 = 'A_735',
  /** 736x */
  A_736 = 'A_736',
  /** 737x */
  A_737 = 'A_737',
  /** 738x */
  A_738 = 'A_738',
  /** 739x */
  A_739 = 'A_739',
  /** 740x */
  A_740 = 'A_740',
  /** 741x */
  A_741 = 'A_741',
  /** 742x */
  A_742 = 'A_742',
  /** 743x */
  A_743 = 'A_743',
  /** 744x */
  A_744 = 'A_744',
  /** 745x */
  A_745 = 'A_745',
  /** 746x */
  A_746 = 'A_746',
  /** 747x */
  A_747 = 'A_747',
  /** 748x */
  A_748 = 'A_748',
  /** 749x */
  A_749 = 'A_749',
  /** 750x */
  A_750 = 'A_750',
  /** 751x */
  A_751 = 'A_751',
  /** 752x */
  A_752 = 'A_752',
  /** 753x */
  A_753 = 'A_753',
  /** 754x */
  A_754 = 'A_754',
  /** 755x */
  A_755 = 'A_755',
  /** 756x */
  A_756 = 'A_756',
  /** 757x */
  A_757 = 'A_757',
  /** 758x */
  A_758 = 'A_758',
  /** 759x */
  A_759 = 'A_759',
  /** 760x */
  A_760 = 'A_760',
  /** 761x */
  A_761 = 'A_761',
  /** 762x */
  A_762 = 'A_762',
  /** 763x */
  A_763 = 'A_763',
  /** 764x */
  A_764 = 'A_764',
  /** 765x */
  A_765 = 'A_765',
  /** 766x */
  A_766 = 'A_766',
  /** 767x */
  A_767 = 'A_767',
  /** 768x */
  A_768 = 'A_768',
  /** 769x */
  A_769 = 'A_769',
  /** 770x */
  A_770 = 'A_770',
  /** 771x */
  A_771 = 'A_771',
  /** 772x */
  A_772 = 'A_772',
  /** 773x */
  A_773 = 'A_773',
  /** 774x */
  A_774 = 'A_774',
  /** 775x */
  A_775 = 'A_775',
  /** 776x */
  A_776 = 'A_776',
  /** 777x */
  A_777 = 'A_777',
  /** 778x */
  A_778 = 'A_778',
  /** 779x */
  A_779 = 'A_779',
  /** 780x */
  A_780 = 'A_780',
  /** 781x */
  A_781 = 'A_781',
  /** 782x */
  A_782 = 'A_782',
  /** 783x */
  A_783 = 'A_783',
  /** 784x */
  A_784 = 'A_784',
  /** 785x */
  A_785 = 'A_785',
  /** 786x */
  A_786 = 'A_786',
  /** 787x */
  A_787 = 'A_787',
  /** 788x */
  A_788 = 'A_788',
  /** 789x */
  A_789 = 'A_789',
  /** 790x */
  A_790 = 'A_790',
  /** 791x */
  A_791 = 'A_791',
  /** 792x */
  A_792 = 'A_792',
  /** 793x */
  A_793 = 'A_793',
  /** 794x */
  A_794 = 'A_794',
  /** 795x */
  A_795 = 'A_795',
  /** 796x */
  A_796 = 'A_796',
  /** 797x */
  A_797 = 'A_797',
  /** 798x */
  A_798 = 'A_798',
  /** 799x */
  A_799 = 'A_799',
  /** 800x */
  A_800 = 'A_800',
  /** 801x */
  A_801 = 'A_801',
  /** 802x */
  A_802 = 'A_802',
  /** 803x */
  A_803 = 'A_803',
  /** 804x */
  A_804 = 'A_804',
  /** 805x */
  A_805 = 'A_805',
  /** 806x */
  A_806 = 'A_806',
  /** 807x */
  A_807 = 'A_807',
  /** 808x */
  A_808 = 'A_808',
  /** 809x */
  A_809 = 'A_809',
  /** 810x */
  A_810 = 'A_810',
  /** 811x */
  A_811 = 'A_811',
  /** 812x */
  A_812 = 'A_812',
  /** 813x */
  A_813 = 'A_813',
  /** 814x */
  A_814 = 'A_814',
  /** 815x */
  A_815 = 'A_815',
  /** 816x */
  A_816 = 'A_816',
  /** 817x */
  A_817 = 'A_817',
  /** 818x */
  A_818 = 'A_818',
  /** 819x */
  A_819 = 'A_819',
  /** 820x */
  A_820 = 'A_820',
  /** 821x */
  A_821 = 'A_821',
  /** 822x */
  A_822 = 'A_822',
  /** 823x */
  A_823 = 'A_823',
  /** 824x */
  A_824 = 'A_824',
  /** 825x */
  A_825 = 'A_825',
  /** 826x */
  A_826 = 'A_826',
  /** 827x */
  A_827 = 'A_827',
  /** 828x */
  A_828 = 'A_828',
  /** 829x */
  A_829 = 'A_829',
  /** 830x */
  A_830 = 'A_830',
  /** 831x */
  A_831 = 'A_831',
  /** 832x */
  A_832 = 'A_832',
  /** 833x */
  A_833 = 'A_833',
  /** 834x */
  A_834 = 'A_834',
  /** 835x */
  A_835 = 'A_835',
  /** 836x */
  A_836 = 'A_836',
  /** 837x */
  A_837 = 'A_837',
  /** 838x */
  A_838 = 'A_838',
  /** 839x */
  A_839 = 'A_839',
  /** 840x */
  A_840 = 'A_840',
  /** 841x */
  A_841 = 'A_841',
  /** 842x */
  A_842 = 'A_842',
  /** 843x */
  A_843 = 'A_843',
  /** 844x */
  A_844 = 'A_844',
  /** 845x */
  A_845 = 'A_845',
  /** 846x */
  A_846 = 'A_846',
  /** 847x */
  A_847 = 'A_847',
  /** 848x */
  A_848 = 'A_848',
  /** 849x */
  A_849 = 'A_849',
  /** 850x */
  A_850 = 'A_850',
  /** 851x */
  A_851 = 'A_851',
  /** 852x */
  A_852 = 'A_852',
  /** 853x */
  A_853 = 'A_853',
  /** 854x */
  A_854 = 'A_854',
  /** 855x */
  A_855 = 'A_855',
  /** 856x */
  A_856 = 'A_856',
  /** 857x */
  A_857 = 'A_857',
  /** 858x */
  A_858 = 'A_858',
  /** 859x */
  A_859 = 'A_859',
  /** 860x */
  A_860 = 'A_860',
  /** 861x */
  A_861 = 'A_861',
  /** 862x */
  A_862 = 'A_862',
  /** 863x */
  A_863 = 'A_863',
  /** 864x */
  A_864 = 'A_864',
  /** 865x */
  A_865 = 'A_865',
  /** 866x */
  A_866 = 'A_866',
  /** 867x */
  A_867 = 'A_867',
  /** 868x */
  A_868 = 'A_868',
  /** 869x */
  A_869 = 'A_869',
  /** 870x */
  A_870 = 'A_870',
  /** 871x */
  A_871 = 'A_871',
  /** 872x */
  A_872 = 'A_872',
  /** 873x */
  A_873 = 'A_873',
  /** 874x */
  A_874 = 'A_874',
  /** 875x */
  A_875 = 'A_875',
  /** 876x */
  A_876 = 'A_876',
  /** 877x */
  A_877 = 'A_877',
  /** 878x */
  A_878 = 'A_878',
  /** 879x */
  A_879 = 'A_879',
  /** 880x */
  A_880 = 'A_880',
  /** 881x */
  A_881 = 'A_881',
  /** 882x */
  A_882 = 'A_882',
  /** 883x */
  A_883 = 'A_883',
  /** 884x */
  A_884 = 'A_884',
  /** 885x */
  A_885 = 'A_885',
  /** 886x */
  A_886 = 'A_886',
  /** 887x */
  A_887 = 'A_887',
  /** 888x */
  A_888 = 'A_888',
  /** 889x */
  A_889 = 'A_889',
  /** 890x */
  A_890 = 'A_890',
  /** 891x */
  A_891 = 'A_891',
  /** 892x */
  A_892 = 'A_892',
  /** 893x */
  A_893 = 'A_893',
  /** 894x */
  A_894 = 'A_894',
  /** 895x */
  A_895 = 'A_895',
  /** 896x */
  A_896 = 'A_896',
  /** 897x */
  A_897 = 'A_897',
  /** 898x */
  A_898 = 'A_898',
  /** 899x */
  A_899 = 'A_899',
  /** 900x */
  A_900 = 'A_900',
  /** 901x */
  A_901 = 'A_901',
  /** 902x */
  A_902 = 'A_902',
  /** 903x */
  A_903 = 'A_903',
  /** 904x */
  A_904 = 'A_904',
  /** 905x */
  A_905 = 'A_905',
  /** 906x */
  A_906 = 'A_906',
  /** 907x */
  A_907 = 'A_907',
  /** 908x */
  A_908 = 'A_908',
  /** 909x */
  A_909 = 'A_909',
  /** 910x */
  A_910 = 'A_910',
  /** 911x */
  A_911 = 'A_911',
  /** 912x */
  A_912 = 'A_912',
  /** 913x */
  A_913 = 'A_913',
  /** 914x */
  A_914 = 'A_914',
  /** 915x */
  A_915 = 'A_915',
  /** 916x */
  A_916 = 'A_916',
  /** 917x */
  A_917 = 'A_917',
  /** 918x */
  A_918 = 'A_918',
  /** 919x */
  A_919 = 'A_919',
  /** 920x */
  A_920 = 'A_920',
  /** 921x */
  A_921 = 'A_921',
  /** 922x */
  A_922 = 'A_922',
  /** 923x */
  A_923 = 'A_923',
  /** 924x */
  A_924 = 'A_924',
  /** 925x */
  A_925 = 'A_925',
  /** 926x */
  A_926 = 'A_926',
  /** 927x */
  A_927 = 'A_927',
  /** 928x */
  A_928 = 'A_928',
  /** 929x */
  A_929 = 'A_929',
  /** 930x */
  A_930 = 'A_930',
  /** 931x */
  A_931 = 'A_931',
  /** 932x */
  A_932 = 'A_932',
  /** 933x */
  A_933 = 'A_933',
  /** 934x */
  A_934 = 'A_934',
  /** 935x */
  A_935 = 'A_935',
  /** 936x */
  A_936 = 'A_936',
  /** 937x */
  A_937 = 'A_937',
  /** 938x */
  A_938 = 'A_938',
  /** 939x */
  A_939 = 'A_939',
  /** 940x */
  A_940 = 'A_940',
  /** 941x */
  A_941 = 'A_941',
  /** 942x */
  A_942 = 'A_942',
  /** 943x */
  A_943 = 'A_943',
  /** 944x */
  A_944 = 'A_944',
  /** 945x */
  A_945 = 'A_945',
  /** 946x */
  A_946 = 'A_946',
  /** 947x */
  A_947 = 'A_947',
  /** 948x */
  A_948 = 'A_948',
  /** 949x */
  A_949 = 'A_949',
  /** 950x */
  A_950 = 'A_950',
  /** 951x */
  A_951 = 'A_951',
  /** 952x */
  A_952 = 'A_952',
  /** 953x */
  A_953 = 'A_953',
  /** 954x */
  A_954 = 'A_954',
  /** 955x */
  A_955 = 'A_955',
  /** 956x */
  A_956 = 'A_956',
  /** 957x */
  A_957 = 'A_957',
  /** 958x */
  A_958 = 'A_958',
  /** 959x */
  A_959 = 'A_959',
  /** 960x */
  A_960 = 'A_960',
  /** 961x */
  A_961 = 'A_961',
  /** 962x */
  A_962 = 'A_962',
  /** 963x */
  A_963 = 'A_963',
  /** 964x */
  A_964 = 'A_964',
  /** 965x */
  A_965 = 'A_965',
  /** 966x */
  A_966 = 'A_966',
  /** 967x */
  A_967 = 'A_967',
  /** 968x */
  A_968 = 'A_968',
  /** 969x */
  A_969 = 'A_969',
  /** 970x */
  A_970 = 'A_970',
  /** 971x */
  A_971 = 'A_971',
  /** 972x */
  A_972 = 'A_972',
  /** 973x */
  A_973 = 'A_973',
  /** 974x */
  A_974 = 'A_974',
  /** 975x */
  A_975 = 'A_975',
  /** 976x */
  A_976 = 'A_976',
  /** 977x */
  A_977 = 'A_977',
  /** 978x */
  A_978 = 'A_978',
  /** 979x */
  A_979 = 'A_979',
  /** 980x */
  A_980 = 'A_980',
  /** 981x */
  A_981 = 'A_981',
  /** 982x */
  A_982 = 'A_982',
  /** 983x */
  A_983 = 'A_983',
  /** 984x */
  A_984 = 'A_984',
  /** 985x */
  A_985 = 'A_985',
  /** 986x */
  A_986 = 'A_986',
  /** 987x */
  A_987 = 'A_987',
  /** 988x */
  A_988 = 'A_988',
  /** 989x */
  A_989 = 'A_989',
  /** 990x */
  A_990 = 'A_990',
  /** 991x */
  A_991 = 'A_991',
  /** 992x */
  A_992 = 'A_992',
  /** 993x */
  A_993 = 'A_993',
  /** 994x */
  A_994 = 'A_994',
  /** 995x */
  A_995 = 'A_995',
  /** 996x */
  A_996 = 'A_996',
  /** 997x */
  A_997 = 'A_997',
  /** 998x */
  A_998 = 'A_998',
  /** 999x */
  A_999 = 'A_999',
  /** 1000x */
  A_1000 = 'A_1000'
}

/** An enumeration. */
export enum TaxasParcelasParcelas {
  /** 1x */
  A_1 = 'A_1',
  /** 2x */
  A_2 = 'A_2',
  /** 3x */
  A_3 = 'A_3',
  /** 4x */
  A_4 = 'A_4',
  /** 5x */
  A_5 = 'A_5',
  /** 6x */
  A_6 = 'A_6',
  /** 7x */
  A_7 = 'A_7',
  /** 8x */
  A_8 = 'A_8',
  /** 9x */
  A_9 = 'A_9',
  /** 10x */
  A_10 = 'A_10',
  /** 11x */
  A_11 = 'A_11',
  /** 12x */
  A_12 = 'A_12',
  /** 13x */
  A_13 = 'A_13',
  /** 14x */
  A_14 = 'A_14',
  /** 15x */
  A_15 = 'A_15',
  /** 16x */
  A_16 = 'A_16',
  /** 17x */
  A_17 = 'A_17',
  /** 18x */
  A_18 = 'A_18',
  /** 19x */
  A_19 = 'A_19',
  /** 20x */
  A_20 = 'A_20',
  /** 21x */
  A_21 = 'A_21',
  /** 22x */
  A_22 = 'A_22',
  /** 23x */
  A_23 = 'A_23',
  /** 24x */
  A_24 = 'A_24',
  /** 25x */
  A_25 = 'A_25',
  /** 26x */
  A_26 = 'A_26',
  /** 27x */
  A_27 = 'A_27',
  /** 28x */
  A_28 = 'A_28',
  /** 29x */
  A_29 = 'A_29',
  /** 30x */
  A_30 = 'A_30',
  /** 31x */
  A_31 = 'A_31',
  /** 32x */
  A_32 = 'A_32',
  /** 33x */
  A_33 = 'A_33',
  /** 34x */
  A_34 = 'A_34',
  /** 35x */
  A_35 = 'A_35',
  /** 36x */
  A_36 = 'A_36',
  /** 37x */
  A_37 = 'A_37',
  /** 38x */
  A_38 = 'A_38',
  /** 39x */
  A_39 = 'A_39',
  /** 40x */
  A_40 = 'A_40',
  /** 41x */
  A_41 = 'A_41',
  /** 42x */
  A_42 = 'A_42',
  /** 43x */
  A_43 = 'A_43',
  /** 44x */
  A_44 = 'A_44',
  /** 45x */
  A_45 = 'A_45',
  /** 46x */
  A_46 = 'A_46',
  /** 47x */
  A_47 = 'A_47',
  /** 48x */
  A_48 = 'A_48',
  /** 49x */
  A_49 = 'A_49',
  /** 50x */
  A_50 = 'A_50',
  /** 51x */
  A_51 = 'A_51',
  /** 52x */
  A_52 = 'A_52',
  /** 53x */
  A_53 = 'A_53',
  /** 54x */
  A_54 = 'A_54',
  /** 55x */
  A_55 = 'A_55',
  /** 56x */
  A_56 = 'A_56',
  /** 57x */
  A_57 = 'A_57',
  /** 58x */
  A_58 = 'A_58',
  /** 59x */
  A_59 = 'A_59',
  /** 60x */
  A_60 = 'A_60',
  /** 61x */
  A_61 = 'A_61',
  /** 62x */
  A_62 = 'A_62',
  /** 63x */
  A_63 = 'A_63',
  /** 64x */
  A_64 = 'A_64',
  /** 65x */
  A_65 = 'A_65',
  /** 66x */
  A_66 = 'A_66',
  /** 67x */
  A_67 = 'A_67',
  /** 68x */
  A_68 = 'A_68',
  /** 69x */
  A_69 = 'A_69',
  /** 70x */
  A_70 = 'A_70',
  /** 71x */
  A_71 = 'A_71',
  /** 72x */
  A_72 = 'A_72',
  /** 73x */
  A_73 = 'A_73',
  /** 74x */
  A_74 = 'A_74',
  /** 75x */
  A_75 = 'A_75',
  /** 76x */
  A_76 = 'A_76',
  /** 77x */
  A_77 = 'A_77',
  /** 78x */
  A_78 = 'A_78',
  /** 79x */
  A_79 = 'A_79',
  /** 80x */
  A_80 = 'A_80',
  /** 81x */
  A_81 = 'A_81',
  /** 82x */
  A_82 = 'A_82',
  /** 83x */
  A_83 = 'A_83',
  /** 84x */
  A_84 = 'A_84',
  /** 85x */
  A_85 = 'A_85',
  /** 86x */
  A_86 = 'A_86',
  /** 87x */
  A_87 = 'A_87',
  /** 88x */
  A_88 = 'A_88',
  /** 89x */
  A_89 = 'A_89',
  /** 90x */
  A_90 = 'A_90',
  /** 91x */
  A_91 = 'A_91',
  /** 92x */
  A_92 = 'A_92',
  /** 93x */
  A_93 = 'A_93',
  /** 94x */
  A_94 = 'A_94',
  /** 95x */
  A_95 = 'A_95',
  /** 96x */
  A_96 = 'A_96',
  /** 97x */
  A_97 = 'A_97',
  /** 98x */
  A_98 = 'A_98',
  /** 99x */
  A_99 = 'A_99',
  /** 100x */
  A_100 = 'A_100',
  /** 101x */
  A_101 = 'A_101',
  /** 102x */
  A_102 = 'A_102',
  /** 103x */
  A_103 = 'A_103',
  /** 104x */
  A_104 = 'A_104',
  /** 105x */
  A_105 = 'A_105',
  /** 106x */
  A_106 = 'A_106',
  /** 107x */
  A_107 = 'A_107',
  /** 108x */
  A_108 = 'A_108',
  /** 109x */
  A_109 = 'A_109',
  /** 110x */
  A_110 = 'A_110',
  /** 111x */
  A_111 = 'A_111',
  /** 112x */
  A_112 = 'A_112',
  /** 113x */
  A_113 = 'A_113',
  /** 114x */
  A_114 = 'A_114',
  /** 115x */
  A_115 = 'A_115',
  /** 116x */
  A_116 = 'A_116',
  /** 117x */
  A_117 = 'A_117',
  /** 118x */
  A_118 = 'A_118',
  /** 119x */
  A_119 = 'A_119',
  /** 120x */
  A_120 = 'A_120',
  /** 121x */
  A_121 = 'A_121',
  /** 122x */
  A_122 = 'A_122',
  /** 123x */
  A_123 = 'A_123',
  /** 124x */
  A_124 = 'A_124',
  /** 125x */
  A_125 = 'A_125',
  /** 126x */
  A_126 = 'A_126',
  /** 127x */
  A_127 = 'A_127',
  /** 128x */
  A_128 = 'A_128',
  /** 129x */
  A_129 = 'A_129',
  /** 130x */
  A_130 = 'A_130',
  /** 131x */
  A_131 = 'A_131',
  /** 132x */
  A_132 = 'A_132',
  /** 133x */
  A_133 = 'A_133',
  /** 134x */
  A_134 = 'A_134',
  /** 135x */
  A_135 = 'A_135',
  /** 136x */
  A_136 = 'A_136',
  /** 137x */
  A_137 = 'A_137',
  /** 138x */
  A_138 = 'A_138',
  /** 139x */
  A_139 = 'A_139',
  /** 140x */
  A_140 = 'A_140',
  /** 141x */
  A_141 = 'A_141',
  /** 142x */
  A_142 = 'A_142',
  /** 143x */
  A_143 = 'A_143',
  /** 144x */
  A_144 = 'A_144',
  /** 145x */
  A_145 = 'A_145',
  /** 146x */
  A_146 = 'A_146',
  /** 147x */
  A_147 = 'A_147',
  /** 148x */
  A_148 = 'A_148',
  /** 149x */
  A_149 = 'A_149',
  /** 150x */
  A_150 = 'A_150',
  /** 151x */
  A_151 = 'A_151',
  /** 152x */
  A_152 = 'A_152',
  /** 153x */
  A_153 = 'A_153',
  /** 154x */
  A_154 = 'A_154',
  /** 155x */
  A_155 = 'A_155',
  /** 156x */
  A_156 = 'A_156',
  /** 157x */
  A_157 = 'A_157',
  /** 158x */
  A_158 = 'A_158',
  /** 159x */
  A_159 = 'A_159',
  /** 160x */
  A_160 = 'A_160',
  /** 161x */
  A_161 = 'A_161',
  /** 162x */
  A_162 = 'A_162',
  /** 163x */
  A_163 = 'A_163',
  /** 164x */
  A_164 = 'A_164',
  /** 165x */
  A_165 = 'A_165',
  /** 166x */
  A_166 = 'A_166',
  /** 167x */
  A_167 = 'A_167',
  /** 168x */
  A_168 = 'A_168',
  /** 169x */
  A_169 = 'A_169',
  /** 170x */
  A_170 = 'A_170',
  /** 171x */
  A_171 = 'A_171',
  /** 172x */
  A_172 = 'A_172',
  /** 173x */
  A_173 = 'A_173',
  /** 174x */
  A_174 = 'A_174',
  /** 175x */
  A_175 = 'A_175',
  /** 176x */
  A_176 = 'A_176',
  /** 177x */
  A_177 = 'A_177',
  /** 178x */
  A_178 = 'A_178',
  /** 179x */
  A_179 = 'A_179',
  /** 180x */
  A_180 = 'A_180',
  /** 181x */
  A_181 = 'A_181',
  /** 182x */
  A_182 = 'A_182',
  /** 183x */
  A_183 = 'A_183',
  /** 184x */
  A_184 = 'A_184',
  /** 185x */
  A_185 = 'A_185',
  /** 186x */
  A_186 = 'A_186',
  /** 187x */
  A_187 = 'A_187',
  /** 188x */
  A_188 = 'A_188',
  /** 189x */
  A_189 = 'A_189',
  /** 190x */
  A_190 = 'A_190',
  /** 191x */
  A_191 = 'A_191',
  /** 192x */
  A_192 = 'A_192',
  /** 193x */
  A_193 = 'A_193',
  /** 194x */
  A_194 = 'A_194',
  /** 195x */
  A_195 = 'A_195',
  /** 196x */
  A_196 = 'A_196',
  /** 197x */
  A_197 = 'A_197',
  /** 198x */
  A_198 = 'A_198',
  /** 199x */
  A_199 = 'A_199',
  /** 200x */
  A_200 = 'A_200',
  /** 201x */
  A_201 = 'A_201',
  /** 202x */
  A_202 = 'A_202',
  /** 203x */
  A_203 = 'A_203',
  /** 204x */
  A_204 = 'A_204',
  /** 205x */
  A_205 = 'A_205',
  /** 206x */
  A_206 = 'A_206',
  /** 207x */
  A_207 = 'A_207',
  /** 208x */
  A_208 = 'A_208',
  /** 209x */
  A_209 = 'A_209',
  /** 210x */
  A_210 = 'A_210',
  /** 211x */
  A_211 = 'A_211',
  /** 212x */
  A_212 = 'A_212',
  /** 213x */
  A_213 = 'A_213',
  /** 214x */
  A_214 = 'A_214',
  /** 215x */
  A_215 = 'A_215',
  /** 216x */
  A_216 = 'A_216',
  /** 217x */
  A_217 = 'A_217',
  /** 218x */
  A_218 = 'A_218',
  /** 219x */
  A_219 = 'A_219',
  /** 220x */
  A_220 = 'A_220',
  /** 221x */
  A_221 = 'A_221',
  /** 222x */
  A_222 = 'A_222',
  /** 223x */
  A_223 = 'A_223',
  /** 224x */
  A_224 = 'A_224',
  /** 225x */
  A_225 = 'A_225',
  /** 226x */
  A_226 = 'A_226',
  /** 227x */
  A_227 = 'A_227',
  /** 228x */
  A_228 = 'A_228',
  /** 229x */
  A_229 = 'A_229',
  /** 230x */
  A_230 = 'A_230',
  /** 231x */
  A_231 = 'A_231',
  /** 232x */
  A_232 = 'A_232',
  /** 233x */
  A_233 = 'A_233',
  /** 234x */
  A_234 = 'A_234',
  /** 235x */
  A_235 = 'A_235',
  /** 236x */
  A_236 = 'A_236',
  /** 237x */
  A_237 = 'A_237',
  /** 238x */
  A_238 = 'A_238',
  /** 239x */
  A_239 = 'A_239',
  /** 240x */
  A_240 = 'A_240',
  /** 241x */
  A_241 = 'A_241',
  /** 242x */
  A_242 = 'A_242',
  /** 243x */
  A_243 = 'A_243',
  /** 244x */
  A_244 = 'A_244',
  /** 245x */
  A_245 = 'A_245',
  /** 246x */
  A_246 = 'A_246',
  /** 247x */
  A_247 = 'A_247',
  /** 248x */
  A_248 = 'A_248',
  /** 249x */
  A_249 = 'A_249',
  /** 250x */
  A_250 = 'A_250',
  /** 251x */
  A_251 = 'A_251',
  /** 252x */
  A_252 = 'A_252',
  /** 253x */
  A_253 = 'A_253',
  /** 254x */
  A_254 = 'A_254',
  /** 255x */
  A_255 = 'A_255',
  /** 256x */
  A_256 = 'A_256',
  /** 257x */
  A_257 = 'A_257',
  /** 258x */
  A_258 = 'A_258',
  /** 259x */
  A_259 = 'A_259',
  /** 260x */
  A_260 = 'A_260',
  /** 261x */
  A_261 = 'A_261',
  /** 262x */
  A_262 = 'A_262',
  /** 263x */
  A_263 = 'A_263',
  /** 264x */
  A_264 = 'A_264',
  /** 265x */
  A_265 = 'A_265',
  /** 266x */
  A_266 = 'A_266',
  /** 267x */
  A_267 = 'A_267',
  /** 268x */
  A_268 = 'A_268',
  /** 269x */
  A_269 = 'A_269',
  /** 270x */
  A_270 = 'A_270',
  /** 271x */
  A_271 = 'A_271',
  /** 272x */
  A_272 = 'A_272',
  /** 273x */
  A_273 = 'A_273',
  /** 274x */
  A_274 = 'A_274',
  /** 275x */
  A_275 = 'A_275',
  /** 276x */
  A_276 = 'A_276',
  /** 277x */
  A_277 = 'A_277',
  /** 278x */
  A_278 = 'A_278',
  /** 279x */
  A_279 = 'A_279',
  /** 280x */
  A_280 = 'A_280',
  /** 281x */
  A_281 = 'A_281',
  /** 282x */
  A_282 = 'A_282',
  /** 283x */
  A_283 = 'A_283',
  /** 284x */
  A_284 = 'A_284',
  /** 285x */
  A_285 = 'A_285',
  /** 286x */
  A_286 = 'A_286',
  /** 287x */
  A_287 = 'A_287',
  /** 288x */
  A_288 = 'A_288',
  /** 289x */
  A_289 = 'A_289',
  /** 290x */
  A_290 = 'A_290',
  /** 291x */
  A_291 = 'A_291',
  /** 292x */
  A_292 = 'A_292',
  /** 293x */
  A_293 = 'A_293',
  /** 294x */
  A_294 = 'A_294',
  /** 295x */
  A_295 = 'A_295',
  /** 296x */
  A_296 = 'A_296',
  /** 297x */
  A_297 = 'A_297',
  /** 298x */
  A_298 = 'A_298',
  /** 299x */
  A_299 = 'A_299',
  /** 300x */
  A_300 = 'A_300',
  /** 301x */
  A_301 = 'A_301',
  /** 302x */
  A_302 = 'A_302',
  /** 303x */
  A_303 = 'A_303',
  /** 304x */
  A_304 = 'A_304',
  /** 305x */
  A_305 = 'A_305',
  /** 306x */
  A_306 = 'A_306',
  /** 307x */
  A_307 = 'A_307',
  /** 308x */
  A_308 = 'A_308',
  /** 309x */
  A_309 = 'A_309',
  /** 310x */
  A_310 = 'A_310',
  /** 311x */
  A_311 = 'A_311',
  /** 312x */
  A_312 = 'A_312',
  /** 313x */
  A_313 = 'A_313',
  /** 314x */
  A_314 = 'A_314',
  /** 315x */
  A_315 = 'A_315',
  /** 316x */
  A_316 = 'A_316',
  /** 317x */
  A_317 = 'A_317',
  /** 318x */
  A_318 = 'A_318',
  /** 319x */
  A_319 = 'A_319',
  /** 320x */
  A_320 = 'A_320',
  /** 321x */
  A_321 = 'A_321',
  /** 322x */
  A_322 = 'A_322',
  /** 323x */
  A_323 = 'A_323',
  /** 324x */
  A_324 = 'A_324',
  /** 325x */
  A_325 = 'A_325',
  /** 326x */
  A_326 = 'A_326',
  /** 327x */
  A_327 = 'A_327',
  /** 328x */
  A_328 = 'A_328',
  /** 329x */
  A_329 = 'A_329',
  /** 330x */
  A_330 = 'A_330',
  /** 331x */
  A_331 = 'A_331',
  /** 332x */
  A_332 = 'A_332',
  /** 333x */
  A_333 = 'A_333',
  /** 334x */
  A_334 = 'A_334',
  /** 335x */
  A_335 = 'A_335',
  /** 336x */
  A_336 = 'A_336',
  /** 337x */
  A_337 = 'A_337',
  /** 338x */
  A_338 = 'A_338',
  /** 339x */
  A_339 = 'A_339',
  /** 340x */
  A_340 = 'A_340',
  /** 341x */
  A_341 = 'A_341',
  /** 342x */
  A_342 = 'A_342',
  /** 343x */
  A_343 = 'A_343',
  /** 344x */
  A_344 = 'A_344',
  /** 345x */
  A_345 = 'A_345',
  /** 346x */
  A_346 = 'A_346',
  /** 347x */
  A_347 = 'A_347',
  /** 348x */
  A_348 = 'A_348',
  /** 349x */
  A_349 = 'A_349',
  /** 350x */
  A_350 = 'A_350',
  /** 351x */
  A_351 = 'A_351',
  /** 352x */
  A_352 = 'A_352',
  /** 353x */
  A_353 = 'A_353',
  /** 354x */
  A_354 = 'A_354',
  /** 355x */
  A_355 = 'A_355',
  /** 356x */
  A_356 = 'A_356',
  /** 357x */
  A_357 = 'A_357',
  /** 358x */
  A_358 = 'A_358',
  /** 359x */
  A_359 = 'A_359',
  /** 360x */
  A_360 = 'A_360',
  /** 361x */
  A_361 = 'A_361',
  /** 362x */
  A_362 = 'A_362',
  /** 363x */
  A_363 = 'A_363',
  /** 364x */
  A_364 = 'A_364',
  /** 365x */
  A_365 = 'A_365',
  /** 366x */
  A_366 = 'A_366',
  /** 367x */
  A_367 = 'A_367',
  /** 368x */
  A_368 = 'A_368',
  /** 369x */
  A_369 = 'A_369',
  /** 370x */
  A_370 = 'A_370',
  /** 371x */
  A_371 = 'A_371',
  /** 372x */
  A_372 = 'A_372',
  /** 373x */
  A_373 = 'A_373',
  /** 374x */
  A_374 = 'A_374',
  /** 375x */
  A_375 = 'A_375',
  /** 376x */
  A_376 = 'A_376',
  /** 377x */
  A_377 = 'A_377',
  /** 378x */
  A_378 = 'A_378',
  /** 379x */
  A_379 = 'A_379',
  /** 380x */
  A_380 = 'A_380',
  /** 381x */
  A_381 = 'A_381',
  /** 382x */
  A_382 = 'A_382',
  /** 383x */
  A_383 = 'A_383',
  /** 384x */
  A_384 = 'A_384',
  /** 385x */
  A_385 = 'A_385',
  /** 386x */
  A_386 = 'A_386',
  /** 387x */
  A_387 = 'A_387',
  /** 388x */
  A_388 = 'A_388',
  /** 389x */
  A_389 = 'A_389',
  /** 390x */
  A_390 = 'A_390',
  /** 391x */
  A_391 = 'A_391',
  /** 392x */
  A_392 = 'A_392',
  /** 393x */
  A_393 = 'A_393',
  /** 394x */
  A_394 = 'A_394',
  /** 395x */
  A_395 = 'A_395',
  /** 396x */
  A_396 = 'A_396',
  /** 397x */
  A_397 = 'A_397',
  /** 398x */
  A_398 = 'A_398',
  /** 399x */
  A_399 = 'A_399',
  /** 400x */
  A_400 = 'A_400',
  /** 401x */
  A_401 = 'A_401',
  /** 402x */
  A_402 = 'A_402',
  /** 403x */
  A_403 = 'A_403',
  /** 404x */
  A_404 = 'A_404',
  /** 405x */
  A_405 = 'A_405',
  /** 406x */
  A_406 = 'A_406',
  /** 407x */
  A_407 = 'A_407',
  /** 408x */
  A_408 = 'A_408',
  /** 409x */
  A_409 = 'A_409',
  /** 410x */
  A_410 = 'A_410',
  /** 411x */
  A_411 = 'A_411',
  /** 412x */
  A_412 = 'A_412',
  /** 413x */
  A_413 = 'A_413',
  /** 414x */
  A_414 = 'A_414',
  /** 415x */
  A_415 = 'A_415',
  /** 416x */
  A_416 = 'A_416',
  /** 417x */
  A_417 = 'A_417',
  /** 418x */
  A_418 = 'A_418',
  /** 419x */
  A_419 = 'A_419',
  /** 420x */
  A_420 = 'A_420',
  /** 421x */
  A_421 = 'A_421',
  /** 422x */
  A_422 = 'A_422',
  /** 423x */
  A_423 = 'A_423',
  /** 424x */
  A_424 = 'A_424',
  /** 425x */
  A_425 = 'A_425',
  /** 426x */
  A_426 = 'A_426',
  /** 427x */
  A_427 = 'A_427',
  /** 428x */
  A_428 = 'A_428',
  /** 429x */
  A_429 = 'A_429',
  /** 430x */
  A_430 = 'A_430',
  /** 431x */
  A_431 = 'A_431',
  /** 432x */
  A_432 = 'A_432',
  /** 433x */
  A_433 = 'A_433',
  /** 434x */
  A_434 = 'A_434',
  /** 435x */
  A_435 = 'A_435',
  /** 436x */
  A_436 = 'A_436',
  /** 437x */
  A_437 = 'A_437',
  /** 438x */
  A_438 = 'A_438',
  /** 439x */
  A_439 = 'A_439',
  /** 440x */
  A_440 = 'A_440',
  /** 441x */
  A_441 = 'A_441',
  /** 442x */
  A_442 = 'A_442',
  /** 443x */
  A_443 = 'A_443',
  /** 444x */
  A_444 = 'A_444',
  /** 445x */
  A_445 = 'A_445',
  /** 446x */
  A_446 = 'A_446',
  /** 447x */
  A_447 = 'A_447',
  /** 448x */
  A_448 = 'A_448',
  /** 449x */
  A_449 = 'A_449',
  /** 450x */
  A_450 = 'A_450',
  /** 451x */
  A_451 = 'A_451',
  /** 452x */
  A_452 = 'A_452',
  /** 453x */
  A_453 = 'A_453',
  /** 454x */
  A_454 = 'A_454',
  /** 455x */
  A_455 = 'A_455',
  /** 456x */
  A_456 = 'A_456',
  /** 457x */
  A_457 = 'A_457',
  /** 458x */
  A_458 = 'A_458',
  /** 459x */
  A_459 = 'A_459',
  /** 460x */
  A_460 = 'A_460',
  /** 461x */
  A_461 = 'A_461',
  /** 462x */
  A_462 = 'A_462',
  /** 463x */
  A_463 = 'A_463',
  /** 464x */
  A_464 = 'A_464',
  /** 465x */
  A_465 = 'A_465',
  /** 466x */
  A_466 = 'A_466',
  /** 467x */
  A_467 = 'A_467',
  /** 468x */
  A_468 = 'A_468',
  /** 469x */
  A_469 = 'A_469',
  /** 470x */
  A_470 = 'A_470',
  /** 471x */
  A_471 = 'A_471',
  /** 472x */
  A_472 = 'A_472',
  /** 473x */
  A_473 = 'A_473',
  /** 474x */
  A_474 = 'A_474',
  /** 475x */
  A_475 = 'A_475',
  /** 476x */
  A_476 = 'A_476',
  /** 477x */
  A_477 = 'A_477',
  /** 478x */
  A_478 = 'A_478',
  /** 479x */
  A_479 = 'A_479',
  /** 480x */
  A_480 = 'A_480',
  /** 481x */
  A_481 = 'A_481',
  /** 482x */
  A_482 = 'A_482',
  /** 483x */
  A_483 = 'A_483',
  /** 484x */
  A_484 = 'A_484',
  /** 485x */
  A_485 = 'A_485',
  /** 486x */
  A_486 = 'A_486',
  /** 487x */
  A_487 = 'A_487',
  /** 488x */
  A_488 = 'A_488',
  /** 489x */
  A_489 = 'A_489',
  /** 490x */
  A_490 = 'A_490',
  /** 491x */
  A_491 = 'A_491',
  /** 492x */
  A_492 = 'A_492',
  /** 493x */
  A_493 = 'A_493',
  /** 494x */
  A_494 = 'A_494',
  /** 495x */
  A_495 = 'A_495',
  /** 496x */
  A_496 = 'A_496',
  /** 497x */
  A_497 = 'A_497',
  /** 498x */
  A_498 = 'A_498',
  /** 499x */
  A_499 = 'A_499',
  /** 500x */
  A_500 = 'A_500',
  /** 501x */
  A_501 = 'A_501',
  /** 502x */
  A_502 = 'A_502',
  /** 503x */
  A_503 = 'A_503',
  /** 504x */
  A_504 = 'A_504',
  /** 505x */
  A_505 = 'A_505',
  /** 506x */
  A_506 = 'A_506',
  /** 507x */
  A_507 = 'A_507',
  /** 508x */
  A_508 = 'A_508',
  /** 509x */
  A_509 = 'A_509',
  /** 510x */
  A_510 = 'A_510',
  /** 511x */
  A_511 = 'A_511',
  /** 512x */
  A_512 = 'A_512',
  /** 513x */
  A_513 = 'A_513',
  /** 514x */
  A_514 = 'A_514',
  /** 515x */
  A_515 = 'A_515',
  /** 516x */
  A_516 = 'A_516',
  /** 517x */
  A_517 = 'A_517',
  /** 518x */
  A_518 = 'A_518',
  /** 519x */
  A_519 = 'A_519',
  /** 520x */
  A_520 = 'A_520',
  /** 521x */
  A_521 = 'A_521',
  /** 522x */
  A_522 = 'A_522',
  /** 523x */
  A_523 = 'A_523',
  /** 524x */
  A_524 = 'A_524',
  /** 525x */
  A_525 = 'A_525',
  /** 526x */
  A_526 = 'A_526',
  /** 527x */
  A_527 = 'A_527',
  /** 528x */
  A_528 = 'A_528',
  /** 529x */
  A_529 = 'A_529',
  /** 530x */
  A_530 = 'A_530',
  /** 531x */
  A_531 = 'A_531',
  /** 532x */
  A_532 = 'A_532',
  /** 533x */
  A_533 = 'A_533',
  /** 534x */
  A_534 = 'A_534',
  /** 535x */
  A_535 = 'A_535',
  /** 536x */
  A_536 = 'A_536',
  /** 537x */
  A_537 = 'A_537',
  /** 538x */
  A_538 = 'A_538',
  /** 539x */
  A_539 = 'A_539',
  /** 540x */
  A_540 = 'A_540',
  /** 541x */
  A_541 = 'A_541',
  /** 542x */
  A_542 = 'A_542',
  /** 543x */
  A_543 = 'A_543',
  /** 544x */
  A_544 = 'A_544',
  /** 545x */
  A_545 = 'A_545',
  /** 546x */
  A_546 = 'A_546',
  /** 547x */
  A_547 = 'A_547',
  /** 548x */
  A_548 = 'A_548',
  /** 549x */
  A_549 = 'A_549',
  /** 550x */
  A_550 = 'A_550',
  /** 551x */
  A_551 = 'A_551',
  /** 552x */
  A_552 = 'A_552',
  /** 553x */
  A_553 = 'A_553',
  /** 554x */
  A_554 = 'A_554',
  /** 555x */
  A_555 = 'A_555',
  /** 556x */
  A_556 = 'A_556',
  /** 557x */
  A_557 = 'A_557',
  /** 558x */
  A_558 = 'A_558',
  /** 559x */
  A_559 = 'A_559',
  /** 560x */
  A_560 = 'A_560',
  /** 561x */
  A_561 = 'A_561',
  /** 562x */
  A_562 = 'A_562',
  /** 563x */
  A_563 = 'A_563',
  /** 564x */
  A_564 = 'A_564',
  /** 565x */
  A_565 = 'A_565',
  /** 566x */
  A_566 = 'A_566',
  /** 567x */
  A_567 = 'A_567',
  /** 568x */
  A_568 = 'A_568',
  /** 569x */
  A_569 = 'A_569',
  /** 570x */
  A_570 = 'A_570',
  /** 571x */
  A_571 = 'A_571',
  /** 572x */
  A_572 = 'A_572',
  /** 573x */
  A_573 = 'A_573',
  /** 574x */
  A_574 = 'A_574',
  /** 575x */
  A_575 = 'A_575',
  /** 576x */
  A_576 = 'A_576',
  /** 577x */
  A_577 = 'A_577',
  /** 578x */
  A_578 = 'A_578',
  /** 579x */
  A_579 = 'A_579',
  /** 580x */
  A_580 = 'A_580',
  /** 581x */
  A_581 = 'A_581',
  /** 582x */
  A_582 = 'A_582',
  /** 583x */
  A_583 = 'A_583',
  /** 584x */
  A_584 = 'A_584',
  /** 585x */
  A_585 = 'A_585',
  /** 586x */
  A_586 = 'A_586',
  /** 587x */
  A_587 = 'A_587',
  /** 588x */
  A_588 = 'A_588',
  /** 589x */
  A_589 = 'A_589',
  /** 590x */
  A_590 = 'A_590',
  /** 591x */
  A_591 = 'A_591',
  /** 592x */
  A_592 = 'A_592',
  /** 593x */
  A_593 = 'A_593',
  /** 594x */
  A_594 = 'A_594',
  /** 595x */
  A_595 = 'A_595',
  /** 596x */
  A_596 = 'A_596',
  /** 597x */
  A_597 = 'A_597',
  /** 598x */
  A_598 = 'A_598',
  /** 599x */
  A_599 = 'A_599',
  /** 600x */
  A_600 = 'A_600',
  /** 601x */
  A_601 = 'A_601',
  /** 602x */
  A_602 = 'A_602',
  /** 603x */
  A_603 = 'A_603',
  /** 604x */
  A_604 = 'A_604',
  /** 605x */
  A_605 = 'A_605',
  /** 606x */
  A_606 = 'A_606',
  /** 607x */
  A_607 = 'A_607',
  /** 608x */
  A_608 = 'A_608',
  /** 609x */
  A_609 = 'A_609',
  /** 610x */
  A_610 = 'A_610',
  /** 611x */
  A_611 = 'A_611',
  /** 612x */
  A_612 = 'A_612',
  /** 613x */
  A_613 = 'A_613',
  /** 614x */
  A_614 = 'A_614',
  /** 615x */
  A_615 = 'A_615',
  /** 616x */
  A_616 = 'A_616',
  /** 617x */
  A_617 = 'A_617',
  /** 618x */
  A_618 = 'A_618',
  /** 619x */
  A_619 = 'A_619',
  /** 620x */
  A_620 = 'A_620',
  /** 621x */
  A_621 = 'A_621',
  /** 622x */
  A_622 = 'A_622',
  /** 623x */
  A_623 = 'A_623',
  /** 624x */
  A_624 = 'A_624',
  /** 625x */
  A_625 = 'A_625',
  /** 626x */
  A_626 = 'A_626',
  /** 627x */
  A_627 = 'A_627',
  /** 628x */
  A_628 = 'A_628',
  /** 629x */
  A_629 = 'A_629',
  /** 630x */
  A_630 = 'A_630',
  /** 631x */
  A_631 = 'A_631',
  /** 632x */
  A_632 = 'A_632',
  /** 633x */
  A_633 = 'A_633',
  /** 634x */
  A_634 = 'A_634',
  /** 635x */
  A_635 = 'A_635',
  /** 636x */
  A_636 = 'A_636',
  /** 637x */
  A_637 = 'A_637',
  /** 638x */
  A_638 = 'A_638',
  /** 639x */
  A_639 = 'A_639',
  /** 640x */
  A_640 = 'A_640',
  /** 641x */
  A_641 = 'A_641',
  /** 642x */
  A_642 = 'A_642',
  /** 643x */
  A_643 = 'A_643',
  /** 644x */
  A_644 = 'A_644',
  /** 645x */
  A_645 = 'A_645',
  /** 646x */
  A_646 = 'A_646',
  /** 647x */
  A_647 = 'A_647',
  /** 648x */
  A_648 = 'A_648',
  /** 649x */
  A_649 = 'A_649',
  /** 650x */
  A_650 = 'A_650',
  /** 651x */
  A_651 = 'A_651',
  /** 652x */
  A_652 = 'A_652',
  /** 653x */
  A_653 = 'A_653',
  /** 654x */
  A_654 = 'A_654',
  /** 655x */
  A_655 = 'A_655',
  /** 656x */
  A_656 = 'A_656',
  /** 657x */
  A_657 = 'A_657',
  /** 658x */
  A_658 = 'A_658',
  /** 659x */
  A_659 = 'A_659',
  /** 660x */
  A_660 = 'A_660',
  /** 661x */
  A_661 = 'A_661',
  /** 662x */
  A_662 = 'A_662',
  /** 663x */
  A_663 = 'A_663',
  /** 664x */
  A_664 = 'A_664',
  /** 665x */
  A_665 = 'A_665',
  /** 666x */
  A_666 = 'A_666',
  /** 667x */
  A_667 = 'A_667',
  /** 668x */
  A_668 = 'A_668',
  /** 669x */
  A_669 = 'A_669',
  /** 670x */
  A_670 = 'A_670',
  /** 671x */
  A_671 = 'A_671',
  /** 672x */
  A_672 = 'A_672',
  /** 673x */
  A_673 = 'A_673',
  /** 674x */
  A_674 = 'A_674',
  /** 675x */
  A_675 = 'A_675',
  /** 676x */
  A_676 = 'A_676',
  /** 677x */
  A_677 = 'A_677',
  /** 678x */
  A_678 = 'A_678',
  /** 679x */
  A_679 = 'A_679',
  /** 680x */
  A_680 = 'A_680',
  /** 681x */
  A_681 = 'A_681',
  /** 682x */
  A_682 = 'A_682',
  /** 683x */
  A_683 = 'A_683',
  /** 684x */
  A_684 = 'A_684',
  /** 685x */
  A_685 = 'A_685',
  /** 686x */
  A_686 = 'A_686',
  /** 687x */
  A_687 = 'A_687',
  /** 688x */
  A_688 = 'A_688',
  /** 689x */
  A_689 = 'A_689',
  /** 690x */
  A_690 = 'A_690',
  /** 691x */
  A_691 = 'A_691',
  /** 692x */
  A_692 = 'A_692',
  /** 693x */
  A_693 = 'A_693',
  /** 694x */
  A_694 = 'A_694',
  /** 695x */
  A_695 = 'A_695',
  /** 696x */
  A_696 = 'A_696',
  /** 697x */
  A_697 = 'A_697',
  /** 698x */
  A_698 = 'A_698',
  /** 699x */
  A_699 = 'A_699',
  /** 700x */
  A_700 = 'A_700',
  /** 701x */
  A_701 = 'A_701',
  /** 702x */
  A_702 = 'A_702',
  /** 703x */
  A_703 = 'A_703',
  /** 704x */
  A_704 = 'A_704',
  /** 705x */
  A_705 = 'A_705',
  /** 706x */
  A_706 = 'A_706',
  /** 707x */
  A_707 = 'A_707',
  /** 708x */
  A_708 = 'A_708',
  /** 709x */
  A_709 = 'A_709',
  /** 710x */
  A_710 = 'A_710',
  /** 711x */
  A_711 = 'A_711',
  /** 712x */
  A_712 = 'A_712',
  /** 713x */
  A_713 = 'A_713',
  /** 714x */
  A_714 = 'A_714',
  /** 715x */
  A_715 = 'A_715',
  /** 716x */
  A_716 = 'A_716',
  /** 717x */
  A_717 = 'A_717',
  /** 718x */
  A_718 = 'A_718',
  /** 719x */
  A_719 = 'A_719',
  /** 720x */
  A_720 = 'A_720',
  /** 721x */
  A_721 = 'A_721',
  /** 722x */
  A_722 = 'A_722',
  /** 723x */
  A_723 = 'A_723',
  /** 724x */
  A_724 = 'A_724',
  /** 725x */
  A_725 = 'A_725',
  /** 726x */
  A_726 = 'A_726',
  /** 727x */
  A_727 = 'A_727',
  /** 728x */
  A_728 = 'A_728',
  /** 729x */
  A_729 = 'A_729',
  /** 730x */
  A_730 = 'A_730',
  /** 731x */
  A_731 = 'A_731',
  /** 732x */
  A_732 = 'A_732',
  /** 733x */
  A_733 = 'A_733',
  /** 734x */
  A_734 = 'A_734',
  /** 735x */
  A_735 = 'A_735',
  /** 736x */
  A_736 = 'A_736',
  /** 737x */
  A_737 = 'A_737',
  /** 738x */
  A_738 = 'A_738',
  /** 739x */
  A_739 = 'A_739',
  /** 740x */
  A_740 = 'A_740',
  /** 741x */
  A_741 = 'A_741',
  /** 742x */
  A_742 = 'A_742',
  /** 743x */
  A_743 = 'A_743',
  /** 744x */
  A_744 = 'A_744',
  /** 745x */
  A_745 = 'A_745',
  /** 746x */
  A_746 = 'A_746',
  /** 747x */
  A_747 = 'A_747',
  /** 748x */
  A_748 = 'A_748',
  /** 749x */
  A_749 = 'A_749',
  /** 750x */
  A_750 = 'A_750',
  /** 751x */
  A_751 = 'A_751',
  /** 752x */
  A_752 = 'A_752',
  /** 753x */
  A_753 = 'A_753',
  /** 754x */
  A_754 = 'A_754',
  /** 755x */
  A_755 = 'A_755',
  /** 756x */
  A_756 = 'A_756',
  /** 757x */
  A_757 = 'A_757',
  /** 758x */
  A_758 = 'A_758',
  /** 759x */
  A_759 = 'A_759',
  /** 760x */
  A_760 = 'A_760',
  /** 761x */
  A_761 = 'A_761',
  /** 762x */
  A_762 = 'A_762',
  /** 763x */
  A_763 = 'A_763',
  /** 764x */
  A_764 = 'A_764',
  /** 765x */
  A_765 = 'A_765',
  /** 766x */
  A_766 = 'A_766',
  /** 767x */
  A_767 = 'A_767',
  /** 768x */
  A_768 = 'A_768',
  /** 769x */
  A_769 = 'A_769',
  /** 770x */
  A_770 = 'A_770',
  /** 771x */
  A_771 = 'A_771',
  /** 772x */
  A_772 = 'A_772',
  /** 773x */
  A_773 = 'A_773',
  /** 774x */
  A_774 = 'A_774',
  /** 775x */
  A_775 = 'A_775',
  /** 776x */
  A_776 = 'A_776',
  /** 777x */
  A_777 = 'A_777',
  /** 778x */
  A_778 = 'A_778',
  /** 779x */
  A_779 = 'A_779',
  /** 780x */
  A_780 = 'A_780',
  /** 781x */
  A_781 = 'A_781',
  /** 782x */
  A_782 = 'A_782',
  /** 783x */
  A_783 = 'A_783',
  /** 784x */
  A_784 = 'A_784',
  /** 785x */
  A_785 = 'A_785',
  /** 786x */
  A_786 = 'A_786',
  /** 787x */
  A_787 = 'A_787',
  /** 788x */
  A_788 = 'A_788',
  /** 789x */
  A_789 = 'A_789',
  /** 790x */
  A_790 = 'A_790',
  /** 791x */
  A_791 = 'A_791',
  /** 792x */
  A_792 = 'A_792',
  /** 793x */
  A_793 = 'A_793',
  /** 794x */
  A_794 = 'A_794',
  /** 795x */
  A_795 = 'A_795',
  /** 796x */
  A_796 = 'A_796',
  /** 797x */
  A_797 = 'A_797',
  /** 798x */
  A_798 = 'A_798',
  /** 799x */
  A_799 = 'A_799',
  /** 800x */
  A_800 = 'A_800',
  /** 801x */
  A_801 = 'A_801',
  /** 802x */
  A_802 = 'A_802',
  /** 803x */
  A_803 = 'A_803',
  /** 804x */
  A_804 = 'A_804',
  /** 805x */
  A_805 = 'A_805',
  /** 806x */
  A_806 = 'A_806',
  /** 807x */
  A_807 = 'A_807',
  /** 808x */
  A_808 = 'A_808',
  /** 809x */
  A_809 = 'A_809',
  /** 810x */
  A_810 = 'A_810',
  /** 811x */
  A_811 = 'A_811',
  /** 812x */
  A_812 = 'A_812',
  /** 813x */
  A_813 = 'A_813',
  /** 814x */
  A_814 = 'A_814',
  /** 815x */
  A_815 = 'A_815',
  /** 816x */
  A_816 = 'A_816',
  /** 817x */
  A_817 = 'A_817',
  /** 818x */
  A_818 = 'A_818',
  /** 819x */
  A_819 = 'A_819',
  /** 820x */
  A_820 = 'A_820',
  /** 821x */
  A_821 = 'A_821',
  /** 822x */
  A_822 = 'A_822',
  /** 823x */
  A_823 = 'A_823',
  /** 824x */
  A_824 = 'A_824',
  /** 825x */
  A_825 = 'A_825',
  /** 826x */
  A_826 = 'A_826',
  /** 827x */
  A_827 = 'A_827',
  /** 828x */
  A_828 = 'A_828',
  /** 829x */
  A_829 = 'A_829',
  /** 830x */
  A_830 = 'A_830',
  /** 831x */
  A_831 = 'A_831',
  /** 832x */
  A_832 = 'A_832',
  /** 833x */
  A_833 = 'A_833',
  /** 834x */
  A_834 = 'A_834',
  /** 835x */
  A_835 = 'A_835',
  /** 836x */
  A_836 = 'A_836',
  /** 837x */
  A_837 = 'A_837',
  /** 838x */
  A_838 = 'A_838',
  /** 839x */
  A_839 = 'A_839',
  /** 840x */
  A_840 = 'A_840',
  /** 841x */
  A_841 = 'A_841',
  /** 842x */
  A_842 = 'A_842',
  /** 843x */
  A_843 = 'A_843',
  /** 844x */
  A_844 = 'A_844',
  /** 845x */
  A_845 = 'A_845',
  /** 846x */
  A_846 = 'A_846',
  /** 847x */
  A_847 = 'A_847',
  /** 848x */
  A_848 = 'A_848',
  /** 849x */
  A_849 = 'A_849',
  /** 850x */
  A_850 = 'A_850',
  /** 851x */
  A_851 = 'A_851',
  /** 852x */
  A_852 = 'A_852',
  /** 853x */
  A_853 = 'A_853',
  /** 854x */
  A_854 = 'A_854',
  /** 855x */
  A_855 = 'A_855',
  /** 856x */
  A_856 = 'A_856',
  /** 857x */
  A_857 = 'A_857',
  /** 858x */
  A_858 = 'A_858',
  /** 859x */
  A_859 = 'A_859',
  /** 860x */
  A_860 = 'A_860',
  /** 861x */
  A_861 = 'A_861',
  /** 862x */
  A_862 = 'A_862',
  /** 863x */
  A_863 = 'A_863',
  /** 864x */
  A_864 = 'A_864',
  /** 865x */
  A_865 = 'A_865',
  /** 866x */
  A_866 = 'A_866',
  /** 867x */
  A_867 = 'A_867',
  /** 868x */
  A_868 = 'A_868',
  /** 869x */
  A_869 = 'A_869',
  /** 870x */
  A_870 = 'A_870',
  /** 871x */
  A_871 = 'A_871',
  /** 872x */
  A_872 = 'A_872',
  /** 873x */
  A_873 = 'A_873',
  /** 874x */
  A_874 = 'A_874',
  /** 875x */
  A_875 = 'A_875',
  /** 876x */
  A_876 = 'A_876',
  /** 877x */
  A_877 = 'A_877',
  /** 878x */
  A_878 = 'A_878',
  /** 879x */
  A_879 = 'A_879',
  /** 880x */
  A_880 = 'A_880',
  /** 881x */
  A_881 = 'A_881',
  /** 882x */
  A_882 = 'A_882',
  /** 883x */
  A_883 = 'A_883',
  /** 884x */
  A_884 = 'A_884',
  /** 885x */
  A_885 = 'A_885',
  /** 886x */
  A_886 = 'A_886',
  /** 887x */
  A_887 = 'A_887',
  /** 888x */
  A_888 = 'A_888',
  /** 889x */
  A_889 = 'A_889',
  /** 890x */
  A_890 = 'A_890',
  /** 891x */
  A_891 = 'A_891',
  /** 892x */
  A_892 = 'A_892',
  /** 893x */
  A_893 = 'A_893',
  /** 894x */
  A_894 = 'A_894',
  /** 895x */
  A_895 = 'A_895',
  /** 896x */
  A_896 = 'A_896',
  /** 897x */
  A_897 = 'A_897',
  /** 898x */
  A_898 = 'A_898',
  /** 899x */
  A_899 = 'A_899',
  /** 900x */
  A_900 = 'A_900',
  /** 901x */
  A_901 = 'A_901',
  /** 902x */
  A_902 = 'A_902',
  /** 903x */
  A_903 = 'A_903',
  /** 904x */
  A_904 = 'A_904',
  /** 905x */
  A_905 = 'A_905',
  /** 906x */
  A_906 = 'A_906',
  /** 907x */
  A_907 = 'A_907',
  /** 908x */
  A_908 = 'A_908',
  /** 909x */
  A_909 = 'A_909',
  /** 910x */
  A_910 = 'A_910',
  /** 911x */
  A_911 = 'A_911',
  /** 912x */
  A_912 = 'A_912',
  /** 913x */
  A_913 = 'A_913',
  /** 914x */
  A_914 = 'A_914',
  /** 915x */
  A_915 = 'A_915',
  /** 916x */
  A_916 = 'A_916',
  /** 917x */
  A_917 = 'A_917',
  /** 918x */
  A_918 = 'A_918',
  /** 919x */
  A_919 = 'A_919',
  /** 920x */
  A_920 = 'A_920',
  /** 921x */
  A_921 = 'A_921',
  /** 922x */
  A_922 = 'A_922',
  /** 923x */
  A_923 = 'A_923',
  /** 924x */
  A_924 = 'A_924',
  /** 925x */
  A_925 = 'A_925',
  /** 926x */
  A_926 = 'A_926',
  /** 927x */
  A_927 = 'A_927',
  /** 928x */
  A_928 = 'A_928',
  /** 929x */
  A_929 = 'A_929',
  /** 930x */
  A_930 = 'A_930',
  /** 931x */
  A_931 = 'A_931',
  /** 932x */
  A_932 = 'A_932',
  /** 933x */
  A_933 = 'A_933',
  /** 934x */
  A_934 = 'A_934',
  /** 935x */
  A_935 = 'A_935',
  /** 936x */
  A_936 = 'A_936',
  /** 937x */
  A_937 = 'A_937',
  /** 938x */
  A_938 = 'A_938',
  /** 939x */
  A_939 = 'A_939',
  /** 940x */
  A_940 = 'A_940',
  /** 941x */
  A_941 = 'A_941',
  /** 942x */
  A_942 = 'A_942',
  /** 943x */
  A_943 = 'A_943',
  /** 944x */
  A_944 = 'A_944',
  /** 945x */
  A_945 = 'A_945',
  /** 946x */
  A_946 = 'A_946',
  /** 947x */
  A_947 = 'A_947',
  /** 948x */
  A_948 = 'A_948',
  /** 949x */
  A_949 = 'A_949',
  /** 950x */
  A_950 = 'A_950',
  /** 951x */
  A_951 = 'A_951',
  /** 952x */
  A_952 = 'A_952',
  /** 953x */
  A_953 = 'A_953',
  /** 954x */
  A_954 = 'A_954',
  /** 955x */
  A_955 = 'A_955',
  /** 956x */
  A_956 = 'A_956',
  /** 957x */
  A_957 = 'A_957',
  /** 958x */
  A_958 = 'A_958',
  /** 959x */
  A_959 = 'A_959',
  /** 960x */
  A_960 = 'A_960',
  /** 961x */
  A_961 = 'A_961',
  /** 962x */
  A_962 = 'A_962',
  /** 963x */
  A_963 = 'A_963',
  /** 964x */
  A_964 = 'A_964',
  /** 965x */
  A_965 = 'A_965',
  /** 966x */
  A_966 = 'A_966',
  /** 967x */
  A_967 = 'A_967',
  /** 968x */
  A_968 = 'A_968',
  /** 969x */
  A_969 = 'A_969',
  /** 970x */
  A_970 = 'A_970',
  /** 971x */
  A_971 = 'A_971',
  /** 972x */
  A_972 = 'A_972',
  /** 973x */
  A_973 = 'A_973',
  /** 974x */
  A_974 = 'A_974',
  /** 975x */
  A_975 = 'A_975',
  /** 976x */
  A_976 = 'A_976',
  /** 977x */
  A_977 = 'A_977',
  /** 978x */
  A_978 = 'A_978',
  /** 979x */
  A_979 = 'A_979',
  /** 980x */
  A_980 = 'A_980',
  /** 981x */
  A_981 = 'A_981',
  /** 982x */
  A_982 = 'A_982',
  /** 983x */
  A_983 = 'A_983',
  /** 984x */
  A_984 = 'A_984',
  /** 985x */
  A_985 = 'A_985',
  /** 986x */
  A_986 = 'A_986',
  /** 987x */
  A_987 = 'A_987',
  /** 988x */
  A_988 = 'A_988',
  /** 989x */
  A_989 = 'A_989',
  /** 990x */
  A_990 = 'A_990',
  /** 991x */
  A_991 = 'A_991',
  /** 992x */
  A_992 = 'A_992',
  /** 993x */
  A_993 = 'A_993',
  /** 994x */
  A_994 = 'A_994',
  /** 995x */
  A_995 = 'A_995',
  /** 996x */
  A_996 = 'A_996',
  /** 997x */
  A_997 = 'A_997',
  /** 998x */
  A_998 = 'A_998',
  /** 999x */
  A_999 = 'A_999',
  /** 1000x */
  A_1000 = 'A_1000'
}

export type TaxasParcelasType = {
   __typename?: 'TaxasParcelasType',
  id: Scalars['ID'],
  entidade: EntidadeTypeRelay,
  parcelas: TaxasParcelasParcelas,
  taxaLucro?: Maybe<Scalars['Float']>,
  taxaMinima?: Maybe<Scalars['Float']>,
  taxaSeguranca?: Maybe<Scalars['Float']>,
};

export type TaxasTabelasInput = {
  valor: Scalars['Float'],
  parcelas?: Maybe<Array<Maybe<TaxasParcelasInput>>>,
};

export type TelefoneDeClienteType = {
   __typename?: 'TelefoneDeClienteType',
  id: Scalars['ID'],
  cliente: EmprestimoClienteNode,
  ddd?: Maybe<Scalars['String']>,
  numero: Scalars['String'],
  descricao?: Maybe<Scalars['String']>,
};

export type TelefoneDeEntidadeType = {
   __typename?: 'TelefoneDeEntidadeType',
  id: Scalars['ID'],
  entidade: EntidadeTypeRelay,
  ddd?: Maybe<Scalars['String']>,
  numero: Scalars['String'],
  descricao?: Maybe<Scalars['String']>,
};

export type TelefoneDeFornecedorType = {
   __typename?: 'TelefoneDeFornecedorType',
  id: Scalars['ID'],
  fornecedor: FornecedorViewNodeType,
  ddd?: Maybe<Scalars['String']>,
  numero: Scalars['String'],
  descricao?: Maybe<Scalars['String']>,
};

export type TemplatesEmailType = {
   __typename?: 'TemplatesEmailType',
  id: Scalars['ID'],
  /** Print do template de email */
  imagem: Scalars['String'],
  /** Ex: sgisistemas.com.br */
  dominio: Scalars['String'],
  /** Nome do Template no Mailgun */
  nomeTemplate: Scalars['String'],
};


/** An enumeration. */
export enum TipoDeEmprestimoModalidadeCliente {
  /** Pessoa Física */
  PessoaFisica = 'PESSOA_FISICA',
  /** Pessoa Jurídica */
  PessoaJuridica = 'PESSOA_JURIDICA',
  /** Ambos */
  Ambos = 'AMBOS'
}

export type TipoDeEmprestimoObjectType = {
   __typename?: 'TipoDeEmprestimoObjectType',
  nome?: Maybe<Scalars['String']>,
  quantidade?: Maybe<Scalars['Int']>,
  porcentagem?: Maybe<Scalars['Float']>,
};

/** An enumeration. */
export enum TipoDeEmprestimoPeriodicidadeRecorrencia {
  /** Diária */
  Diaria = 'DIARIA',
  /** Mensal */
  Mensal = 'MENSAL',
  /** Trimestral */
  Trimestral = 'TRIMESTRAL',
  /** Semestral */
  Semestral = 'SEMESTRAL',
  /** Anual */
  Anual = 'ANUAL'
}

export type TipoDeEmprestimoRelayType = Node & {
   __typename?: 'TipoDeEmprestimoRelayType',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  modalidadeCliente: TipoDeEmprestimoModalidadeCliente,
  tipoUso: TipoDeEmprestimoTipoUso,
  valorMinimo?: Maybe<Scalars['Float']>,
  valorMaximo?: Maybe<Scalars['Float']>,
  parcelasMinimas?: Maybe<Scalars['Int']>,
  parcelasMaximas?: Maybe<Scalars['Int']>,
  periodicidadeRecorrencia: TipoDeEmprestimoPeriodicidadeRecorrencia,
  /** Taxa de juros aplicada ao empréstimo (em porcentagem). */
  taxaJuros?: Maybe<Scalars['Float']>,
  tcc?: Maybe<Scalars['Float']>,
  descricao?: Maybe<Scalars['String']>,
  /** Indica se o tipo de empréstimo está ativo. */
  ativo: Scalars['Boolean'],
  tipoCalculo?: Maybe<TipoDeEmprestimoTipoCalculo>,
  entidades: EntidadeTypeRelayConnection,
  /** Campos adicionais para personalizar o empréstimo, armazenados em formato JSON. */
  loanExtraFields?: Maybe<Scalars['JSONString']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  emprestimoSet: EmprestimoRelatorioTypeConnection,
  metas: MetaNodeTypeRelayConnection,
  pk: Scalars['Int'],
};


export type TipoDeEmprestimoRelayTypeEntidadesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type TipoDeEmprestimoRelayTypeEmprestimoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type TipoDeEmprestimoRelayTypeMetasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  valorMeta?: Maybe<Scalars['Float']>,
  taxaMeta?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['String']>,
  inicioMeta?: Maybe<Scalars['String']>,
  inicioMeta_Gte?: Maybe<Scalars['Date']>,
  inicioMeta_Gt?: Maybe<Scalars['Date']>,
  inicioMeta_Lt?: Maybe<Scalars['Date']>,
  inicioMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta?: Maybe<Scalars['String']>,
  fimMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta_Lt?: Maybe<Scalars['Date']>,
  fimMeta_Gte?: Maybe<Scalars['Date']>,
  fimMeta_Gt?: Maybe<Scalars['Date']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  tipoRegramento?: Maybe<Scalars['String']>,
  tipoRegramento_In?: Maybe<Scalars['String']>,
  vinculoProduto?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  statusSaude?: Maybe<Scalars['String']>,
  grupoIds_In?: Maybe<Scalars['String']>,
  vinculoProduto_In?: Maybe<Scalars['String']>
};

export type TipoDeEmprestimoRelayTypeConnection = {
   __typename?: 'TipoDeEmprestimoRelayTypeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TipoDeEmprestimoRelayTypeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `TipoDeEmprestimoRelayType` and its cursor. */
export type TipoDeEmprestimoRelayTypeEdge = {
   __typename?: 'TipoDeEmprestimoRelayTypeEdge',
  /** The item at the end of the edge */
  node?: Maybe<TipoDeEmprestimoRelayType>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

/** An enumeration. */
export enum TipoDeEmprestimoTipoCalculo {
  /** Tabela Price */
  TabelaPrice = 'TABELA_PRICE',
  /** Juros Simples */
  JurosSimples = 'JUROS_SIMPLES'
}

/** An enumeration. */
export enum TipoDeEmprestimoTipoUso {
  /** Público */
  Publico = 'PUBLICO',
  /** Privado */
  Privado = 'PRIVADO',
  /** Ambos */
  Ambos = 'AMBOS'
}

export type TipoDeEmprestimoType = {
   __typename?: 'TipoDeEmprestimoType',
  id: Scalars['ID'],
  nome: Scalars['String'],
  modalidadeCliente: TipoDeEmprestimoModalidadeCliente,
  tipoUso: TipoDeEmprestimoTipoUso,
  valorMinimo?: Maybe<Scalars['Float']>,
  valorMaximo?: Maybe<Scalars['Float']>,
  parcelasMinimas?: Maybe<Scalars['Int']>,
  parcelasMaximas?: Maybe<Scalars['Int']>,
  periodicidadeRecorrencia: TipoDeEmprestimoPeriodicidadeRecorrencia,
  /** Taxa de juros aplicada ao empréstimo (em porcentagem). */
  taxaJuros?: Maybe<Scalars['Float']>,
  tcc?: Maybe<Scalars['Float']>,
  descricao?: Maybe<Scalars['String']>,
  /** Indica se o tipo de empréstimo está ativo. */
  ativo: Scalars['Boolean'],
  tipoCalculo?: Maybe<TipoDeEmprestimoTipoCalculo>,
  entidades: EntidadeTypeRelayConnection,
  /** Campos adicionais para personalizar o empréstimo, armazenados em formato JSON. */
  loanExtraFields?: Maybe<Scalars['JSONString']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  emprestimoSet: EmprestimoRelatorioTypeConnection,
  metas: MetaNodeTypeRelayConnection,
};


export type TipoDeEmprestimoTypeEntidadesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};


export type TipoDeEmprestimoTypeEmprestimoSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>
};


export type TipoDeEmprestimoTypeMetasArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  valorMeta?: Maybe<Scalars['Float']>,
  taxaMeta?: Maybe<Scalars['Float']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['String']>,
  inicioMeta?: Maybe<Scalars['String']>,
  inicioMeta_Gte?: Maybe<Scalars['Date']>,
  inicioMeta_Gt?: Maybe<Scalars['Date']>,
  inicioMeta_Lt?: Maybe<Scalars['Date']>,
  inicioMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta?: Maybe<Scalars['String']>,
  fimMeta_Lte?: Maybe<Scalars['Date']>,
  fimMeta_Lt?: Maybe<Scalars['Date']>,
  fimMeta_Gte?: Maybe<Scalars['Date']>,
  fimMeta_Gt?: Maybe<Scalars['Date']>,
  funcionarioId?: Maybe<Scalars['ID']>,
  funcionarioId_In?: Maybe<Scalars['ID']>,
  tipoRegramento?: Maybe<Scalars['String']>,
  tipoRegramento_In?: Maybe<Scalars['String']>,
  vinculoProduto?: Maybe<Scalars['String']>,
  id?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>,
  tipoDeEmprestimos_Id_In?: Maybe<Scalars['String']>,
  statusSaude?: Maybe<Scalars['String']>,
  grupoIds_In?: Maybe<Scalars['String']>,
  vinculoProduto_In?: Maybe<Scalars['String']>
};

export type TipoFuncionarioTypeRelay = Node & {
   __typename?: 'TipoFuncionarioTypeRelay',
  /** The ID of the object. */
  id: Scalars['ID'],
  nome: Scalars['String'],
  tipoDefault: Scalars['Boolean'],
  excluido: Scalars['Boolean'],
  funcionarioSet: FuncionarioTypeRelayConnection,
  totalFuncionarioPorTipo?: Maybe<Scalars['Int']>,
};


export type TipoFuncionarioTypeRelayFuncionarioSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  categoria?: Maybe<Scalars['String']>,
  tipoFuncionario_Nome?: Maybe<Scalars['String']>,
  tipoContrato?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  email_Icontains?: Maybe<Scalars['String']>,
  cpf?: Maybe<Scalars['String']>,
  rg?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  user_IsActive?: Maybe<Scalars['Boolean']>,
  orderBy?: Maybe<Scalars['String']>
};

export type TipoFuncionarioTypeRelayConnection = {
   __typename?: 'TipoFuncionarioTypeRelayConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TipoFuncionarioTypeRelayEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `TipoFuncionarioTypeRelay` and its cursor. */
export type TipoFuncionarioTypeRelayEdge = {
   __typename?: 'TipoFuncionarioTypeRelayEdge',
  /** The item at the end of the edge */
  node?: Maybe<TipoFuncionarioTypeRelay>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export type TiposDeEmprestimosPorLojaType = {
   __typename?: 'TiposDeEmprestimosPorLojaType',
  nomeTipoEmprestimo?: Maybe<Scalars['String']>,
  quantidade?: Maybe<Scalars['Int']>,
};

export type TiposEntidadesNodeType = Node & {
   __typename?: 'TiposEntidadesNodeType',
  /** The ID of the object. */
  id: Scalars['ID'],
  tipoLoja: Scalars['String'],
  valorAcimaTipo: Scalars['Float'],
  default: Scalars['Boolean'],
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
  excluido: Scalars['Boolean'],
  entidades: EntidadeTypeRelayConnection,
  totalEntidadesTipoLoja?: Maybe<Scalars['Int']>,
};


export type TiposEntidadesNodeTypeEntidadesArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  id?: Maybe<Scalars['Float']>,
  id_In?: Maybe<Scalars['String']>,
  nomeIdentificacao?: Maybe<Scalars['String']>,
  nomeIdentificacao_Icontains?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  inscricaoEstadual?: Maybe<Scalars['String']>,
  inscricaoEstadual_Icontains?: Maybe<Scalars['String']>,
  municipio?: Maybe<Scalars['String']>,
  municipio_Icontains?: Maybe<Scalars['String']>,
  razao?: Maybe<Scalars['String']>,
  razao_Icontains?: Maybe<Scalars['String']>,
  cnpj?: Maybe<Scalars['String']>,
  categoria?: Maybe<Scalars['String']>,
  criadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  atualizadoEm?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Lt?: Maybe<Scalars['DateTime']>,
  atualizadoEm_Gt?: Maybe<Scalars['DateTime']>,
  tipoLoja_TipoLoja?: Maybe<Scalars['String']>,
  valorAcimaEntidade?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_In?: Maybe<Scalars['Float']>,
  valorAcimaEntidade_Gt?: Maybe<Scalars['Float']>,
  orderBy?: Maybe<Scalars['String']>
};

export type TiposEntidadesNodeTypeConnection = {
   __typename?: 'TiposEntidadesNodeTypeConnection',
  /** Pagination data for this connection. */
  pageInfo: PageInfo,
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TiposEntidadesNodeTypeEdge>>,
  totalCount?: Maybe<Scalars['Int']>,
  edgeCount?: Maybe<Scalars['Int']>,
};

/** A Relay edge containing a `TiposEntidadesNodeType` and its cursor. */
export type TiposEntidadesNodeTypeEdge = {
   __typename?: 'TiposEntidadesNodeTypeEdge',
  /** The item at the end of the edge */
  node?: Maybe<TiposEntidadesNodeType>,
  /** A cursor for use in pagination */
  cursor: Scalars['String'],
};

export enum TiposEnvioOpcoes {
  Email = 'EMAIL',
  Sms = 'SMS',
  Whatsapp = 'WHATSAPP'
}

export type TitularDivergenteInput = {
  nome: Scalars['String'],
  cpf: Scalars['String'],
  anexoCpf: Scalars['String'],
  anexoRg: Scalars['String'],
  rg: Scalars['String'],
  cep: Scalars['String'],
  endereco: Scalars['String'],
  complemento: Scalars['String'],
  bairro: Scalars['String'],
  municipio: Scalars['String'],
  uf: Scalars['String'],
  pais: Scalars['String'],
  comprovanteEndereco?: Maybe<Scalars['String']>,
};

export type TodasMetasDash = {
   __typename?: 'TodasMetasDash',
  ok?: Maybe<Scalars['Boolean']>,
  valor?: Maybe<Scalars['Float']>,
  valorAlcancado?: Maybe<Scalars['Float']>,
  taxaGeral?: Maybe<Scalars['Float']>,
  taxaAlcancado?: Maybe<Scalars['Float']>,
  parcelas?: Maybe<Array<Maybe<ParcelasMetasDash>>>,
  metas?: Maybe<Array<Maybe<MetaType>>>,
  origens?: Maybe<Array<Maybe<OrigensMetasDash>>>,
  bandeiras?: Maybe<Array<Maybe<BandeirasDash>>>,
};

export type TokenSmsType = {
   __typename?: 'TokenSmsType',
  id: Scalars['ID'],
  tokenSms?: Maybe<Scalars['String']>,
  envios: EnvioSmsTypeRelay,
};

export type TriggerInputZApiInput = {
  statusId?: Maybe<Scalars['ID']>,
  texto?: Maybe<Scalars['String']>,
};

export type UpdateClienteMobile = {
   __typename?: 'UpdateClienteMobile',
  ok?: Maybe<Scalars['Boolean']>,
  cliente?: Maybe<ClienteType>,
  token?: Maybe<Scalars['String']>,
};

export type UpdateContaClienteMobile = {
   __typename?: 'UpdateContaClienteMobile',
  ok?: Maybe<Scalars['Boolean']>,
  conta?: Maybe<ContaDeClienteType>,
};

export type UpdateEnderecoClienteMobile = {
   __typename?: 'UpdateEnderecoClienteMobile',
  ok?: Maybe<Scalars['Boolean']>,
  cliente?: Maybe<ClienteType>,
};

export type UpdateMetaDiariaMutation = {
   __typename?: 'UpdateMetaDiariaMutation',
  ok?: Maybe<Scalars['Boolean']>,
  metaDiaria?: Maybe<Array<Maybe<MetasDiariasType>>>,
};

export type UpdateMetaMutation = {
   __typename?: 'UpdateMetaMutation',
  ok?: Maybe<Scalars['Boolean']>,
  metasComErroOutput?: Maybe<Array<Maybe<Scalars['String']>>>,
};

export type Upload_Foto_64 = {
   __typename?: 'upload_foto_64',
  ok?: Maybe<Scalars['Boolean']>,
  url?: Maybe<Scalars['String']>,
};

export type UserType = {
   __typename?: 'UserType',
  id: Scalars['ID'],
  password: Scalars['String'],
  lastLogin?: Maybe<Scalars['DateTime']>,
  /** Indica que este usuário tem todas as permissões sem atribuí-las explicitamente. */
  isSuperuser: Scalars['Boolean'],
  /** Obrigatório. 150 caracteres ou menos. Letras, números e @/./+/-/_ apenas. */
  username: Scalars['String'],
  firstName: Scalars['String'],
  lastName: Scalars['String'],
  email: Scalars['String'],
  /** Indica que usuário consegue acessar este site de administração. */
  isStaff: Scalars['Boolean'],
  /** Indica que o usuário será tratado como ativo. Ao invés de excluir contas de usuário, desmarque isso. */
  isActive: Scalars['Boolean'],
  dateJoined: Scalars['DateTime'],
  funcionario?: Maybe<FuncionarioTypeRelay>,
  cliente?: Maybe<EmprestimoClienteNode>,
};

export type VagaType = {
   __typename?: 'VagaType',
  id: Scalars['ID'],
  descricao: Scalars['String'],
  leadsSet: LeadsNodeTypeRelayPropConnection,
};


export type VagaTypeLeadsSetArgs = {
  before?: Maybe<Scalars['String']>,
  after?: Maybe<Scalars['String']>,
  first?: Maybe<Scalars['Int']>,
  last?: Maybe<Scalars['Int']>,
  propostas_ValorDesejado?: Maybe<Scalars['Float']>,
  origem_Icontains?: Maybe<Scalars['String']>,
  origem?: Maybe<Scalars['String']>,
  origem_In?: Maybe<Scalars['String']>,
  telefone?: Maybe<Scalars['String']>,
  telefone_Icontains?: Maybe<Scalars['String']>,
  telefone_Startswith?: Maybe<Scalars['String']>,
  email?: Maybe<Scalars['String']>,
  cidade?: Maybe<Scalars['String']>,
  cidade_Icontains?: Maybe<Scalars['String']>,
  uf?: Maybe<Scalars['String']>,
  nome?: Maybe<Scalars['String']>,
  nome_Icontains?: Maybe<Scalars['String']>,
  clienteId?: Maybe<Scalars['ID']>,
  clienteId_In?: Maybe<Scalars['ID']>,
  cliente_Isnull?: Maybe<Scalars['Boolean']>,
  entidadeId?: Maybe<Scalars['ID']>,
  entidadeId_In?: Maybe<Scalars['ID']>,
  utmSource?: Maybe<Scalars['String']>,
  utmSource_In?: Maybe<Scalars['String']>,
  utmSource_Icontains?: Maybe<Scalars['String']>,
  utmCampaign?: Maybe<Scalars['String']>,
  utmCampaign_In?: Maybe<Scalars['String']>,
  utmCampaign_Icontains?: Maybe<Scalars['String']>,
  utmMedium?: Maybe<Scalars['String']>,
  utmMedium_In?: Maybe<Scalars['String']>,
  utmMedium_Icontains?: Maybe<Scalars['String']>,
  utmTerm?: Maybe<Scalars['String']>,
  utmTerm_In?: Maybe<Scalars['String']>,
  utmTerm_Icontains?: Maybe<Scalars['String']>,
  utmContent?: Maybe<Scalars['String']>,
  utmContent_In?: Maybe<Scalars['String']>,
  utmContent_Icontains?: Maybe<Scalars['String']>,
  responsavelId?: Maybe<Scalars['ID']>,
  responsavelId_In?: Maybe<Scalars['ID']>,
  criadoEm?: Maybe<Scalars['String']>,
  criadoEm_Gte?: Maybe<Scalars['DateTime']>,
  criadoEm_Gt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lt?: Maybe<Scalars['DateTime']>,
  criadoEm_Lte?: Maybe<Scalars['DateTime']>,
  orderBy?: Maybe<Scalars['String']>
};

export type VendaLead = {
   __typename?: 'VendaLead',
  lead?: Maybe<LeadsType>,
  ok?: Maybe<Scalars['Boolean']>,
};

export type Verify = {
   __typename?: 'Verify',
  payload: Scalars['GenericScalar'],
};

export type VinculaLeadEmprestimo = {
   __typename?: 'VinculaLeadEmprestimo',
  ok?: Maybe<Scalars['Boolean']>,
};

export type VincularClickSignMutation = {
   __typename?: 'VincularClickSignMutation',
  ok?: Maybe<Scalars['Boolean']>,
  emprestimo?: Maybe<EmprestimoType>,
};

export type VincularFornecedorEntidade = {
   __typename?: 'VincularFornecedorEntidade',
  fornecedor?: Maybe<FornecedorNodeType>,
};

export type VincularTokenOnesignalMutation = {
   __typename?: 'VincularTokenOnesignalMutation',
  ok?: Maybe<Scalars['Boolean']>,
  newOnesignalId?: Maybe<Scalars['String']>,
};

export type ZekiGiftbackConsultaType = {
   __typename?: 'ZekiGiftbackConsultaType',
  giftbackId?: Maybe<Scalars['Int']>,
  codigo?: Maybe<Scalars['String']>,
  valorDesconto?: Maybe<Scalars['Decimal']>,
  valorTotalOriginal?: Maybe<Scalars['Decimal']>,
  valorTotalComDesconto?: Maybe<Scalars['Decimal']>,
  status?: Maybe<Scalars['String']>,
  payloadConsulta?: Maybe<Scalars['JSONString']>,
};

export type ZekiGiftbackResgateType = {
   __typename?: 'ZekiGiftbackResgateType',
  id: Scalars['ID'],
  emprestimo: EmprestimoRelatorioType,
  giftbackId: Scalars['Int'],
  codigo: Scalars['String'],
  valorDesconto: Scalars['Float'],
  valorTotalOriginal: Scalars['Float'],
  valorTotalComDesconto: Scalars['Float'],
  status?: Maybe<Scalars['String']>,
  payloadConsulta?: Maybe<Scalars['JSONString']>,
  payloadResgate?: Maybe<Scalars['JSONString']>,
  ultimoErro?: Maybe<Scalars['String']>,
  resgatadoEm?: Maybe<Scalars['DateTime']>,
  criadoEm: Scalars['DateTime'],
  atualizadoEm: Scalars['DateTime'],
};
